import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Upload: any;
};

export type IAccumulatedInteractionStatus = {
  closed: Scalars['Int'];
  completed: Scalars['Int'];
  locked: Scalars['Int'];
  pending: Scalars['Int'];
  percentCompleted: Scalars['Float'];
  percentPending: Scalars['Float'];
  progress: Scalars['String'];
  started: Scalars['Int'];
  total: Scalars['Int'];
};

export type IAdHocExam = {
  sessions?: Maybe<Array<Maybe<IAdHocExamSession>>>;
  signupUrl?: Maybe<Scalars['String']>;
};

export type IAdHocExamSession = {
  displayName: Scalars['String'];
  launchUrl: Scalars['String'];
};

export type IAlternationRestriction = {
  alternation: ITaxonomyItem;
  description: ILangString;
  gimp: IVersionRestriction;
  id: Scalars['ID'];
  itsr3Client: IVersionRestriction;
  msOffice: IVersionRestriction;
  windows: IVersionRestriction;
};

export enum Architecture {
  X64 = 'x64',
  X86 = 'x86'
}

export type IAttachmentUrlObject = {
  altText: ILangString;
  etag: Scalars['String'];
  href: Scalars['String'];
  hrefResolved: Scalars['String'];
  id: Scalars['ID'];
  imageMetadata?: Maybe<IImageMetadata>;
  md5: Scalars['String'];
  name: Scalars['String'];
  realName: Scalars['String'];
  sha256: Scalars['String'];
  sha512: Scalars['String'];
  size: Scalars['Int'];
  uniqueId: Scalars['String'];
  videoMetadata?: Maybe<IVideoMetadata>;
};

export type IAudienceDocument = IItemBankDoc & {
  _id: Scalars['String'];
  _rev: Scalars['String'];
  attachments: Array<IAttachmentUrlObject>;
  audienceId: Scalars['String'];
  docReferenceId: Scalars['String'];
  docType: Doctype;
  isDeleted: Scalars['Boolean'];
  subjects: Array<ISubjectDocument>;
  title: Scalars['String'];
};

export type IAudienceFilterOptions = {
  showDeleted?: InputMaybe<TriStateEnum>;
  subjectDocRefIds?: InputMaybe<Array<Scalars['String']>>;
};

export type IAudienceMutation = {
  newAudience: IAudienceDocument;
  upsertAudience: IAudienceDocument;
};


export type IAudienceMutationUpsertAudienceArgs = {
  params: IUpsertAudienceInput;
};

export type IAudienceQuery = {
  all: Array<IAudienceDocument>;
  byId: IAudienceDocument;
  get: Array<IAudienceDocument>;
};


export type IAudienceQueryAllArgs = {
  params?: InputMaybe<IGetAllAudiencesInput>;
};


export type IAudienceQueryByIdArgs = {
  docRef: Scalars['ID'];
};


export type IAudienceQueryGetArgs = {
  params: IGetAudiencesInput;
};

export type IAuthorMutation = {
  createAdHocExam?: Maybe<IAdHocExam>;
};


export type IAuthorMutationCreateAdHocExamArgs = {
  itemDocRefs: Array<Scalars['ID']>;
  language: Scalars['ID'];
  sessions?: InputMaybe<Scalars['Int']>;
  testDefinitionProfileDocRef: Scalars['ID'];
  userAgentString?: InputMaybe<Scalars['String']>;
};

export type IAuthorQuery = {
  adHocExams: Array<IAdHocExam>;
};

export enum AuthoringStatusEnum {
  Done = 'done',
  Inprogress = 'inprogress',
  Locked = 'locked',
  Open = 'open',
  Reopened = 'reopened'
}

export type IBasicPrivilege = IPrivilege & {
  privilege: Privilege;
};

export enum BinaryFunctionOperator {
  Between = 'BETWEEN',
  Contains = 'CONTAINS',
  Diff = 'DIFF',
  Endswith = 'ENDSWITH',
  Eq = 'EQ',
  Ge = 'GE',
  Gt = 'GT',
  Issamearray = 'ISSAMEARRAY',
  Le = 'LE',
  Lt = 'LT',
  Matches = 'MATCHES',
  Notcontains = 'NOTCONTAINS',
  Startswith = 'STARTSWITH'
}

export type IBinaryFunctionResult = IResult & {
  argsBoolean?: Maybe<Scalars['Boolean']>;
  argsBooleanArray?: Maybe<Array<Scalars['Boolean']>>;
  argsNumber?: Maybe<Scalars['Float']>;
  argsNumberArray?: Maybe<Array<Scalars['Float']>>;
  argsStr?: Maybe<Scalars['String']>;
  argsStrArr?: Maybe<Array<Scalars['String']>>;
  error?: Maybe<Scalars['String']>;
  fieldId: Scalars['String'];
  id: Scalars['ID'];
  operator: BinaryFunctionOperator;
  result: Scalars['Boolean'];
};

export type IBrowserSession = {
  id: Scalars['ID'];
  isoLanguages: Array<Scalars['String']>;
  localization: ILocalization;
  loginId: Scalars['String'];
  /** @deprecated LPU was split to its-itembank-ripple */
  lpuDocRefId: Scalars['ID'];
  myExamSession?: Maybe<IQueryExamSession>;
  type: BrowserSessionType;
  user?: Maybe<IUserDocument>;
  validUntil: Scalars['String'];
};

export enum BrowserSessionType {
  Anonymous = 'anonymous',
  Candidate = 'candidate',
  Review = 'review',
  User = 'user'
}

export type IBulkProcessingResponse = {
  errors: Array<Scalars['String']>;
  notprocessed: Scalars['Int'];
  processed: Scalars['Int'];
  total: Scalars['Int'];
};

export type IButton = {
  id: Scalars['ID'];
  label: ILangString;
  visibility: ButtonVisibility;
};

export enum ButtonVisibility {
  Default = 'default',
  Hide = 'hide',
  Show = 'show'
}

export type ICttDimensionEntry = {
  id: Scalars['ID'];
  isLeaf: Scalars['Boolean'];
  name: ILangString;
  parentId?: Maybe<Scalars['ID']>;
  taxon: Scalars['ID'];
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type IChildItem = {
  id: Scalars['ID'];
  index: Scalars['Int'];
  item: IItemDocument;
};

export type IChoiceTextEditItem = {
  gaps: Array<IChoiceTextEdit_Gap>;
  header: ILangString;
  id: Scalars['ID'];
  perGapScore?: Maybe<Scalars['Float']>;
  question: ILangString;
  scoring: ChoiceTextEdit_Scoring;
  shuffleMode: ChoiceTextEdit_ShuffleMode;
  text: ILangString;
  values: Array<IChoiceTextEdit_Value>;
};

export type IChoiceTextEditMutation = {
  addGap: IChoiceTextEdit_Gap;
  addValue: IChoiceTextEdit_Value;
  convert: Scalars['String'];
  removeGap: Scalars['Boolean'];
  removeValue: Scalars['Boolean'];
  upsert?: Maybe<IChoiceTextEditItem>;
};


export type IChoiceTextEditMutationAddGapArgs = {
  itemId: Scalars['ID'];
};


export type IChoiceTextEditMutationAddValueArgs = {
  gapId: Scalars['ID'];
  itemId: Scalars['ID'];
};


export type IChoiceTextEditMutationConvertArgs = {
  itemIds: Array<Scalars['ID']>;
};


export type IChoiceTextEditMutationRemoveGapArgs = {
  gapId: Scalars['ID'];
  itemId: Scalars['ID'];
};


export type IChoiceTextEditMutationRemoveValueArgs = {
  itemId: Scalars['ID'];
  valueId: Scalars['ID'];
};


export type IChoiceTextEditMutationUpsertArgs = {
  params: IChoiceTextEditUpsertInput;
};

export type IChoiceTextEditQuery = {
  get: IChoiceTextEditItem;
};


export type IChoiceTextEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IChoiceTextEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  perGapScore?: InputMaybe<Scalars['Float']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  scoring?: InputMaybe<ChoiceTextEdit_Scoring>;
  setGaps?: InputMaybe<Array<IChoiceTextEdit_UpsertGap>>;
  setValues?: InputMaybe<Array<IChoiceTextEdit_UpsertValue>>;
  shuffleMode?: InputMaybe<ChoiceTextEdit_ShuffleMode>;
  subject?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<IUpsertLangStringInput>;
  upsertGaps?: InputMaybe<Array<IChoiceTextEdit_UpsertGap>>;
  upsertValues?: InputMaybe<Array<IChoiceTextEdit_UpsertValue>>;
};

export type IChoiceTextEdit_Gap = {
  correct: IChoiceTextEdit_Value;
  gapId: Scalars['ID'];
  id: Scalars['ID'];
  possibilities: Array<IChoiceTextEdit_Value>;
};

export enum ChoiceTextEdit_Scoring {
  AllOrNothing = 'AllOrNothing',
  PerGap = 'PerGap'
}

export enum ChoiceTextEdit_ShuffleMode {
  Ordered = 'Ordered',
  Shuffled = 'Shuffled',
  ShuffledExceptLast = 'ShuffledExceptLast'
}

export type IChoiceTextEdit_UpsertGap = {
  correct?: InputMaybe<Scalars['ID']>;
  gapId: Scalars['ID'];
  possibilities?: InputMaybe<Array<Scalars['ID']>>;
};

export type IChoiceTextEdit_UpsertValue = {
  value?: InputMaybe<IUpsertLangStringInput>;
  valueId: Scalars['ID'];
};

export type IChoiceTextEdit_Value = {
  id: Scalars['ID'];
  value: ILangString;
  valueId: Scalars['ID'];
};

export type IClient_AttachmentUrlObjectInput = {
  etag: Scalars['String'];
  hrefResolved: Scalars['String'];
  id: Scalars['ID'];
  sha256: Scalars['String'];
  size: Scalars['Int'];
  uniqueId: Scalars['String'];
};

export type IClient_FileInput = {
  id: Scalars['ID'];
  path: Scalars['String'];
  resource?: InputMaybe<IClient_AttachmentUrlObjectInput>;
  userCreated: Scalars['Boolean'];
};

export type IClient_InitInput = {
  sessionId: Scalars['ID'];
};

export type IClient_InitResult = {
  driveH: Scalars['String'];
};

export type IClient_InvestigateResult = {
  investigatorId: Scalars['ID'];
  serializedValue: Scalars['String'];
};

export type IClient_InvestigatorInput = {
  id: Scalars['ID'];
  investigatorUri: Scalars['String'];
  properties: Array<IClient_PropertyInput>;
  serviceProviderId: Scalars['String'];
};

export type IClient_PreparatorInput = {
  id: Scalars['ID'];
  preparatorUri: Scalars['ID'];
  properties: Array<IClient_PropertyInput>;
  serviceProviderId: Scalars['ID'];
};

export type IClient_PropertyInput = {
  propertyId: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type IClient_TopItemDataInput = {
  files: Array<IClient_FileInput>;
  id: Scalars['ID'];
  investigators: Array<IClient_InvestigatorInput>;
  itemNr: Scalars['Int'];
  preparators: Array<IClient_PreparatorInput>;
  sessionId: Scalars['ID'];
  topItemId: Scalars['ID'];
};

export enum ConditionFunctionOperator {
  And = 'AND',
  Or = 'OR'
}

export type IConditionResult = IResult & {
  args: Array<IResult>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  operator: ConditionFunctionOperator;
  result: Scalars['Boolean'];
};

export type IConfigMutation = {
  deleteSharePointConnections: Scalars['Boolean'];
  enableItemTranslation: Scalars['Boolean'];
  enableLevelOfSecrecy: Scalars['Boolean'];
  enableLocalizationForAdministration: Array<ILocalization>;
  enableLocalizationForExams: Array<ILocalization>;
  setRequestDelay: Scalars['Boolean'];
  upsertSharePointConnection: Scalars['Boolean'];
};


export type IConfigMutationDeleteSharePointConnectionsArgs = {
  ids: Array<Scalars['ID']>;
};


export type IConfigMutationEnableItemTranslationArgs = {
  enabled: Scalars['Boolean'];
};


export type IConfigMutationEnableLevelOfSecrecyArgs = {
  enabled: Scalars['Boolean'];
};


export type IConfigMutationEnableLocalizationForAdministrationArgs = {
  ids: Array<Scalars['ID']>;
};


export type IConfigMutationEnableLocalizationForExamsArgs = {
  ids: Array<Scalars['ID']>;
};


export type IConfigMutationSetRequestDelayArgs = {
  delay: Scalars['Float'];
};


export type IConfigMutationUpsertSharePointConnectionArgs = {
  params: IUpsertSharePointConnection;
};

export type IConfigQuery = {
  connectionLostTime: Scalars['Int'];
  contentLanguages: Array<ILanguage>;
  customlogo1?: Maybe<Scalars['String']>;
  customlogo2?: Maybe<Scalars['String']>;
  golemEnabled: Scalars['Boolean'];
  instanceName: Scalars['String'];
  itemTranslationEnabled: Scalars['Boolean'];
  levelOfSecrecyEnabled: Scalars['Boolean'];
  localizations: Array<ILocalization>;
  onlineHelp: Array<IOnlineHelp>;
  onlineHelpById: IOnlineHelp;
  passedTimeUpdateInterval: Scalars['Int'];
  requestDelay: Scalars['Float'];
  serverVersion: Scalars['String'];
  sharePointConnections: Array<ISharePointConnection>;
  stopOnConnectionLost: Scalars['Boolean'];
  submitEnableTime: Scalars['Int'];
};


export type IConfigQueryLocalizationsArgs = {
  enabledForAdministration?: InputMaybe<TriStateEnum>;
  enabledForExams?: InputMaybe<TriStateEnum>;
};


export type IConfigQueryOnlineHelpByIdArgs = {
  id: Scalars['ID'];
};


export type IConfigQueryServerVersionArgs = {
  delay?: InputMaybe<Scalars['Int']>;
};

export type IContainedReferencedItem = {
  itemId?: Maybe<Scalars['String']>;
};

export type IContainerEditItem = {
  attachmentFile1?: Maybe<Scalars['String']>;
  attachmentFile2?: Maybe<Scalars['String']>;
  attachmentFile3?: Maybe<Scalars['String']>;
  attachmentFile4?: Maybe<Scalars['String']>;
  attachmentFile5?: Maybe<Scalars['String']>;
  audioFile?: Maybe<Scalars['String']>;
  filestructure: Array<IContainerEdit_FileStructureEntry>;
  header: ILangString;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  instruction: ILangString;
  onlineVideoLink?: Maybe<Scalars['String']>;
  textBlock?: Maybe<ILangString>;
  textBlockFormat: KosovoContainer_TextBlockFormat;
  videoFile?: Maybe<Scalars['String']>;
};

export type IContainerEditMutation = {
  upsert?: Maybe<IContainerEditItem>;
};


export type IContainerEditMutationUpsertArgs = {
  params: IContainerEditUpsertInput;
};

export type IContainerEditQuery = {
  get: IContainerEditItem;
};


export type IContainerEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IContainerEditUpsertInput = {
  attachmentFile1?: InputMaybe<Scalars['String']>;
  attachmentFile2?: InputMaybe<Scalars['String']>;
  attachmentFile3?: InputMaybe<Scalars['String']>;
  attachmentFile4?: InputMaybe<Scalars['String']>;
  attachmentFile5?: InputMaybe<Scalars['String']>;
  audioFile?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<IUpsertLangStringInput>;
  image?: InputMaybe<Scalars['String']>;
  instruction?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  onlineVideoLink?: InputMaybe<Scalars['String']>;
  parentItemId?: InputMaybe<Scalars['ID']>;
  removeFiles?: InputMaybe<Array<Scalars['ID']>>;
  setFiles?: InputMaybe<Array<IContainerEdit_UpsertFileStructureEntryInput>>;
  subject?: InputMaybe<Scalars['ID']>;
  textBlock?: InputMaybe<IUpsertLangStringInput>;
  textBlockFormat?: InputMaybe<KosovoContainer_TextBlockFormat>;
  upsertFiles?: InputMaybe<Array<IContainerEdit_UpsertFileStructureEntryInput>>;
  videoFile?: InputMaybe<Scalars['String']>;
};

export type IContainerEdit_FileStructureEntry = {
  fileId: Scalars['String'];
  id: Scalars['ID'];
  path: Scalars['String'];
  resourceItem?: Maybe<Scalars['String']>;
  resourceName?: Maybe<Scalars['String']>;
  userCreated: Scalars['Boolean'];
};

export type IContainerEdit_UpsertFileStructureEntryInput = {
  fileId: Scalars['String'];
  path?: InputMaybe<Scalars['String']>;
  resourceItem?: InputMaybe<Scalars['String']>;
  resourceName?: InputMaybe<Scalars['String']>;
  userCreated?: InputMaybe<Scalars['Boolean']>;
};

export enum ContinuationModeEnum {
  Admin = 'admin',
  System = 'system',
  Takeover = 'takeover'
}

export enum ContinueWithEnum {
  Item = 'item',
  Overview = 'overview'
}

export type ICopyItem = {
  toContainer: ICopyReviseItemActionResult;
  toSubject: ICopyReviseItemActionResult;
};


export type ICopyItemToContainerArgs = {
  containerDocRefId: Scalars['String'];
};


export type ICopyItemToSubjectArgs = {
  subjectDocRefId: Scalars['String'];
};

export type ICopyItemInput = {
  docRefId: Scalars['String'];
  noteForAuthor?: InputMaybe<Scalars['String']>;
};

export type ICopyReviseItemActionResult = {
  message: ILangString;
  newItemDocRefId?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type ICrossoutEditFragment = {
  id: Scalars['ID'];
  index: Scalars['String'];
  value: Scalars['String'];
};

export type ICrossoutEditItem = {
  header: ILangString;
  id: Scalars['ID'];
  lines: Array<ICrossoutEditLine>;
  question: ILangString;
  scoringMode: CrossoutScoringMode;
  shuffleMode: CrossoutShuffleMode;
};

export type ICrossoutEditLine = {
  annotatedText: Scalars['String'];
  fragments: Array<ICrossoutEditFragment>;
  id: Scalars['ID'];
  incorrect?: Maybe<ICrossoutEditFragment>;
  index: Scalars['ID'];
};

export type ICrossoutEditMutation = {
  upsert: ICrossoutEditItem;
};


export type ICrossoutEditMutationUpsertArgs = {
  params: ICrossoutEditUpsertInput;
};

export type ICrossoutEditQuery = {
  get: ICrossoutEditItem;
};


export type ICrossoutEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type ICrossoutEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removeLines?: InputMaybe<Array<Scalars['ID']>>;
  scoringMode?: InputMaybe<CrossoutScoringMode>;
  setLines?: InputMaybe<Array<ICrossoutEdit_UpsertLineInput>>;
  shuffleMode?: InputMaybe<CrossoutShuffleMode>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertLines?: InputMaybe<Array<ICrossoutEdit_UpsertLineInput>>;
};

export type ICrossoutEdit_UpsertFragmentInput = {
  index: Scalars['ID'];
  value?: InputMaybe<Scalars['String']>;
};

export type ICrossoutEdit_UpsertLineInput = {
  annotatedText?: InputMaybe<Scalars['String']>;
  incorrect?: InputMaybe<Scalars['ID']>;
  index: Scalars['ID'];
  setFragments?: InputMaybe<Array<ICrossoutEdit_UpsertFragmentInput>>;
};

export enum CrossoutScoringMode {
  AllOrNothing = 'AllOrNothing',
  PerLine = 'PerLine'
}

export enum CrossoutShuffleMode {
  Ordered = 'ordered',
  Shuffled = 'shuffled'
}

export enum CustomFieldType {
  Email = 'email',
  Int = 'int',
  Percentage = 'percentage',
  String = 'string'
}

export enum Doctype {
  Audience = 'audience',
  Examination = 'examination',
  Examinationorder = 'examinationorder',
  Golemscript = 'golemscript',
  Item = 'item',
  Scormtoken = 'scormtoken',
  Statisticexportconfig = 'statisticexportconfig',
  Subject = 'subject',
  Taxonomy = 'taxonomy',
  Testalias = 'testalias',
  Testdefinitionprofile = 'testdefinitionprofile',
  User = 'user'
}

export type IDeusExamOrderSettings = {
  defaultSyllabusDepth?: Maybe<Scalars['Int']>;
};

export type IDeusExamSessionsPerDay = {
  count: Scalars['Int'];
  timestamp: Scalars['String'];
};

export type IDeusItemType = {
  aliases: Array<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
  supported: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
};

export type IDeusItemTypeKosovoContainerMutation = {
  setSupportsAttachments: IItemTypeKosovoContainerQuery;
  setSupportsAudio: IItemTypeKosovoContainerQuery;
  setSupportsFileStructure: IItemTypeKosovoContainerQuery;
  setSupportsImage: IItemTypeKosovoContainerQuery;
  setSupportsText: IItemTypeKosovoContainerQuery;
  setSupportsVideo: IItemTypeKosovoContainerQuery;
};


export type IDeusItemTypeKosovoContainerMutationSetSupportsAttachmentsArgs = {
  supported: Scalars['Boolean'];
};


export type IDeusItemTypeKosovoContainerMutationSetSupportsAudioArgs = {
  supported: Scalars['Boolean'];
};


export type IDeusItemTypeKosovoContainerMutationSetSupportsFileStructureArgs = {
  supported: Scalars['Boolean'];
};


export type IDeusItemTypeKosovoContainerMutationSetSupportsImageArgs = {
  supported: Scalars['Boolean'];
};


export type IDeusItemTypeKosovoContainerMutationSetSupportsTextArgs = {
  supported: Scalars['Boolean'];
};


export type IDeusItemTypeKosovoContainerMutationSetSupportsVideoArgs = {
  supported: Scalars['Boolean'];
};

export type IDeusItemTypeKosovoMutation = {
  container?: Maybe<IDeusItemTypeKosovoContainerMutation>;
  dummy?: Maybe<Scalars['Boolean']>;
};

export type IDeusItemTypesMutation = {
  dummy?: Maybe<Scalars['String']>;
  kosovo?: Maybe<IDeusItemTypeKosovoMutation>;
};

export type IDeusMutations = {
  itemtype?: Maybe<IDeusItemTypesMutation>;
  purgeExamMetadata?: Maybe<Scalars['Boolean']>;
  setExamOrderSetting?: Maybe<Scalars['Boolean']>;
  supportItemType?: Maybe<IDeusItemType>;
  supportItemTypes?: Maybe<Array<Maybe<IDeusItemType>>>;
  unsupportItemType?: Maybe<IDeusItemType>;
  updateDocuments?: Maybe<Scalars['Boolean']>;
  verifyConfig?: Maybe<IDeusVerfiyConfigResponse>;
};


export type IDeusMutationsSetExamOrderSettingArgs = {
  defaultSyllabusDepth?: InputMaybe<Scalars['Int']>;
};


export type IDeusMutationsSupportItemTypeArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type IDeusMutationsSupportItemTypesArgs = {
  filter?: InputMaybe<ISupportItemTypesFilterArgs>;
};


export type IDeusMutationsUnsupportItemTypeArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type IDeusMutationsVerifyConfigArgs = {
  mailTo?: InputMaybe<Scalars['String']>;
  transationId?: InputMaybe<Scalars['String']>;
};

export type IDeusQueries = {
  examOrderSettings: IDeusExamOrderSettings;
  examSessionsByDayCreated?: Maybe<Array<IDeusExamSessionsPerDay>>;
  itemTypes: Array<IDeusItemType>;
  items: Array<IItemDocument>;
};


export type IDeusQueriesExamSessionsByDayCreatedArgs = {
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type IDeusVerfiyConfigResponse = {
  log: Scalars['String'];
  ok: Scalars['Boolean'];
};

export enum DisplayItemIdEnum {
  Default = 'default',
  No = 'no',
  Yes = 'yes'
}

export enum DisplayObjectiveIdEnum {
  Default = 'default',
  No = 'no',
  Yes = 'yes'
}

export enum DisplayProgress {
  Default = 'default',
  No = 'no',
  Passed = 'passed',
  Remaining = 'remaining'
}

export enum DisplayTime {
  Default = 'default',
  No = 'no',
  Passed = 'passed',
  Remaining = 'remaining'
}

export type IDocumentMutation = {
  addAttachment: IAttachmentUrlObject;
  newImageStub: IAttachmentUrlObject;
  removeAttachments: Scalars['Boolean'];
  updateAttachment: IAttachmentUrlObject;
};


export type IDocumentMutationAddAttachmentArgs = {
  base64Content: Scalars['String'];
  mimeType?: InputMaybe<Scalars['String']>;
  name: Scalars['ID'];
};


export type IDocumentMutationRemoveAttachmentsArgs = {
  names: Array<Scalars['ID']>;
};


export type IDocumentMutationUpdateAttachmentArgs = {
  data: IUpdateAttachmentInput;
};

export type IDocumentQuery = {
  get?: Maybe<IItemBankDoc>;
};


export type IDocumentQueryGetArgs = {
  docReferenceId: Scalars['ID'];
  docType: Doctype;
};

export type IDonkey = {
  /** @deprecated not supported anymore */
  config?: Maybe<IDonkeyConfig>;
  /** @deprecated not supported anymore */
  online: Scalars['Boolean'];
  /** @deprecated not supported anymore */
  onlineSince: Scalars['String'];
  /** @deprecated not supported anymore */
  serviceProvider: Scalars['ID'];
};

export type IDonkeyCommand = {
  /** @deprecated not supported anymore */
  files: Array<IHandsOn_FileStructureEntry>;
  /** @deprecated not supported anymore */
  id: Scalars['ID'];
  /** @deprecated not supported anymore */
  investigators: Array<IHandsOn_Investigator>;
  /** @deprecated not supported anymore */
  itemId?: Maybe<Scalars['String']>;
  /** @deprecated not supported anymore */
  itemNr?: Maybe<Scalars['Int']>;
  /** @deprecated not supported anymore */
  preparators: Array<IHandsOn_Preparator>;
  /** @deprecated not supported anymore */
  sessionDocRefId?: Maybe<Scalars['ID']>;
  /** @deprecated not supported anymore */
  type: DonkeyCommandTypeEnum;
};

export enum DonkeyCommandTypeEnum {
  Cache = 'Cache',
  Cleanup = 'Cleanup',
  Investigate = 'Investigate',
  Reset = 'Reset',
  Setup = 'Setup'
}

export type IDonkeyConfig = {
  /** @deprecated not supported anymore */
  msOfficeApps?: Maybe<Array<Scalars['String']>>;
  /** @deprecated not supported anymore */
  msOfficeArchitecture?: Maybe<Architecture>;
  /** @deprecated not supported anymore */
  msOfficeVersion?: Maybe<Scalars['String']>;
  /** @deprecated not supported anymore */
  os: Os;
  /** @deprecated not supported anymore */
  osArchitecture: Architecture;
  /** @deprecated not supported anymore */
  osVersion: Scalars['String'];
  /** @deprecated not supported anymore */
  resourcePath: Scalars['String'];
};

export type IDonkeyMutation = {
  /** @deprecated not supported anymore */
  login: Scalars['ID'];
  /** @deprecated not supported anymore */
  newDonkeyId: Scalars['ID'];
  /** @deprecated not supported anymore */
  setError: Scalars['Boolean'];
  /** @deprecated not supported anymore */
  setProgress: Scalars['Boolean'];
  /** @deprecated not supported anymore */
  setResult: Scalars['Boolean'];
  /** @deprecated not supported anymore */
  updateConfig: Scalars['Boolean'];
};


export type IDonkeyMutationLoginArgs = {
  donkeyId: Scalars['ID'];
  secret: Scalars['ID'];
};


export type IDonkeyMutationNewDonkeyIdArgs = {
  secret: Scalars['ID'];
  serviceProvider: Scalars['ID'];
};


export type IDonkeyMutationSetErrorArgs = {
  command: DonkeyCommandTypeEnum;
  errorMessage?: InputMaybe<ILangStringInput>;
  responseTo: Scalars['ID'];
  sessionId?: InputMaybe<Scalars['ID']>;
};


export type IDonkeyMutationSetProgressArgs = {
  command: DonkeyCommandTypeEnum;
  progress: Scalars['Int'];
  responseTo: Scalars['ID'];
  sessionId?: InputMaybe<Scalars['ID']>;
};


export type IDonkeyMutationSetResultArgs = {
  investigatorId: Scalars['ID'];
  responseTo: Scalars['ID'];
  serializedValue: Scalars['String'];
  sessionId: Scalars['ID'];
};


export type IDonkeyMutationUpdateConfigArgs = {
  config: IUpdateDonkeyConfig;
};

export type IDonkeyQuery = {
  /** @deprecated not supported anymore */
  get: Array<IDonkey>;
  /** @deprecated not supported anymore */
  getById?: Maybe<IDonkey>;
};


export type IDonkeyQueryGetArgs = {
  filter?: InputMaybe<IGetDonkeyFilter>;
};


export type IDonkeyQueryGetByIdArgs = {
  donkeyId: Scalars['ID'];
};

export enum EMailConfirmed {
  Auto = 'auto',
  No = 'no',
  Yes = 'yes'
}

export type IEditItemAction = {
  docRefId: Scalars['String'];
};

export type IEnrichmentDescription = {
  enumDescriptions: Array<IEnrichmentEnumDescription>;
  id: Scalars['String'];
  investigatorDescriptions: Array<IInvestigatorDescription>;
  preparatorDescriptions: Array<IPreparatorDescription>;
  registeredInstances: Scalars['Int'];
  version: Scalars['String'];
};

export type IEnrichmentEnumDescription = {
  description: ILangString;
  id: Scalars['String'];
  name: ILangString;
  values: Array<IEnrichmentEnumDescriptionValue>;
};

export type IEnrichmentEnumDescriptionInput = {
  description?: InputMaybe<ILangStringInput>;
  id: Scalars['String'];
  name?: InputMaybe<ILangStringInput>;
  values: Array<IEnrichmentEnumDescriptionValueInput>;
};

export type IEnrichmentEnumDescriptionValue = {
  description: ILangString;
  id: Scalars['String'];
  name: ILangString;
};

export type IEnrichmentEnumDescriptionValueInput = {
  description?: InputMaybe<ILangStringInput>;
  id: Scalars['String'];
  name?: InputMaybe<ILangStringInput>;
};

export type IEnrichmentMutation = {
  register: Scalars['Boolean'];
  unregister?: Maybe<IEnrichmentMutationUnregisterResponse>;
};


export type IEnrichmentMutationRegisterArgs = {
  params: IEnrichmentMutationRegisterParams;
};


export type IEnrichmentMutationUnregisterArgs = {
  token: Scalars['String'];
};

export type IEnrichmentMutationRegisterParams = {
  enumDescriptions?: InputMaybe<Array<IEnrichmentEnumDescriptionInput>>;
  id: Scalars['String'];
  investigatorDescriptions?: InputMaybe<Array<IInvestigatorDescriptionInput>>;
  preparatorDescriptions?: InputMaybe<Array<IPreparatorDescriptionInput>>;
  version: Scalars['String'];
};

export type IEnrichmentMutationRegisterResponse = {
  token: Scalars['ID'];
};

export type IEnrichmentMutationUnregisterResponse = {
  ok?: Maybe<Scalars['String']>;
};

export enum EnrichmentParamTypeEnum {
  ResultDataFileIdConverter = 'ResultDataFileIDConverter',
  TaskResourceDirectoryIdConverter = 'TaskResourceDirectoryIDConverter',
  TaskResourceFileIdConverter = 'TaskResourceFileIDConverter',
  Attachment = 'attachment',
  Bool = 'bool',
  Datetime = 'datetime',
  Directory = 'directory',
  Double = 'double',
  Enum = 'enum',
  File = 'file',
  Int = 'int',
  OptionalBool = 'optionalBool',
  OptionalDatetime = 'optionalDatetime',
  OptionalDouble = 'optionalDouble',
  OptionalEnum = 'optionalEnum',
  OptionalInt = 'optionalInt',
  OptionalTimestamp = 'optionalTimestamp',
  Regex = 'regex',
  String = 'string',
  Timestamp = 'timestamp',
  Uri = 'uri'
}

export type IEnrichmentProperty = {
  description?: Maybe<ILangString>;
  enumType?: Maybe<IEnrichmentEnumDescription>;
  id: Scalars['String'];
  name: ILangString;
  type: EnrichmentParamTypeEnum;
  validationRule: ValidationRuleEnum;
};

export type IEnrichmentPropertyInput = {
  description?: InputMaybe<ILangStringInput>;
  enumType?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: ILangStringInput;
  type: EnrichmentParamTypeEnum;
  validationRule: ValidationRuleEnum;
};

export type IEnrichmentQuery = {
  status: IEnrichmentStatus;
};

export enum EnrichmentResultTypeEnum {
  Bool = 'bool',
  Datetime = 'datetime',
  Double = 'double',
  Enum = 'enum',
  Int = 'int',
  Json = 'json',
  String = 'string',
  Timespan = 'timespan',
  Xml = 'xml'
}

export type IEnrichmentStatus = {
  serviceProviders: Array<IEnrichmentDescription>;
};

export type IEssayEditItem = {
  evaluationInfo: ILangString;
  header: ILangString;
  id: Scalars['ID'];
  question: ILangString;
};

export type IEssayEditMutation = {
  upsert: IEssayEditItem;
};


export type IEssayEditMutationUpsertArgs = {
  params: IEssayEditUpsertInput;
};

export type IEssayEditQuery = {
  get: IEssayEditItem;
};


export type IEssayEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IEssayEditUpsertInput = {
  evaluationInfo?: InputMaybe<IUpsertLangStringInput>;
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  subject?: InputMaybe<Scalars['ID']>;
};

export type IEssayGradingItem = {
  attachments: Array<IAttachmentUrlObject>;
  essayText: Scalars['String'];
  evalInfo: ILangString;
  header: ILangString;
  id: Scalars['ID'];
  itemId: Scalars['ID'];
  objectives: Array<IEssayGradingObjective>;
  question: ILangString;
  reason: Scalars['String'];
  sessionId: Scalars['ID'];
};

export type IEssayGradingMutation = {
  setReason: Scalars['Boolean'];
  setScore: Scalars['Boolean'];
  submit: Scalars['Boolean'];
};


export type IEssayGradingMutationSetReasonArgs = {
  itemId: Scalars['ID'];
  reason: Scalars['String'];
  sessionId: Scalars['ID'];
};


export type IEssayGradingMutationSetScoreArgs = {
  itemId: Scalars['ID'];
  objectiveId: Scalars['ID'];
  score: Scalars['Float'];
  sessionId: Scalars['ID'];
};


export type IEssayGradingMutationSubmitArgs = {
  itemId: Scalars['ID'];
  sessionId: Scalars['ID'];
};

export type IEssayGradingObjective = {
  id: Scalars['ID'];
  maxScore: Scalars['Float'];
  objectiveId: Scalars['ID'];
  score: Scalars['Float'];
};

export type IEssayGradingQuery = {
  get: IEssayGradingItem;
};


export type IEssayGradingQueryGetArgs = {
  itemId: Scalars['ID'];
  sessionId: Scalars['ID'];
};

export type IExamOrder = IItemBankDoc & {
  _id: Scalars['String'];
  _rev: Scalars['String'];
  aliases: Array<Scalars['String']>;
  alternations: Array<ITaxonomyItem>;
  attachments: Array<IAttachmentUrlObject>;
  audience?: Maybe<IAudienceDocument>;
  categoryDepth: Scalars['Int'];
  dateCreated: Scalars['String'];
  defineScore: ExaminationOrderDefineScore;
  docReferenceId: Scalars['String'];
  docType: Doctype;
  examDate?: Maybe<Scalars['String']>;
  examTime?: Maybe<Scalars['String']>;
  examinationOrderId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  itemCount: Scalars['Int'];
  itemOrderStrategy: ItemOrderStrategy;
  items: Array<IExamOrderSubjectItem>;
  levelOfSecrecy: LevelOfSecrecy;
  localizations: Array<ILocalization>;
  maxTimeAllowed: Scalars['String'];
  profile?: Maybe<ITestDefinitionProfile>;
  scoreMax: Scalars['Float'];
  scoreRoundingMode: ScoreRoundingModeEnum;
  status: ExaminationOrderStatus;
  strings: Array<IExamOrderString>;
  subject: IExamOrderSubject;
  subjects: Array<IExamOrderSubject>;
  syllabusDepth: Scalars['Int'];
  title: Scalars['String'];
  validToPublish: IValidation;
  validToSendToSubjectCoordinator: IValidation;
};


export type IExamOrderItemsArgs = {
  subjectDocRef?: InputMaybe<Scalars['ID']>;
};


export type IExamOrderSubjectArgs = {
  subjectDocRef: Scalars['ID'];
};

export type IExamOrderMutation = {
  copy: IExamOrder;
  createCTTfromItems: Scalars['Boolean'];
  edit: Scalars['Boolean'];
  finishSubject: Scalars['Boolean'];
  moveItem: IExamOrder;
  new: IExamOrder;
  publish: Scalars['Boolean'];
  sendToSubjectCoordinator: Scalars['Boolean'];
  updateItems: Scalars['Boolean'];
  updateStrings: Scalars['Boolean'];
  upsert: IExamOrder;
};


export type IExamOrderMutationCopyArgs = {
  examOrderDocRef: Scalars['ID'];
};


export type IExamOrderMutationCreateCtTfromItemsArgs = {
  examOrderDocRef: Scalars['ID'];
  subjectDocRef: Scalars['ID'];
};


export type IExamOrderMutationEditArgs = {
  examOrderDocRef: Scalars['ID'];
};


export type IExamOrderMutationFinishSubjectArgs = {
  examOrderDocRef: Scalars['ID'];
  subjectDocRef: Scalars['ID'];
};


export type IExamOrderMutationMoveItemArgs = {
  before: Scalars['ID'];
  examOrderDocRef: Scalars['ID'];
  move: Scalars['ID'];
};


export type IExamOrderMutationPublishArgs = {
  examOrderDocRef: Scalars['ID'];
};


export type IExamOrderMutationSendToSubjectCoordinatorArgs = {
  examOrderDocRef: Scalars['ID'];
};


export type IExamOrderMutationUpdateItemsArgs = {
  examOrderDocRef: Scalars['ID'];
  subjectDocRef: Scalars['ID'];
};


export type IExamOrderMutationUpdateStringsArgs = {
  examOrder: Scalars['ID'];
  strings: Array<IExamOrderUpdateStringsInput>;
};


export type IExamOrderMutationUpsertArgs = {
  params: IUpsertExamOrderInput;
};

export type IExamOrderQuery = {
  byId: IExamOrder;
  list: Array<IExamOrder>;
};


export type IExamOrderQueryByIdArgs = {
  docRef?: InputMaybe<Scalars['String']>;
};


export type IExamOrderQueryListArgs = {
  forTranslation?: InputMaybe<Scalars['Boolean']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type IExamOrderString = {
  id: Scalars['ID'];
  key: Scalars['ID'];
  label: ILangString;
  value: ILangString;
};

export type IExamOrderSubject = {
  dimensionCategories: Array<ICttDimensionEntry>;
  dimensionSyllabus: Array<ICttDimensionEntry>;
  entries: Array<IExamOrderSubjectEntry>;
  id: Scalars['ID'];
  localizations: Array<ILocalization>;
  score: Scalars['Float'];
  sectionTitle: ILangString;
  status: ExamOrderSubjectStatus;
  subject: ISubjectDocument;
  validToFinish: IValidation;
};

export type IExamOrderSubjectEntry = {
  assignedScore: Scalars['Float'];
  categoryId: Scalars['String'];
  id: Scalars['String'];
  items: Array<IItemDocument>;
  objectiveId: Scalars['String'];
  targetScore: Scalars['Float'];
};

export type IExamOrderSubjectItem = {
  chance: Scalars['Float'];
  id: Scalars['ID'];
  index: Scalars['Int'];
  item: IItemDocument;
};

export enum ExamOrderSubjectStatus {
  Finished = 'finished',
  Open = 'open'
}

export type IExamOrderUpdateStringsInput = {
  key: Scalars['ID'];
  value: IUpsertLangStringInput;
};

export enum ExamSessionItemOrder {
  Default = 'Default',
  Exam = 'Exam',
  Session = 'Session'
}

export type IExamSessionMutationInput = {
  sessionDocRefId: Scalars['ID'];
};

export type IExamSessionQueryInput = {
  sessionDocRefId: Scalars['ID'];
};

export type IExamSessionsQueryInput = {
  all?: InputMaybe<Scalars['Boolean']>;
  examAlias?: InputMaybe<Array<Scalars['ID']>>;
  laxExternalId?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  sessionDocRefId?: InputMaybe<Array<Scalars['ID']>>;
  sessionStartTimeMax?: InputMaybe<Scalars['String']>;
  sessionStartTimeMin?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  strictExternalId?: InputMaybe<Array<Scalars['ID']>>;
};

export enum ExamTypeEnum {
  Demo = 'DEMO',
  Matura = 'MATURA',
  Other = 'OTHER'
}

export type IExamination = IItemBankDoc & {
  _id: Scalars['String'];
  _rev: Scalars['String'];
  alternationRestrictions: Array<IAlternationRestriction>;
  attachments: Array<IAttachmentUrlObject>;
  continueWith: ContinueWithEnum;
  dateCreated: Scalars['String'];
  demoUrl?: Maybe<Scalars['String']>;
  docReferenceId: Scalars['String'];
  docType: Doctype;
  examAliases: Array<Scalars['String']>;
  examOrder?: Maybe<IExamOrder>;
  examinationId: Scalars['String'];
  executionPage: IExecutionPage;
  golemScript: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  json: Scalars['String'];
  maxScore: Scalars['Float'];
  obsolete: Scalars['Boolean'];
  passesRestrictions: Scalars['Boolean'];
  pdfReportSettings: IPdfReportSettings;
  resultPage: IResultPage;
  title?: Maybe<Scalars['String']>;
  type: ExaminationTypeEnum;
  welcomePage: IWelcomePage;
};


export type IExaminationPassesRestrictionsArgs = {
  userAgentString: Scalars['String'];
};

export type IExaminationMutations = {
  import: IExamination;
  purgeAdHocExaminations: Scalars['Int'];
  setObsolete: Array<IExamination>;
};


export type IExaminationMutationsImportArgs = {
  file: Scalars['Upload'];
};


export type IExaminationMutationsPurgeAdHocExaminationsArgs = {
  olderThanHours: Scalars['Int'];
};


export type IExaminationMutationsSetObsoleteArgs = {
  docRef: Array<Scalars['String']>;
  obsolete: Scalars['Boolean'];
};

export enum ExaminationOrderDefineScore {
  Any = 'any',
  Subjectcoordinator = 'subjectcoordinator',
  Superuser = 'superuser'
}

export enum ExaminationOrderStatus {
  Open = 'open',
  Populating = 'populating',
  Published = 'published',
  Ready = 'ready'
}

export type IExaminationQueries = {
  all: Array<IExamination>;
  byId: IExamination;
  get: Array<IExamination>;
  getDemoExams: Array<IExamination>;
  resolveAlias: Array<IResolvedExamAlias>;
};


export type IExaminationQueriesByIdArgs = {
  id: Scalars['ID'];
};


export type IExaminationQueriesGetArgs = {
  filter: IGetExaminationFilterInput;
};


export type IExaminationQueriesResolveAliasArgs = {
  examAlias: Array<Scalars['String']>;
};

export enum ExaminationTypeEnum {
  Adhoc = 'adhoc',
  Assessment = 'assessment',
  Certification = 'certification',
  Demo = 'demo',
  Qa = 'qa',
  Selfassessment = 'selfassessment',
  Showcase = 'showcase'
}

export type IExecutionPage = {
  displayProgress: DisplayProgress;
  displayTime: DisplayTime;
  finishButton: IButton;
  immediateResultSeconds: Scalars['Int'];
  immediateResultText: ILangString;
  minHeight: Scalars['Int'];
  minWidth: Scalars['Int'];
  nextButton: IButton;
  overviewButton: IButton;
  postponeButton: IButton;
  previousButton: IButton;
  progressLabel: ILangString;
  resetButton: IButton;
  showImmediateResult: ShowImmediateResult;
  showItemMaxScore: ShowItemMaxScore;
  submitButton: IButton;
  timeLabel: ILangString;
};

export type IFillInGapEditItem = {
  gaps: Array<IFillInGapEdit_Gap>;
  header: ILangString;
  id: Scalars['ID'];
  perGapScore?: Maybe<Scalars['Float']>;
  question: ILangString;
  scoring: FillInGapEdit_Scoring;
  shuffleMode: FillInGapEdit_ShuffleMode;
  text: ILangString;
  values: Array<IFillInGapEdit_Value>;
};

export type IFillInGapEditMutation = {
  addGap: IFillInGapEdit_Gap;
  addValue: IFillInGapEdit_Value;
  removeGap: Scalars['Boolean'];
  removeValue: Scalars['Boolean'];
  upsert?: Maybe<IFillInGapEditItem>;
};


export type IFillInGapEditMutationAddGapArgs = {
  itemId: Scalars['ID'];
};


export type IFillInGapEditMutationAddValueArgs = {
  gapId: Scalars['ID'];
  itemId: Scalars['ID'];
};


export type IFillInGapEditMutationRemoveGapArgs = {
  gapId: Scalars['ID'];
  itemId: Scalars['ID'];
};


export type IFillInGapEditMutationRemoveValueArgs = {
  itemId: Scalars['ID'];
  valueId: Scalars['ID'];
};


export type IFillInGapEditMutationUpsertArgs = {
  params: IFillInGapEditUpsertInput;
};

export type IFillInGapEditQuery = {
  get: IFillInGapEditItem;
};


export type IFillInGapEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IFillInGapEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  perGapScore?: InputMaybe<Scalars['Float']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  scoring?: InputMaybe<FillInGapEdit_Scoring>;
  setGaps?: InputMaybe<Array<IFillInGapEdit_UpsertGap>>;
  setValues?: InputMaybe<Array<IFillInGapEdit_UpsertValue>>;
  shuffleMode?: InputMaybe<FillInGapEdit_ShuffleMode>;
  subject?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<IUpsertLangStringInput>;
  upsertGaps?: InputMaybe<Array<IFillInGapEdit_UpsertGap>>;
  upsertValues?: InputMaybe<Array<IFillInGapEdit_UpsertValue>>;
};

export type IFillInGapEdit_Gap = {
  correct: IFillInGapEdit_Value;
  gapId: Scalars['ID'];
  id: Scalars['ID'];
  possibilities: Array<IFillInGapEdit_Value>;
};

export enum FillInGapEdit_Scoring {
  AllOrNothing = 'AllOrNothing',
  PerGap = 'PerGap'
}

export enum FillInGapEdit_ShuffleMode {
  Ordered = 'Ordered',
  Shuffled = 'Shuffled',
  ShuffledExceptLast = 'ShuffledExceptLast'
}

export type IFillInGapEdit_UpsertGap = {
  correct?: InputMaybe<Scalars['ID']>;
  gapId: Scalars['ID'];
  possibilities?: InputMaybe<Array<Scalars['ID']>>;
};

export type IFillInGapEdit_UpsertValue = {
  value?: InputMaybe<IUpsertLangStringInput>;
  valueId: Scalars['ID'];
};

export type IFillInGapEdit_Value = {
  id: Scalars['ID'];
  value: ILangString;
  valueId: Scalars['ID'];
};

export type IFillInPoolEditItem = {
  gaps: Array<IFillInPoolEdit_Gap>;
  header: ILangString;
  id: Scalars['ID'];
  perGapScore?: Maybe<Scalars['Float']>;
  question: ILangString;
  scoring: FillInPoolEdit_Scoring;
  text: ILangString;
  values: Array<IFillInPoolEdit_Value>;
};

export type IFillInPoolEditMutation = {
  addGap: IFillInPoolEdit_Gap;
  addValue: IFillInPoolEdit_Value;
  removeGap: Scalars['Boolean'];
  removeValue: Scalars['Boolean'];
  upsert?: Maybe<IFillInPoolEditItem>;
};


export type IFillInPoolEditMutationAddGapArgs = {
  itemId: Scalars['ID'];
};


export type IFillInPoolEditMutationAddValueArgs = {
  itemId: Scalars['ID'];
};


export type IFillInPoolEditMutationRemoveGapArgs = {
  gapId: Scalars['ID'];
  itemId: Scalars['ID'];
};


export type IFillInPoolEditMutationRemoveValueArgs = {
  itemId: Scalars['ID'];
  valueId: Scalars['ID'];
};


export type IFillInPoolEditMutationUpsertArgs = {
  params: IFillInPoolEditUpsertInput;
};

export type IFillInPoolEditQuery = {
  get: IFillInPoolEditItem;
};


export type IFillInPoolEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IFillInPoolEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  perGapScore?: InputMaybe<Scalars['Float']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  scoring?: InputMaybe<FillInPoolEdit_Scoring>;
  setGaps?: InputMaybe<Array<IFillInPoolEdit_UpsertGap>>;
  setValues?: InputMaybe<Array<IFillInPoolEdit_UpsertValue>>;
  subject?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<IUpsertLangStringInput>;
  upsertGaps?: InputMaybe<Array<IFillInPoolEdit_UpsertGap>>;
  upsertValues?: InputMaybe<Array<IFillInPoolEdit_UpsertValue>>;
};

export type IFillInPoolEdit_Gap = {
  correct: IFillInPoolEdit_Value;
  gapId: Scalars['ID'];
  id: Scalars['ID'];
};

export enum FillInPoolEdit_Scoring {
  AllOrNothing = 'AllOrNothing',
  PerGap = 'PerGap'
}

export type IFillInPoolEdit_UpsertGap = {
  correct?: InputMaybe<Scalars['ID']>;
  gapId: Scalars['ID'];
  possibilities?: InputMaybe<Array<Scalars['ID']>>;
};

export type IFillInPoolEdit_UpsertValue = {
  value?: InputMaybe<IUpsertLangStringInput>;
  valueId: Scalars['ID'];
};

export type IFillInPoolEdit_Value = {
  gap?: Maybe<IFillInPoolEdit_Gap>;
  id: Scalars['ID'];
  value: ILangString;
  valueId: Scalars['ID'];
};

export type IFormulaFieldValueInput = {
  id: Scalars['String'];
  serializedValue: Scalars['String'];
};

export type IGetAllAudiencesInput = {
  filter?: InputMaybe<IAudienceFilterOptions>;
};

export type IGetAllGolemScriptsInput = {
  filter?: InputMaybe<IGolemScriptFilterOptions>;
};

export type IGetAttachmentUrlInput = {
  attachmentName: Scalars['String'];
  itemDocRefId: Scalars['String'];
};

export type IGetAudiencesInput = {
  audienceDocRefIds: Array<Scalars['String']>;
  filter?: InputMaybe<IAudienceFilterOptions>;
};

export type IGetBySubjectInput = {
  filter?: InputMaybe<IItemFilterOptions>;
  subjectDocRefIds: Array<Scalars['String']>;
};

export type IGetDonkeyFilter = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type IGetExaminationFilterInput = {
  alias?: InputMaybe<Array<Scalars['String']>>;
  docRef?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['String']>>;
  includeObsolete?: InputMaybe<Scalars['Boolean']>;
};

export type IGetGolemScriptsInput = {
  filter?: InputMaybe<IGolemScriptFilterOptions>;
  golemScriptDocRefIds: Array<Scalars['String']>;
};

export type IGetItemTranslationsInput = {
  examOrderDocRefIds?: InputMaybe<Array<Scalars['String']>>;
  isoCodes: Array<Scalars['String']>;
  itemDocRefIds?: InputMaybe<Array<Scalars['String']>>;
  subjectDocRefId: Scalars['String'];
};

export type IGetTestDefinitionProfileFilterInput = {
  id?: InputMaybe<Array<Scalars['String']>>;
};

export type IGolemScriptDocument = IItemBankDoc & {
  _id: Scalars['String'];
  _rev: Scalars['String'];
  attachments: Array<IAttachmentUrlObject>;
  docReferenceId: Scalars['String'];
  docType: Doctype;
  golemScriptId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  scriptJson: Scalars['String'];
  scriptYaml: Scalars['String'];
  title: Scalars['String'];
};

export type IGolemScriptFilterOptions = {
  showDeleted?: InputMaybe<TriStateEnum>;
};

export type IGolemScriptMutation = {
  new: IGolemScriptDocument;
  upsert: IGolemScriptDocument;
};


export type IGolemScriptMutationUpsertArgs = {
  params: IUpsertGolemScriptInput;
};

export type IGolemScriptQuery = {
  all: Array<IGolemScriptDocument>;
  byId: IGolemScriptDocument;
  get: Array<IGolemScriptDocument>;
};


export type IGolemScriptQueryAllArgs = {
  params?: InputMaybe<IGetAllGolemScriptsInput>;
};


export type IGolemScriptQueryByIdArgs = {
  docRef: Scalars['ID'];
};


export type IGolemScriptQueryGetArgs = {
  params: IGetGolemScriptsInput;
};

export type IGrade = {
  condition: Scalars['String'];
  id: Scalars['ID'];
  letter: Scalars['String'];
  passed: Scalars['Boolean'];
  text: ILangString;
};

export enum GradingMode {
  Atonce = 'ATONCE',
  Later = 'LATER',
  Manual = 'MANUAL',
  None = 'NONE'
}

export enum GradingModeEnum {
  Atonce = 'ATONCE',
  Later = 'LATER',
  Manual = 'MANUAL',
  None = 'NONE'
}

export type IHandsOnEditItem = {
  evaluationInfo: ILangString;
  evaluations: Array<IHandsOnEdit_Evaluation>;
  filestructure: Array<IHandsOnEdit_FileStructureEntry>;
  header: ILangString;
  id: Scalars['ID'];
  investigators: Array<IHandsOnEdit_Investigator>;
  preparators: Array<IHandsOnEdit_Preparator>;
  question: ILangString;
};

export type IHandsOnEditMutation = {
  upsert: IHandsOnEditItem;
  validateFormula: IValidateFormulaResult;
  validateFormulas: Array<IValidateFormulaResult>;
};


export type IHandsOnEditMutationUpsertArgs = {
  params: IHandsOnEditUpsertInput;
};


export type IHandsOnEditMutationValidateFormulaArgs = {
  fields: Array<IFormulaFieldValueInput>;
  formula: Scalars['String'];
};


export type IHandsOnEditMutationValidateFormulasArgs = {
  fields: Array<IFormulaFieldValueInput>;
  formulas: Array<Scalars['String']>;
};

export type IHandsOnEditQuery = {
  get: IHandsOnEditItem;
};


export type IHandsOnEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IHandsOnEditQuery_TemporaryResults_Result = {
  id: Scalars['ID'];
  serializedValue?: Maybe<Scalars['String']>;
  status: HandsOnEditQuery_TemporaryResults_ResultStatusEnum;
};

export enum HandsOnEditQuery_TemporaryResults_ResultStatusEnum {
  Available = 'available',
  Pending = 'pending',
  Running = 'running',
  Unscheduled = 'unscheduled'
}

export type IHandsOnEditUpsertInput = {
  evaluationInfo?: InputMaybe<IUpsertLangStringInput>;
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removeEvaluations?: InputMaybe<Array<Scalars['ID']>>;
  removeFiles?: InputMaybe<Array<Scalars['ID']>>;
  removeInvestigators?: InputMaybe<Array<Scalars['ID']>>;
  removePreparators?: InputMaybe<Array<Scalars['ID']>>;
  setEvaluations?: InputMaybe<Array<IHandsOnEdit_UpsertEvaluationInput>>;
  setFiles?: InputMaybe<Array<IHandsOnEdit_UpsertFileStructureEntryInput>>;
  setInvestigators?: InputMaybe<Array<IHandsOnEdit_UpsertInvestigatorInput>>;
  setPreparators?: InputMaybe<Array<IHandsOnEdit_UpsertPreparatorInput>>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertEvaluations?: InputMaybe<Array<IHandsOnEdit_UpsertEvaluationInput>>;
  upsertFiles?: InputMaybe<Array<IHandsOnEdit_UpsertFileStructureEntryInput>>;
  upsertInvestigators?: InputMaybe<Array<IHandsOnEdit_UpsertInvestigatorInput>>;
  upsertPreparators?: InputMaybe<Array<IHandsOnEdit_UpsertPreparatorInput>>;
};

export type IHandsOnEdit_Evaluation = {
  evaluationId: Scalars['String'];
  formula: Scalars['String'];
  id: Scalars['ID'];
  score: Scalars['Float'];
  valid: Scalars['Boolean'];
  validationMessage?: Maybe<ILangString>;
};

export type IHandsOnEdit_FileStructureEntry = {
  fileId: Scalars['String'];
  id: Scalars['ID'];
  path: Scalars['String'];
  resourceItem?: Maybe<Scalars['String']>;
  resourceName?: Maybe<Scalars['String']>;
  userCreated: Scalars['Boolean'];
  valid: Scalars['Boolean'];
  validationMessage?: Maybe<ILangString>;
};

export type IHandsOnEdit_Investigator = {
  id: Scalars['ID'];
  info?: Maybe<IInvestigatorDescription>;
  investigatorId: Scalars['String'];
  investigatorUri: Scalars['String'];
  properties: Array<IHandsOnEdit_Property>;
  serviceProviderId: Scalars['String'];
  temporaryResult?: Maybe<IHandsOnEditQuery_TemporaryResults_Result>;
  valid: Scalars['Boolean'];
  validationMessage?: Maybe<ILangString>;
};

export type IHandsOnEdit_Preparator = {
  id: Scalars['ID'];
  info?: Maybe<IPreparatorDescription>;
  preparatorId: Scalars['ID'];
  preparatorUri: Scalars['ID'];
  properties: Array<IHandsOnEdit_Property>;
  serviceProviderId: Scalars['ID'];
  valid: Scalars['Boolean'];
  validationMessage?: Maybe<ILangString>;
};

export type IHandsOnEdit_Property = {
  id: Scalars['ID'];
  info?: Maybe<IEnrichmentProperty>;
  propertyId: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type IHandsOnEdit_PropertyInput = {
  propertyId: Scalars['String'];
  value: Scalars['String'];
};

export type IHandsOnEdit_UpsertEvaluationInput = {
  evaluationId: Scalars['String'];
  formula?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['Float']>;
};

export type IHandsOnEdit_UpsertFileStructureEntryInput = {
  fileId: Scalars['String'];
  path?: InputMaybe<Scalars['String']>;
  resourceItem?: InputMaybe<Scalars['String']>;
  resourceName?: InputMaybe<Scalars['String']>;
  userCreated?: InputMaybe<Scalars['Boolean']>;
};

export type IHandsOnEdit_UpsertInvestigatorInput = {
  investigatorId: Scalars['String'];
  investigatorUri: Scalars['String'];
  removeProperties?: InputMaybe<Array<Scalars['ID']>>;
  serviceProviderId: Scalars['String'];
  setProperties?: InputMaybe<Array<IHandsOnEdit_PropertyInput>>;
  upsertProperties?: InputMaybe<Array<IHandsOnEdit_PropertyInput>>;
};

export type IHandsOnEdit_UpsertPreparatorInput = {
  preparatorId: Scalars['ID'];
  preparatorUri: Scalars['ID'];
  removeProperties?: InputMaybe<Array<Scalars['ID']>>;
  serviceProviderId: Scalars['ID'];
  setProperties?: InputMaybe<Array<IHandsOnEdit_PropertyInput>>;
  upsertProperties?: InputMaybe<Array<IHandsOnEdit_PropertyInput>>;
};

export enum HandsOn_CollectMode {
  Always = 'ALWAYS',
  Never = 'NEVER'
}

export enum HandsOn_EnrichmentParamTypeEnum {
  ResultDataFileIdConverter = 'ResultDataFileIDConverter',
  TaskResourceDirectoryIdConverter = 'TaskResourceDirectoryIDConverter',
  TaskResourceFileIdConverter = 'TaskResourceFileIDConverter',
  Attachment = 'attachment',
  Bool = 'bool',
  Datetime = 'datetime',
  Directory = 'directory',
  Double = 'double',
  Enum = 'enum',
  File = 'file',
  Int = 'int',
  OptionalBool = 'optionalBool',
  OptionalDatetime = 'optionalDatetime',
  OptionalDouble = 'optionalDouble',
  OptionalEnum = 'optionalEnum',
  OptionalInt = 'optionalInt',
  OptionalTimestamp = 'optionalTimestamp',
  Regex = 'regex',
  String = 'string',
  Timestamp = 'timestamp',
  Uri = 'uri'
}

export type IHandsOn_FileStructureEntry = {
  fileId: Scalars['String'];
  id: Scalars['ID'];
  path: Scalars['String'];
  resource?: Maybe<IAttachmentUrlObject>;
  userCreated: Scalars['Boolean'];
};

export type IHandsOn_Investigator = {
  id: Scalars['ID'];
  info: IInvestigatorDescription;
  investigatorId: Scalars['String'];
  investigatorUri: Scalars['String'];
  properties: Array<IHandsOn_Property>;
  serviceProviderId: Scalars['String'];
};

export type IHandsOn_Preparator = {
  id: Scalars['ID'];
  preparatorId: Scalars['ID'];
  preparatorUri: Scalars['ID'];
  properties: Array<IHandsOn_Property>;
  serviceProviderId: Scalars['ID'];
};

export type IHandsOn_Property = {
  enumType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  propertyId: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type IHandsOn_QueryItemSessionData = IQueryItemSessionData & {
  header: ILangString;
  id: Scalars['ID'];
  investigatorResults: Array<IHandsOn_Result>;
  isDone: Scalars['Boolean'];
  question: ILangString;
};

export type IHandsOn_Result = {
  id: Scalars['ID'];
  investigatorId: Scalars['ID'];
  serializedValue: Scalars['String'];
};

export type IHandsOn_ResultInput = {
  investigatorId: Scalars['ID'];
  serializedValue: Scalars['String'];
};

export type IHandsOn_TopItemData = {
  files: Array<IHandsOn_FileStructureEntry>;
  id: Scalars['ID'];
  investigators: Array<IHandsOn_Investigator>;
  itemNr: Scalars['Int'];
  preparators: Array<IHandsOn_Preparator>;
  topItemId: Scalars['ID'];
};

export type IIItemType = {
  description: ILangString;
  enabled: Scalars['Boolean'];
  gradingMode: GradingMode;
  id: Scalars['String'];
  ordernr: Scalars['Int'];
  supportsObjectives: Scalars['Boolean'];
  supportsSubItems: Scalars['Boolean'];
  supportsTranslations: Scalars['Boolean'];
  title: ILangString;
  uuid: Scalars['String'];
};

export type IIScore = {
  pointsGained?: Maybe<Scalars['Float']>;
  pointsLost?: Maybe<Scalars['Float']>;
  pointsMax?: Maybe<Scalars['Float']>;
  pointsPending?: Maybe<Scalars['Float']>;
};

export type IItsr3ClientMutation = {
  cache: Scalars['Boolean'];
  cleanup: Scalars['Boolean'];
  init: IClient_InitResult;
  investigate: Array<IClient_InvestigateResult>;
  reset: Scalars['Boolean'];
  setup: Scalars['Boolean'];
};


export type IItsr3ClientMutationCacheArgs = {
  data: IClient_TopItemDataInput;
};


export type IItsr3ClientMutationCleanupArgs = {
  data: IClient_TopItemDataInput;
};


export type IItsr3ClientMutationInitArgs = {
  data: IClient_InitInput;
};


export type IItsr3ClientMutationInvestigateArgs = {
  data: IClient_TopItemDataInput;
};


export type IItsr3ClientMutationResetArgs = {
  data: IClient_TopItemDataInput;
};


export type IItsr3ClientMutationSetupArgs = {
  data: IClient_TopItemDataInput;
};

export type IImageMetadata = {
  height: Scalars['Int'];
  id: Scalars['ID'];
  width: Scalars['Int'];
};

export type IInApplicationComboEditItem = {
  filestructure: Array<IHandsOnEdit_FileStructureEntry>;
  header: ILangString;
  id: Scalars['ID'];
  instruction: ILangString;
  preparators: Array<IHandsOnEdit_Preparator>;
};

export type IInApplicationComboEditMutation = {
  convert: Scalars['String'];
  upsert?: Maybe<IInApplicationComboEditItem>;
};


export type IInApplicationComboEditMutationConvertArgs = {
  itemIds: Array<Scalars['ID']>;
};


export type IInApplicationComboEditMutationUpsertArgs = {
  params: IInApplicationComboEditUpsertInput;
};

export type IInApplicationComboEditQuery = {
  get: IInApplicationComboEditItem;
};


export type IInApplicationComboEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IInApplicationComboEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  instruction?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  removeFiles?: InputMaybe<Array<Scalars['ID']>>;
  removePreparators?: InputMaybe<Array<Scalars['ID']>>;
  setFiles?: InputMaybe<Array<IHandsOnEdit_UpsertFileStructureEntryInput>>;
  setPreparators?: InputMaybe<Array<IHandsOnEdit_UpsertPreparatorInput>>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertFiles?: InputMaybe<Array<IHandsOnEdit_UpsertFileStructureEntryInput>>;
  upsertPreparators?: InputMaybe<Array<IHandsOnEdit_UpsertPreparatorInput>>;
};

export type IInApplicationCombo_QueryItemSessionData = IQueryItemSessionData & {
  header: ILangString;
  id: Scalars['ID'];
  instruction: ILangString;
  selectedSubItem?: Maybe<Scalars['String']>;
  subItems: Array<IInApplicationCombo_SubItem>;
};

export type IInApplicationCombo_SubItem = {
  id: Scalars['ID'];
  itemDocRefId: Scalars['String'];
  itemType: Scalars['String'];
  status: InApplicationCombo_SubItem_StatusEnum;
};

export enum InApplicationCombo_SubItem_StatusEnum {
  Done = 'Done',
  NotYetStarted = 'NotYetStarted',
  Started = 'Started'
}

export type IInstructionEditItem = {
  header: ILangString;
  id: Scalars['ID'];
  instruction: ILangString;
};

export type IInstructionEditMutation = {
  upsert?: Maybe<IInstructionEditItem>;
};


export type IInstructionEditMutationUpsertArgs = {
  params: IInstructionEditUpsertInput;
};

export type IInstructionEditQuery = {
  get: IInstructionEditItem;
};


export type IInstructionEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IInstructionEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  instruction?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  subject?: InputMaybe<Scalars['ID']>;
};

export type IInstruction_QueryItemSessionData = IQueryItemSessionData & {
  done: Scalars['Boolean'];
  header: ILangString;
  id: Scalars['ID'];
  instruction: ILangString;
};

export type IInvestigatorDescription = {
  description: ILangString;
  id: Scalars['String'];
  investigatorType: InvestigatorTypeEnum;
  name: ILangString;
  obsolete: Scalars['Boolean'];
  properties: Array<IEnrichmentProperty>;
  resultEnumType?: Maybe<IEnrichmentEnumDescription>;
  resultIsArray: Scalars['Boolean'];
  resultType: EnrichmentResultTypeEnum;
};

export type IInvestigatorDescriptionInput = {
  description?: InputMaybe<ILangStringInput>;
  id: Scalars['String'];
  investigatorType: InvestigatorTypeEnum;
  name: ILangStringInput;
  obsolete?: InputMaybe<Scalars['Boolean']>;
  properties?: InputMaybe<Array<IEnrichmentPropertyInput>>;
  resultEnumType?: InputMaybe<Scalars['String']>;
  resultIsArray?: InputMaybe<Scalars['Boolean']>;
  resultType: EnrichmentResultTypeEnum;
};

export enum InvestigatorTypeEnum {
  Cold = 'cold',
  Hot = 'hot',
  Lukewarm = 'lukewarm'
}

export type IInvisibleHotSpotEditItem = {
  answers: Array<IInvisibleHotSpotEdit_Answer>;
  header: ILangString;
  id: Scalars['ID'];
  image?: Maybe<IAttachmentUrlObject>;
  imageHeight: Scalars['Int'];
  imageWidth: Scalars['Int'];
  markerHeight: Scalars['Float'];
  markerRadius: Scalars['Float'];
  markerWidth: Scalars['Float'];
  maxAnswers: Scalars['Int'];
  minAnswers: Scalars['Int'];
  perAnswerScore: Scalars['Float'];
  question: ILangString;
  scoringMode: InvisibleHotSpotEdit_Scoring;
};

export type IInvisibleHotSpotEditMutation = {
  upsert: IInvisibleHotSpotEditItem;
};


export type IInvisibleHotSpotEditMutationUpsertArgs = {
  params: IInvisibleHotSpotEditUpsertInput;
};

export type IInvisibleHotSpotEditQuery = {
  get: IInvisibleHotSpotEditItem;
};


export type IInvisibleHotSpotEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IInvisibleHotSpotEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  image?: InputMaybe<Scalars['String']>;
  imageHeight?: InputMaybe<Scalars['Int']>;
  imageWidth?: InputMaybe<Scalars['Int']>;
  itemId: Scalars['ID'];
  markerHeight?: InputMaybe<Scalars['Float']>;
  markerRadius?: InputMaybe<Scalars['Float']>;
  markerWidth?: InputMaybe<Scalars['Float']>;
  maxAnswers?: InputMaybe<Scalars['Int']>;
  minAnswers?: InputMaybe<Scalars['Int']>;
  parentItemId?: InputMaybe<Scalars['ID']>;
  perAnswerScore?: InputMaybe<Scalars['Float']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removeAnswers?: InputMaybe<Array<Scalars['ID']>>;
  scoringMode?: InputMaybe<InvisibleHotSpotEdit_Scoring>;
  setAnswers?: InputMaybe<Array<IInvisibleHotSpotEdit_UpsertAnswer>>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertAnswers?: InputMaybe<Array<IInvisibleHotSpotEdit_UpsertAnswer>>;
};

export type IInvisibleHotSpotEdit_Answer = {
  circles: Array<IInvisibleHotSpotEdit_AreaCircle>;
  id: Scalars['ID'];
  index: Scalars['ID'];
  rects: Array<IInvisibleHotSpotEdit_AreaRect>;
};

export type IInvisibleHotSpotEdit_AreaCircle = {
  id: Scalars['ID'];
  index: Scalars['ID'];
  radius: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type IInvisibleHotSpotEdit_AreaRect = {
  height: Scalars['Float'];
  id: Scalars['ID'];
  index: Scalars['ID'];
  left: Scalars['Float'];
  top: Scalars['Float'];
  width: Scalars['Float'];
};

export enum InvisibleHotSpotEdit_Scoring {
  AllOrNothing = 'AllOrNothing',
  PerAnswer = 'PerAnswer'
}

export type IInvisibleHotSpotEdit_UpsertAnswer = {
  index: Scalars['ID'];
  removeCircles?: InputMaybe<Array<Scalars['ID']>>;
  removeRects?: InputMaybe<Array<Scalars['ID']>>;
  setCircles?: InputMaybe<Array<IInvisibleHotSpotEdit_UpsertAreaCircle>>;
  setRects?: InputMaybe<Array<IInvisibleHotSpotEdit_UpsertAreaRect>>;
  upsertCircles?: InputMaybe<Array<IInvisibleHotSpotEdit_UpsertAreaCircle>>;
  upsertRects?: InputMaybe<Array<IInvisibleHotSpotEdit_UpsertAreaRect>>;
};

export type IInvisibleHotSpotEdit_UpsertAreaCircle = {
  index: Scalars['ID'];
  radius?: InputMaybe<Scalars['Float']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type IInvisibleHotSpotEdit_UpsertAreaRect = {
  height?: InputMaybe<Scalars['Float']>;
  index: Scalars['ID'];
  left?: InputMaybe<Scalars['Float']>;
  top?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export enum InvisibleHotSpot_CorrectState {
  Correct = 'correct',
  Duplicate = 'duplicate',
  Incorrect = 'incorrect'
}

export type IInvisibleHotSpot_QueryItemSessionData = IQueryItemSessionData & {
  givenAnswers: Array<IInvisibleHotSpot_QueryItemSessionData_Answer>;
  header: ILangString;
  id: Scalars['ID'];
  image: IAttachmentUrlObject;
  imageHeight: Scalars['Int'];
  imageWidth: Scalars['Int'];
  markerRadius: Scalars['Float'];
  maxAnswers: Scalars['Int'];
  minAnswers: Scalars['Int'];
  question: ILangString;
  scoringMode: InvisibleHotSpotEdit_Scoring;
  zones?: Maybe<Array<IInvisibleHotSpot_QueryItemSessionData_Rect>>;
};

export type IInvisibleHotSpot_QueryItemSessionData_Answer = {
  correct?: Maybe<InvisibleHotSpot_CorrectState>;
  id: Scalars['ID'];
  index: Scalars['ID'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type IInvisibleHotSpot_QueryItemSessionData_Rect = {
  group: Scalars['ID'];
  height: Scalars['Float'];
  id: Scalars['ID'];
  left: Scalars['Float'];
  top: Scalars['Float'];
  width: Scalars['Float'];
};

export type IItemActionResult = {
  message: ILangString;
  ok: Scalars['Boolean'];
};

export type IItemActionSource = {
  itemDocRefId: Scalars['String'];
};

export type IItemActionTarget = {
  itemDocRefId?: Maybe<Scalars['String']>;
  subjectDocRefId?: Maybe<Scalars['String']>;
};

export type IItemBankDoc = {
  _id: Scalars['String'];
  _rev: Scalars['String'];
  attachments: Array<IAttachmentUrlObject>;
  docReferenceId: Scalars['String'];
  docType: Doctype;
  isDeleted: Scalars['Boolean'];
};

export type IItemDocument = IItemBankDoc & {
  _id: Scalars['String'];
  _rev: Scalars['String'];
  accumulatedCategories: Array<ITaxonomyItem>;
  accumulatedObjectives: Array<ITaxonomyItem>;
  accumulatedScoreMax: Scalars['Float'];
  attachments: Array<IAttachmentUrlObject>;
  basicValidationMessage?: Maybe<ILangString>;
  childItems: Array<IChildItem>;
  descendantItems: Array<IItemDocument>;
  docReferenceId: Scalars['String'];
  docType: Doctype;
  fullValidationMessage?: Maybe<ILangString>;
  isDeleted: Scalars['Boolean'];
  isTopItem: Scalars['Boolean'];
  itemId: Scalars['ID'];
  itemType: IIItemType;
  keywords: Array<Scalars['String']>;
  metaData: IItemMetaData;
  parentItemId: Array<Scalars['String']>;
  scoreMax: Scalars['Float'];
  subject: ISubjectDocument;
  topItem: IItemDocument;
  visibleText: Scalars['String'];
  workflow: IItemWorkflow;
};


export type IItemDocumentKeywordsArgs = {
  includeChildItems?: InputMaybe<Scalars['Boolean']>;
};


export type IItemDocumentVisibleTextArgs = {
  includeChildItems?: InputMaybe<Scalars['Boolean']>;
  includeSolutionHints?: InputMaybe<Scalars['Boolean']>;
};

export enum ItemEditVisibility {
  AllAuthors = 'allAuthors',
  AssignedAuthors = 'assignedAuthors'
}

export type IItemFilterOptions = {
  authoringStatus?: InputMaybe<AuthoringStatusEnum>;
  obsolete?: InputMaybe<TriStateEnum>;
  showDeleted?: InputMaybe<TriStateEnum>;
  supportsSubItems?: InputMaybe<TriStateEnum>;
  topItemDocRefs?: InputMaybe<Array<Scalars['ID']>>;
  topItems?: InputMaybe<TriStateEnum>;
};

export type IItemForBulkGrading = {
  evaluatorHint: ILangString;
  id: Scalars['ID'];
  item: IItemDocument;
  sessionsForItemCount: Scalars['Int'];
  subject: ISubjectDocument;
};

export type IItemForManualGrading = {
  id: Scalars['ID'];
  item: IItemDocument;
  sessions: Array<Scalars['ID']>;
  sessionsForItemCount: Scalars['Int'];
  subject: ISubjectDocument;
};


export type IItemForManualGradingSessionsArgs = {
  pick: Scalars['Int'];
};

export type IItemGradingData = {
  id: Scalars['ID'];
  itemId: Scalars['ID'];
  sessionId: Scalars['ID'];
  submitted: Scalars['Boolean'];
};

export enum ItemHostEnum {
  Hierarchical = 'hierarchical',
  Singleitem = 'singleitem'
}

export type IItemMetaData = {
  alternations: Array<ITaxonomyItem>;
  audience: Array<IAudienceDocument>;
  category: ITaxonomyItem;
  containedItems: Array<IContainedReferencedItem>;
  copyFrom?: Maybe<IItemDocument>;
  /** @deprecated Field no longer supported */
  defaultLanguage: Scalars['String'];
  defaultLocalization?: Maybe<ILocalization>;
  gradingMode: GradingMode;
  isSubItem: Scalars['Boolean'];
  itemDifficultyIndex: Scalars['String'];
  minHeight: Scalars['Int'];
  minWidth: Scalars['Int'];
  objectives: Array<IItemObjective>;
  publicTitle: ILangString;
  referencedItems: Array<IContainedReferencedItem>;
  revisionFrom?: Maybe<IItemDocument>;
  subject: ISubjectDocument;
  successorItem?: Maybe<IItemDocument>;
  title: Scalars['String'];
};

export type IItemMutation = {
  assignAuthor: Scalars['Boolean'];
  copyItem: ICopyItem;
  deleteItem: IItemActionResult;
  newItem: IItemDocument;
  reopenItem: Scalars['Boolean'];
  reviseItem: ICopyReviseItemActionResult;
  setToDone: IItemActionResult;
  updateMetaData: IItemActionResult;
  updateWorklowData: Scalars['Boolean'];
  validate: IItemActionResult;
};


export type IItemMutationAssignAuthorArgs = {
  author: Scalars['ID'];
  itemId: Scalars['ID'];
  noteForAuthor?: InputMaybe<Scalars['String']>;
};


export type IItemMutationCopyItemArgs = {
  item: ICopyItemInput;
};


export type IItemMutationDeleteItemArgs = {
  itemId: Scalars['ID'];
};


export type IItemMutationNewItemArgs = {
  params: INewItemInput;
};


export type IItemMutationReopenItemArgs = {
  itemId: Scalars['ID'];
};


export type IItemMutationReviseItemArgs = {
  item: IReviseItemInput;
};


export type IItemMutationSetToDoneArgs = {
  itemId: Scalars['ID'];
};


export type IItemMutationUpdateMetaDataArgs = {
  keepWorkflowStatus?: InputMaybe<Scalars['Boolean']>;
  params: IUpdateItemMetaDataInput;
};


export type IItemMutationUpdateWorklowDataArgs = {
  params: IUpdateWorkflowDataInput;
};


export type IItemMutationValidateArgs = {
  itemId: Scalars['ID'];
};

export enum ItemNavigationStatus {
  Attempting = 'ATTEMPTING',
  Notattempted = 'NOTATTEMPTED',
  Postponed = 'POSTPONED',
  Revisable = 'REVISABLE',
  Submitted = 'SUBMITTED'
}

export type IItemObjective = {
  id: Scalars['ID'];
  objectiveId: Scalars['String'];
  scoreMax: Scalars['Float'];
  taxonomy: ITaxonomyItem;
};

export enum ItemOrderStrategy {
  Default = 'default',
  Fixed = 'fixed',
  Randomized = 'randomized',
  RandomizedHeavyFirst = 'randomizedHeavyFirst',
  RandomizedLightFirst = 'randomizedLightFirst'
}

export type IItemQuery = {
  get: IItemDocument;
  getAttachmentUrl?: Maybe<IAttachmentUrlObject>;
  getFileStructure: Array<ITopItemFileStructureEntry>;
};


export type IItemQueryGetArgs = {
  itemId: Scalars['String'];
};


export type IItemQueryGetAttachmentUrlArgs = {
  params: IGetAttachmentUrlInput;
};


export type IItemQueryGetFileStructureArgs = {
  topItemId: Scalars['ID'];
};

export type IItemTranslationEntry = {
  defaultLanguage: Scalars['String'];
  itemDocRefId: Scalars['String'];
  translations: Array<IItemTranslationObject>;
};

export type IItemTranslationInput = {
  id?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type IItemTranslationObject = {
  id: Scalars['String'];
  key: Scalars['String'];
  value: Scalars['String'];
};

export type IItemTranslationStatus = {
  currentTranslator?: Maybe<IUserDocument>;
  id: Scalars['ID'];
  localization: ILocalization;
  status: TranslationStatusEnum;
  translateableByYou: Scalars['Boolean'];
};

export type IItemTranslations = {
  caption: ILangString;
  entries: Array<IItemTranslationEntry>;
  isoCode: Scalars['String'];
};

export type IItemType = IIItemType & {
  description: ILangString;
  enabled: Scalars['Boolean'];
  gradingMode: GradingMode;
  id: Scalars['String'];
  ordernr: Scalars['Int'];
  supportsObjectives: Scalars['Boolean'];
  supportsSubItems: Scalars['Boolean'];
  supportsTranslations: Scalars['Boolean'];
  title: ILangString;
  uuid: Scalars['String'];
};

export type IItemTypeKosovoContainerQuery = IIItemType & {
  description: ILangString;
  enabled: Scalars['Boolean'];
  gradingMode: GradingMode;
  id: Scalars['String'];
  ordernr: Scalars['Int'];
  supportsAttachments: Scalars['Boolean'];
  supportsAudio: Scalars['Boolean'];
  supportsFileStructure: Scalars['Boolean'];
  supportsImage: Scalars['Boolean'];
  supportsObjectives: Scalars['Boolean'];
  supportsSubItems: Scalars['Boolean'];
  supportsText: Scalars['Boolean'];
  supportsTranslations: Scalars['Boolean'];
  supportsVideo: Scalars['Boolean'];
  title: ILangString;
  uuid: Scalars['String'];
};

export type IItemTypeKosovoQuery = {
  container: IItemTypeKosovoContainerQuery;
  dummy?: Maybe<Scalars['Boolean']>;
};

export type IItemTypeMutation = {
  disable: Array<IIItemType>;
  enable: Array<IIItemType>;
};


export type IItemTypeMutationDisableArgs = {
  itemTypes: Array<Scalars['ID']>;
};


export type IItemTypeMutationEnableArgs = {
  itemTypes: Array<Scalars['ID']>;
};

export type IItemTypeQuery = {
  dummy?: Maybe<Scalars['Boolean']>;
  kosovo?: Maybe<IItemTypeKosovoQuery>;
};

export type IItemWorkflow = {
  authoringStatus: AuthoringStatusEnum;
  currentAuthor?: Maybe<IUserDocument>;
  deleteAllowed: Scalars['Boolean'];
  editAllowed: Scalars['Boolean'];
  editableByYou: Scalars['Boolean'];
  isHiddenForAuthor?: Maybe<Scalars['Boolean']>;
  isHiddenForSubjectCoordinator?: Maybe<Scalars['Boolean']>;
  itemOrderId?: Maybe<Scalars['String']>;
  locked: Scalars['Boolean'];
  noteForAuthor: Scalars['String'];
  obsolete: Scalars['Boolean'];
  provisioned: Array<IExamOrder>;
  published: Array<IExamOrder>;
  setToDoneAllowed: Scalars['Boolean'];
  translateableByYou: Scalars['Boolean'];
  translationStatus: Array<IItemTranslationStatus>;
  version: Scalars['Int'];
};

export type IKeyValueInput = {
  key: Scalars['ID'];
  value: Scalars['String'];
};

export type IKosovoChoiceText_QueryItemSessionData = IQueryItemSessionData & {
  gaps: Array<IKosovoChoiceText_QueryItemSessionData_Gap>;
  header: ILangString;
  id: Scalars['ID'];
  question: ILangString;
  text: ILangString;
};

export type IKosovoChoiceText_QueryItemSessionData_Gap = {
  correctValue?: Maybe<Scalars['String']>;
  gapId: Scalars['ID'];
  id: Scalars['ID'];
  selectedValue?: Maybe<Scalars['String']>;
  values: Array<IKosovoChoiceText_QueryItemSessionData_Value>;
};

export type IKosovoChoiceText_QueryItemSessionData_Value = {
  id: Scalars['ID'];
  value: ILangString;
};

export type IKosovoContainer_MultiMedia = {
  attachments?: Maybe<Array<IAttachmentUrlObject>>;
  audio?: Maybe<IAttachmentUrlObject>;
  id: Scalars['ID'];
  image?: Maybe<IAttachmentUrlObject>;
  onlineVideoLink?: Maybe<Scalars['String']>;
  text?: Maybe<ILangString>;
  textFormat: KosovoContainer_TextBlockFormat;
  video?: Maybe<IAttachmentUrlObject>;
};

export type IKosovoContainer_QueryItemSessionData = IQueryItemSessionData & {
  hasResultFiles: Scalars['Boolean'];
  header: ILangString;
  id: Scalars['ID'];
  image?: Maybe<IAttachmentUrlObject>;
  instruction: ILangString;
  multiMedia?: Maybe<IKosovoContainer_MultiMedia>;
  selectedSubItem?: Maybe<Scalars['String']>;
  subItems: Array<IKosovoContainer_SubItem>;
};

export type IKosovoContainer_SubItem = {
  id: Scalars['ID'];
  itemDocRefId: Scalars['String'];
  itemType: Scalars['String'];
  status: KosovoContainer_SubItem_StatusEnum;
};

export enum KosovoContainer_SubItem_StatusEnum {
  Done = 'Done',
  NotYetStarted = 'NotYetStarted',
  Started = 'Started'
}

export enum KosovoContainer_TextBlockFormat {
  CLikeSource = 'CLikeSource',
  CssSource = 'CSSSource',
  Html = 'HTML',
  HtmlSource = 'HTMLSource',
  JavaScriptSource = 'JavaScriptSource',
  PlainText = 'PlainText',
  PythonSource = 'PythonSource'
}

export type IKosovoCrossout_QueryItemSessionData = IQueryItemSessionData & {
  header: ILangString;
  id: Scalars['ID'];
  lines: Array<IKosovoCrossout_QueryItemSessionData_Line>;
  question: ILangString;
  text: ILangString;
};

export type IKosovoCrossout_QueryItemSessionData_Line = {
  fragments: Array<IKosovoCrossout_QueryItemSessionData_Line_Fragment>;
  id: Scalars['ID'];
  incorrectFragment?: Maybe<Scalars['String']>;
  selectedFragment?: Maybe<Scalars['String']>;
};

export type IKosovoCrossout_QueryItemSessionData_Line_Fragment = {
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type IKosovoEssay_QueryItemSessionData = IQueryItemSessionData & {
  essayText?: Maybe<Scalars['String']>;
  evalInfo: ILangString;
  header: ILangString;
  id: Scalars['ID'];
  question: ILangString;
};

export type IKosovoFillinGap_QueryItemSessionData = IQueryItemSessionData & {
  gaps: Array<IKosovoFillinGap_QueryItemSessionData_Gap>;
  header: ILangString;
  id: Scalars['ID'];
  question: ILangString;
  text: ILangString;
};

export type IKosovoFillinGap_QueryItemSessionData_Gap = {
  correctValue?: Maybe<Scalars['String']>;
  gapId: Scalars['ID'];
  id: Scalars['ID'];
  selectedValue?: Maybe<Scalars['String']>;
  values: Array<IKosovoFillinGap_QueryItemSessionData_Value>;
};

export type IKosovoFillinGap_QueryItemSessionData_Value = {
  id: Scalars['ID'];
  value: ILangString;
};

export type IKosovoMatchingHotSpot_QueryItemSessionData = IQueryItemSessionData & {
  answers: Array<IKosovoMatchingHotSpot_QueryItemSessionData_Answer>;
  header: ILangString;
  id: Scalars['ID'];
  image?: Maybe<IAttachmentUrlObject>;
  imageHeight?: Maybe<Scalars['Int']>;
  imageWidth?: Maybe<Scalars['Int']>;
  question: ILangString;
  shapes: Array<IKosovoMatchingHotSpot_QueryItemSessionData_Shape>;
};

export type IKosovoMatchingHotSpot_QueryItemSessionData_Answer = {
  correctShape?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  selectedShape?: Maybe<Scalars['String']>;
  value: ILangString;
};

export type IKosovoMatchingHotSpot_QueryItemSessionData_Shape = {
  id: Scalars['ID'];
  shape: Scalars['String'];
};

export type IKosovoMatchingImage_QueryItemSessionData = IQueryItemSessionData & {
  answers: Array<IKosovoMatchingImage_QueryItemSessionData_Answer>;
  header: ILangString;
  id: Scalars['ID'];
  images: Array<IKosovoMatchingImage_QueryItemSessionData_Image>;
  question: ILangString;
};

export type IKosovoMatchingImage_QueryItemSessionData_Answer = {
  correctImage?: Maybe<IKosovoMatchingImage_QueryItemSessionData_Image>;
  id: Scalars['ID'];
  selectedImage?: Maybe<IKosovoMatchingImage_QueryItemSessionData_Image>;
  value: ILangString;
};

export type IKosovoMatchingImage_QueryItemSessionData_Image = {
  id: Scalars['ID'];
  image: IAttachmentUrlObject;
  img?: Maybe<Scalars['String']>;
};

export type IKosovoMatchingText_QueryItemSessionData = IQueryItemSessionData & {
  answerTitle: ILangString;
  answers: Array<IKosovoMatchingText_QueryItemSessionData_Answer>;
  header: ILangString;
  id: Scalars['ID'];
  question: ILangString;
  textTitle: ILangString;
  texts: Array<IKosovoMatchingText_QueryItemSessionData_Text>;
};

export type IKosovoMatchingText_QueryItemSessionData_Answer = {
  correctText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  selectedText?: Maybe<Scalars['String']>;
  value: ILangString;
};

export type IKosovoMatchingText_QueryItemSessionData_Text = {
  id: Scalars['ID'];
  value: ILangString;
};

export type IKosovoOrderingSelection_QueryItemSessionData = IQueryItemSessionData & {
  availableAnswers: Array<IKosovoOrderingSelection_QueryItemSessionData_Answer>;
  correctAnswer?: Maybe<Array<IKosovoOrderingSelection_QueryItemSessionData_Answer>>;
  distractorAnswers?: Maybe<Array<IKosovoOrderingSelection_QueryItemSessionData_Answer>>;
  header: ILangString;
  id: Scalars['ID'];
  question: ILangString;
  selectedAnswers: Array<IKosovoOrderingSelection_QueryItemSessionData_Answer>;
};

export type IKosovoOrderingSelection_QueryItemSessionData_Answer = {
  answerId: Scalars['ID'];
  id: Scalars['ID'];
  value: ILangString;
};

export type IKosovoOrderingSentences_QueryItemSessionData = IQueryItemSessionData & {
  answers: Array<IKosovoOrderingSentences_QueryItemSessionData_Answer>;
  correctAnswer?: Maybe<Array<IKosovoOrderingSentences_QueryItemSessionData_Answer>>;
  header: ILangString;
  id: Scalars['ID'];
  initialOrder: Array<IKosovoOrderingSentences_QueryItemSessionData_Answer>;
  question: ILangString;
};

export type IKosovoOrderingSentences_QueryItemSessionData_Answer = {
  id: Scalars['ID'];
  value: ILangString;
};

export type IKosovoOrderingWords_QueryItemSessionData = IQueryItemSessionData & {
  answers: Array<IKosovoOrderingWords_QueryItemSessionData_Answer>;
  correctAnswer?: Maybe<Array<IKosovoOrderingWords_QueryItemSessionData_Answer>>;
  header: ILangString;
  id: Scalars['ID'];
  initialOrder: Array<IKosovoOrderingWords_QueryItemSessionData_Answer>;
  question: ILangString;
};

export type IKosovoOrderingWords_QueryItemSessionData_Answer = {
  id: Scalars['ID'];
  value: ILangString;
};

export type IKosovoSingleChoiceHotSpot_QueryItemSessionData = IQueryItemSessionData & {
  answers: Array<IKosovoSingleChoiceHotSpot_QueryItemSessionData_Answer>;
  correctAnswer?: Maybe<Scalars['String']>;
  header: ILangString;
  id: Scalars['ID'];
  image: IAttachmentUrlObject;
  imageHeight: Scalars['Int'];
  imageWidth: Scalars['Int'];
  question: ILangString;
  selectedAnswer?: Maybe<Scalars['String']>;
};

export type IKosovoSingleChoiceHotSpot_QueryItemSessionData_Answer = {
  id: Scalars['ID'];
  shape: Scalars['String'];
};

export type IKosovoSingleChoiceImage_QueryItemSessionData = IQueryItemSessionData & {
  answers: Array<IKosovoSingleChoiceImage_QueryItemSessionData_Answer>;
  correctAnswer?: Maybe<Scalars['String']>;
  header: ILangString;
  id: Scalars['ID'];
  image?: Maybe<IAttachmentUrlObject>;
  imgHeight: Scalars['Int'];
  imgWidth: Scalars['Int'];
  question: ILangString;
  selectedAnswer?: Maybe<Scalars['String']>;
};

export type IKosovoSingleChoiceImage_QueryItemSessionData_Answer = {
  id: Scalars['ID'];
  img: IAttachmentUrlObject;
};

export type IKosovoSingleChoiceMatrix_QueryItemSessionData = IQueryItemSessionData & {
  columns: Array<IKosovoSingleChoiceMatrix_QueryItemSessionData_Column>;
  header: ILangString;
  id: Scalars['ID'];
  question: ILangString;
  rows: Array<IKosovoSingleChoiceMatrix_QueryItemSessionData_Row>;
};

export type IKosovoSingleChoiceMatrix_QueryItemSessionData_Column = {
  id: Scalars['ID'];
  value: ILangString;
};

export type IKosovoSingleChoiceMatrix_QueryItemSessionData_Row = {
  cells: Array<IKosovoSingleChoiceMatrix_QueryItemSessionData_Row_Cell>;
  correctAnswer?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  selectedAnswer?: Maybe<Scalars['String']>;
  value: ILangString;
};

export type IKosovoSingleChoiceMatrix_QueryItemSessionData_Row_Cell = {
  correct?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  selected?: Maybe<Scalars['Boolean']>;
};

export type IKosovoSingleChoiceText_QueryItemSessionData = IQueryItemSessionData & {
  answers: Array<IKosovoSingleChoiceText_QueryItemSessionData_Answer>;
  correctAnswer?: Maybe<Scalars['String']>;
  header: ILangString;
  id: Scalars['ID'];
  image?: Maybe<IAttachmentUrlObject>;
  question: ILangString;
  selectedAnswer?: Maybe<Scalars['String']>;
};

export type IKosovoSingleChoiceText_QueryItemSessionData_Answer = {
  id: Scalars['ID'];
  text: ILangString;
};

export type IKosovoTextEntry_Auto_QueryItemSessionData = IQueryItemSessionData & {
  gaps: Array<IKosovoTextEntry_Auto_QueryItemSessionData_Gap>;
  header: ILangString;
  id: Scalars['ID'];
  image?: Maybe<IAttachmentUrlObject>;
  question: ILangString;
  text: ILangString;
};

export type IKosovoTextEntry_Auto_QueryItemSessionData_Answer = {
  id: Scalars['ID'];
  value: ILangString;
};

export type IKosovoTextEntry_Auto_QueryItemSessionData_Gap = {
  correctAnswers?: Maybe<Array<IKosovoTextEntry_Auto_QueryItemSessionData_Answer>>;
  gapId: Scalars['ID'];
  gapIndex: Scalars['Int'];
  givenAnswer?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isCorrect?: Maybe<Scalars['Boolean']>;
  pattern: Scalars['String'];
  validationMessage: ILangString;
  width: Scalars['String'];
};

export type IKosovoTextEntry_Manual_QueryItemSessionData = IQueryItemSessionData & {
  answers: Array<IKosovoTextEntry_Manual_QueryItemSessionData_Answer>;
  gaps: Array<IKosovoTextEntry_Manual_QueryItemSessionData_Gap>;
  header: ILangString;
  id: Scalars['ID'];
  image?: Maybe<IAttachmentUrlObject>;
  question: ILangString;
  text: ILangString;
};

export type IKosovoTextEntry_Manual_QueryItemSessionData_Answer = {
  id: Scalars['ID'];
  value: ILangString;
};

export type IKosovoTextEntry_Manual_QueryItemSessionData_Gap = {
  correctAnswers?: Maybe<Array<IKosovoTextEntry_Manual_QueryItemSessionData_Answer>>;
  gapId: Scalars['ID'];
  gapIndex: Scalars['Int'];
  givenAnswer?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isCorrect?: Maybe<Scalars['Boolean']>;
  pattern: Scalars['String'];
  validationMessage: ILangString;
};

export type ILangString = {
  defaultValue: Scalars['String'];
  languages: Array<Maybe<ILangStringValue>>;
  localizations: Array<ILocalizedValue>;
  value: Scalars['String'];
};


export type ILangStringLocalizationsArgs = {
  localizationId?: InputMaybe<Array<Scalars['ID']>>;
};


export type ILangStringValueArgs = {
  uiLanguagePreference?: InputMaybe<Array<Scalars['String']>>;
};

export type ILangStringInput = {
  languages: Array<InputMaybe<ILangStringValueInput>>;
};

export type ILangStringValue = {
  isoCode: Scalars['String'];
  value: Scalars['String'];
};

export type ILangStringValueInput = {
  isoCode: Scalars['String'];
  value: Scalars['String'];
};

export type ILanguage = {
  id: Scalars['ID'];
  isoCode: Scalars['String'];
  name: ILangString;
};

export type ILaunchAsScoArgs = {
  golemScript?: InputMaybe<Scalars['String']>;
  onClose?: InputMaybe<OnCloseEnum>;
  onCloseParam?: InputMaybe<Scalars['String']>;
  scormTokenId: Scalars['ID'];
  skipResultPage?: InputMaybe<Scalars['Boolean']>;
  studentId: Scalars['String'];
  studentName: Scalars['String'];
  suspendData: Scalars['String'];
  userAgentString: Scalars['String'];
};

export type ILavakFillinPool_QueryItemSessionData = IQueryItemSessionData & {
  evaluationRemark?: Maybe<Scalars['String']>;
  gaps: Array<ILavakFillinPool_QueryItemSessionData_Gap>;
  header: ILangString;
  id: Scalars['ID'];
  question: ILangString;
  text: ILangString;
  values: Array<ILavakFillinPool_QueryItemSessionData_Value>;
};

export type ILavakFillinPool_QueryItemSessionData_Gap = {
  correctValue?: Maybe<Scalars['String']>;
  evaluationRemark?: Maybe<Scalars['String']>;
  gapId: Scalars['ID'];
  id: Scalars['ID'];
  selectedValue?: Maybe<Scalars['String']>;
};

export type ILavakFillinPool_QueryItemSessionData_Value = {
  id: Scalars['ID'];
  value?: Maybe<ILangString>;
};

export type ILavakLineTextEntryMutation = {
  evaluator_setTopicValue: ILavakLineTextEntrySharedGradingData_Answer;
  evaluator_submit: Scalars['Boolean'];
  evaluator_updateSharedGradingData: ILavakLineTextEntrySharedGradingData;
};


export type ILavakLineTextEntryMutationEvaluator_SetTopicValueArgs = {
  itemDocRefId: Scalars['ID'];
  topicId: Scalars['ID'];
  value: Scalars['String'];
};


export type ILavakLineTextEntryMutationEvaluator_SubmitArgs = {
  itemDocRefId: Scalars['ID'];
};


export type ILavakLineTextEntryMutationEvaluator_UpdateSharedGradingDataArgs = {
  itemDocRefId: Scalars['ID'];
};

export type ILavakLineTextEntrySharedGradingData = {
  answers: Array<ILavakLineTextEntrySharedGradingData_Answer>;
  header: ILangString;
  id: Scalars['ID'];
  itemDocRefId: Scalars['ID'];
  question: ILangString;
  topics: Array<ILavakLineTextEntrySharedGradingData_Topic>;
};

export type ILavakLineTextEntrySharedGradingData_Answer = {
  answerId: Scalars['ID'];
  count: Scalars['Int'];
  id: Scalars['ID'];
  submitted: Scalars['Boolean'];
  topicId?: Maybe<Scalars['ID']>;
  value: Scalars['String'];
};

export type ILavakLineTextEntrySharedGradingData_Topic = {
  id: Scalars['ID'];
  isKeyAnswer: Scalars['Boolean'];
  itemDocRefId: Scalars['ID'];
  score: Scalars['Float'];
  text: ILangString;
  topicId: Scalars['ID'];
};

export type ILavakLineTextEntry_QueryItemSessionData = IQueryItemSessionData & {
  evaluationRemark?: Maybe<Scalars['String']>;
  header: ILangString;
  id: Scalars['ID'];
  lines: Array<ILavakLineTextEntry_QueryItemSessionData_Line>;
  question: ILangString;
};

export type ILavakLineTextEntry_QueryItemSessionData_Line = {
  evaluationRemark?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isCorrect?: Maybe<Scalars['Boolean']>;
  lineIndex: Scalars['Int'];
  value?: Maybe<Scalars['String']>;
};

export type ILavakMultiplechoice_QueryItemSessionData = IQueryItemSessionData & {
  answers: Array<ILavakMultiplechoice_QueryItemSessionData_Answer>;
  evaluationRemark?: Maybe<Scalars['String']>;
  header: ILangString;
  id: Scalars['ID'];
  maxSelectionLimit: Scalars['Int'];
  minSelectionLimit: Scalars['Int'];
  question: ILangString;
};

export type ILavakMultiplechoice_QueryItemSessionData_Answer = {
  evaluationRemark?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isCorrectAnswer?: Maybe<Scalars['Boolean']>;
  isSelected: Scalars['Boolean'];
  text: ILangString;
};

export enum LevelOfSecrecy {
  Public = 'public',
  Restricted = 'restricted',
  Secret = 'secret',
  Topsecret = 'topsecret'
}

export type ILineTextEntryEditItem = {
  answers: Array<ILineTextEntryEdit_Text>;
  header: ILangString;
  id: Scalars['ID'];
  lines: Scalars['Int'];
  question: ILangString;
  scoring: LineTextEntryEdit_Scoring;
};

export type ILineTextEntryEditMutation = {
  upsert: ILineTextEntryEditItem;
};


export type ILineTextEntryEditMutationUpsertArgs = {
  params: ILineTextEntryEditUpsertInput;
};

export type ILineTextEntryEditQuery = {
  get: ILineTextEntryEditItem;
};


export type ILineTextEntryEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type ILineTextEntryEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  lines?: InputMaybe<Scalars['Int']>;
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removeAnswers?: InputMaybe<Array<Scalars['ID']>>;
  scoring?: InputMaybe<LineTextEntryEdit_Scoring>;
  setAnswers?: InputMaybe<Array<ILineTextEntryEdit_UpsertText>>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertAnswers?: InputMaybe<Array<ILineTextEntryEdit_UpsertText>>;
};

export enum LineTextEntryEdit_Scoring {
  AllOrNothing = 'allOrNothing',
  PerLine = 'perLine'
}

export type ILineTextEntryEdit_Text = {
  correct: Scalars['Boolean'];
  id: Scalars['ID'];
  index: Scalars['ID'];
  score: Scalars['Float'];
  value: ILangString;
};

export type ILineTextEntryEdit_UpsertText = {
  correct?: InputMaybe<Scalars['Boolean']>;
  index: Scalars['ID'];
  score?: InputMaybe<Scalars['Float']>;
  value?: InputMaybe<IUpsertLangStringInput>;
};

export type ILocalization = {
  enabledForAdministration: Scalars['Boolean'];
  enabledForExams: Scalars['Boolean'];
  englishName: Scalars['String'];
  id: Scalars['ID'];
  isoCodes: Array<Scalars['String']>;
  isoLanguages: Array<ILanguage>;
  localizationId: Scalars['ID'];
  name: ILangString;
  readOnly: Scalars['Boolean'];
};

export type ILocalizationPrivilege = IPrivilege & {
  localizations: Array<ILocalization>;
  privilege: Privilege;
};

export type ILocalizedValue = {
  localizationId: Scalars['ID'];
  value: Scalars['String'];
};

export type ILoginResponse = {
  browserSessionId: Scalars['ID'];
  href: Scalars['String'];
  type: BrowserSessionType;
};

export type IMatchingHotspotEditItem = {
  answers: Array<IMatchingHotspotEdit_Answer>;
  header: ILangString;
  id: Scalars['ID'];
  image?: Maybe<IAttachmentUrlObject>;
  imageHeight?: Maybe<Scalars['Int']>;
  imageWidth?: Maybe<Scalars['Int']>;
  perAnswerScore?: Maybe<Scalars['Float']>;
  question: ILangString;
  scoring: MatchingHotspotEdit_Scoring;
  shapes: Array<IMatchingHotspotEdit_Shape>;
  shuffleMode: MatchingHotspotEdit_ShuffleMode;
};

export type IMatchingHotspotEditMutation = {
  addCircle?: Maybe<IMatchingHotspotEdit_Shape>;
  connect?: Maybe<IMatchingHotspotEditItem>;
  upsert?: Maybe<IMatchingHotspotEditItem>;
};


export type IMatchingHotspotEditMutationAddCircleArgs = {
  itemId: Scalars['ID'];
  radius: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};


export type IMatchingHotspotEditMutationConnectArgs = {
  answerIndex?: InputMaybe<Scalars['ID']>;
  itemId: Scalars['ID'];
  shapeIndex?: InputMaybe<Scalars['ID']>;
};


export type IMatchingHotspotEditMutationUpsertArgs = {
  params: IMatchingHotspotEditUpsertInput;
};

export type IMatchingHotspotEditQuery = {
  get: IMatchingHotspotEditItem;
};


export type IMatchingHotspotEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IMatchingHotspotEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  image?: InputMaybe<Scalars['String']>;
  imageHeight?: InputMaybe<Scalars['Int']>;
  imageWidth?: InputMaybe<Scalars['Int']>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  perAnswerScore?: InputMaybe<Scalars['Float']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removeAnsers?: InputMaybe<Array<Scalars['ID']>>;
  removeShapes?: InputMaybe<Array<Scalars['ID']>>;
  scoring?: InputMaybe<MatchingHotspotEdit_Scoring>;
  setAnswers?: InputMaybe<Array<IMatchingHotspotEdit_UpsertAnswer>>;
  setShapes?: InputMaybe<Array<IMatchingHotspotEdit_UpsertShape>>;
  shuffleMode?: InputMaybe<MatchingHotspotEdit_ShuffleMode>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertAnswers?: InputMaybe<Array<IMatchingHotspotEdit_UpsertAnswer>>;
  upsertShapes?: InputMaybe<Array<IMatchingHotspotEdit_UpsertShape>>;
};

export type IMatchingHotspotEdit_Answer = {
  correct?: Maybe<IMatchingHotspotEdit_Shape>;
  id: Scalars['ID'];
  index: Scalars['ID'];
  value: ILangString;
};

export enum MatchingHotspotEdit_Scoring {
  AllOrNothing = 'AllOrNothing',
  PerAnswer = 'PerAnswer'
}

export type IMatchingHotspotEdit_Shape = {
  correct?: Maybe<IMatchingHotspotEdit_Answer>;
  id: Scalars['ID'];
  index: Scalars['ID'];
  shape: Scalars['String'];
};

export enum MatchingHotspotEdit_ShuffleMode {
  Ordered = 'Ordered',
  Shuffled = 'Shuffled'
}

export type IMatchingHotspotEdit_UpsertAnswer = {
  correct?: InputMaybe<Scalars['ID']>;
  index: Scalars['ID'];
  value?: InputMaybe<IUpsertLangStringInput>;
};

export type IMatchingHotspotEdit_UpsertShape = {
  index: Scalars['ID'];
  shape?: InputMaybe<Scalars['String']>;
};

export type IMatchingImageEditItem = {
  header: ILangString;
  id: Scalars['ID'];
  pairs: Array<IMatchingImageEdit_Pair>;
  question: ILangString;
};

export type IMatchingImageEditMutation = {
  upsert?: Maybe<IMatchingImageEditItem>;
};


export type IMatchingImageEditMutationUpsertArgs = {
  params: IMatchingImageEditUpsertInput;
};

export type IMatchingImageEditQuery = {
  get: IMatchingImageEditItem;
};


export type IMatchingImageEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IMatchingImageEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removePairs?: InputMaybe<Array<Scalars['ID']>>;
  setPairs?: InputMaybe<Array<IMatchingImageEdit_UpsertPair>>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertPairs?: InputMaybe<Array<IMatchingImageEdit_UpsertPair>>;
};

export type IMatchingImageEdit_Pair = {
  id: Scalars['ID'];
  image?: Maybe<IAttachmentUrlObject>;
  index: Scalars['ID'];
  value: ILangString;
};

export type IMatchingImageEdit_UpsertPair = {
  image?: InputMaybe<Scalars['String']>;
  index: Scalars['ID'];
  value?: InputMaybe<IUpsertLangStringInput>;
};

export type IMatchingTextEditItem = {
  header: ILangString;
  id: Scalars['ID'];
  leftTitle: ILangString;
  pairs: Array<IMatchingTextEdit_Pair>;
  question: ILangString;
  rightTitle: ILangString;
  shuffleLeft: MatchingTextEdit_ShuffleMode;
  shuffleRight: MatchingTextEdit_ShuffleMode;
};

export type IMatchingTextEditMutation = {
  upsert?: Maybe<IMatchingTextEditItem>;
};


export type IMatchingTextEditMutationUpsertArgs = {
  params: IMatchingTextEditUpsertInput;
};

export type IMatchingTextEditQuery = {
  get: IMatchingTextEditItem;
};


export type IMatchingTextEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IMatchingTextEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  leftTitle?: InputMaybe<IUpsertLangStringInput>;
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removePairs?: InputMaybe<Array<Scalars['ID']>>;
  rightTitle?: InputMaybe<IUpsertLangStringInput>;
  setPairs?: InputMaybe<Array<IMatchingTextEdit_UpsertPair>>;
  shuffleLeft?: InputMaybe<MatchingTextEdit_ShuffleMode>;
  shuffleRight?: InputMaybe<MatchingTextEdit_ShuffleMode>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertPairs?: InputMaybe<Array<IMatchingTextEdit_UpsertPair>>;
};

export type IMatchingTextEdit_Pair = {
  id: Scalars['ID'];
  index: Scalars['ID'];
  leftText: ILangString;
  rightText: ILangString;
};

export enum MatchingTextEdit_ShuffleMode {
  Ordered = 'ordered',
  Shuffled = 'shuffled'
}

export type IMatchingTextEdit_UpsertPair = {
  index: Scalars['ID'];
  leftText?: InputMaybe<IUpsertLangStringInput>;
  rightText?: InputMaybe<IUpsertLangStringInput>;
};

export type IMultipleChoiceEditItem = {
  answers: Array<IMultipleChoiceEdit_Text>;
  header: ILangString;
  id: Scalars['ID'];
  maxSelectionLimit: Scalars['Int'];
  minSelectionLimit: Scalars['Int'];
  question: ILangString;
  scoring: MultipleChoiceEdit_Scoring;
  shuffle: MultipleChoiceEdit_Shuffle;
};

export type IMultipleChoiceEditMutation = {
  upsert: IMultipleChoiceEditItem;
};


export type IMultipleChoiceEditMutationUpsertArgs = {
  params: IMultipleChoiceEditUpsertInput;
};

export type IMultipleChoiceEditQuery = {
  get: IMultipleChoiceEditItem;
};


export type IMultipleChoiceEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IMultipleChoiceEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  maxSelectionLimit?: InputMaybe<Scalars['Int']>;
  minSelectionLimit?: InputMaybe<Scalars['Int']>;
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removeAnswers?: InputMaybe<Array<Scalars['ID']>>;
  scoring?: InputMaybe<MultipleChoiceEdit_Scoring>;
  setAnswers?: InputMaybe<Array<IMultipleChoiceEdit_UpsertText>>;
  shuffle?: InputMaybe<MultipleChoiceEdit_Shuffle>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertAnswers?: InputMaybe<Array<IMultipleChoiceEdit_UpsertText>>;
};

export enum MultipleChoiceEdit_Scoring {
  AllOrNothing = 'allOrNothing',
  PerAnswer = 'perAnswer'
}

export enum MultipleChoiceEdit_Shuffle {
  Ordered = 'ordered',
  Shuffled = 'shuffled',
  ShuffledExceptLast = 'shuffledExceptLast'
}

export type IMultipleChoiceEdit_Text = {
  correct: Scalars['Boolean'];
  id: Scalars['ID'];
  index: Scalars['ID'];
  score: Scalars['Float'];
  value: ILangString;
};

export type IMultipleChoiceEdit_UpsertText = {
  correct?: InputMaybe<Scalars['Boolean']>;
  index: Scalars['ID'];
  score?: InputMaybe<Scalars['Float']>;
  value?: InputMaybe<IUpsertLangStringInput>;
};

export type IMultistepHotSpotEditItem = {
  header: ILangString;
  id: Scalars['ID'];
  itemId: Scalars['ID'];
  markerHeight: Scalars['Float'];
  markerRadius: Scalars['Float'];
  markerWidth: Scalars['Float'];
  question: ILangString;
  steps: Array<IMultistepHotSpotEdit_Step>;
};

export type IMultistepHotSpotEditMutation = {
  upsert: IMultistepHotSpotEditItem;
};


export type IMultistepHotSpotEditMutationUpsertArgs = {
  params: IMultistepHotSpotEditUpsertInput;
};

export type IMultistepHotSpotEditQuery = {
  get: IMultistepHotSpotEditItem;
};


export type IMultistepHotSpotEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IMultistepHotSpotEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  markerHeight?: InputMaybe<Scalars['Float']>;
  markerRadius?: InputMaybe<Scalars['Float']>;
  markerWidth?: InputMaybe<Scalars['Float']>;
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removeSteps?: InputMaybe<Array<Scalars['ID']>>;
  setSteps?: InputMaybe<Array<IMultistepHotSpotEdit_UpsertStep>>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertSteps?: InputMaybe<Array<IMultistepHotSpotEdit_UpsertStep>>;
};

export type IMultistepHotSpotEdit_AreaCircle = {
  areaId: Scalars['ID'];
  id: Scalars['ID'];
  radius: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type IMultistepHotSpotEdit_AreaRect = {
  areaId: Scalars['ID'];
  centerX: Scalars['Float'];
  centerY: Scalars['Float'];
  height: Scalars['Float'];
  id: Scalars['ID'];
  left: Scalars['Float'];
  top: Scalars['Float'];
  width: Scalars['Float'];
};

export type IMultistepHotSpotEdit_Step = {
  authorHint: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<IAttachmentUrlObject>;
  imageHeight: Scalars['Int'];
  imageWidth: Scalars['Int'];
  isStartingStep: Scalars['Boolean'];
  stepId: Scalars['ID'];
  zones: Array<IMultistepHotSpotEdit_Zone>;
};

export type IMultistepHotSpotEdit_UpsertAreaCircle = {
  areaId: Scalars['ID'];
  radius?: InputMaybe<Scalars['Float']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type IMultistepHotSpotEdit_UpsertAreaRect = {
  areaId: Scalars['ID'];
  centerX?: InputMaybe<Scalars['Float']>;
  centerY?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  left?: InputMaybe<Scalars['Float']>;
  top?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type IMultistepHotSpotEdit_UpsertStep = {
  authorHint?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  imageHeight?: InputMaybe<Scalars['Int']>;
  imageWidth?: InputMaybe<Scalars['Int']>;
  isStartingStep?: InputMaybe<Scalars['Boolean']>;
  removeZones?: InputMaybe<Array<Scalars['ID']>>;
  setZones?: InputMaybe<Array<IMultistepHotSpotEdit_UpsertZone>>;
  stepId: Scalars['ID'];
  upsertZones?: InputMaybe<Array<IMultistepHotSpotEdit_UpsertZone>>;
};

export type IMultistepHotSpotEdit_UpsertZone = {
  removeCircles?: InputMaybe<Array<Scalars['ID']>>;
  removeRects?: InputMaybe<Array<Scalars['ID']>>;
  setCircles?: InputMaybe<Array<IMultistepHotSpotEdit_UpsertAreaCircle>>;
  setRects?: InputMaybe<Array<IMultistepHotSpotEdit_UpsertAreaRect>>;
  stepLinkId?: InputMaybe<Scalars['ID']>;
  upsertCircles?: InputMaybe<Array<IMultistepHotSpotEdit_UpsertAreaCircle>>;
  upsertRects?: InputMaybe<Array<IMultistepHotSpotEdit_UpsertAreaRect>>;
  zoneId: Scalars['ID'];
};

export type IMultistepHotSpotEdit_Zone = {
  circles: Array<IMultistepHotSpotEdit_AreaCircle>;
  id: Scalars['ID'];
  rects: Array<IMultistepHotSpotEdit_AreaRect>;
  stepId: Scalars['ID'];
  stepLinkId?: Maybe<Scalars['ID']>;
  zoneId: Scalars['ID'];
};

export enum MultistepHotSpot_CorrectState {
  Correct = 'correct',
  Incorrect = 'incorrect'
}

export type IMultistepHotSpot_QueryItemSessionData = IQueryItemSessionData & {
  givenAnswer?: Maybe<IMultistepHotSpot_QueryItemSessionData_Answer>;
  header: ILangString;
  id: Scalars['ID'];
  initialStepId: Scalars['ID'];
  markerRadius: Scalars['Float'];
  question: ILangString;
  steps: Array<IMultistepHotSpot_QueryItemSessionData_Step>;
};

export type IMultistepHotSpot_QueryItemSessionData_Answer = {
  area?: Maybe<IMultistepHotSpot_QueryItemSessionData_Rect>;
  correct?: Maybe<MultistepHotSpot_CorrectState>;
  id: Scalars['ID'];
  steps: Array<Scalars['ID']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type IMultistepHotSpot_QueryItemSessionData_Rect = {
  areaId: Scalars['ID'];
  height: Scalars['Float'];
  id: Scalars['ID'];
  left: Scalars['Float'];
  stepId: Scalars['ID'];
  top: Scalars['Float'];
  width: Scalars['Float'];
  zoneId: Scalars['ID'];
};

export type IMultistepHotSpot_QueryItemSessionData_Step = {
  id: Scalars['ID'];
  image: IAttachmentUrlObject;
  imageHeight: Scalars['Int'];
  imageWidth: Scalars['Int'];
  stepId: Scalars['ID'];
  zones: Array<IMultistepHotSpot_QueryItemSessionData_Zone>;
};

export type IMultistepHotSpot_QueryItemSessionData_Zone = {
  areas: Array<IMultistepHotSpot_QueryItemSessionData_Rect>;
  id: Scalars['ID'];
  stepLinkId?: Maybe<Scalars['ID']>;
  zoneId: Scalars['ID'];
};

export type IMutateExamSession = {
  /** @deprecated not supported anymore */
  assignDonkey?: Maybe<IDonkey>;
  finishExam?: Maybe<IMutateFinishExamResult>;
  /** @deprecated Use tickTock */
  postpone: IQueryExamSession;
  /** @deprecated Use tickTock */
  reset: IQueryExamSession;
  /** @deprecated Use tickTock */
  selectItem: IQueryExamSession;
  /** @deprecated Use tickTock */
  selectSection: IQueryExamSession;
  setSessionItems: Array<IQueryItemInSession>;
  setUserFields: IQueryExamSession;
  startExam?: Maybe<IQueryExamSession>;
  /** @deprecated Use tickTock */
  submit: IMutateSubmitResult;
  tickTock: IQueryExamSession;
  /** @deprecated Unused method */
  toggleFlag: IQueryExamSession;
  /** @deprecated not supported anymore */
  triggerDonkeyCommand: Scalars['Boolean'];
  /** @deprecated not supported anymore */
  unassignDonkey: Scalars['Boolean'];
};


export type IMutateExamSessionAssignDonkeyArgs = {
  donkeyId: Scalars['ID'];
};


export type IMutateExamSessionPostponeArgs = {
  params: IMutationPostponeInput;
};


export type IMutateExamSessionResetArgs = {
  params: IMutationResetInput;
};


export type IMutateExamSessionSelectItemArgs = {
  params: IMutationSelectItemInput;
};


export type IMutateExamSessionSelectSectionArgs = {
  params: IMutationSelectSectionInput;
};


export type IMutateExamSessionSetSessionItemsArgs = {
  topItems: Array<Scalars['ID']>;
};


export type IMutateExamSessionSetUserFieldsArgs = {
  params: Array<ISetUserFieldInput>;
};


export type IMutateExamSessionStartExamArgs = {
  params: IMutationStartExamParams;
};


export type IMutateExamSessionSubmitArgs = {
  params: IMutationSubmitInput;
};


export type IMutateExamSessionTickTockArgs = {
  timePassedMS: Scalars['Int'];
  updateExamState?: InputMaybe<IUpdateExamStateInput>;
};


export type IMutateExamSessionToggleFlagArgs = {
  params: IMutationToggleFlagInput;
};


export type IMutateExamSessionTriggerDonkeyCommandArgs = {
  command: DonkeyCommandTypeEnum;
  serviceProvider: Scalars['ID'];
  topTaskId: Scalars['ID'];
};


export type IMutateExamSessionUnassignDonkeyArgs = {
  donkeyId: Scalars['ID'];
};

export type IMutateFinishExamResult = {
  message?: Maybe<ILangString>;
  ok?: Maybe<Scalars['Boolean']>;
  session?: Maybe<IQueryExamSession>;
};

export type IMutateSubmitResult = {
  error?: Maybe<IMutateSubmitResultError>;
  message?: Maybe<ILangString>;
  ok: Scalars['Boolean'];
  session: IQueryExamSession;
  submittedItem?: Maybe<IQueryItemInSession>;
};

export type IMutateSubmitResultError = {
  interactionNotCompleted?: Maybe<Scalars['Boolean']>;
};

export type IMutation = {
  ChoiceTextEdit: IChoiceTextEditMutation;
  CrossoutEdit: ICrossoutEditMutation;
  EssayEdit: IEssayEditMutation;
  FillInGapEdit?: Maybe<IFillInGapEditMutation>;
  FillInPoolEdit?: Maybe<IFillInPoolEditMutation>;
  InstructionEdit?: Maybe<IInstructionEditMutation>;
  InvisibleHotSpotEdit: IInvisibleHotSpotEditMutation;
  LavakLineTextEntry?: Maybe<ILavakLineTextEntryMutation>;
  LineTextEntryEdit: ILineTextEntryEditMutation;
  MatchingHotspotEdit?: Maybe<IMatchingHotspotEditMutation>;
  MatchingImageEdit?: Maybe<IMatchingImageEditMutation>;
  MatchingTextEdit?: Maybe<IMatchingTextEditMutation>;
  MultipleChoiceEdit: IMultipleChoiceEditMutation;
  MultistepHotSpotEdit: IMultistepHotSpotEditMutation;
  OrderingSelectionEdit: IOrderingSelectionEditMutation;
  OrderingSentencesEdit: IOrderingSentencesEditMutation;
  OrderingWordsEdit: IOrderingWordsEditMutation;
  OrganisationEdit?: Maybe<IOrganisationEdit_Mutation>;
  PlaceholderEdit?: Maybe<IPlaceholderEditMutation>;
  SingleChoiceHotspotEdit?: Maybe<ISingleChoiceHotspotEditMutation>;
  SingleChoiceImageEdit: ISingleChoiceImageEditMutation;
  SingleChoiceMatrixEdit: ISingleChoiceMatrixEditMutation;
  SingleChoiceTextEdit: ISingleChoiceTextEditMutation;
  SpellingMatrixEdit?: Maybe<ISpellingMatrixEdit_Mutation>;
  SurveyComboEdit?: Maybe<ISurveyComboEditMutation>;
  SurveyComparisionEdit: ISurveyComparisionEditMutation;
  SurveySingleChoiceMatrixEdit: ISurveySingleChoiceMatrixEditMutation;
  SurveySingleChoiceTextEdit: ISurveySingleChoiceTextEditMutation;
  SurveyTextEntryEdit?: Maybe<ISurveyTextEntryEditMutation>;
  SurveyTextInputEdit: ISurveyTextInputEditMutation;
  TestAlias: ITestAliasMutation;
  TestDefinitionProfile: ITestDefinitionProfileMutations;
  TextEntryAutoEdit?: Maybe<ITextEntryAutoEditMutation>;
  TextEntryManualEdit?: Maybe<ITextEntryManualEditMutation>;
  TextEntryManualGrading: ITextEntryManualGradingMutation;
  TypingTest2023Edit: ITypingTest2023EditMutation;
  TypingTestEdit: ITypingTestEditMutation;
  audiences: IAudienceMutation;
  author?: Maybe<IAuthorMutation>;
  config?: Maybe<IConfigMutation>;
  containerEdit?: Maybe<IContainerEditMutation>;
  deleteSession: IBulkProcessingResponse;
  deus: IDeusMutations;
  document: IDocumentMutation;
  /** @deprecated not supported anymore */
  donkey?: Maybe<IDonkeyMutation>;
  dummy?: Maybe<Scalars['String']>;
  enrichment: IEnrichmentMutation;
  essayGrading: IEssayGradingMutation;
  examOrder?: Maybe<IExamOrderMutation>;
  examSession?: Maybe<IMutateExamSession>;
  examination?: Maybe<IExaminationMutations>;
  generatePassword: Scalars['String'];
  golemScripts: IGolemScriptMutation;
  gradeSession: Scalars['Boolean'];
  handsOnEdit: IHandsOnEditMutation;
  inApplicationComboEdit?: Maybe<IInApplicationComboEditMutation>;
  interact?: Maybe<Scalars['Boolean']>;
  item: IItemMutation;
  itemtype?: Maybe<IItemTypeMutation>;
  itsr3client?: Maybe<IItsr3ClientMutation>;
  launchAsSco: IScoData;
  login: ILoginResponse;
  loginAnonymous: ILoginResponse;
  logout: Scalars['Boolean'];
  newDemoSession: INewExamSessionMutationResponse;
  newExamSession: INewExamSessionMutationResponse;
  printSession: IPrintSessionResult;
  removeAlternationRestrictions: Scalars['Boolean'];
  scormTokens: IScormTokenMutation;
  sessionReport: IPrintSessionResult;
  setSessionMode: IBulkProcessingResponse;
  setSessionNotificationEmail: Scalars['Boolean'];
  statisticexportconfig: IStatisticExportConfigMutation;
  subjects: ISubjectMutation;
  switchLanguage: Scalars['Boolean'];
  taxonomy: ITaxonomyMutation;
  updateItemTranslation: IItemTranslationObject;
  upsertAlternationRestriction: IAlternationRestriction;
  upsertAlternationRestrictions: Array<Maybe<IAlternationRestriction>>;
  users: IUserMutation;
};


export type IMutationDeleteSessionArgs = {
  selector: IExamSessionsQueryInput;
};


export type IMutationDocumentArgs = {
  docReferenceId: Scalars['ID'];
  docType: Doctype;
};


export type IMutationDummyArgs = {
  in?: InputMaybe<Scalars['String']>;
};


export type IMutationExamSessionArgs = {
  params: IExamSessionMutationInput;
};


export type IMutationGradeSessionArgs = {
  selector: IExamSessionsQueryInput;
};


export type IMutationInteractArgs = {
  params?: InputMaybe<IMutationInteractionInput>;
};


export type IMutationLaunchAsScoArgs = {
  args: ILaunchAsScoArgs;
};


export type IMutationLoginArgs = {
  lang?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  type?: InputMaybe<BrowserSessionType>;
  username: Scalars['String'];
};


export type IMutationLoginAnonymousArgs = {
  lang?: InputMaybe<Scalars['String']>;
};


export type IMutationNewDemoSessionArgs = {
  params: INewDemoSessionMutationInput;
};


export type IMutationNewExamSessionArgs = {
  params: INewExamSessionMutationInput;
};


export type IMutationPrintSessionArgs = {
  sessionId: Scalars['ID'];
};


export type IMutationRemoveAlternationRestrictionsArgs = {
  alternations: Array<Scalars['ID']>;
};


export type IMutationSessionReportArgs = {
  sessionId: Scalars['ID'];
};


export type IMutationSetSessionModeArgs = {
  newMode: SessionModesEnum;
  selector: IExamSessionsQueryInput;
  skipStages?: InputMaybe<Scalars['Boolean']>;
};


export type IMutationSetSessionNotificationEmailArgs = {
  confirmed?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['ID'];
};


export type IMutationSwitchLanguageArgs = {
  lang?: InputMaybe<Scalars['String']>;
};


export type IMutationUpdateItemTranslationArgs = {
  params: IUpdateItemTranslationInput;
};


export type IMutationUpsertAlternationRestrictionArgs = {
  restriction: IUpsertAlternationRestriction;
};


export type IMutationUpsertAlternationRestrictionsArgs = {
  restrictions: Array<IUpsertAlternationRestriction>;
};

export type IMutationInteractionError = {
  message: Scalars['String'];
  stack: Scalars['String'];
};

export type IMutationInteractionInput = {
  duration: Scalars['Int'];
  error?: InputMaybe<IMutationInteractionError>;
  object?: InputMaybe<IMutationInteractionObject>;
  relativeTime: Scalars['Int'];
  success: Scalars['Boolean'];
  verb: Scalars['String'];
};

export type IMutationInteractionObject = {
  itemId?: InputMaybe<Scalars['String']>;
  sectionId?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
};

export type IMutationPostponeInput = {
  itemDocRefId: Scalars['String'];
  nextItemStrategy?: InputMaybe<RingBufferOptions>;
  stayInSection?: InputMaybe<Scalars['Boolean']>;
};

export type IMutationResetInput = {
  itemDocRefId: Scalars['String'];
};

export type IMutationSelectItemInput = {
  itemDocRefId: Scalars['String'];
};

export type IMutationSelectSectionInput = {
  sectionId?: InputMaybe<Scalars['String']>;
};

export type IMutationStartExamParams = {
  selectFirstItem?: InputMaybe<Scalars['Boolean']>;
};

export type IMutationSubmitInput = {
  itemDocRefId: Scalars['String'];
  nextItemStrategy?: InputMaybe<RingBufferOptions>;
  stayInItem?: InputMaybe<Scalars['Boolean']>;
  stayInSection?: InputMaybe<Scalars['Boolean']>;
};

export type IMutationToggleFlagInput = {
  itemDocRefId: Scalars['String'];
};

export enum NavigationStyleEnum {
  PreviousNext = 'PreviousNext',
  SubmitPostpone = 'SubmitPostpone',
  SubmitPostponeAutoFocus = 'SubmitPostponeAutoFocus'
}

export type INewDemoSessionMutationInput = {
  examAlias: Scalars['String'];
  golemScript?: InputMaybe<Scalars['String']>;
  onClose?: InputMaybe<OnCloseEnum>;
  onCloseParam?: InputMaybe<Scalars['String']>;
  skipResultPage?: InputMaybe<Scalars['Boolean']>;
  userAgentString?: InputMaybe<Scalars['String']>;
};

export type INewExamSessionMutationInput = {
  candidateDisplay?: InputMaybe<Scalars['String']>;
  candidateId?: InputMaybe<Scalars['String']>;
  examAlias: Scalars['String'];
  externalId: Scalars['String'];
  golemScript?: InputMaybe<Scalars['String']>;
  onClose?: InputMaybe<OnCloseEnum>;
  onCloseParam?: InputMaybe<Scalars['String']>;
  scoreRoundingMode?: InputMaybe<ScoreRoundingModeEnum>;
  skipResultPage?: InputMaybe<Scalars['Boolean']>;
  userAgentString?: InputMaybe<Scalars['String']>;
};

export type INewExamSessionMutationResponse = {
  browserSessionId: Scalars['ID'];
  href: Scalars['String'];
  sessionId: Scalars['ID'];
};

export type INewItemInput = {
  baseId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  defaultLanguage?: InputMaybe<Scalars['String']>;
  defaultLocalization?: InputMaybe<Scalars['ID']>;
  itemType: Scalars['String'];
  objectiveId?: InputMaybe<Scalars['String']>;
  parentItemId?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type INewScormTokenArgs = {
  downloadCode?: InputMaybe<Scalars['String']>;
  examAlias: Scalars['ID'];
  lmsOrigins?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<IUpsertLangStringInput>;
  status?: InputMaybe<ScormTokenStatus>;
  trackability?: InputMaybe<ScormTokenTrackability>;
};

export enum Os {
  Windows = 'Windows'
}

export enum OnCloseEnum {
  Back = 'Back',
  Blank = 'Blank',
  Close = 'Close',
  None = 'None',
  Redirect = 'Redirect',
  Text = 'Text'
}

export type IOnlineHelp = {
  id: Scalars['ID'];
  label: ILangString;
  url: Scalars['String'];
};


export type IOnlineHelpUrlArgs = {
  widgetName?: InputMaybe<Array<Scalars['String']>>;
};

export type IOrderingSelectionEditItem = {
  answers: Array<IOrderingSelectionEdit_Text>;
  correctOrder: Array<Scalars['ID']>;
  distractors: Array<IOrderingSelectionEdit_Text>;
  header: ILangString;
  id: Scalars['ID'];
  question: ILangString;
};

export type IOrderingSelectionEditMutation = {
  upsert: IOrderingSelectionEditItem;
};


export type IOrderingSelectionEditMutationUpsertArgs = {
  params: IOrderingSelectionEditUpsertInput;
};

export type IOrderingSelectionEditQuery = {
  get: IOrderingSelectionEditItem;
};


export type IOrderingSelectionEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IOrderingSelectionEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removeAnswers?: InputMaybe<Array<Scalars['ID']>>;
  removeDistractors?: InputMaybe<Array<Scalars['ID']>>;
  setAnswers?: InputMaybe<Array<IOrderingSelectionEdit_UpsertText>>;
  setCorrectOrder?: InputMaybe<Array<Scalars['ID']>>;
  setDistractors?: InputMaybe<Array<IOrderingSelectionEdit_UpsertText>>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertAnswers?: InputMaybe<Array<IOrderingSelectionEdit_UpsertText>>;
  upsertDistractors?: InputMaybe<Array<IOrderingSelectionEdit_UpsertText>>;
};

export type IOrderingSelectionEdit_Text = {
  id: Scalars['ID'];
  index: Scalars['ID'];
  value: ILangString;
};

export type IOrderingSelectionEdit_UpsertText = {
  index: Scalars['ID'];
  value?: InputMaybe<IUpsertLangStringInput>;
};

export type IOrderingSentencesEditItem = {
  answers: Array<IOrderingSentencesEdit_Text>;
  correctOrder: Array<Scalars['ID']>;
  header: ILangString;
  id: Scalars['ID'];
  question: ILangString;
};

export type IOrderingSentencesEditMutation = {
  upsert: IOrderingSentencesEditItem;
};


export type IOrderingSentencesEditMutationUpsertArgs = {
  params: IOrderingSentencesEditUpsertInput;
};

export type IOrderingSentencesEditQuery = {
  get: IOrderingSentencesEditItem;
};


export type IOrderingSentencesEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IOrderingSentencesEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removeAnswers?: InputMaybe<Array<Scalars['ID']>>;
  setAnswers?: InputMaybe<Array<IOrderingSentencesEdit_UpsertText>>;
  setCorrectOrder?: InputMaybe<Array<Scalars['ID']>>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertAnswers?: InputMaybe<Array<IOrderingSentencesEdit_UpsertText>>;
};

export type IOrderingSentencesEdit_Text = {
  id: Scalars['ID'];
  index: Scalars['ID'];
  value: ILangString;
};

export type IOrderingSentencesEdit_UpsertText = {
  index: Scalars['ID'];
  value?: InputMaybe<IUpsertLangStringInput>;
};

export type IOrderingWordsEditItem = {
  answers: Array<IOrderingWordsEdit_Text>;
  correctOrder: Array<Scalars['ID']>;
  header: ILangString;
  id: Scalars['ID'];
  question: ILangString;
};

export type IOrderingWordsEditMutation = {
  upsert: IOrderingWordsEditItem;
};


export type IOrderingWordsEditMutationUpsertArgs = {
  params: IOrderingWordsEditUpsertInput;
};

export type IOrderingWordsEditQuery = {
  get: IOrderingWordsEditItem;
};


export type IOrderingWordsEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IOrderingWordsEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removeAnswers?: InputMaybe<Array<Scalars['ID']>>;
  setAnswers?: InputMaybe<Array<IOrderingWordsEdit_UpsertText>>;
  setCorrectOrder?: InputMaybe<Array<Scalars['ID']>>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertAnswers?: InputMaybe<Array<IOrderingWordsEdit_UpsertText>>;
};

export type IOrderingWordsEdit_Text = {
  id: Scalars['ID'];
  index: Scalars['ID'];
  value: ILangString;
};

export type IOrderingWordsEdit_UpsertText = {
  index: Scalars['ID'];
  value?: InputMaybe<IUpsertLangStringInput>;
};

export type IOrganisationEdit_Action = {
  action: ILangString;
  id: Scalars['ID'];
  key: Scalars['ID'];
  note: IOrganisationEdit_Note;
  noteId: Scalars['ID'];
};

export type IOrganisationEdit_Item = {
  actions: Array<IOrganisationEdit_Action>;
  header: ILangString;
  id: Scalars['ID'];
  notes: Array<IOrganisationEdit_Note>;
  text: ILangString;
};

export type IOrganisationEdit_Mutation = {
  upsert?: Maybe<IOrganisationEdit_Item>;
};


export type IOrganisationEdit_MutationUpsertArgs = {
  params: IOrganisationEdit_UpsertInput;
};

export type IOrganisationEdit_Note = {
  actions: Array<IOrganisationEdit_Action>;
  caption: ILangString;
  correct?: Maybe<IOrganisationEdit_Action>;
  id: Scalars['ID'];
  key: Scalars['ID'];
  noteBody: ILangString;
  noteHeader: ILangString;
  noteType: Organisation_NoteType;
};

export type IOrganisationEdit_Query = {
  get: IOrganisationEdit_Item;
};


export type IOrganisationEdit_QueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IOrganisationEdit_UpsertAction = {
  action?: InputMaybe<IUpsertLangStringInput>;
  actionId: Scalars['ID'];
  key?: InputMaybe<Scalars['ID']>;
};

export type IOrganisationEdit_UpsertInput = {
  addNotes?: InputMaybe<Array<IOrganisationEdit_UpsertNote>>;
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  removeNotes?: InputMaybe<Array<Scalars['ID']>>;
  setNotes?: InputMaybe<Array<IOrganisationEdit_UpsertNote>>;
  subject?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<IUpsertLangStringInput>;
};

export type IOrganisationEdit_UpsertNote = {
  addActions?: InputMaybe<Array<IOrganisationEdit_UpsertAction>>;
  caption?: InputMaybe<IUpsertLangStringInput>;
  correctActionId?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['ID']>;
  noteBody?: InputMaybe<IUpsertLangStringInput>;
  noteHeader?: InputMaybe<IUpsertLangStringInput>;
  noteId: Scalars['ID'];
  noteType?: InputMaybe<Organisation_NoteType>;
  removeActions?: InputMaybe<Array<Scalars['ID']>>;
  setActions?: InputMaybe<Array<IOrganisationEdit_UpsertAction>>;
};

export type IOrganisation_Action = {
  action: ILangString;
  id: Scalars['ID'];
};

export type IOrganisation_Note = {
  actions: Array<IOrganisation_Action>;
  caption: ILangString;
  correct?: Maybe<IOrganisation_Action>;
  given?: Maybe<IOrganisation_Action>;
  id: Scalars['ID'];
  noteBody: ILangString;
  noteHeader: ILangString;
  noteType: Organisation_NoteType;
};

export enum Organisation_NoteType {
  Email = 'email',
  Fax = 'fax',
  Letter = 'letter',
  Note = 'note',
  Telephone = 'telephone',
  Voicemail = 'voicemail'
}

export type IOrganisation_QueryItemSessionData = IQueryItemSessionData & {
  header: ILangString;
  id: Scalars['ID'];
  notes: Array<IOrganisation_Note>;
  text: ILangString;
};

export type IPdfReportSettings = {
  displayItemId: DisplayItemIdEnum;
  displayObjectiveId: DisplayObjectiveIdEnum;
  emailBody: ILangString;
  emailSubject: ILangString;
  includeItems: PdfReportSettingsIncludeItems;
  itemDetailCaption: ILangString;
  itemHeader: ILangString;
  itemText: ILangString;
  objectiveHeader: ILangString;
  objectiveMaxDepth: Scalars['Int'];
  objectiveMinDepth: Scalars['Int'];
  objectiveText: ILangString;
  pageFooter: ILangString;
  pageHeader: ILangString;
  text: ILangString;
};

export enum PdfReportSettingsIncludeItems {
  No = 'no',
  WhatCandidateSaw = 'whatCandidateSaw',
  Yes = 'yes'
}

export enum Privilege {
  Admin = 'admin',
  AuthorSubjects = 'author_subjects',
  EvaluatorSubjects = 'evaluator_subjects',
  SubjectcoordinatorSubjects = 'subjectcoordinator_subjects',
  Superuser = 'superuser',
  TranslatorLocalizations = 'translator_localizations',
  TranslatorSubjects = 'translator_subjects'
}

export type IPagerInput = {
  limit?: InputMaybe<Scalars['Int']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  since_docReferenceId?: InputMaybe<Scalars['String']>;
};

export type IPlaceholderEditItem = {
  id: Scalars['ID'];
};

export type IPlaceholderEditMutation = {
  upsert?: Maybe<IPlaceholderEditItem>;
};


export type IPlaceholderEditMutationUpsertArgs = {
  params: IPlaceholderEditUpsertInput;
};

export type IPlaceholderEditQuery = {
  get: IPlaceholderEditItem;
};


export type IPlaceholderEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type IPlaceholderEditUpsertInput = {
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  subject?: InputMaybe<Scalars['ID']>;
};

export type IPlaceholder_QueryItemSessionData = IQueryItemSessionData & {
  id: Scalars['ID'];
};

export type IPreparatorDescription = {
  description?: Maybe<ILangString>;
  id: Scalars['String'];
  name: ILangString;
  obsolete?: Maybe<Scalars['Boolean']>;
  properties: Array<IEnrichmentProperty>;
};

export type IPreparatorDescriptionInput = {
  description?: InputMaybe<ILangStringInput>;
  id: Scalars['String'];
  name?: InputMaybe<ILangStringInput>;
  obsolete?: InputMaybe<Scalars['Boolean']>;
  properties?: InputMaybe<Array<IEnrichmentPropertyInput>>;
};

export type IPrintSessionResult = {
  browserSessionId: Scalars['ID'];
  href: Scalars['ID'];
  id: Scalars['ID'];
};

export type IPrivilege = {
  privilege: Privilege;
};

export enum ProgressSymbolSet {
  V1 = 'v1',
  V2 = 'v2'
}

export type IQuery = {
  ChoiceTextEdit: IChoiceTextEditQuery;
  CrossoutEdit: ICrossoutEditQuery;
  EssayEdit: IEssayEditQuery;
  FillInGapEdit?: Maybe<IFillInGapEditQuery>;
  FillInPoolEdit?: Maybe<IFillInPoolEditQuery>;
  InstructionEdit?: Maybe<IInstructionEditQuery>;
  InvisibleHotSpotEdit: IInvisibleHotSpotEditQuery;
  LineTextEntryEdit: ILineTextEntryEditQuery;
  MatchingHotspotEdit?: Maybe<IMatchingHotspotEditQuery>;
  MatchingImageEdit: IMatchingImageEditQuery;
  MatchingTextEdit: IMatchingTextEditQuery;
  MultipleChoiceEdit: IMultipleChoiceEditQuery;
  MultistepHotSpotEdit: IMultistepHotSpotEditQuery;
  OrderingSelectionEdit: IOrderingSelectionEditQuery;
  OrderingSentencesEdit: IOrderingSentencesEditQuery;
  OrderingWordsEdit: IOrderingWordsEditQuery;
  OrganisationEdit: IOrganisationEdit_Query;
  PlaceholderEdit?: Maybe<IPlaceholderEditQuery>;
  SingleChoiceHotspotEdit?: Maybe<ISingleChoiceHotspotEditQuery>;
  SingleChoiceImageEdit: ISingleChoiceImageEditQuery;
  SingleChoiceMatrixEdit: ISingleChoiceMatrixEditQuery;
  SingleChoiceTextEdit: ISingleChoiceTextEditQuery;
  SpellingMatrixEdit: ISpellingMatrixEdit_Query;
  SurveyComboEdit: ISurveyComboEditQuery;
  SurveyComparisionEdit: ISurveyComparisionEditQuery;
  SurveySingleChoiceMatrixEdit: ISurveySingleChoiceMatrixEditQuery;
  SurveySingleChoiceTextEdit: ISurveySingleChoiceTextEditQuery;
  SurveyTextEntryEdit?: Maybe<ISurveyTextEntryEditQuery>;
  SurveyTextInputEdit: ISurveyTextInputEditQuery;
  TestAlias: ITestAliasQueries;
  TestDefinitionProfile: ITestDefinitionProfileQueries;
  TextEntryAutoEdit?: Maybe<ITextEntryAutoEditQuery>;
  TextEntryManualEdit?: Maybe<ITextEntryManualEditQuery>;
  TextEntryManualGrading: ITextEntryManualGradingQuery;
  TypingTest2023Edit: ITypingTest2023EditQuery;
  TypingTestEdit: ITypingTestEditQuery;
  alternationRestrictions: Array<IAlternationRestriction>;
  audiences: IAudienceQuery;
  author?: Maybe<IAuthorQuery>;
  browserSessions: Array<IBrowserSession>;
  config: IConfigQuery;
  containerEdit?: Maybe<IContainerEditQuery>;
  deus: IDeusQueries;
  documents?: Maybe<IDocumentQuery>;
  /** @deprecated not supported anymore */
  donkey?: Maybe<IDonkeyQuery>;
  dummy?: Maybe<Scalars['String']>;
  enrichment: IEnrichmentQuery;
  essayGrading: IEssayGradingQuery;
  examOrder: IExamOrderQuery;
  examSession: IQueryExamSession;
  examSessions: Array<IQueryExamSession>;
  examination: IExaminationQueries;
  getItemTranslations: Array<IItemTranslations>;
  getUserById: IUserDocument;
  golemScripts: IGolemScriptQuery;
  handsOnEdit?: Maybe<IHandsOnEditQuery>;
  hasSessionForWave: Array<ISessionForWaveResult>;
  inApplicationComboEdit: IInApplicationComboEditQuery;
  item: IItemQuery;
  itemForManualGrading: IItemForManualGrading;
  itemGradingData: Array<IItemGradingData>;
  itemsForBulkGrading: Array<IItemForBulkGrading>;
  itemsForManualGrading: Array<IItemForManualGrading>;
  itemtype: IItemTypeQuery;
  itemtypes: Array<IIItemType>;
  parseUserAgent?: Maybe<IUserAgentVersion>;
  scormTokens: IScormTokenQuery;
  sessionItem: IQueryItemInSession;
  statisticexportconfig: IStatisticExportConfigQuery;
  subjectById: ISubjectDocument;
  subjects: Array<ISubjectDocument>;
  taxonomy: ITaxonomyQuery;
  users: Array<IUserDocument>;
  whoAmI: IBrowserSession;
};


export type IQueryExamSessionArgs = {
  params: IExamSessionQueryInput;
};


export type IQueryExamSessionsArgs = {
  params: IExamSessionsQueryInput;
};


export type IQueryGetItemTranslationsArgs = {
  params: IGetItemTranslationsInput;
};


export type IQueryGetUserByIdArgs = {
  userDocRef: Scalars['ID'];
};


export type IQueryHasSessionForWaveArgs = {
  params: ISessionForWaveQueryInput;
};


export type IQueryItemForManualGradingArgs = {
  itemId: Scalars['ID'];
};


export type IQueryItemGradingDataArgs = {
  itemId: Scalars['ID'];
  sessions: Array<Scalars['ID']>;
};


export type IQueryItemsForBulkGradingArgs = {
  subject: Scalars['ID'];
};


export type IQueryItemsForManualGradingArgs = {
  subject: Scalars['ID'];
};


export type IQueryItemtypesArgs = {
  filter?: InputMaybe<IGetItemTypesFilter>;
};


export type IQueryParseUserAgentArgs = {
  userAgentString: Scalars['String'];
};


export type IQuerySessionItemArgs = {
  params: ISessionItemQueryInput;
};


export type IQuerySubjectByIdArgs = {
  docReferenceId: Scalars['ID'];
};


export type IQuerySubjectsArgs = {
  myRole?: InputMaybe<Privilege>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type IQueryUsersArgs = {
  pager?: InputMaybe<IPagerInput>;
};

export type IQueryExamSession = {
  auditCreated: Scalars['String'];
  auditUpdated: Scalars['String'];
  candidate?: Maybe<IQueryExamSessionCandidate>;
  currentItem?: Maybe<IQueryItemInSession>;
  currentSection?: Maybe<IQueryExamSessionSectionInSession>;
  customField?: Maybe<IQueryExamSessionCustomField>;
  customFields: Array<IQueryExamSessionCustomField>;
  docReferenceId: Scalars['ID'];
  examInfo: IQueryExamSessionExamInfo;
  externalId?: Maybe<Scalars['ID']>;
  flags: Array<Scalars['String']>;
  golemScript?: Maybe<IGolemScriptDocument>;
  id: Scalars['ID'];
  item: IQueryItemInSession;
  itemInfo: IAccumulatedInteractionStatus;
  items: Array<IQueryItemInSession>;
  json: Scalars['String'];
  maxTime: Scalars['String'];
  mode: SessionModesEnum;
  notification: IQueryExamSessionNotification;
  objectives: Array<IQueryItemInSessionObjective>;
  resultPdf?: Maybe<IResultPdf>;
  score?: Maybe<IScore>;
  scormData: Scalars['String'];
  sections: Array<IQueryExamSessionSectionInSession>;
  sessionCloseTime: Scalars['String'];
  sessionId: Scalars['String'];
  sessionStartTime: Scalars['String'];
  startMode: SessionStartModesEnum;
  timeLeft: IQueryTimeStamp;
  topItemComplete: ITopItemCompleteResult;
  totalTime: Scalars['String'];
};


export type IQueryExamSessionCustomFieldArgs = {
  name: Scalars['ID'];
};


export type IQueryExamSessionItemArgs = {
  itemId: Scalars['ID'];
};


export type IQueryExamSessionItemInfoArgs = {
  mode?: InputMaybe<ScoreModeAfterGrading>;
  symbols?: InputMaybe<ProgressSymbolSet>;
};


export type IQueryExamSessionItemsArgs = {
  order?: InputMaybe<ExamSessionItemOrder>;
  topItemsOnly?: InputMaybe<Scalars['Boolean']>;
};


export type IQueryExamSessionObjectivesArgs = {
  mode?: InputMaybe<ScoreModeAfterGrading>;
  params?: InputMaybe<IQueryExamSessionObjectivesInput>;
};


export type IQueryExamSessionScoreArgs = {
  mode?: InputMaybe<ScoreModeAfterGrading>;
};


export type IQueryExamSessionTimeLeftArgs = {
  clientTime?: InputMaybe<Scalars['String']>;
};


export type IQueryExamSessionTopItemCompleteArgs = {
  topItemId: Scalars['ID'];
};

export type IQueryExamSessionCandidate = {
  candidateId: Scalars['String'];
  display: Scalars['String'];
};

export type IQueryExamSessionCustomField = {
  id: Scalars['ID'];
  name: Scalars['ID'];
  type: CustomFieldType;
  value: Scalars['String'];
};

export type IQueryExamSessionExamInfo = {
  continueWith: ContinueWithEnum;
  examAlias: Scalars['String'];
  examId: Scalars['String'];
  examType: TestTypeEnum;
  executionPage: IExecutionPage;
  grade?: Maybe<IGrade>;
  grades: Array<IGrade>;
  hasInApplication: Scalars['Boolean'];
  itemHost: ItemHostEnum;
  languageTag: Scalars['String'];
  masteryScore: Scalars['Float'];
  maxScore: Scalars['Float'];
  navigationStyle: NavigationStyleEnum;
  passesRestrictions: Scalars['Boolean'];
  pdfReportSettings: IPdfReportSettings;
  resetOnNavigate: Scalars['Boolean'];
  restrictions: Scalars['String'];
  resultPage: IResultPage;
  title: Scalars['String'];
  version?: Maybe<Scalars['String']>;
  versionDate?: Maybe<Scalars['String']>;
  welcomePage: IWelcomePage;
};


export type IQueryExamSessionExamInfoPassesRestrictionsArgs = {
  userAgentString: Scalars['String'];
};


export type IQueryExamSessionExamInfoRestrictionsArgs = {
  userAgentString?: InputMaybe<Scalars['String']>;
};

export type IQueryExamSessionGradingRuntimeObjective = {
  id: Scalars['String'];
  scoreGained: Scalars['Float'];
  scoreLost: Scalars['Float'];
  scoreMax: Scalars['Float'];
  scorePending: Scalars['Float'];
};

export type IQueryExamSessionItemInSessionInteractionStatus = {
  closed?: Maybe<Scalars['Boolean']>;
  complete?: Maybe<Scalars['Boolean']>;
  locked?: Maybe<Scalars['Boolean']>;
  started?: Maybe<Scalars['Boolean']>;
};

export type IQueryExamSessionNotification = {
  email?: Maybe<Scalars['String']>;
  emailConfirmed: EMailConfirmed;
  emailSent: SentEnum;
};

export type IQueryExamSessionObjectivesInput = {
  maxDepth?: InputMaybe<Scalars['Int']>;
};

export type IQueryExamSessionSectionInSession = {
  id: Scalars['ID'];
  items: Array<IQueryItemInSession>;
  sectionInfo: IQueryExamSessionSectionInfo;
};

export type IQueryExamSessionSectionInfo = {
  alternateColor?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  itemInfo?: Maybe<IAccumulatedInteractionStatus>;
  name?: Maybe<Scalars['String']>;
  score?: Maybe<IScore>;
  title?: Maybe<Scalars['String']>;
};


export type IQueryExamSessionSectionInfoItemInfoArgs = {
  mode?: InputMaybe<ScoreModeAfterGrading>;
  symbols?: InputMaybe<ProgressSymbolSet>;
};


export type IQueryExamSessionSectionInfoScoreArgs = {
  mode?: InputMaybe<ScoreModeAfterGrading>;
};

export type IQueryItemInSession = {
  HandsOn_Data?: Maybe<IHandsOn_TopItemData>;
  accumulatedScore?: Maybe<IScore>;
  attachments: Array<IAttachmentUrlObject>;
  childItemsCount: Scalars['Int'];
  data?: Maybe<IQueryItemSessionData>;
  gradingMode?: Maybe<GradingModeEnum>;
  hasFocusMode: Scalars['Boolean'];
  id: Scalars['ID'];
  index: Scalars['Int'];
  interactionStatus?: Maybe<IQueryExamSessionItemInSessionInteractionStatus>;
  isOnlySibling: Scalars['Boolean'];
  isTopItem: Scalars['Boolean'];
  itemDocRefId: Scalars['String'];
  itemId: Scalars['String'];
  itemInfo: IAccumulatedInteractionStatus;
  itemType: Scalars['String'];
  minHeight: Scalars['Int'];
  minWidth: Scalars['Int'];
  navigationStatus: ItemNavigationStatus;
  objectives?: Maybe<Array<IQueryItemInSessionObjective>>;
  parentItems: Array<IQueryItemInSession>;
  score?: Maybe<IScore>;
  subject?: Maybe<Scalars['String']>;
  title: ILangString;
};


export type IQueryItemInSessionAccumulatedScoreArgs = {
  mode?: InputMaybe<ScoreModeAfterGrading>;
};


export type IQueryItemInSessionItemInfoArgs = {
  mode?: InputMaybe<ScoreModeAfterGrading>;
  symbols?: InputMaybe<ProgressSymbolSet>;
};


export type IQueryItemInSessionObjectivesArgs = {
  mode?: InputMaybe<ScoreModeAfterGrading>;
};


export type IQueryItemInSessionScoreArgs = {
  mode?: InputMaybe<ScoreModeAfterGrading>;
};

export type IQueryItemInSessionObjective = {
  description: ILangString;
  id: Scalars['ID'];
  objectiveDepth: Scalars['Int'];
  objectiveId: Scalars['String'];
  scoreGained?: Maybe<Scalars['Float']>;
  scoreLost?: Maybe<Scalars['Float']>;
  scoreMax?: Maybe<Scalars['Float']>;
  scorePending?: Maybe<Scalars['Float']>;
  taxonomyId: Scalars['String'];
};

export type IQueryItemSessionData = {
  id: Scalars['ID'];
};

export type IQueryTimeStamp = {
  clientTime?: Maybe<Scalars['String']>;
  isTicking: Scalars['Boolean'];
  lastUpdate: Scalars['String'];
  maxTime: Scalars['String'];
  serverTime: Scalars['String'];
  stale: Scalars['Boolean'];
  timeLeft: Scalars['String'];
  timePassed: Scalars['String'];
};

export enum ResetOnNavigateEnum {
  Always = 'always',
  Default = 'default',
  Never = 'never'
}

export type IResolvedExamAlias = {
  client?: Maybe<IVersionRestriction>;
  examAlias: Scalars['String'];
  examinationCount: Scalars['Int'];
};

export type IResult = {
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  result: Scalars['Boolean'];
};

export type IResultPage = {
  closeButton: IButton;
  displayItemId: DisplayItemIdEnum;
  displayObjectiveId: DisplayObjectiveIdEnum;
  email: ResultPageEMail;
  emailLabel: ILangString;
  emailText: ILangString;
  itemHeader: ILangString;
  itemText: ILangString;
  objectiveHeader: ILangString;
  objectiveMaxDepth: Scalars['Int'];
  objectiveMinDepth: Scalars['Int'];
  objectiveText: ILangString;
  pdf: ResultPagePdf;
  pdfButton: IButton;
  text: ILangString;
};

export enum ResultPageEMail {
  No = 'no',
  Optional = 'optional',
  Required = 'required'
}

export enum ResultPagePdf {
  No = 'no',
  Yes = 'yes'
}

export type IResultPdf = {
  href: Scalars['String'];
  hrefResolved: Scalars['String'];
  id: Scalars['ID'];
};

export type IReviseItemInput = {
  docRefId: Scalars['String'];
  noteForAuthor?: InputMaybe<Scalars['String']>;
  targetUserDocRefId?: InputMaybe<Scalars['String']>;
};

export type IRichTextBlock = {
  id: Scalars['ID'];
  paragraphs?: Maybe<Array<Maybe<IRichTextBlock_Paragraph>>>;
};

export type IRichTextBlock_Paragraph = {
  cssClass?: Maybe<Scalars['String']>;
  html?: Maybe<ILangString>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imageHeight?: Maybe<Scalars['Float']>;
  imageWidth?: Maybe<Scalars['Float']>;
  text?: Maybe<ILangString>;
};

export enum RingBufferOptions {
  Any = 'any',
  Next = 'next',
  Previous = 'previous'
}

export type IScoData = {
  browserSessionId: Scalars['String'];
  launchUrl: Scalars['String'];
  mode: SessionModesEnum;
  scormData: Scalars['String'];
  sessionId: Scalars['String'];
  suspendData: Scalars['String'];
};

export type IScore = IIScore & {
  pointsGained: Scalars['Float'];
  pointsLost: Scalars['Float'];
  pointsMax: Scalars['Float'];
  pointsPending: Scalars['Float'];
  pointsPercentage?: Maybe<Scalars['Int']>;
};

export enum ScoreModeAfterGrading {
  NoPending = 'NoPending',
  UnstartedAsPending = 'UnstartedAsPending'
}

export enum ScoreRoundingModeEnum {
  Default = 'Default',
  IntegerHalfUp = 'IntegerHalfUp',
  IntegerUp = 'IntegerUp',
  NoRounding = 'NoRounding'
}

export type IScormToken = IItemBankDoc & {
  _id: Scalars['String'];
  _rev: Scalars['String'];
  attachments: Array<IAttachmentUrlObject>;
  auditCreated: Scalars['String'];
  auditUpdated: Scalars['String'];
  docReferenceId: Scalars['String'];
  docType: Doctype;
  downloadCode: Scalars['String'];
  examAlias: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  lmsOrgins: Array<Scalars['String']>;
  name: ILangString;
  privateDownloadUrl: Scalars['String'];
  publicDownloadUrl?: Maybe<Scalars['String']>;
  scormTokenId: Scalars['String'];
  status: ScormTokenStatus;
  trackability: ScormTokenTrackability;
};

export type IScormTokenFilterOptions = {
  showDeleted?: InputMaybe<TriStateEnum>;
  status?: InputMaybe<ScormTokenStatus>;
};

export type IScormTokenMutation = {
  newScormToken: IScormToken;
  upsertScormToken: IScormToken;
};


export type IScormTokenMutationNewScormTokenArgs = {
  args: INewScormTokenArgs;
};


export type IScormTokenMutationUpsertScormTokenArgs = {
  params: IUpsertScormTokenInput;
};

export type IScormTokenQuery = {
  all: Array<IScormToken>;
  byId: IScormToken;
};


export type IScormTokenQueryAllArgs = {
  filter?: InputMaybe<IScormTokenFilterOptions>;
};


export type IScormTokenQueryByIdArgs = {
  docRef: Scalars['ID'];
};

export enum ScormTokenStatus {
  Active = 'active',
  Closing = 'closing',
  Inactive = 'inactive'
}

export enum ScormTokenTrackability {
  Anonymous = 'anonymous',
  Verbatim = 'verbatim'
}

export enum SentEnum {
  No = 'no',
  Yes = 'yes'
}

export type ISessionActivity = {
  /** @deprecated not supported anymore */
  activity: SessionActivityEnum;
  /** @deprecated not supported anymore */
  donkeyId?: Maybe<Scalars['ID']>;
  /** @deprecated not supported anymore */
  id: Scalars['ID'];
  /** @deprecated not supported anymore */
  message?: Maybe<ILangString>;
  /** @deprecated not supported anymore */
  topItemId?: Maybe<Scalars['ID']>;
};

export enum SessionActivityEnum {
  DonkeyConnected = 'DonkeyConnected',
  DonkeyDisconnected = 'DonkeyDisconnected',
  ItemCacheCompleted = 'ItemCacheCompleted',
  ItemCacheFailed = 'ItemCacheFailed',
  ItemCacheProgress = 'ItemCacheProgress',
  ItemCacheStarted = 'ItemCacheStarted',
  ItemCleanupCompleted = 'ItemCleanupCompleted',
  ItemCleanupFailed = 'ItemCleanupFailed',
  ItemCleanupProgress = 'ItemCleanupProgress',
  ItemCleanupStarted = 'ItemCleanupStarted',
  ItemInvestigateCompleted = 'ItemInvestigateCompleted',
  ItemInvestigateFailed = 'ItemInvestigateFailed',
  ItemInvestigateProgress = 'ItemInvestigateProgress',
  ItemInvestigateStarted = 'ItemInvestigateStarted',
  ItemResetCompleted = 'ItemResetCompleted',
  ItemResetFailed = 'ItemResetFailed',
  ItemResetProgress = 'ItemResetProgress',
  ItemResetStarted = 'ItemResetStarted',
  ItemSetupCompleted = 'ItemSetupCompleted',
  ItemSetupFailed = 'ItemSetupFailed',
  ItemSetupProgress = 'ItemSetupProgress',
  ItemSetupStarted = 'ItemSetupStarted'
}

export type ISessionForWaveQueryInput = {
  candidateId?: InputMaybe<Scalars['String']>;
  waveDocRefId?: InputMaybe<Array<Scalars['String']>>;
};

export type ISessionForWaveResult = {
  hasSessions?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  waveDocRefId: Scalars['String'];
};

export type ISessionItemQueryInput = {
  itemDocRefId: Scalars['String'];
  sessionDocRefId: Scalars['String'];
};

export enum SessionModesEnum {
  Archived = 'Archived',
  AvailableForExport = 'AvailableForExport',
  AvailableForGrading = 'AvailableForGrading',
  AvailableForParticipation = 'AvailableForParticipation',
  Exported = 'Exported',
  Graded = 'Graded',
  Grading = 'Grading',
  New = 'New',
  Participated = 'Participated',
  Participating = 'Participating'
}

export enum SessionStartModesEnum {
  Aborted = 'Aborted',
  Finished = 'Finished',
  NotYetStarted = 'NotYetStarted',
  Paused = 'Paused',
  Started = 'Started'
}

export type ISetUserFieldInput = {
  name: Scalars['ID'];
  serialized: Scalars['String'];
  type: CustomFieldType;
};

export type ISharePointConnection = {
  downloadFolder: Scalars['String'];
  forcedImport: Scalars['Int'];
  id: Scalars['ID'];
  password: Scalars['String'];
  siteUrl: Scalars['String'];
  triggerKey: Scalars['String'];
  username: Scalars['String'];
};

export enum ShowImmediateResult {
  Never = 'never',
  Scored = 'scored'
}

export enum ShowItemMaxScore {
  Default = 'default',
  No = 'no',
  Yes = 'yes'
}

export type ISingleChoiceHotspotEditItem = {
  header: ILangString;
  id: Scalars['ID'];
  image?: Maybe<IAttachmentUrlObject>;
  imageHeight?: Maybe<Scalars['Int']>;
  imageWidth?: Maybe<Scalars['Int']>;
  question: ILangString;
  shapes: Array<ISingleChoiceHotspotEdit_Shape>;
};

export type ISingleChoiceHotspotEditMutation = {
  addCircle?: Maybe<ISingleChoiceHotspotEdit_Shape>;
  upsert?: Maybe<ISingleChoiceHotspotEditItem>;
};


export type ISingleChoiceHotspotEditMutationAddCircleArgs = {
  itemId: Scalars['ID'];
  radius: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};


export type ISingleChoiceHotspotEditMutationUpsertArgs = {
  params: ISingleChoiceHotspotEditUpsertInput;
};

export type ISingleChoiceHotspotEditQuery = {
  get: ISingleChoiceHotspotEditItem;
};


export type ISingleChoiceHotspotEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type ISingleChoiceHotspotEditUpsertInput = {
  correct?: InputMaybe<Scalars['ID']>;
  header?: InputMaybe<IUpsertLangStringInput>;
  image?: InputMaybe<Scalars['String']>;
  imageHeight?: InputMaybe<Scalars['Int']>;
  imageWidth?: InputMaybe<Scalars['Int']>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removeShapes?: InputMaybe<Array<Scalars['ID']>>;
  setShapes?: InputMaybe<Array<ISingleChoiceHotspotEdit_UpsertShape>>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertShapes?: InputMaybe<Array<ISingleChoiceHotspotEdit_UpsertShape>>;
};

export type ISingleChoiceHotspotEdit_Shape = {
  correct: Scalars['Boolean'];
  id: Scalars['ID'];
  index: Scalars['ID'];
  shape: Scalars['String'];
};

export type ISingleChoiceHotspotEdit_UpsertShape = {
  correct?: InputMaybe<Scalars['Boolean']>;
  index: Scalars['ID'];
  shape?: InputMaybe<Scalars['String']>;
};

export type ISingleChoiceImageEditItem = {
  answers: Array<ISingleChoiceImageEdit_Answer>;
  header: ILangString;
  id: Scalars['ID'];
  imgHeight: Scalars['Int'];
  imgWidth: Scalars['Int'];
  question: ILangString;
};

export type ISingleChoiceImageEditMutation = {
  upsert: ISingleChoiceImageEditItem;
};


export type ISingleChoiceImageEditMutationUpsertArgs = {
  params: ISingleChoiceImageEditUpsertInput;
};

export type ISingleChoiceImageEditQuery = {
  get: ISingleChoiceImageEditItem;
};


export type ISingleChoiceImageEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type ISingleChoiceImageEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  imgHeight?: InputMaybe<Scalars['Int']>;
  imgWidth?: InputMaybe<Scalars['Int']>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removeAnsers?: InputMaybe<Array<Scalars['ID']>>;
  setAnswers?: InputMaybe<Array<ISingleChoiceImageEdit_UpsertAnswer>>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertAnswers?: InputMaybe<Array<ISingleChoiceImageEdit_UpsertAnswer>>;
};

export type ISingleChoiceImageEdit_Answer = {
  correct: Scalars['Boolean'];
  id: Scalars['ID'];
  image?: Maybe<IAttachmentUrlObject>;
  index: Scalars['ID'];
};

export type ISingleChoiceImageEdit_UpsertAnswer = {
  correct?: InputMaybe<Scalars['Boolean']>;
  image?: InputMaybe<Scalars['String']>;
  index: Scalars['ID'];
};

export type ISingleChoiceMatrixEditItem = {
  columns: Array<ISingleChoiceMatrixEdit_Column>;
  header: ILangString;
  id: Scalars['ID'];
  question: ILangString;
  rows: Array<ISingleChoiceMatrixEdit_Row>;
  scoring: SingleChoiceMatrixEdit_Scoring;
  shuffleColumn: SingleChoiceMatrixEdit_ShuffleColumn;
  shuffleRow: SingleChoiceMatrixEdit_ShuffleRow;
};

export type ISingleChoiceMatrixEditMutation = {
  upsert: ISingleChoiceMatrixEditItem;
};


export type ISingleChoiceMatrixEditMutationUpsertArgs = {
  params: ISingleChoiceMatrixEditUpsertInput;
};

export type ISingleChoiceMatrixEditQuery = {
  get: ISingleChoiceMatrixEditItem;
};


export type ISingleChoiceMatrixEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type ISingleChoiceMatrixEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removeColumns?: InputMaybe<Array<Scalars['ID']>>;
  removeRows?: InputMaybe<Array<Scalars['ID']>>;
  scoring?: InputMaybe<SingleChoiceMatrixEdit_Scoring>;
  setColumns?: InputMaybe<Array<ISingleChoiceMatrixEdit_UpsertColumn>>;
  setRows?: InputMaybe<Array<ISingleChoiceMatrixEdit_UpsertRow>>;
  shuffleColumn?: InputMaybe<SingleChoiceMatrixEdit_ShuffleColumn>;
  shuffleRow?: InputMaybe<SingleChoiceMatrixEdit_ShuffleRow>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertColumns?: InputMaybe<Array<ISingleChoiceMatrixEdit_UpsertColumn>>;
  upsertRows?: InputMaybe<Array<ISingleChoiceMatrixEdit_UpsertRow>>;
};

export type ISingleChoiceMatrixEdit_Column = {
  id: Scalars['ID'];
  index: Scalars['ID'];
  value: ILangString;
};

export type ISingleChoiceMatrixEdit_Row = {
  correct: Scalars['ID'];
  id: Scalars['ID'];
  index: Scalars['ID'];
  score?: Maybe<Scalars['Float']>;
  value: ILangString;
};

export enum SingleChoiceMatrixEdit_Scoring {
  AllOrNothing = 'allOrNothing',
  Individual = 'individual'
}

export enum SingleChoiceMatrixEdit_ShuffleColumn {
  Ordered = 'ordered',
  Shuffled = 'shuffled',
  ShuffledExceptLast = 'shuffledExceptLast'
}

export enum SingleChoiceMatrixEdit_ShuffleRow {
  Ordered = 'ordered',
  Shuffled = 'shuffled'
}

export type ISingleChoiceMatrixEdit_UpsertColumn = {
  index: Scalars['ID'];
  value?: InputMaybe<IUpsertLangStringInput>;
};

export type ISingleChoiceMatrixEdit_UpsertRow = {
  correct?: InputMaybe<Scalars['ID']>;
  index: Scalars['ID'];
  score?: InputMaybe<Scalars['Float']>;
  value?: InputMaybe<IUpsertLangStringInput>;
};

export type ISingleChoiceTextEditItem = {
  answers: Array<ISingleChoiceTextEdit_Answer>;
  header: ILangString;
  id: Scalars['ID'];
  image?: Maybe<IAttachmentUrlObject>;
  question: ILangString;
  shuffleMode: SingleChoiceTextEdit_Shuffle;
};

export type ISingleChoiceTextEditMutation = {
  upsert: ISingleChoiceTextEditItem;
};


export type ISingleChoiceTextEditMutationUpsertArgs = {
  params: ISingleChoiceTextEditUpsertInput;
};

export type ISingleChoiceTextEditQuery = {
  get: ISingleChoiceTextEditItem;
};


export type ISingleChoiceTextEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type ISingleChoiceTextEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  image?: InputMaybe<Scalars['String']>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removeAnsers?: InputMaybe<Array<Scalars['ID']>>;
  setAnswers?: InputMaybe<Array<ISingleChoiceTextEdit_UpsertAnswer>>;
  shuffleMode?: InputMaybe<SingleChoiceTextEdit_Shuffle>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertAnswers?: InputMaybe<Array<ISingleChoiceTextEdit_UpsertAnswer>>;
};

export type ISingleChoiceTextEdit_Answer = {
  correct: Scalars['Boolean'];
  id: Scalars['ID'];
  index: Scalars['ID'];
  text: ILangString;
};

export enum SingleChoiceTextEdit_Shuffle {
  Ordered = 'ordered',
  Shuffled = 'shuffled',
  ShuffledExceptLast = 'shuffledExceptLast'
}

export type ISingleChoiceTextEdit_UpsertAnswer = {
  correct?: InputMaybe<Scalars['Boolean']>;
  index: Scalars['ID'];
  text?: InputMaybe<IUpsertLangStringInput>;
};

export type ISpellingMatrixEdit_Item = {
  header: ILangString;
  id: Scalars['ID'];
  tables: Array<ISpellingMatrixEdit_Table>;
  text: ILangString;
  values: Array<ISpellingMatrixEdit_Value>;
};

export type ISpellingMatrixEdit_Mutation = {
  upsert?: Maybe<ISpellingMatrixEdit_Item>;
};


export type ISpellingMatrixEdit_MutationUpsertArgs = {
  params: ISpellingMatrixEdit_UpsertInput;
};

export type ISpellingMatrixEdit_Query = {
  get: ISpellingMatrixEdit_Item;
};


export type ISpellingMatrixEdit_QueryGetArgs = {
  itemId: Scalars['ID'];
};

export type ISpellingMatrixEdit_Table = {
  answers: Array<Scalars['String']>;
  caption: ILangString;
  id: Scalars['ID'];
  key: Scalars['ID'];
};

export type ISpellingMatrixEdit_UpsertInput = {
  addTables?: InputMaybe<Array<ISpellingMatrixEdit_UpsertTable>>;
  addValues?: InputMaybe<Array<ISpellingMatrixEdit_UpsertValue>>;
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  removeTables?: InputMaybe<Array<Scalars['ID']>>;
  removeValues?: InputMaybe<Array<Scalars['ID']>>;
  setTables?: InputMaybe<Array<ISpellingMatrixEdit_UpsertTable>>;
  setValues?: InputMaybe<Array<ISpellingMatrixEdit_UpsertValue>>;
  subject?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<IUpsertLangStringInput>;
};

export type ISpellingMatrixEdit_UpsertTable = {
  caption?: InputMaybe<IUpsertLangStringInput>;
  key?: InputMaybe<Scalars['ID']>;
  setAnswers?: InputMaybe<Array<Scalars['String']>>;
  tableId: Scalars['ID'];
};

export type ISpellingMatrixEdit_UpsertValue = {
  gapFormat?: InputMaybe<SpellingMatrix_GapFormat>;
  key?: InputMaybe<Scalars['ID']>;
  label?: InputMaybe<Scalars['String']>;
  tableId?: InputMaybe<Scalars['ID']>;
  value?: InputMaybe<Scalars['String']>;
  valueId: Scalars['ID'];
};

export type ISpellingMatrixEdit_Value = {
  gapFormat: SpellingMatrix_GapFormat;
  id: Scalars['ID'];
  key: Scalars['ID'];
  label: Scalars['String'];
  table?: Maybe<ISpellingMatrixEdit_Table>;
  tableId: Scalars['ID'];
  value: Scalars['String'];
};

export enum SpellingMatrix_GapFormat {
  AsIs = 'AsIs',
  FirstLetterUpperCase = 'FirstLetterUpperCase'
}

export type ISpellingMatrix_QueryItemSessionData = IQueryItemSessionData & {
  header: ILangString;
  id: Scalars['ID'];
  tables: Array<ISpellingMatrix_Table>;
  text: ILangString;
};

export type ISpellingMatrix_Table = {
  answers: Array<Scalars['String']>;
  caption: ILangString;
  id: Scalars['ID'];
  values: Array<ISpellingMatrix_Value>;
};

export type ISpellingMatrix_Value = {
  correctValue?: Maybe<Scalars['String']>;
  gapFormat: SpellingMatrix_GapFormat;
  given?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type IStatisticExportConfig = IItemBankDoc & {
  _id: Scalars['String'];
  _rev: Scalars['String'];
  accumulatedObjectivesColumns: Array<Scalars['ID']>;
  attachments: Array<IAttachmentUrlObject>;
  colNameItemScore: Scalars['String'];
  colNameItemScoreMax: Scalars['String'];
  colNameItemScorePercentage: Scalars['String'];
  colNameItemText: Scalars['String'];
  colNameItemType: Scalars['String'];
  colNameItemTypeId: Scalars['String'];
  colNameItemValue: Scalars['String'];
  colNameSessionScore: Scalars['String'];
  colNameSessionScoreMax: Scalars['String'];
  colNameSessionScorePercentage: Scalars['String'];
  colNameSessionStatus: Scalars['String'];
  colNameTopItemScore: Scalars['String'];
  colNameTopItemScoreMax: Scalars['String'];
  colNameTopItemScorePercentage: Scalars['String'];
  configurationId: Scalars['ID'];
  docReferenceId: Scalars['String'];
  docType: Doctype;
  exportAnswers: Scalars['Boolean'];
  exportCsv: Scalars['Boolean'];
  exportItemText: Scalars['Boolean'];
  exportItems: Scalars['Boolean'];
  exportJson: Scalars['Boolean'];
  exportObjectives: Scalars['Boolean'];
  exportSessions: Scalars['Boolean'];
  exportXlsx: Scalars['Boolean'];
  externalIdColumn: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  maxObjectiveDepth: Scalars['Int'];
  mergeItemIdRegex: Scalars['String'];
  onlyUpdate: Scalars['Boolean'];
  sessionIdColumn: Scalars['String'];
  textexport_itemIds: Array<Scalars['ID']>;
  title: Scalars['String'];
  xlsxFilename: Scalars['String'];
  yamlConfig: Scalars['String'];
};

export type IStatisticExportConfigMutation = {
  upsert: IStatisticExportConfig;
};


export type IStatisticExportConfigMutationUpsertArgs = {
  params: IUpsertStatisticExportConfigInput;
};

export type IStatisticExportConfigQuery = {
  all: Array<IStatisticExportConfig>;
  byId: IStatisticExportConfig;
  getYamlConfig: Scalars['String'];
};


export type IStatisticExportConfigQueryAllArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type IStatisticExportConfigQueryByIdArgs = {
  idOrDocRef: Scalars['ID'];
};


export type IStatisticExportConfigQueryGetYamlConfigArgs = {
  params: IStatisticExportConfigQueryGetYamlConfigOptions;
};

export type IStatisticExportConfigQueryGetYamlConfigOptions = {
  examOrAlias: Array<Scalars['ID']>;
  includeAccumulatedScore?: InputMaybe<Scalars['Boolean']>;
  includeItemRaw?: InputMaybe<Scalars['Boolean']>;
  includeItemScore?: InputMaybe<Scalars['Boolean']>;
};

export type ISubjectDocument = IItemBankDoc & {
  _id: Scalars['String'];
  _rev: Scalars['String'];
  allowNonTranslateable: Scalars['Boolean'];
  alternateColor?: Maybe<Scalars['String']>;
  attachments: Array<IAttachmentUrlObject>;
  audiences: Array<IAudienceDocument>;
  authors: Array<IUserDocument>;
  categories: Array<ITaxonomyItem>;
  color?: Maybe<Scalars['String']>;
  /** @deprecated Field no longer supported */
  defaultLanguage?: Maybe<Scalars['String']>;
  defaultLocalization?: Maybe<ILocalization>;
  description: Scalars['String'];
  docReferenceId: Scalars['String'];
  docType: Doctype;
  evaluators: Array<IUserDocument>;
  image?: Maybe<IAttachmentUrlObject>;
  isDeleted: Scalars['Boolean'];
  itemEditVisibility: ItemEditVisibility;
  itemsForAuthor: Array<IItemDocument>;
  itemsForBulkGrading: Array<IItemForBulkGrading>;
  itemsForManualGrading: Array<IItemForManualGrading>;
  itemsForSubjectCoordinator: Array<IItemDocument>;
  myPrivilege?: Maybe<ISubjectPrivilege>;
  myPrivileges: Array<ISubjectPrivilege>;
  openExamOrders: Array<IExamOrder>;
  subjectCoordinators: Array<IUserDocument>;
  subjectId: Scalars['String'];
  syllabus: Array<ITaxonomyItem>;
  title: Scalars['String'];
};


export type ISubjectDocumentItemsForAuthorArgs = {
  filter?: InputMaybe<IItemFilterOptions>;
};


export type ISubjectDocumentItemsForSubjectCoordinatorArgs = {
  filter?: InputMaybe<IItemFilterOptions>;
};


export type ISubjectDocumentMyPrivilegeArgs = {
  privilege: Privilege;
};

export type ISubjectMutation = {
  newSubject: ISubjectDocument;
  upsertSubject: ISubjectDocument;
};


export type ISubjectMutationUpsertSubjectArgs = {
  params: IUpsertSubjectInput;
};

export type ISubjectPrivilege = IPrivilege & {
  privilege: Privilege;
  subjects: Array<ISubjectDocument>;
};

export type ISubscription = {
  /** @deprecated not supported anymore */
  donkey: IDonkeyCommand;
  dummy?: Maybe<Scalars['String']>;
  /** @deprecated not supported anymore */
  session: ISessionActivity;
};


export type ISubscriptionDonkeyArgs = {
  donkeyId: Scalars['ID'];
};


export type ISubscriptionSessionArgs = {
  sessionId: Scalars['ID'];
};

export type ISupportItemTypesFilterArgs = {
  except?: InputMaybe<Array<Scalars['String']>>;
  only?: InputMaybe<Array<Scalars['String']>>;
};

export type ISurveyComboEditItem = {
  header: ILangString;
  hideCaption: ILangString;
  id: Scalars['ID'];
  showCaption: ILangString;
  showHideButtonOrder: SurveyCombo_ShowHideButtonOrder;
  text: ILangString;
};

export type ISurveyComboEditMutation = {
  upsert?: Maybe<ISurveyComboEditItem>;
};


export type ISurveyComboEditMutationUpsertArgs = {
  params: ISurveyComboEditUpsertInput;
};

export type ISurveyComboEditQuery = {
  get: ISurveyComboEditItem;
};


export type ISurveyComboEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type ISurveyComboEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  hideCaption?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  showCaption?: InputMaybe<IUpsertLangStringInput>;
  showHideButtonOrder?: InputMaybe<SurveyCombo_ShowHideButtonOrder>;
  subject?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<IUpsertLangStringInput>;
};

export type ISurveyCombo_QueryItemSessionData = IQueryItemSessionData & {
  header: ILangString;
  hideCaption: ILangString;
  id: Scalars['ID'];
  showCaption: ILangString;
  showHideButtonOrder: SurveyCombo_ShowHideButtonOrder;
  showSubItems: SurveyCombo_ShowSubItems;
  subItems: Array<ISurveyCombo_SubItem>;
  text: ILangString;
};

export enum SurveyCombo_ShowHideButtonOrder {
  HideShow = 'HideShow',
  None = 'None',
  ShowHide = 'ShowHide'
}

export enum SurveyCombo_ShowSubItems {
  No = 'no',
  Undefined = 'undefined',
  Yes = 'yes'
}

export type ISurveyCombo_SubItem = {
  id: Scalars['ID'];
  itemDocRefId: Scalars['String'];
  itemType: Scalars['String'];
  status: SurveyCombo_SubItem_StatusEnum;
};

export enum SurveyCombo_SubItem_StatusEnum {
  Done = 'Done',
  NotYetStarted = 'NotYetStarted',
  Started = 'Started'
}

export type ISurveyComparisionEditItem = {
  columns: Array<ISurveyComparisionEdit_Column>;
  header: ILangString;
  id: Scalars['ID'];
  question: ILangString;
  rows: Array<ISurveyComparisionEdit_Row>;
  scale: Array<ISurveyComparisionEdit_Scale>;
};

export type ISurveyComparisionEditMutation = {
  upsert: ISurveyComparisionEditItem;
};


export type ISurveyComparisionEditMutationUpsertArgs = {
  params: ISurveyComparisionEditUpsertInput;
};

export type ISurveyComparisionEditQuery = {
  get: ISurveyComparisionEditItem;
};


export type ISurveyComparisionEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type ISurveyComparisionEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removeColumns?: InputMaybe<Array<Scalars['ID']>>;
  removeRows?: InputMaybe<Array<Scalars['ID']>>;
  removeScale?: InputMaybe<Array<Scalars['ID']>>;
  setColumns?: InputMaybe<Array<ISurveyComparisionEdit_UpsertColumn>>;
  setRows?: InputMaybe<Array<ISurveyComparisionEdit_UpsertRow>>;
  setScale?: InputMaybe<Array<ISurveyComparisionEdit_UpsertScale>>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertColumns?: InputMaybe<Array<ISurveyComparisionEdit_UpsertColumn>>;
  upsertRows?: InputMaybe<Array<ISurveyComparisionEdit_UpsertRow>>;
  upsertScale?: InputMaybe<Array<ISurveyComparisionEdit_UpsertScale>>;
};

export type ISurveyComparisionEdit_Column = {
  caption: ILangString;
  id: Scalars['ID'];
  index: Scalars['ID'];
  objective?: Maybe<ITaxonomyItem>;
  objectiveId?: Maybe<Scalars['String']>;
  score: Scalars['Float'];
};

export type ISurveyComparisionEdit_Row = {
  caption: ILangString;
  id: Scalars['ID'];
  index: Scalars['ID'];
};

export type ISurveyComparisionEdit_Scale = {
  hint: ILangString;
  id: Scalars['ID'];
  index: Scalars['ID'];
  invalid: Scalars['Boolean'];
  value: Scalars['Int'];
};

export type ISurveyComparisionEdit_UpsertColumn = {
  caption?: InputMaybe<IUpsertLangStringInput>;
  index: Scalars['ID'];
  objectiveId?: InputMaybe<Scalars['ID']>;
};

export type ISurveyComparisionEdit_UpsertRow = {
  caption?: InputMaybe<IUpsertLangStringInput>;
  index: Scalars['ID'];
};

export type ISurveyComparisionEdit_UpsertScale = {
  hint?: InputMaybe<IUpsertLangStringInput>;
  index: Scalars['ID'];
  invalid?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type ISurveyComparision_QueryItemSessionData = IQueryItemSessionData & {
  cells: Array<ISurveyComparision_QueryItemSessionData_Cell>;
  columns: Array<ISurveyComparision_QueryItemSessionData_Column>;
  header: ILangString;
  id: Scalars['ID'];
  question: ILangString;
  rows: Array<ISurveyComparision_QueryItemSessionData_Row>;
  scale: Array<ISurveyComparision_QueryItemSessionData_Scale>;
};

export type ISurveyComparision_QueryItemSessionData_Cell = {
  col: ISurveyComparision_QueryItemSessionData_Column;
  id: Scalars['ID'];
  initial: ISurveyComparision_QueryItemSessionData_Scale;
  row: ISurveyComparision_QueryItemSessionData_Row;
  selected?: Maybe<ISurveyComparision_QueryItemSessionData_Scale>;
};

export type ISurveyComparision_QueryItemSessionData_Column = {
  caption: ILangString;
  id: Scalars['ID'];
};

export type ISurveyComparision_QueryItemSessionData_Row = {
  caption: ILangString;
  id: Scalars['ID'];
};

export type ISurveyComparision_QueryItemSessionData_Scale = {
  hint: ILangString;
  id: Scalars['ID'];
  invalid: Scalars['Boolean'];
};

export type ISurveySingleChoiceMatrixEditItem = {
  columns: Array<ISurveySingleChoiceMatrixEdit_Column>;
  header: ILangString;
  id: Scalars['ID'];
  neutralScore: Scalars['Float'];
  option: SurveySingleChoiceMatrixEdit_Option;
  question: ILangString;
  rows: Array<ISurveySingleChoiceMatrixEdit_Row>;
  shuffleColumn: SurveySingleChoiceMatrixEdit_ShuffleColumn;
  shuffleRow: SurveySingleChoiceMatrixEdit_ShuffleRow;
};

export type ISurveySingleChoiceMatrixEditMutation = {
  upsert: ISurveySingleChoiceMatrixEditItem;
};


export type ISurveySingleChoiceMatrixEditMutationUpsertArgs = {
  params: ISurveySingleChoiceMatrixEditUpsertInput;
};

export type ISurveySingleChoiceMatrixEditQuery = {
  get: ISurveySingleChoiceMatrixEditItem;
};


export type ISurveySingleChoiceMatrixEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type ISurveySingleChoiceMatrixEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  neutralScore?: InputMaybe<Scalars['Float']>;
  option?: InputMaybe<SurveySingleChoiceMatrixEdit_Option>;
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removeColumns?: InputMaybe<Array<Scalars['ID']>>;
  removeRows?: InputMaybe<Array<Scalars['ID']>>;
  setColumns?: InputMaybe<Array<ISurveySingleChoiceMatrixEdit_UpsertColumn>>;
  setRows?: InputMaybe<Array<ISurveySingleChoiceMatrixEdit_UpsertRow>>;
  shuffleColumn?: InputMaybe<SurveySingleChoiceMatrixEdit_ShuffleColumn>;
  shuffleRow?: InputMaybe<SurveySingleChoiceMatrixEdit_ShuffleRow>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertColumns?: InputMaybe<Array<ISurveySingleChoiceMatrixEdit_UpsertColumn>>;
  upsertRows?: InputMaybe<Array<ISurveySingleChoiceMatrixEdit_UpsertRow>>;
};

export type ISurveySingleChoiceMatrixEdit_Column = {
  id: Scalars['ID'];
  index: Scalars['ID'];
  score: Scalars['Float'];
  value: ILangString;
};

export enum SurveySingleChoiceMatrixEdit_Option {
  Optional = 'optional',
  Required = 'required'
}

export type ISurveySingleChoiceMatrixEdit_Row = {
  id: Scalars['ID'];
  index: Scalars['ID'];
  value: ILangString;
};

export enum SurveySingleChoiceMatrixEdit_ShuffleColumn {
  Ordered = 'ordered',
  Shuffled = 'shuffled',
  ShuffledExceptLast = 'shuffledExceptLast'
}

export enum SurveySingleChoiceMatrixEdit_ShuffleRow {
  Ordered = 'ordered',
  Shuffled = 'shuffled'
}

export type ISurveySingleChoiceMatrixEdit_UpsertColumn = {
  index: Scalars['ID'];
  score?: InputMaybe<Scalars['Float']>;
  value?: InputMaybe<IUpsertLangStringInput>;
};

export type ISurveySingleChoiceMatrixEdit_UpsertRow = {
  index: Scalars['ID'];
  value?: InputMaybe<IUpsertLangStringInput>;
};

export type ISurveySingleChoiceMatrix_QueryItemSessionData = IQueryItemSessionData & {
  columns?: Maybe<Array<Maybe<ISurveySingleChoiceMatrix_QueryItemSessionData_Column>>>;
  header: ILangString;
  id: Scalars['ID'];
  option?: Maybe<SurveySingleChoiceMatrix_QueryItemSessionData_Option>;
  question: ILangString;
  rows?: Maybe<Array<Maybe<ISurveySingleChoiceMatrix_QueryItemSessionData_Row>>>;
};

export type ISurveySingleChoiceMatrix_QueryItemSessionData_Column = {
  id: Scalars['ID'];
  value?: Maybe<ILangString>;
};

export enum SurveySingleChoiceMatrix_QueryItemSessionData_Option {
  Optional = 'Optional',
  Required = 'Required'
}

export type ISurveySingleChoiceMatrix_QueryItemSessionData_Row = {
  cells?: Maybe<Array<Maybe<ISurveySingleChoiceMatrix_QueryItemSessionData_Row_Cell>>>;
  id: Scalars['ID'];
  selectedAnswer?: Maybe<Scalars['String']>;
  value?: Maybe<ILangString>;
};

export type ISurveySingleChoiceMatrix_QueryItemSessionData_Row_Cell = {
  id: Scalars['ID'];
  selected?: Maybe<Scalars['Boolean']>;
};

export type ISurveySingleChoiceTextEditItem = {
  answers: Array<ISurveySingleChoiceTextEdit_Answer>;
  header: ILangString;
  id: Scalars['ID'];
  image?: Maybe<IAttachmentUrlObject>;
  neutralScore: Scalars['Float'];
  option: SurveySingleChoiceTextEdit_Option;
  question: ILangString;
  shuffleMode: SurveySingleChoiceTextEdit_Shuffle;
  userTextEntry: SurveySingleChoiceTextEdit_UserTextEntry;
};

export type ISurveySingleChoiceTextEditMutation = {
  upsert: ISurveySingleChoiceTextEditItem;
};


export type ISurveySingleChoiceTextEditMutationUpsertArgs = {
  params: ISurveySingleChoiceTextEditUpsertInput;
};

export type ISurveySingleChoiceTextEditQuery = {
  get: ISurveySingleChoiceTextEditItem;
};


export type ISurveySingleChoiceTextEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type ISurveySingleChoiceTextEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  image?: InputMaybe<Scalars['String']>;
  itemId: Scalars['ID'];
  neutralScore?: InputMaybe<Scalars['Float']>;
  option?: InputMaybe<SurveySingleChoiceTextEdit_Option>;
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  removeAnswers?: InputMaybe<Array<Scalars['ID']>>;
  setAnswers?: InputMaybe<Array<ISurveySingleChoiceTextEdit_UpsertAnswer>>;
  shuffleMode?: InputMaybe<SurveySingleChoiceTextEdit_Shuffle>;
  subject?: InputMaybe<Scalars['ID']>;
  upsertAnswers?: InputMaybe<Array<ISurveySingleChoiceTextEdit_UpsertAnswer>>;
  userTextEntry?: InputMaybe<SurveySingleChoiceTextEdit_UserTextEntry>;
};

export type ISurveySingleChoiceTextEdit_Answer = {
  id: Scalars['ID'];
  index: Scalars['ID'];
  score: Scalars['Float'];
  text: ILangString;
};

export enum SurveySingleChoiceTextEdit_Option {
  Optional = 'optional',
  Required = 'required'
}

export enum SurveySingleChoiceTextEdit_Shuffle {
  Ordered = 'ordered',
  Shuffled = 'shuffled',
  ShuffledExceptLast = 'shuffledExceptLast'
}

export type ISurveySingleChoiceTextEdit_UpsertAnswer = {
  index: Scalars['ID'];
  score?: InputMaybe<Scalars['Float']>;
  text?: InputMaybe<IUpsertLangStringInput>;
};

export enum SurveySingleChoiceTextEdit_UserTextEntry {
  No = 'no',
  Yes = 'yes'
}

export type ISurveySingleChoiceText_QueryItemSessionData = IQueryItemSessionData & {
  answers: Array<ISurveySingleChoiceText_QueryItemSessionData_Answer>;
  header: ILangString;
  id: Scalars['ID'];
  image?: Maybe<IAttachmentUrlObject>;
  option: SurveySingleChoiceText_QueryItemSessionData_Option;
  question: ILangString;
  selectedAnswer?: Maybe<ISurveySingleChoiceText_QueryItemSessionData_Answer>;
  userText: Scalars['String'];
  userTextAnswer?: Maybe<ISurveySingleChoiceText_QueryItemSessionData_Answer>;
};

export type ISurveySingleChoiceText_QueryItemSessionData_Answer = {
  id: Scalars['ID'];
  score: Scalars['Float'];
  text: ILangString;
};

export enum SurveySingleChoiceText_QueryItemSessionData_Option {
  Optional = 'Optional',
  Required = 'Required'
}

export type ISurveyTextEntryEditItem = {
  gaps: Array<ISurveyTextEntryEdit_Gap>;
  header: ILangString;
  id: Scalars['ID'];
  question: ILangString;
  text: ILangString;
};

export type ISurveyTextEntryEditMutation = {
  addGap: ISurveyTextEntryEdit_Gap;
  removeGap: Scalars['Boolean'];
  upsert?: Maybe<ISurveyTextEntryEditItem>;
};


export type ISurveyTextEntryEditMutationAddGapArgs = {
  itemId: Scalars['ID'];
};


export type ISurveyTextEntryEditMutationRemoveGapArgs = {
  gapId: Scalars['ID'];
  itemId: Scalars['ID'];
};


export type ISurveyTextEntryEditMutationUpsertArgs = {
  params: ISurveyTextEntryEditUpsertInput;
};

export type ISurveyTextEntryEditQuery = {
  get: ISurveyTextEntryEditItem;
};


export type ISurveyTextEntryEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type ISurveyTextEntryEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  setGaps?: InputMaybe<Array<ISurveyTextEntryEdit_UpsertGap>>;
  subject?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<IUpsertLangStringInput>;
  upsertGaps?: InputMaybe<Array<ISurveyTextEntryEdit_UpsertGap>>;
};

export type ISurveyTextEntryEdit_Gap = {
  gapId: Scalars['ID'];
  id: Scalars['ID'];
  pattern: Scalars['String'];
  validationMessage: ILangString;
};

export type ISurveyTextEntryEdit_UpsertGap = {
  gapId: Scalars['ID'];
  pattern?: InputMaybe<Scalars['String']>;
  validationMessage?: InputMaybe<IUpsertLangStringInput>;
};

export type ISurveyTextEntryEdit_UpsertValue = {
  value?: InputMaybe<IUpsertLangStringInput>;
  valueId: Scalars['ID'];
};

export type ISurveyTextEntry_QueryItemSessionData = IQueryItemSessionData & {
  gaps: Array<ISurveyTextEntry_QueryItemSessionData_Gap>;
  header: ILangString;
  id: Scalars['ID'];
  image?: Maybe<IAttachmentUrlObject>;
  question: ILangString;
  text: ILangString;
};

export type ISurveyTextEntry_QueryItemSessionData_Gap = {
  gapId: Scalars['ID'];
  gapIndex: Scalars['Int'];
  givenAnswer?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pattern: Scalars['String'];
  validationMessage: ILangString;
};

export type ISurveyTextInputEditItem = {
  header: ILangString;
  id: Scalars['ID'];
  option: SurveyTextInputEdit_Option;
  question: ILangString;
};

export type ISurveyTextInputEditMutation = {
  upsert: ISurveyTextInputEditItem;
};


export type ISurveyTextInputEditMutationUpsertArgs = {
  params: ISurveyTextInputEditUpsertInput;
};

export type ISurveyTextInputEditQuery = {
  get: ISurveyTextInputEditItem;
};


export type ISurveyTextInputEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type ISurveyTextInputEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  option?: InputMaybe<SurveyTextInputEdit_Option>;
  parentItemId?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  subject?: InputMaybe<Scalars['ID']>;
};

export enum SurveyTextInputEdit_Option {
  Optional = 'optional',
  Required = 'required'
}

export type ISurveyTextInput_QueryItemSessionData = IQueryItemSessionData & {
  done: Scalars['Boolean'];
  essayText?: Maybe<Scalars['String']>;
  header: ILangString;
  id: Scalars['ID'];
  option: SurveyTextInput_QueryItemSessionData_Option;
  question: ILangString;
};

export enum SurveyTextInput_QueryItemSessionData_Option {
  Optional = 'Optional',
  Required = 'Required'
}

export type ITaxonomyDocument = {
  _id: Scalars['String'];
  _rev: Scalars['String'];
  docReferenceId: Scalars['String'];
  docType: Doctype;
  isDeleted?: Maybe<Scalars['Boolean']>;
  items: Array<ITaxonomyItem>;
  taxonomy: Scalars['String'];
  version?: Maybe<Scalars['Boolean']>;
};

export type ITaxonomyItem = {
  anchestors: Array<ITaxonomyItem>;
  id: Scalars['String'];
  name: ILangString;
  taxon: Scalars['String'];
};

export type ITaxonomyMutation = {
  import: Scalars['Boolean'];
  upsert: ITaxonomyDocument;
};


export type ITaxonomyMutationImportArgs = {
  taxonomyFile: Scalars['Upload'];
};


export type ITaxonomyMutationUpsertArgs = {
  params: IUpsertTaxonomyInput;
};

export type ITaxonomyQuery = {
  get: Array<ITaxonomyDocument>;
  getById: ITaxonomyDocument;
};


export type ITaxonomyQueryGetArgs = {
  params: ITaxonomyQueryParams;
};


export type ITaxonomyQueryGetByIdArgs = {
  docRefOrId: Scalars['ID'];
};

export type ITaxonomyQueryParams = {
  taxonomyDocRefIds: Array<Scalars['ID']>;
};

export type ITestAlias = IItemBankDoc & {
  _id: Scalars['String'];
  _rev: Scalars['String'];
  alias: Scalars['String'];
  attachments: Array<IAttachmentUrlObject>;
  docReferenceId: Scalars['String'];
  docType: Doctype;
  id: Scalars['ID'];
  isDeleted: Scalars['Boolean'];
  resolvesTo: Array<Scalars['String']>;
};

export type ITestAliasMutation = {
  new: ITestAlias;
  upsert?: Maybe<ITestAlias>;
};


export type ITestAliasMutationUpsertArgs = {
  params: IUpsertTestAlias;
};

export type ITestAliasQueries = {
  all: Array<ITestAlias>;
  byId: ITestAlias;
};


export type ITestAliasQueriesByIdArgs = {
  id: Scalars['ID'];
};

export type ITestDefinitionProfile = IItemBankDoc & {
  _id: Scalars['String'];
  _rev: Scalars['String'];
  attachments: Array<IAttachmentUrlObject>;
  continuationMode: ContinuationModeEnum;
  continueWith: ContinueWithEnum;
  docReferenceId: Scalars['String'];
  docType: Doctype;
  examinationType: ExaminationTypeEnum;
  executionPage: IExecutionPage;
  grades: Array<IGrade>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  itemHost: ItemHostEnum;
  maxTimeAllowed: Scalars['String'];
  navigationStyle: NavigationStyleEnum;
  pdfReportSettings: IPdfReportSettings;
  resetOnNavigate: ResetOnNavigateEnum;
  resultPage: IResultPage;
  revisableItemCount: Scalars['Int'];
  scoreRoundingMode: ScoreRoundingModeEnum;
  title: Scalars['String'];
  welcomePage: IWelcomePage;
};

export type ITestDefinitionProfileMutations = {
  copy: ITestDefinitionProfile;
  new: ITestDefinitionProfile;
  upsert: ITestDefinitionProfile;
};


export type ITestDefinitionProfileMutationsCopyArgs = {
  docRef: Scalars['ID'];
};


export type ITestDefinitionProfileMutationsUpsertArgs = {
  params: IUpsertTestDefinitionProfile;
};

export type ITestDefinitionProfileQueries = {
  all: Array<ITestDefinitionProfile>;
  byId: ITestDefinitionProfile;
  get: Array<ITestDefinitionProfile>;
};


export type ITestDefinitionProfileQueriesByIdArgs = {
  id: Scalars['ID'];
};


export type ITestDefinitionProfileQueriesGetArgs = {
  filter: IGetTestDefinitionProfileFilterInput;
};

export enum TestTypeEnum {
  AdHoc = 'AdHoc',
  Assessment = 'Assessment',
  Certification = 'Certification',
  Demo = 'Demo',
  Qa = 'QA',
  SelfAssessment = 'SelfAssessment',
  Showcase = 'Showcase'
}

export type ITextEntryAutoEditItem = {
  defaultGapMode: TextEntryAutoEdit_GapMode;
  gaps: Array<ITextEntryAutoEdit_Gap>;
  header: ILangString;
  id: Scalars['ID'];
  perGapScore?: Maybe<Scalars['Float']>;
  question: ILangString;
  scoring: TextEntryAutoEdit_Scoring;
  text: ILangString;
  values: Array<ITextEntryAutoEdit_Value>;
};

export type ITextEntryAutoEditMutation = {
  addGap: ITextEntryAutoEdit_Gap;
  addValue: ITextEntryAutoEdit_Value;
  removeGap: Scalars['Boolean'];
  removeValue: Scalars['Boolean'];
  upsert?: Maybe<ITextEntryAutoEditItem>;
};


export type ITextEntryAutoEditMutationAddGapArgs = {
  itemId: Scalars['ID'];
};


export type ITextEntryAutoEditMutationAddValueArgs = {
  gapId: Scalars['ID'];
  itemId: Scalars['ID'];
};


export type ITextEntryAutoEditMutationRemoveGapArgs = {
  gapId: Scalars['ID'];
  itemId: Scalars['ID'];
};


export type ITextEntryAutoEditMutationRemoveValueArgs = {
  itemId: Scalars['ID'];
  valueId: Scalars['ID'];
};


export type ITextEntryAutoEditMutationUpsertArgs = {
  params: ITextEntryAutoEditUpsertInput;
};

export type ITextEntryAutoEditQuery = {
  get: ITextEntryAutoEditItem;
};


export type ITextEntryAutoEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type ITextEntryAutoEditUpsertInput = {
  defaultGapMode?: InputMaybe<TextEntryAutoEdit_GapMode>;
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  perGapScore?: InputMaybe<Scalars['Float']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  scoring?: InputMaybe<TextEntryAutoEdit_Scoring>;
  setGaps?: InputMaybe<Array<ITextEntryAutoEdit_UpsertGap>>;
  setValues?: InputMaybe<Array<ITextEntryAutoEdit_UpsertValue>>;
  subject?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<IUpsertLangStringInput>;
  upsertGaps?: InputMaybe<Array<ITextEntryAutoEdit_UpsertGap>>;
  upsertValues?: InputMaybe<Array<ITextEntryAutoEdit_UpsertValue>>;
};

export type ITextEntryAutoEdit_Gap = {
  gapId: Scalars['ID'];
  id: Scalars['ID'];
  pattern: Scalars['String'];
  possibilities: Array<ITextEntryAutoEdit_Value>;
  validationMessage: ILangString;
  width: Scalars['String'];
};

export enum TextEntryAutoEdit_GapMode {
  CaseInsensitive = 'CaseInsensitive',
  Keyword = 'Keyword',
  RegEx = 'RegEx',
  Strict = 'Strict'
}

export enum TextEntryAutoEdit_Scoring {
  AllOrNothing = 'AllOrNothing',
  PerGap = 'PerGap'
}

export type ITextEntryAutoEdit_UpsertGap = {
  gapId: Scalars['ID'];
  pattern?: InputMaybe<Scalars['String']>;
  possibilities?: InputMaybe<Array<Scalars['ID']>>;
  validationMessage?: InputMaybe<IUpsertLangStringInput>;
  width?: InputMaybe<Scalars['String']>;
};

export type ITextEntryAutoEdit_UpsertValue = {
  value?: InputMaybe<IUpsertLangStringInput>;
  valueId: Scalars['ID'];
};

export type ITextEntryAutoEdit_Value = {
  id: Scalars['ID'];
  value: ILangString;
  valueId: Scalars['ID'];
};

export type ITextEntryManualEditItem = {
  gaps: Array<ITextEntryManualEdit_Gap>;
  header: ILangString;
  id: Scalars['ID'];
  perGapScore?: Maybe<Scalars['Float']>;
  question: ILangString;
  scoring: TextEntryManualEdit_Scoring;
  text: ILangString;
  values: Array<ITextEntryManualEdit_Value>;
};

export type ITextEntryManualEditMutation = {
  addGap: ITextEntryManualEdit_Gap;
  addValue: ITextEntryManualEdit_Value;
  removeGap: Scalars['Boolean'];
  removeValue: Scalars['Boolean'];
  upsert?: Maybe<ITextEntryManualEditItem>;
};


export type ITextEntryManualEditMutationAddGapArgs = {
  itemId: Scalars['ID'];
};


export type ITextEntryManualEditMutationAddValueArgs = {
  gapId: Scalars['ID'];
  itemId: Scalars['ID'];
};


export type ITextEntryManualEditMutationRemoveGapArgs = {
  gapId: Scalars['ID'];
  itemId: Scalars['ID'];
};


export type ITextEntryManualEditMutationRemoveValueArgs = {
  itemId: Scalars['ID'];
  valueId: Scalars['ID'];
};


export type ITextEntryManualEditMutationUpsertArgs = {
  params: ITextEntryManualEditUpsertInput;
};

export type ITextEntryManualEditQuery = {
  get: ITextEntryManualEditItem;
};


export type ITextEntryManualEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type ITextEntryManualEditUpsertInput = {
  header?: InputMaybe<IUpsertLangStringInput>;
  itemId: Scalars['ID'];
  parentItemId?: InputMaybe<Scalars['ID']>;
  perGapScore?: InputMaybe<Scalars['Float']>;
  question?: InputMaybe<IUpsertLangStringInput>;
  scoring?: InputMaybe<TextEntryManualEdit_Scoring>;
  setGaps?: InputMaybe<Array<ITextEntryManualEdit_UpsertGap>>;
  setValues?: InputMaybe<Array<ITextEntryManualEdit_UpsertValue>>;
  subject?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<IUpsertLangStringInput>;
  upsertGaps?: InputMaybe<Array<ITextEntryManualEdit_UpsertGap>>;
  upsertValues?: InputMaybe<Array<ITextEntryManualEdit_UpsertValue>>;
};

export type ITextEntryManualEdit_Gap = {
  gapId: Scalars['ID'];
  id: Scalars['ID'];
  pattern: Scalars['String'];
  possibilities: Array<ITextEntryManualEdit_Value>;
  validationMessage: ILangString;
};

export enum TextEntryManualEdit_Scoring {
  AllOrNothing = 'AllOrNothing',
  PerGap = 'PerGap'
}

export type ITextEntryManualEdit_UpsertGap = {
  gapId: Scalars['ID'];
  pattern?: InputMaybe<Scalars['String']>;
  possibilities?: InputMaybe<Array<Scalars['ID']>>;
  validationMessage?: InputMaybe<IUpsertLangStringInput>;
};

export type ITextEntryManualEdit_UpsertValue = {
  value?: InputMaybe<IUpsertLangStringInput>;
  valueId: Scalars['ID'];
};

export type ITextEntryManualEdit_Value = {
  id: Scalars['ID'];
  value: ILangString;
  valueId: Scalars['ID'];
};

export type ITextEntryManualGradingItem = {
  attachments: Array<IAttachmentUrlObject>;
  gaps: Array<ITextEntryManualGrading_Gap>;
  header: ILangString;
  id: Scalars['ID'];
  question: ILangString;
  text: ILangString;
};

export type ITextEntryManualGradingMutation = {
  setAnswer: Scalars['Boolean'];
  submit?: Maybe<Scalars['Boolean']>;
  update: ITextEntryManualGradingItem;
};


export type ITextEntryManualGradingMutationSetAnswerArgs = {
  correct: Scalars['Boolean'];
  gapId: Scalars['ID'];
  itemId: Scalars['ID'];
  value: Scalars['String'];
};


export type ITextEntryManualGradingMutationSubmitArgs = {
  itemId: Scalars['ID'];
};


export type ITextEntryManualGradingMutationUpdateArgs = {
  itemId: Scalars['ID'];
};

export type ITextEntryManualGradingQuery = {
  get: ITextEntryManualGradingItem;
};


export type ITextEntryManualGradingQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type ITextEntryManualGrading_Gap = {
  gapId: Scalars['ID'];
  given: Array<ITextEntryManualGrading_GivenAnswer>;
  id: Scalars['ID'];
  possibilities: Array<ITextEntryManualGrading_WellKnownAnswer>;
};

export type ITextEntryManualGrading_GivenAnswer = {
  correct?: Maybe<Scalars['Boolean']>;
  count: Scalars['Int'];
  gap: ITextEntryManualGrading_Gap;
  id: Scalars['ID'];
  submitted: Scalars['Boolean'];
  value: Scalars['String'];
};

export type ITextEntryManualGrading_WellKnownAnswer = {
  id: Scalars['ID'];
  value: ILangString;
  valueId: Scalars['ID'];
};

export type ITopItemCompleteResult = {
  complete: Scalars['Boolean'];
  message: ILangString;
};

export type ITopItemFileStructureEntry = {
  fileId: Scalars['ID'];
  id: Scalars['ID'];
  itemId: Scalars['ID'];
  path: Scalars['String'];
  userCreated: Scalars['Boolean'];
};

export enum TranslationStatusEnum {
  Done = 'done',
  Inprogress = 'inprogress',
  Open = 'open',
  Reopened = 'reopened'
}

export enum TriStateEnum {
  All = 'all',
  No = 'no',
  Yes = 'yes'
}

export type ITypingTest2023EditItem = {
  exportErrorQuota: Scalars['String'];
  exportErrors: Scalars['String'];
  exportStrokesPerMinute: Scalars['String'];
  exportTextLength: Scalars['String'];
  id: Scalars['ID'];
  maxErrorQuota: Scalars['Float'];
  reportDisplayTemplateText: TypingTest2023_DisplayTemplateText;
  text: Scalars['String'];
};

export type ITypingTest2023EditMutation = {
  upsert: ITypingTest2023EditItem;
};


export type ITypingTest2023EditMutationUpsertArgs = {
  params: ITypingTest2023EditUpsertInput;
};

export type ITypingTest2023EditQuery = {
  get: ITypingTest2023EditItem;
};


export type ITypingTest2023EditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type ITypingTest2023EditUpsertInput = {
  exportErrorQuota?: InputMaybe<Scalars['String']>;
  exportErrors?: InputMaybe<Scalars['String']>;
  exportStrokesPerMinute?: InputMaybe<Scalars['String']>;
  exportTextLength?: InputMaybe<Scalars['String']>;
  itemId: Scalars['ID'];
  maxErrorQuota?: InputMaybe<Scalars['Float']>;
  parentItemId?: InputMaybe<Scalars['ID']>;
  reportDisplayTemplateText?: InputMaybe<TypingTest2023_DisplayTemplateText>;
  subject?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<Scalars['String']>;
};

export enum TypingTest2023_DisplayTemplateText {
  No = 'No',
  Yes = 'Yes'
}

export type ITypingTest2023_Fragment = {
  errorPoints: Scalars['Int'];
  id: Scalars['ID'];
  mode: TypingTest2023_Fragment_Mode;
  text: Scalars['String'];
};

export enum TypingTest2023_Fragment_Mode {
  Added = 'added',
  Normal = 'normal',
  Removed = 'removed'
}

export type ITypingTest2023_Line = {
  errors: Scalars['Int'];
  fragments: Array<ITypingTest2023_Fragment>;
  id: Scalars['ID'];
  lineNr: Scalars['Int'];
  text: Scalars['String'];
  textLength: Scalars['Int'];
  typedText: Scalars['String'];
};

export type ITypingTest2023_QueryItemSessionData = IQueryItemSessionData & {
  errors?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  lines?: Maybe<Array<ITypingTest2023_Line>>;
  reportDisplayTemplateText: TypingTest2023_DisplayTemplateText;
  strokesPerMinute?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  textLength?: Maybe<Scalars['Int']>;
  typedText: Scalars['String'];
};

export type ITypingTestEditItem = {
  exportErrorQuota: Scalars['String'];
  exportErrors: Scalars['String'];
  exportTextLength: Scalars['String'];
  id: Scalars['ID'];
  maxErrorQuota: Scalars['Float'];
  text: Scalars['String'];
};

export type ITypingTestEditMutation = {
  upsert: ITypingTestEditItem;
};


export type ITypingTestEditMutationUpsertArgs = {
  params: ITypingTestEditUpsertInput;
};

export type ITypingTestEditQuery = {
  get: ITypingTestEditItem;
};


export type ITypingTestEditQueryGetArgs = {
  itemId: Scalars['ID'];
};

export type ITypingTestEditUpsertInput = {
  exportErrorQuota?: InputMaybe<Scalars['String']>;
  exportErrors?: InputMaybe<Scalars['String']>;
  exportTextLength?: InputMaybe<Scalars['String']>;
  itemId: Scalars['ID'];
  maxErrorQuota?: InputMaybe<Scalars['Float']>;
  parentItemId?: InputMaybe<Scalars['ID']>;
  subject?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<Scalars['String']>;
};

export type ITypingTest_Fragment = {
  errorPoints: Scalars['Int'];
  mode: TypingTest_Fragment_Mode;
  text: Scalars['String'];
};

export enum TypingTest_Fragment_Mode {
  Added = 'added',
  Normal = 'normal',
  Removed = 'removed'
}

export type ITypingTest_QueryItemSessionData = IQueryItemSessionData & {
  errors?: Maybe<Scalars['Int']>;
  fragments?: Maybe<Array<ITypingTest_Fragment>>;
  id: Scalars['ID'];
  text: Scalars['String'];
  textLength?: Maybe<Scalars['Int']>;
  typedText: Scalars['String'];
};

export enum UnaryFunctionOperator {
  Not = 'NOT'
}

export type IUnaryFunctionResult = IResult & {
  arg: IResult;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  operator: UnaryFunctionOperator;
  result: Scalars['Boolean'];
};

export type IUpdateAttachmentInput = {
  altText?: InputMaybe<IUpsertLangStringInput>;
  name: Scalars['ID'];
};

export type IUpdateDonkeyConfig = {
  msOfficeApps?: InputMaybe<Array<Scalars['String']>>;
  msOfficeArchitecture?: InputMaybe<Architecture>;
  msOfficeVersion?: InputMaybe<Scalars['String']>;
  os: Os;
  osArchitecture: Architecture;
  osVersion: Scalars['String'];
  resourcePath: Scalars['String'];
};

export type IUpdateExamStateInput = {
  interactions?: InputMaybe<Array<IMutationInteractionInput>>;
  itemState?: InputMaybe<Array<IUpdateItemStateInput>>;
  navigatedItems?: InputMaybe<Array<Scalars['ID']>>;
  submittedItems?: InputMaybe<Array<Scalars['ID']>>;
};

export type IUpdateItemMetaDataInput = {
  categoryId?: InputMaybe<Scalars['ID']>;
  defaultLocalization?: InputMaybe<Scalars['ID']>;
  descendantItemOrder?: InputMaybe<Array<Scalars['ID']>>;
  difficulty?: InputMaybe<Scalars['String']>;
  itemId: Scalars['ID'];
  minHeight?: InputMaybe<Scalars['Int']>;
  minWidth?: InputMaybe<Scalars['Int']>;
  publicTitle?: InputMaybe<IUpsertLangStringInput>;
  setAlternations?: InputMaybe<Array<Scalars['ID']>>;
  setAudiences?: InputMaybe<Array<Scalars['ID']>>;
  setObjectives?: InputMaybe<Array<IUpsertObjectiveScore>>;
  title?: InputMaybe<Scalars['String']>;
};

export type IUpdateItemStateInput = {
  ChoiceText?: InputMaybe<IUpdateItemStateInput_ChoiceText>;
  CrossOut?: InputMaybe<IUpdateItemStateInput_CrossOut>;
  Essay?: InputMaybe<IUpdateItemStateInput_Essay>;
  FillInGap?: InputMaybe<IUpdateItemStateInput_FillInGap>;
  FillInPool?: InputMaybe<IUpdateItemStateInput_FillInPool>;
  HandsOn?: InputMaybe<IUpdateItemStateInput_HandsOn>;
  InApplicationCombo?: InputMaybe<IUpdateItemStateInput_InApplicationCombo>;
  Instruction?: InputMaybe<IUpdateItemStateInput_Instruction>;
  InvisibleHotSpot?: InputMaybe<IUpdateItemStateInput_InvisibleHotSpot>;
  ItemCombo?: InputMaybe<IUpdateItemStateInput_ItemCombo>;
  MatchingHotSpot?: InputMaybe<IUpdateItemStateInput_MatchingHotSpot>;
  MatchingImage?: InputMaybe<IUpdateItemStateInput_MatchingImage>;
  MatchingText?: InputMaybe<IUpdateItemStateInput_MatchingText>;
  MultipleChoice?: InputMaybe<IUpdateItemStateInput_MultipleChoice>;
  MultistepHotSpot?: InputMaybe<IUpdateItemStateInput_MultistepHotSpot>;
  OrderingSelection?: InputMaybe<IUpdateItemStateInput_OrderingSelection>;
  OrderingSentences?: InputMaybe<IUpdateItemStateInput_OrderingSentences>;
  OrderingWords?: InputMaybe<IUpdateItemStateInput_OrderingWords>;
  Organisation?: InputMaybe<IUpdateItemStateInput_Organisation>;
  PlaceHolder?: InputMaybe<IUpdateItemStateInput_PlaceHolder>;
  SingleChoiceHotSpot?: InputMaybe<IUpdateItemStateInput_SingleChoiceHotSpot>;
  SingleChoiceImage?: InputMaybe<IUpdateItemStateInput_SingleChoiceImage>;
  SingleChoiceMatrix?: InputMaybe<IUpdateItemStateInput_SingleChoiceMatrix>;
  SingleChoiceText?: InputMaybe<IUpdateItemStateInput_SingleChoiceText>;
  SpellingMatrix?: InputMaybe<IUpdateItemStateInput_SpellingMatrix>;
  SurveyCombo?: InputMaybe<IUpdateItemStateInput_SurveyCombo>;
  SurveyComparision?: InputMaybe<IUpdateItemStateInput_SurveyComparision>;
  SurveySingleChoiceMatrix?: InputMaybe<IUpdateItemStateInput_SurveySingleChoiceMatrix>;
  SurveySingleChoiceText?: InputMaybe<IUpdateItemStateInput_SurveySingleChoiceText>;
  SurveyTextEntry?: InputMaybe<IUpdateItemStateInput_SurveyTextEntry>;
  SurveyTextInput?: InputMaybe<IUpdateItemStateInput_SurveyTextInput>;
  TextEntryAuto?: InputMaybe<IUpdateItemStateInput_TextEntryAuto>;
  TextEntryManual?: InputMaybe<IUpdateItemStateInput_TextEntryManual>;
  TextEntryPool?: InputMaybe<IUpdateItemStateInput_TextEntryPool>;
  TypingTest?: InputMaybe<IUpdateItemStateInput_TypingTest>;
  itemId: Scalars['ID'];
};

export type IUpdateItemStateInput_ChoiceText = {
  gaps: Array<IUpdateItemStateInput_ChoiceText_Gap>;
};

export type IUpdateItemStateInput_ChoiceText_Gap = {
  gapId: Scalars['ID'];
  valueId?: InputMaybe<Scalars['ID']>;
};

export type IUpdateItemStateInput_CrossOut = {
  lines: Array<InputMaybe<IUpdateItemStateInput_CrossOut_Line>>;
};

export type IUpdateItemStateInput_CrossOut_Line = {
  fragmentId?: InputMaybe<Scalars['ID']>;
  lineId: Scalars['ID'];
};

export type IUpdateItemStateInput_Essay = {
  text?: InputMaybe<Scalars['String']>;
};

export type IUpdateItemStateInput_FillInGap = {
  gaps: Array<IUpdateItemStateInput_FillInGap_Gap>;
};

export type IUpdateItemStateInput_FillInGap_Gap = {
  gapId: Scalars['ID'];
  valueId?: InputMaybe<Scalars['ID']>;
};

export type IUpdateItemStateInput_FillInPool = {
  gaps: Array<IUpdateItemStateInput_FillInPool_Gap>;
};

export type IUpdateItemStateInput_FillInPool_Gap = {
  gapId: Scalars['ID'];
  valueId?: InputMaybe<Scalars['ID']>;
};

export type IUpdateItemStateInput_HandsOn = {
  investigatorResults: Array<IHandsOn_ResultInput>;
  isDone: Scalars['Boolean'];
};

export type IUpdateItemStateInput_InApplicationCombo = {
  selectedSubItem: Scalars['ID'];
};

export type IUpdateItemStateInput_Instruction = {
  isDone: Scalars['Boolean'];
};

export type IUpdateItemStateInput_InvisibleHotSpot = {
  givenAnswers: Array<IUpdateItemStateInput_InvisibleHotSpot_Answer>;
};

export type IUpdateItemStateInput_InvisibleHotSpot_Answer = {
  answerId: Scalars['ID'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type IUpdateItemStateInput_ItemCombo = {
  selectedSubItem?: InputMaybe<Scalars['ID']>;
};

export type IUpdateItemStateInput_MatchingHotSpot = {
  answers: Array<IUpdateItemStateInput_MatchingHotSpot_Answer>;
};

export type IUpdateItemStateInput_MatchingHotSpot_Answer = {
  answerId: Scalars['ID'];
  shapeId?: InputMaybe<Scalars['ID']>;
};

export type IUpdateItemStateInput_MatchingImage = {
  answers: Array<IUpdateItemStateInput_MatchingImage_Answer>;
};

export type IUpdateItemStateInput_MatchingImage_Answer = {
  answerId: Scalars['ID'];
  imageId?: InputMaybe<Scalars['ID']>;
};

export type IUpdateItemStateInput_MatchingText = {
  answers: Array<IUpdateItemStateInput_MatchingText_Answer>;
};

export type IUpdateItemStateInput_MatchingText_Answer = {
  answerId: Scalars['ID'];
  textId?: InputMaybe<Scalars['ID']>;
};

export type IUpdateItemStateInput_MultipleChoice = {
  selected: Array<Scalars['ID']>;
};

export type IUpdateItemStateInput_MultistepHotSpot = {
  steps: Array<Scalars['ID']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type IUpdateItemStateInput_OrderingSelection = {
  order: Array<Scalars['ID']>;
};

export type IUpdateItemStateInput_OrderingSentences = {
  order: Array<Scalars['ID']>;
};

export type IUpdateItemStateInput_OrderingWords = {
  order: Array<Scalars['ID']>;
};

export type IUpdateItemStateInput_Organisation = {
  given: Array<IUpdateItemStateInput_Organisation_Given>;
};

export type IUpdateItemStateInput_Organisation_Given = {
  actionId: Scalars['String'];
  noteId: Scalars['String'];
};

export type IUpdateItemStateInput_PlaceHolder = {
  isDone: Scalars['Boolean'];
};

export type IUpdateItemStateInput_SingleChoiceHotSpot = {
  selected?: InputMaybe<Scalars['ID']>;
};

export type IUpdateItemStateInput_SingleChoiceImage = {
  selected?: InputMaybe<Scalars['ID']>;
};

export type IUpdateItemStateInput_SingleChoiceMatrix = {
  rows: Array<IUpdateItemStateInput_SingleChoiceMatrix_Row>;
};

export type IUpdateItemStateInput_SingleChoiceMatrix_Row = {
  rowId: Scalars['ID'];
  selected?: InputMaybe<Scalars['ID']>;
};

export type IUpdateItemStateInput_SingleChoiceText = {
  selected?: InputMaybe<Scalars['ID']>;
};

export type IUpdateItemStateInput_SpellingMatrix = {
  given: Array<IUpdateItemStateInput_SpellingMatrix_Value>;
};

export type IUpdateItemStateInput_SpellingMatrix_Value = {
  id: Scalars['String'];
  value: Scalars['String'];
};

export type IUpdateItemStateInput_SurveyCombo = {
  showSubItems: SurveyCombo_ShowSubItems;
};

export type IUpdateItemStateInput_SurveyComparision = {
  cells: Array<IUpdateItemStateInput_SurveyComparision_Cell>;
};

export type IUpdateItemStateInput_SurveyComparision_Cell = {
  colId: Scalars['ID'];
  rowId: Scalars['ID'];
  selected?: InputMaybe<Scalars['ID']>;
};

export type IUpdateItemStateInput_SurveySingleChoiceMatrix = {
  rows: Array<IUpdateItemStateInput_SurveySingleChoiceMatrix_Row>;
};

export type IUpdateItemStateInput_SurveySingleChoiceMatrix_Row = {
  rowId: Scalars['ID'];
  selected?: InputMaybe<Scalars['ID']>;
};

export type IUpdateItemStateInput_SurveySingleChoiceText = {
  selected?: InputMaybe<Scalars['ID']>;
  userText?: InputMaybe<Scalars['String']>;
};

export type IUpdateItemStateInput_SurveyTextEntry = {
  gaps: Array<IUpdateItemStateInput_SurveyTextEntry_Gap>;
};

export type IUpdateItemStateInput_SurveyTextEntry_Gap = {
  gapId: Scalars['ID'];
  text?: InputMaybe<Scalars['String']>;
};

export type IUpdateItemStateInput_SurveyTextInput = {
  done?: InputMaybe<Scalars['Boolean']>;
  text: Scalars['String'];
};

export type IUpdateItemStateInput_TextEntryAuto = {
  gaps: Array<IUpdateItemStateInput_TextEntryAuto_Gap>;
};

export type IUpdateItemStateInput_TextEntryAuto_Gap = {
  gapId: Scalars['ID'];
  text?: InputMaybe<Scalars['String']>;
};

export type IUpdateItemStateInput_TextEntryManual = {
  gaps: Array<IUpdateItemStateInput_TextEntryManual_Gap>;
};

export type IUpdateItemStateInput_TextEntryManual_Gap = {
  gapId: Scalars['ID'];
  text?: InputMaybe<Scalars['String']>;
};

export type IUpdateItemStateInput_TextEntryPool = {
  lines: Array<IUpdateItemStateInput_TextEntryPool_Line>;
};

export type IUpdateItemStateInput_TextEntryPool_Line = {
  lineId: Scalars['ID'];
  text?: InputMaybe<Scalars['String']>;
};

export type IUpdateItemStateInput_TypingTest = {
  typedText?: InputMaybe<Scalars['String']>;
};

export type IUpdateItemStateInput_TypingTest2023 = {
  typedText?: InputMaybe<Scalars['String']>;
};

export type IUpdateItemTranslationInput = {
  translation?: InputMaybe<IItemTranslationInput>;
};

export type IUpdateItemTranslationStatusInput = {
  currentTranslator?: InputMaybe<Scalars['ID']>;
  localizationId: Scalars['ID'];
  status?: InputMaybe<TranslationStatusEnum>;
};

export type IUpdateWorkflowDataInput = {
  categoryId?: InputMaybe<Scalars['ID']>;
  currentAuthor?: InputMaybe<Scalars['ID']>;
  isHiddenForAuthor?: InputMaybe<Scalars['Boolean']>;
  itemId: Scalars['ID'];
  noteForAuthor?: InputMaybe<Scalars['String']>;
  obsolete?: InputMaybe<Scalars['Boolean']>;
  updateTranslationStatus?: InputMaybe<Array<IUpdateItemTranslationStatusInput>>;
};

export type IUpsertAlternationRestriction = {
  alternation: Scalars['ID'];
  description?: InputMaybe<IUpsertLangStringInput>;
  gimp?: InputMaybe<IUpsertVersionRestriction>;
  itsr3Client?: InputMaybe<IUpsertVersionRestriction>;
  msOffice?: InputMaybe<IUpsertVersionRestriction>;
  windows?: InputMaybe<IUpsertVersionRestriction>;
};

export type IUpsertAudienceInput = {
  addSubjects?: InputMaybe<Array<Scalars['ID']>>;
  audienceDocRef?: InputMaybe<Scalars['ID']>;
  audienceId: Scalars['String'];
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  removeSubjects?: InputMaybe<Array<Scalars['ID']>>;
  setSubjects?: InputMaybe<Array<Scalars['ID']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type IUpsertButtonInput = {
  label?: InputMaybe<IUpsertLangStringInput>;
  visibility?: InputMaybe<ButtonVisibility>;
};

export type IUpsertExamOrderInput = {
  addAliases?: InputMaybe<Array<Scalars['String']>>;
  addAlternations?: InputMaybe<Array<Scalars['ID']>>;
  addItems?: InputMaybe<Array<Scalars['ID']>>;
  addSubjects?: InputMaybe<Array<IUpsertExamOrderSubjectInput>>;
  audience?: InputMaybe<Scalars['ID']>;
  categoryDepth?: InputMaybe<Scalars['Int']>;
  defineScore?: InputMaybe<ExaminationOrderDefineScore>;
  examDate?: InputMaybe<Scalars['String']>;
  examOrderDocRef?: InputMaybe<Scalars['ID']>;
  examOrderId: Scalars['ID'];
  examTime?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  itemOrderStrategy?: InputMaybe<ItemOrderStrategy>;
  levelOfSecrecy?: InputMaybe<LevelOfSecrecy>;
  maxTimeAllowed?: InputMaybe<Scalars['String']>;
  orderItems?: InputMaybe<Array<Scalars['ID']>>;
  profile?: InputMaybe<Scalars['String']>;
  removeAliases?: InputMaybe<Array<Scalars['String']>>;
  removeAlternations?: InputMaybe<Array<Scalars['ID']>>;
  removeItems?: InputMaybe<Array<Scalars['ID']>>;
  removeSubjects?: InputMaybe<Array<Scalars['ID']>>;
  score?: InputMaybe<Scalars['Float']>;
  scoreRoundingMode?: InputMaybe<ScoreRoundingModeEnum>;
  setAliases?: InputMaybe<Array<Scalars['String']>>;
  setAlternations?: InputMaybe<Array<Scalars['ID']>>;
  setItems?: InputMaybe<Array<Scalars['ID']>>;
  syllabusDepth?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type IUpsertExamOrderSubjectEntryInput = {
  categoryId: Scalars['ID'];
  objectiveId: Scalars['ID'];
  targetScore: Scalars['Float'];
};

export type IUpsertExamOrderSubjectInput = {
  addEntries?: InputMaybe<Array<IUpsertExamOrderSubjectEntryInput>>;
  addLanguages?: InputMaybe<Array<Scalars['ID']>>;
  removeLanguages?: InputMaybe<Array<Scalars['ID']>>;
  score?: InputMaybe<Scalars['Float']>;
  sectionTitle?: InputMaybe<IUpsertLangStringInput>;
  setLanguages?: InputMaybe<Array<Scalars['ID']>>;
  subjectDocRef?: InputMaybe<Scalars['ID']>;
  subjectId?: InputMaybe<Scalars['ID']>;
};

export type IUpsertExecutionPageInput = {
  displayProgress?: InputMaybe<DisplayProgress>;
  displayTime?: InputMaybe<DisplayTime>;
  finishButton?: InputMaybe<IUpsertButtonInput>;
  immediateResultSeconds?: InputMaybe<Scalars['Int']>;
  immediateResultText?: InputMaybe<IUpsertLangStringInput>;
  minHeight?: InputMaybe<Scalars['Int']>;
  minWidth?: InputMaybe<Scalars['Int']>;
  nextButton?: InputMaybe<IUpsertButtonInput>;
  overviewButton?: InputMaybe<IUpsertButtonInput>;
  postponeButton?: InputMaybe<IUpsertButtonInput>;
  previousButton?: InputMaybe<IUpsertButtonInput>;
  progressLabel?: InputMaybe<IUpsertLangStringInput>;
  resetButton?: InputMaybe<IUpsertButtonInput>;
  showImmediateResult?: InputMaybe<ShowImmediateResult>;
  showItemMaxScore?: InputMaybe<ShowItemMaxScore>;
  submitButton?: InputMaybe<IUpsertButtonInput>;
  timeLabel?: InputMaybe<IUpsertLangStringInput>;
};

export type IUpsertGolemScriptInput = {
  golemScriptDocRef?: InputMaybe<Scalars['ID']>;
  golemScriptId: Scalars['String'];
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  scriptYaml?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type IUpsertGrade = {
  condition?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  letter?: InputMaybe<Scalars['String']>;
  passed?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<IUpsertLangStringInput>;
};

export type IUpsertLangStringInput = {
  add?: InputMaybe<Array<IKeyValueInput>>;
  remove?: InputMaybe<Array<Scalars['ID']>>;
  set?: InputMaybe<Array<IKeyValueInput>>;
  xnone?: InputMaybe<Scalars['String']>;
};

export type IUpsertObjectiveScore = {
  objectiveId: Scalars['ID'];
  score: Scalars['Float'];
};

export type IUpsertPdfReportSettingsInput = {
  displayItemId?: InputMaybe<DisplayItemIdEnum>;
  displayObjectiveId?: InputMaybe<DisplayObjectiveIdEnum>;
  emailBody?: InputMaybe<IUpsertLangStringInput>;
  emailSubject?: InputMaybe<IUpsertLangStringInput>;
  includeItems?: InputMaybe<PdfReportSettingsIncludeItems>;
  itemDetailCaption?: InputMaybe<IUpsertLangStringInput>;
  itemHeader?: InputMaybe<IUpsertLangStringInput>;
  itemText?: InputMaybe<IUpsertLangStringInput>;
  objectiveHeader?: InputMaybe<IUpsertLangStringInput>;
  objectiveMaxDepth?: InputMaybe<Scalars['Int']>;
  objectiveMinDepth?: InputMaybe<Scalars['Int']>;
  objectiveText?: InputMaybe<IUpsertLangStringInput>;
  pageFooter?: InputMaybe<IUpsertLangStringInput>;
  pageHeader?: InputMaybe<IUpsertLangStringInput>;
  text?: InputMaybe<IUpsertLangStringInput>;
};

export type IUpsertResultPageInput = {
  closeButton?: InputMaybe<IUpsertButtonInput>;
  displayItemId?: InputMaybe<DisplayItemIdEnum>;
  displayObjectiveId?: InputMaybe<DisplayObjectiveIdEnum>;
  email?: InputMaybe<ResultPageEMail>;
  emailLabel?: InputMaybe<IUpsertLangStringInput>;
  emailText?: InputMaybe<IUpsertLangStringInput>;
  itemHeader?: InputMaybe<IUpsertLangStringInput>;
  itemText?: InputMaybe<IUpsertLangStringInput>;
  objectiveHeader?: InputMaybe<IUpsertLangStringInput>;
  objectiveMaxDepth?: InputMaybe<Scalars['Int']>;
  objectiveMinDepth?: InputMaybe<Scalars['Int']>;
  objectiveText?: InputMaybe<IUpsertLangStringInput>;
  pdf?: InputMaybe<ResultPagePdf>;
  pdfButton?: InputMaybe<IUpsertButtonInput>;
  text?: InputMaybe<IUpsertLangStringInput>;
};

export type IUpsertScormTokenInput = {
  addLmsOrigins?: InputMaybe<Array<Scalars['String']>>;
  downloadCode?: InputMaybe<Scalars['String']>;
  examAlias?: InputMaybe<Scalars['ID']>;
  idOrRef: Scalars['ID'];
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<IUpsertLangStringInput>;
  removeLmsOrigins?: InputMaybe<Array<Scalars['String']>>;
  scormTokenId?: InputMaybe<Scalars['ID']>;
  setLmsOrigins?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<ScormTokenStatus>;
  trackability?: InputMaybe<ScormTokenTrackability>;
};

export type IUpsertSharePointConnection = {
  downloadFolder?: InputMaybe<Scalars['String']>;
  forcedImport?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  password?: InputMaybe<Scalars['String']>;
  siteUrl?: InputMaybe<Scalars['String']>;
  triggerKey?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type IUpsertStatisticExportConfigInput = {
  addTextExportItemIds?: InputMaybe<Array<Scalars['ID']>>;
  colNameItemScore?: InputMaybe<Scalars['String']>;
  colNameItemScoreMax?: InputMaybe<Scalars['String']>;
  colNameItemScorePercentage?: InputMaybe<Scalars['String']>;
  colNameItemText?: InputMaybe<Scalars['String']>;
  colNameItemType?: InputMaybe<Scalars['String']>;
  colNameItemTypeId?: InputMaybe<Scalars['String']>;
  colNameItemValue?: InputMaybe<Scalars['String']>;
  colNameSessionScore?: InputMaybe<Scalars['String']>;
  colNameSessionScoreMax?: InputMaybe<Scalars['String']>;
  colNameSessionScorePercentage?: InputMaybe<Scalars['String']>;
  colNameSessionStatus?: InputMaybe<Scalars['String']>;
  colNameTopItemScore?: InputMaybe<Scalars['String']>;
  colNameTopItemScoreMax?: InputMaybe<Scalars['String']>;
  colNameTopItemScorePercentage?: InputMaybe<Scalars['String']>;
  configurationId?: InputMaybe<Scalars['ID']>;
  exportAnswers?: InputMaybe<Scalars['Boolean']>;
  exportCsv?: InputMaybe<Scalars['Boolean']>;
  exportItemText?: InputMaybe<Scalars['Boolean']>;
  exportItems?: InputMaybe<Scalars['Boolean']>;
  exportJson?: InputMaybe<Scalars['Boolean']>;
  exportObjectives?: InputMaybe<Scalars['Boolean']>;
  exportSessions?: InputMaybe<Scalars['Boolean']>;
  exportXlsx?: InputMaybe<Scalars['Boolean']>;
  externalIdColumn?: InputMaybe<Scalars['String']>;
  idOrDocRef: Scalars['ID'];
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  maxObjectiveDepth?: InputMaybe<Scalars['Int']>;
  mergeItemIdRegex?: InputMaybe<Scalars['String']>;
  onlyUpdate?: InputMaybe<Scalars['Boolean']>;
  removeTextExportItemIds?: InputMaybe<Array<Scalars['ID']>>;
  sessionIdColumn?: InputMaybe<Scalars['String']>;
  setAccumulatedObjectivesColumns?: InputMaybe<Array<Scalars['ID']>>;
  setTextExportItemIds?: InputMaybe<Array<Scalars['ID']>>;
  title?: InputMaybe<Scalars['String']>;
  xlsxFilename?: InputMaybe<Scalars['String']>;
  yamlConfig?: InputMaybe<Scalars['String']>;
};

export type IUpsertSubjectInput = {
  allowNonTranslateable?: InputMaybe<Scalars['Boolean']>;
  alternateColor?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  defaultLanguage?: InputMaybe<Scalars['String']>;
  defaultLocalization?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  itemEditVisibility?: InputMaybe<ItemEditVisibility>;
  subjectDocRef?: InputMaybe<Scalars['ID']>;
  subjectId: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type IUpsertTaxonomyInput = {
  docRefOrId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  removeItems?: InputMaybe<Array<Scalars['ID']>>;
  setItems?: InputMaybe<Array<IUpsertTaxonomyItemInput>>;
  upsertItems?: InputMaybe<Array<IUpsertTaxonomyItemInput>>;
};

export type IUpsertTaxonomyItemInput = {
  name?: InputMaybe<IUpsertLangStringInput>;
  taxon: Scalars['ID'];
};

export type IUpsertTestAlias = {
  addResolvesTo?: InputMaybe<Array<Scalars['String']>>;
  alias: Scalars['String'];
  docRef?: InputMaybe<Scalars['ID']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  removeResolvesTo?: InputMaybe<Array<Scalars['String']>>;
  setResolvesTo?: InputMaybe<Array<Scalars['String']>>;
};

export type IUpsertTestDefinitionProfile = {
  continuationMode?: InputMaybe<ContinuationModeEnum>;
  continueWith?: InputMaybe<ContinueWithEnum>;
  docRef?: InputMaybe<Scalars['ID']>;
  examinationType?: InputMaybe<ExaminationTypeEnum>;
  executionPage?: InputMaybe<IUpsertExecutionPageInput>;
  id: Scalars['ID'];
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  itemHost?: InputMaybe<ItemHostEnum>;
  maxTimeAllowed?: InputMaybe<Scalars['String']>;
  navigationStyle?: InputMaybe<NavigationStyleEnum>;
  pdfReportSettings?: InputMaybe<IUpsertPdfReportSettingsInput>;
  removeGrades?: InputMaybe<Array<Scalars['String']>>;
  resetOnNavigate?: InputMaybe<ResetOnNavigateEnum>;
  resultPage?: InputMaybe<IUpsertResultPageInput>;
  revisableItemCount?: InputMaybe<Scalars['Int']>;
  scoreRoundingMode?: InputMaybe<ScoreRoundingModeEnum>;
  setGrades?: InputMaybe<Array<IUpsertGrade>>;
  title?: InputMaybe<Scalars['String']>;
  upsertGrades?: InputMaybe<Array<IUpsertGrade>>;
  welcomePage?: InputMaybe<IUpsertWelcomePageInput>;
};

export type IUpsertUserInput = {
  addPrivileges?: InputMaybe<Array<IUpsertUserPrivilegeInput>>;
  displayName?: InputMaybe<Scalars['String']>;
  initials?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  mobilephone?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  removePrivileges?: InputMaybe<Array<Privilege>>;
  setPrivileges?: InputMaybe<Array<IUpsertUserPrivilegeInput>>;
  userDocRef?: InputMaybe<Scalars['ID']>;
  userId: Scalars['String'];
};

export type IUpsertUserPrivilegeInput = {
  addContext?: InputMaybe<Array<Scalars['ID']>>;
  privilege: Privilege;
  removeContext?: InputMaybe<Array<Scalars['ID']>>;
  setContext?: InputMaybe<Array<Scalars['ID']>>;
};

export type IUpsertVersionRestriction = {
  includeMax?: InputMaybe<Scalars['Boolean']>;
  includeMin?: InputMaybe<Scalars['Boolean']>;
  max?: InputMaybe<Scalars['String']>;
  min?: InputMaybe<Scalars['String']>;
};

export type IUpsertWelcomePageInput = {
  cancelButton?: InputMaybe<IUpsertButtonInput>;
  startButton?: InputMaybe<IUpsertButtonInput>;
  text?: InputMaybe<IUpsertLangStringInput>;
};

export type IUserAgentVersion = {
  gimp: Scalars['String'];
  itsr3Client: Scalars['String'];
  msOffice: Scalars['String'];
  raw: Scalars['String'];
  windows: Scalars['String'];
};

export type IUserDocument = IItemBankDoc & {
  _id: Scalars['String'];
  _rev: Scalars['String'];
  attachments: Array<IAttachmentUrlObject>;
  displayName: Scalars['String'];
  docReferenceId: Scalars['String'];
  docType: Doctype;
  initials: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  mobilephone?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  privilege?: Maybe<IPrivilege>;
  privileges: Array<IPrivilege>;
  shortcut: Scalars['String'];
  userId: Scalars['String'];
};


export type IUserDocumentPrivilegeArgs = {
  privilege: Privilege;
};

export type IUserMutation = {
  newUser: IUserDocument;
  upsertUser: IUserDocument;
};


export type IUserMutationUpsertUserArgs = {
  params: IUpsertUserInput;
};

export type IValidateFormulaResult = {
  allResults?: Maybe<Array<IResult>>;
  error?: Maybe<Scalars['String']>;
  formula: Scalars['String'];
  ok: Scalars['Boolean'];
  rootResult?: Maybe<IResult>;
};

export type IValidation = {
  ok: Scalars['Boolean'];
  validationMessages: Array<ILangString>;
};

export enum ValidationRuleEnum {
  Hasvalue = 'hasvalue',
  None = 'none',
  Onebased = 'onebased'
}

export type IVersionRestriction = {
  id: Scalars['ID'];
  includeMax: Scalars['Boolean'];
  includeMin: Scalars['Boolean'];
  max: Scalars['String'];
  min: Scalars['String'];
};

export type IVideoMetadata = {
  duration: Scalars['Float'];
  height: Scalars['Int'];
  id: Scalars['ID'];
  width: Scalars['Int'];
};

export type IWelcomePage = {
  cancelButton: IButton;
  startButton: IButton;
  text: ILangString;
};

export type IGetItemTypesFilter = {
  enabled?: InputMaybe<TriStateEnum>;
  parentItemDocRef?: InputMaybe<Scalars['ID']>;
  subjectDocRef?: InputMaybe<Scalars['ID']>;
  supportsSubItems?: InputMaybe<TriStateEnum>;
};

export type IPropertiesFragment = { id: string, propertyId: string, value?: string | null, info?: { id: string, type: EnrichmentParamTypeEnum, validationRule: ValidationRuleEnum, enumType?: { values: Array<{ id: string }> } | null, name: { value: string }, description?: { value: string } | null } | null };

export type IInaplicationcombo_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IInaplicationcombo_Edit_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | null } | null, item: { getFileStructure: Array<{ id: string, path: string, itemId: string, userCreated: boolean }> }, inApplicationComboEdit: { get: { id: string, header: { value: string }, instruction: { value: string }, filestructure: Array<{ id: string, fileId: string, resourceItem?: string | null, resourceName?: string | null, userCreated: boolean, path: string }>, preparators: Array<{ id: string, valid: boolean, preparatorId: string, preparatorUri: string, serviceProviderId: string, validationMessage?: { value: string } | null, properties: Array<{ id: string, propertyId: string, value?: string | null, info?: { id: string, type: EnrichmentParamTypeEnum, validationRule: ValidationRuleEnum, enumType?: { values: Array<{ id: string }> } | null, name: { value: string }, description?: { value: string } | null } | null }> }> } } };

export type IInapplication_Combo_Edit_InvestigatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type IInapplication_Combo_Edit_InvestigatorsQuery = { enrichment: { status: { serviceProviders: Array<{ id: string, version: string, preparatorDescriptions: Array<{ id: string, name: { value: string }, description?: { value: string } | null }>, investigatorDescriptions: Array<{ id: string, obsolete: boolean, name: { value: string }, description: { value: string } }> }> } } };

export type IInapplicatiocombo_Edit_UpdateMutationVariables = Exact<{
  params: IInApplicationComboEditUpsertInput;
}>;


export type IInapplicatiocombo_Edit_UpdateMutation = { inApplicationComboEdit?: { upsert?: { id: string } | null } | null };

export type IInstruction_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IInstruction_Edit_DataQuery = { InstructionEdit?: { get: { id: string, header: { value: string }, instruction: { value: string } } } | null };

export type IInstruction_Edit_UpdateMutationVariables = Exact<{
  params: IInstructionEditUpsertInput;
}>;


export type IInstruction_Edit_UpdateMutation = { InstructionEdit?: { upsert?: { id: string } | null } | null };

export type IInvisiblehotspot_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IInvisiblehotspot_Edit_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | null } | null, InvisibleHotSpotEdit: { get: { id: string, minAnswers: number, maxAnswers: number, imageWidth: number, imageHeight: number, scoringMode: InvisibleHotSpotEdit_Scoring, perAnswerScore: number, markerWidth: number, markerHeight: number, markerRadius: number, header: { value: string }, question: { value: string }, image?: { id: string, name: string, hrefResolved: string } | null, answers: Array<{ id: string, index: string, rects: Array<{ id: string, index: string, left: number, top: number, width: number, height: number }>, circles: Array<{ id: string, index: string, x: number, y: number, radius: number }> }> } } };

export type IInvisiblehotspot_Edit_UpdateMutationVariables = Exact<{
  params: IInvisibleHotSpotEditUpsertInput;
}>;


export type IInvisiblehotspot_Edit_UpdateMutation = { InvisibleHotSpotEdit: { upsert: { id: string } } };

export type IChoicetext_Edit_AddgapMutationVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IChoicetext_Edit_AddgapMutation = { ChoiceTextEdit: { addGap: { id: string, gapId: string } } };

export type IChoicetext_Edit_AddvalueMutationVariables = Exact<{
  itemId: Scalars['ID'];
  gapId: Scalars['ID'];
}>;


export type IChoicetext_Edit_AddvalueMutation = { ChoiceTextEdit: { addValue: { id: string, valueId: string } } };

export type IChoicetext_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IChoicetext_Edit_DataQuery = { ChoiceTextEdit: { get: { id: string, scoring: ChoiceTextEdit_Scoring, perGapScore?: number | null, shuffleMode: ChoiceTextEdit_ShuffleMode, header: { value: string }, text: { value: string }, question: { value: string }, gaps: Array<{ id: string, gapId: string, correct: { id: string, valueId: string }, possibilities: Array<{ id: string, valueId: string, value: { value: string } }> }> } } };

export type IChoicetext_Edit_RemovegapMutationVariables = Exact<{
  itemId: Scalars['ID'];
  gapId: Scalars['ID'];
}>;


export type IChoicetext_Edit_RemovegapMutation = { ChoiceTextEdit: { removeGap: boolean } };

export type IChoicetext_Edit_RemovevalueMutationVariables = Exact<{
  itemId: Scalars['ID'];
  valueId: Scalars['ID'];
}>;


export type IChoicetext_Edit_RemovevalueMutation = { ChoiceTextEdit: { removeValue: boolean } };

export type IChoicetext_Edit_UpdateMutationVariables = Exact<{
  params: IChoiceTextEditUpsertInput;
}>;


export type IChoicetext_Edit_UpdateMutation = { ChoiceTextEdit: { upsert?: { id: string } | null } };

export type IContainer_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IContainer_Edit_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | null } | null, containerEdit?: { get: { id: string, textBlockFormat: KosovoContainer_TextBlockFormat, image?: string | null, audioFile?: string | null, videoFile?: string | null, onlineVideoLink?: string | null, attachmentFile1?: string | null, attachmentFile2?: string | null, attachmentFile3?: string | null, attachmentFile4?: string | null, attachmentFile5?: string | null, header: { value: string }, instruction: { value: string }, filestructure: Array<{ id: string, fileId: string, resourceItem?: string | null, resourceName?: string | null, userCreated: boolean, path: string }>, textBlock?: { value: string } | null } } | null };

export type IContainer_Edit_UpdateMutationVariables = Exact<{
  params: IContainerEditUpsertInput;
}>;


export type IContainer_Edit_UpdateMutation = { containerEdit?: { upsert?: { id: string } | null } | null };

export type IContainer_SettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type IContainer_SettingsQuery = { itemtype: { kosovo?: { container: { supportsAudio: boolean, supportsVideo: boolean, supportsAttachments: boolean, supportsImage: boolean, supportsText: boolean, supportsFileStructure: boolean } } | null } };

export type ICrossout_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ICrossout_Edit_DataQuery = { CrossoutEdit: { get: { id: string, scoringMode: CrossoutScoringMode, shuffleMode: CrossoutShuffleMode, question: { value: string }, header: { value: string }, lines: Array<{ id: string, index: string, annotatedText: string, incorrect?: { id: string, index: string } | null, fragments: Array<{ id: string, index: string, value: string }> }> } } };

export type ICrossout_Edit_UpdateMutationVariables = Exact<{
  params: ICrossoutEditUpsertInput;
}>;


export type ICrossout_Edit_UpdateMutation = { CrossoutEdit: { upsert: { id: string } } };

export type IEssay_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IEssay_Edit_DataQuery = { EssayEdit: { get: { id: string, header: { value: string }, question: { value: string }, evaluationInfo: { value: string } } } };

export type IEssay_Edit_UpdateMutationVariables = Exact<{
  params: IEssayEditUpsertInput;
}>;


export type IEssay_Edit_UpdateMutation = { EssayEdit: { upsert: { id: string } } };

export type IEssay_Grading_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
  sessionId: Scalars['ID'];
}>;


export type IEssay_Grading_DataQuery = { essayGrading: { get: { id: string, itemId: string, sessionId: string, essayText: string, reason: string, attachments: Array<{ id: string, name: string, hrefResolved: string, altText: { value: string }, imageMetadata?: { id: string, width: number, height: number } | null, videoMetadata?: { id: string, width: number, height: number } | null }>, header: { value: string }, question: { value: string }, evalInfo: { value: string }, objectives: Array<{ id: string, objectiveId: string, score: number, maxScore: number }> } } };

export type IEssay_Grading_SetreasonMutationVariables = Exact<{
  sessionId: Scalars['ID'];
  itemId: Scalars['ID'];
  reason: Scalars['String'];
}>;


export type IEssay_Grading_SetreasonMutation = { essayGrading: { setReason: boolean } };

export type IEssay_Grading_SetscoreMutationVariables = Exact<{
  sessionId: Scalars['ID'];
  itemId: Scalars['ID'];
  objectiveId: Scalars['ID'];
  score: Scalars['Float'];
}>;


export type IEssay_Grading_SetscoreMutation = { essayGrading: { setScore: boolean } };

export type IEssaygrading_SubmitMutationVariables = Exact<{
  sessionId: Scalars['ID'];
  itemId: Scalars['ID'];
}>;


export type IEssaygrading_SubmitMutation = { essayGrading: { submit: boolean } };

export type IFillingap_Edit_AddgapMutationVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IFillingap_Edit_AddgapMutation = { FillInGapEdit?: { addGap: { id: string, gapId: string } } | null };

export type IFillingap_Edit_AddvalueMutationVariables = Exact<{
  itemId: Scalars['ID'];
  gapId: Scalars['ID'];
}>;


export type IFillingap_Edit_AddvalueMutation = { FillInGapEdit?: { addValue: { id: string, valueId: string } } | null };

export type IFillingap_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IFillingap_Edit_DataQuery = { FillInGapEdit?: { get: { id: string, scoring: FillInGapEdit_Scoring, perGapScore?: number | null, shuffleMode: FillInGapEdit_ShuffleMode, header: { value: string }, text: { value: string }, question: { value: string }, gaps: Array<{ id: string, gapId: string, correct: { id: string, valueId: string }, possibilities: Array<{ id: string, valueId: string, value: { value: string } }> }> } } | null };

export type IFillingap_Edit_RemovegapMutationVariables = Exact<{
  itemId: Scalars['ID'];
  gapId: Scalars['ID'];
}>;


export type IFillingap_Edit_RemovegapMutation = { FillInGapEdit?: { removeGap: boolean } | null };

export type IFillingap_Edit_RemovevalueMutationVariables = Exact<{
  itemId: Scalars['ID'];
  valueId: Scalars['ID'];
}>;


export type IFillingap_Edit_RemovevalueMutation = { FillInGapEdit?: { removeValue: boolean } | null };

export type IFillingap_Edit_UpsertMutationVariables = Exact<{
  params: IFillInGapEditUpsertInput;
}>;


export type IFillingap_Edit_UpsertMutation = { FillInGapEdit?: { upsert?: { id: string } | null } | null };

export type IInapplication_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IInapplication_Edit_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | null } | null, item: { getFileStructure: Array<{ id: string, path: string, itemId: string, userCreated: boolean }> }, handsOnEdit?: { get: { id: string, header: { value: string }, question: { value: string }, evaluationInfo: { value: string }, filestructure: Array<{ id: string, fileId: string, resourceItem?: string | null, resourceName?: string | null, userCreated: boolean, path: string, valid: boolean, validationMessage?: { value: string } | null }>, preparators: Array<{ id: string, valid: boolean, preparatorId: string, preparatorUri: string, serviceProviderId: string, validationMessage?: { value: string } | null, properties: Array<{ id: string, propertyId: string, value?: string | null, info?: { id: string, type: EnrichmentParamTypeEnum, validationRule: ValidationRuleEnum, enumType?: { values: Array<{ id: string }> } | null, name: { value: string }, description?: { value: string } | null } | null }> }>, investigators: Array<{ id: string, valid: boolean, investigatorId: string, investigatorUri: string, serviceProviderId: string, info?: { resultIsArray: boolean, resultType: EnrichmentResultTypeEnum, resultEnumType?: { values: Array<{ id: string }> } | null } | null, validationMessage?: { value: string } | null, properties: Array<{ id: string, propertyId: string, value?: string | null, info?: { id: string, type: EnrichmentParamTypeEnum, validationRule: ValidationRuleEnum, enumType?: { values: Array<{ id: string }> } | null, name: { value: string }, description?: { value: string } | null } | null }>, temporaryResult?: { id: string, serializedValue?: string | null, status: HandsOnEditQuery_TemporaryResults_ResultStatusEnum } | null }>, evaluations: Array<{ id: string, valid: boolean, formula: string, evaluationId: string, score: number, validationMessage?: { value: string } | null }> } } | null };

type IResult_BinaryFunctionResult_Fragment = { __typename: 'BinaryFunctionResult', id: string, error?: string | null, result: boolean, fieldId: string, argsStr?: string | null, argsStrArr?: Array<string> | null, argsNumber?: number | null, argsNumberArray?: Array<number> | null, argsBoolean?: boolean | null, binOp: BinaryFunctionOperator };

type IResult_ConditionResult_Fragment = { __typename: 'ConditionResult', id: string, error?: string | null, result: boolean, conOp: ConditionFunctionOperator, args: Array<{ id: string } | { id: string } | { id: string }> };

type IResult_UnaryFunctionResult_Fragment = { __typename: 'UnaryFunctionResult', id: string, error?: string | null, result: boolean, unOp: UnaryFunctionOperator, arg: { id: string } | { id: string } | { id: string } };

export type IResultFragment = IResult_BinaryFunctionResult_Fragment | IResult_ConditionResult_Fragment | IResult_UnaryFunctionResult_Fragment;

export type IInapplication_Edit_EvalMutationVariables = Exact<{
  formulas: Array<Scalars['String']> | Scalars['String'];
  fields: Array<IFormulaFieldValueInput> | IFormulaFieldValueInput;
}>;


export type IInapplication_Edit_EvalMutation = { handsOnEdit: { validateFormulas: Array<{ formula: string, ok: boolean, error?: string | null, rootResult?: { id: string } | { id: string } | { id: string } | null, allResults?: Array<{ __typename: 'BinaryFunctionResult', id: string, error?: string | null, result: boolean, fieldId: string, argsStr?: string | null, argsStrArr?: Array<string> | null, argsNumber?: number | null, argsNumberArray?: Array<number> | null, argsBoolean?: boolean | null, binOp: BinaryFunctionOperator } | { __typename: 'ConditionResult', id: string, error?: string | null, result: boolean, conOp: ConditionFunctionOperator, args: Array<{ id: string } | { id: string } | { id: string }> } | { __typename: 'UnaryFunctionResult', id: string, error?: string | null, result: boolean, unOp: UnaryFunctionOperator, arg: { id: string } | { id: string } | { id: string } }> | null }> } };

export type IInapplication_Edit_InvestigatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type IInapplication_Edit_InvestigatorsQuery = { enrichment: { status: { serviceProviders: Array<{ id: string, version: string, preparatorDescriptions: Array<{ id: string, name: { value: string }, description?: { value: string } | null }>, investigatorDescriptions: Array<{ id: string, obsolete: boolean, name: { value: string }, description: { value: string } }> }> } } };

export type IInapplicatoin_Edit_UpdateMutationVariables = Exact<{
  params: IHandsOnEditUpsertInput;
}>;


export type IInapplicatoin_Edit_UpdateMutation = { handsOnEdit: { upsert: { id: string } } };

export type IMatchinghotspot_Edit_AddcircleMutationVariables = Exact<{
  itemId: Scalars['ID'];
  x: Scalars['Float'];
  y: Scalars['Float'];
  radius: Scalars['Float'];
}>;


export type IMatchinghotspot_Edit_AddcircleMutation = { MatchingHotspotEdit?: { addCircle?: { id: string, index: string } | null } | null };

export type IMatchinghotspot_Edit_ConnectMutationVariables = Exact<{
  itemId: Scalars['ID'];
  shape?: InputMaybe<Scalars['ID']>;
  answer?: InputMaybe<Scalars['ID']>;
}>;


export type IMatchinghotspot_Edit_ConnectMutation = { MatchingHotspotEdit?: { connect?: { id: string } | null } | null };

export type IMatchinghotspot_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IMatchinghotspot_Edit_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | null } | null, MatchingHotspotEdit?: { get: { id: string, imageWidth?: number | null, imageHeight?: number | null, shuffleMode: MatchingHotspotEdit_ShuffleMode, scoring: MatchingHotspotEdit_Scoring, perAnswerScore?: number | null, header: { value: string }, question: { value: string }, image?: { id: string, name: string, hrefResolved: string } | null, shapes: Array<{ id: string, index: string, shape: string, correct?: { id: string, index: string } | null }>, answers: Array<{ id: string, index: string, correct?: { id: string, index: string } | null, value: { value: string } }> } } | null };

export type IMatchinghotspot_Edit_UpdateMutationVariables = Exact<{
  params: IMatchingHotspotEditUpsertInput;
}>;


export type IMatchinghotspot_Edit_UpdateMutation = { MatchingHotspotEdit?: { upsert?: { id: string } | null } | null };

export type IMatchingimage_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IMatchingimage_Edit_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | null } | null, MatchingImageEdit: { get: { id: string, pairs: Array<{ id: string, index: string, image?: { id: string, name: string, hrefResolved: string } | null, value: { value: string } }>, question: { value: string }, header: { value: string } } } };

export type IMatchingimage_Edit_UpdateMutationVariables = Exact<{
  params: IMatchingImageEditUpsertInput;
}>;


export type IMatchingimage_Edit_UpdateMutation = { MatchingImageEdit?: { upsert?: { id: string } | null } | null };

export type IMatchingtext_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IMatchingtext_Edit_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | null } | null, MatchingTextEdit: { get: { id: string, shuffleLeft: MatchingTextEdit_ShuffleMode, shuffleRight: MatchingTextEdit_ShuffleMode, pairs: Array<{ id: string, index: string, leftText: { value: string }, rightText: { value: string } }>, rightTitle: { value: string }, leftTitle: { value: string }, question: { value: string }, header: { value: string } } } };

export type IMatchingtext_Edit_UpdateMutationVariables = Exact<{
  params: IMatchingTextEditUpsertInput;
}>;


export type IMatchingtext_Edit_UpdateMutation = { MatchingTextEdit?: { upsert?: { id: string } | null } | null };

export type IOrderingselection_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IOrderingselection_Edit_DataQuery = { OrderingSelectionEdit: { get: { id: string, correctOrder: Array<string>, question: { value: string }, header: { value: string }, answers: Array<{ id: string, index: string, value: { value: string } }>, distractors: Array<{ id: string, index: string, value: { value: string } }> } } };

export type IOrderingselection_Edit_UpdateMutationVariables = Exact<{
  params: IOrderingSelectionEditUpsertInput;
}>;


export type IOrderingselection_Edit_UpdateMutation = { OrderingSelectionEdit: { upsert: { id: string } } };

export type IOrderingsentences_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IOrderingsentences_Edit_DataQuery = { OrderingSentencesEdit: { get: { id: string, correctOrder: Array<string>, question: { value: string }, header: { value: string }, answers: Array<{ id: string, index: string, value: { value: string } }> } } };

export type IOrderingsentences_Edit_UpdateMutationVariables = Exact<{
  params: IOrderingSentencesEditUpsertInput;
}>;


export type IOrderingsentences_Edit_UpdateMutation = { OrderingSentencesEdit: { upsert: { id: string } } };

export type IOrderingwords_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IOrderingwords_Edit_DataQuery = { OrderingWordsEdit: { get: { id: string, correctOrder: Array<string>, question: { value: string }, header: { value: string }, answers: Array<{ id: string, index: string, value: { value: string } }> } } };

export type IOrderingwords_Edit_UpdateMutationVariables = Exact<{
  params: IOrderingWordsEditUpsertInput;
}>;


export type IOrderingwords_Edit_UpdateMutation = { OrderingWordsEdit: { upsert: { id: string } } };

export type ISinglechoicehotspot_Edit_AddcircleMutationVariables = Exact<{
  itemId: Scalars['ID'];
  x: Scalars['Float'];
  y: Scalars['Float'];
  radius: Scalars['Float'];
}>;


export type ISinglechoicehotspot_Edit_AddcircleMutation = { SingleChoiceHotspotEdit?: { addCircle?: { id: string, index: string } | null } | null };

export type ISinglechoicehotspot_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ISinglechoicehotspot_Edit_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | null } | null, SingleChoiceHotspotEdit?: { get: { id: string, imageWidth?: number | null, imageHeight?: number | null, header: { value: string }, question: { value: string }, image?: { id: string, name: string, hrefResolved: string } | null, shapes: Array<{ id: string, index: string, shape: string, correct: boolean }> } } | null };

export type ISinglechoicehotspot_Edit_UpdateMutationVariables = Exact<{
  params: ISingleChoiceHotspotEditUpsertInput;
}>;


export type ISinglechoicehotspot_Edit_UpdateMutation = { SingleChoiceHotspotEdit?: { upsert?: { id: string } | null } | null };

export type ISinglechoiceimage_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ISinglechoiceimage_Edit_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | null } | null, SingleChoiceImageEdit: { get: { id: string, imgWidth: number, imgHeight: number, header: { value: string }, question: { value: string }, answers: Array<{ id: string, index: string, correct: boolean, image?: { id: string, hrefResolved: string, name: string } | null }> } } };

export type ISinglechoiceimage_Edit_UpdateMutationVariables = Exact<{
  params: ISingleChoiceImageEditUpsertInput;
}>;


export type ISinglechoiceimage_Edit_UpdateMutation = { SingleChoiceImageEdit: { upsert: { id: string } } };

export type ISinglechoicematrix_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ISinglechoicematrix_Edit_DataQuery = { SingleChoiceMatrixEdit: { get: { id: string, scoring: SingleChoiceMatrixEdit_Scoring, shuffleRow: SingleChoiceMatrixEdit_ShuffleRow, shuffleColumn: SingleChoiceMatrixEdit_ShuffleColumn, header: { value: string }, question: { value: string }, rows: Array<{ id: string, index: string, score?: number | null, correct: string, value: { value: string } }>, columns: Array<{ id: string, index: string, value: { value: string } }> } } };

export type ISinglechoicematrix_Edit_UpdateMutationVariables = Exact<{
  params: ISingleChoiceMatrixEditUpsertInput;
}>;


export type ISinglechoicematrix_Edit_UpdateMutation = { SingleChoiceMatrixEdit: { upsert: { id: string } } };

export type ISinglechoicetext_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ISinglechoicetext_Edit_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | null } | null, SingleChoiceTextEdit: { get: { id: string, shuffleMode: SingleChoiceTextEdit_Shuffle, header: { value: string }, question: { value: string }, image?: { id: string, hrefResolved: string, name: string } | null, answers: Array<{ id: string, index: string, correct: boolean, text: { value: string } }> } } };

export type ISinglechoicetext_Edit_UpdateMutationVariables = Exact<{
  params: ISingleChoiceTextEditUpsertInput;
}>;


export type ISinglechoicetext_Edit_UpdateMutation = { SingleChoiceTextEdit: { upsert: { id: string } } };

export type ITextentry_Auto_Edit_AddgapMutationVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ITextentry_Auto_Edit_AddgapMutation = { TextEntryAutoEdit?: { addGap: { id: string, gapId: string } } | null };

export type ITextentry_Auto_Edit_AddvalueMutationVariables = Exact<{
  itemId: Scalars['ID'];
  gapId: Scalars['ID'];
}>;


export type ITextentry_Auto_Edit_AddvalueMutation = { TextEntryAutoEdit?: { addValue: { id: string, valueId: string } } | null };

export type ITextentry_Auto_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ITextentry_Auto_Edit_DataQuery = { TextEntryAutoEdit?: { get: { id: string, scoring: TextEntryAutoEdit_Scoring, perGapScore?: number | null, defaultGapMode: TextEntryAutoEdit_GapMode, header: { value: string }, text: { value: string }, question: { value: string }, gaps: Array<{ id: string, gapId: string, pattern: string, width: string, possibilities: Array<{ id: string, valueId: string, value: { value: string } }>, validationMessage: { value: string } }> } } | null };

export type ITextentry_Auto_Edit_RemovegapMutationVariables = Exact<{
  itemId: Scalars['ID'];
  gapId: Scalars['ID'];
}>;


export type ITextentry_Auto_Edit_RemovegapMutation = { TextEntryAutoEdit?: { removeGap: boolean } | null };

export type ITextentry_Auto_Edit_RemovevalueMutationVariables = Exact<{
  itemId: Scalars['ID'];
  valueId: Scalars['ID'];
}>;


export type ITextentry_Auto_Edit_RemovevalueMutation = { TextEntryAutoEdit?: { removeValue: boolean } | null };

export type ITextentry_Auto_Edit_UpdateMutationVariables = Exact<{
  params: ITextEntryAutoEditUpsertInput;
}>;


export type ITextentry_Auto_Edit_UpdateMutation = { TextEntryAutoEdit?: { upsert?: { id: string } | null } | null };

export type ITextentry_Manual_Edit_AddgapMutationVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ITextentry_Manual_Edit_AddgapMutation = { TextEntryManualEdit?: { addGap: { id: string, gapId: string } } | null };

export type ITextentry_Manual_Edit_AddvalueMutationVariables = Exact<{
  itemId: Scalars['ID'];
  gapId: Scalars['ID'];
}>;


export type ITextentry_Manual_Edit_AddvalueMutation = { TextEntryManualEdit?: { addValue: { id: string, valueId: string } } | null };

export type ITextentry_Manual_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ITextentry_Manual_Edit_DataQuery = { TextEntryManualEdit?: { get: { id: string, scoring: TextEntryManualEdit_Scoring, perGapScore?: number | null, header: { value: string }, text: { value: string }, question: { value: string }, gaps: Array<{ id: string, gapId: string, pattern: string, possibilities: Array<{ id: string, valueId: string, value: { value: string } }>, validationMessage: { value: string } }> } } | null };

export type ITextentrymanual_Edit_RemovegapMutationVariables = Exact<{
  itemId: Scalars['ID'];
  gapId: Scalars['ID'];
}>;


export type ITextentrymanual_Edit_RemovegapMutation = { TextEntryManualEdit?: { removeGap: boolean } | null };

export type ITextentrymanual_Edit_RemovevalueMutationVariables = Exact<{
  itemId: Scalars['ID'];
  valueId: Scalars['ID'];
}>;


export type ITextentrymanual_Edit_RemovevalueMutation = { TextEntryManualEdit?: { removeValue: boolean } | null };

export type ITextentry_Manual_Edit_UpdateMutationVariables = Exact<{
  params: ITextEntryManualEditUpsertInput;
}>;


export type ITextentry_Manual_Edit_UpdateMutation = { TextEntryManualEdit?: { upsert?: { id: string } | null } | null };

export type ITextentry_Manual_Grading_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ITextentry_Manual_Grading_DataQuery = { TextEntryManualGrading: { get: { id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, altText: { value: string }, imageMetadata?: { id: string, width: number, height: number } | null, videoMetadata?: { id: string, width: number, height: number } | null }>, question: { value: string }, header: { value: string }, text: { value: string }, gaps: Array<{ id: string, gapId: string, given: Array<{ correct?: boolean | null, count: number, id: string, submitted: boolean, value: string }>, possibilities: Array<{ id: string, valueId: string, value: { value: string } }> }> } } };

export type ITextentry_Manual_Grading_SetanswerMutationVariables = Exact<{
  itemId: Scalars['ID'];
  gapId: Scalars['ID'];
  value: Scalars['String'];
  correct: Scalars['Boolean'];
}>;


export type ITextentry_Manual_Grading_SetanswerMutation = { TextEntryManualGrading: { setAnswer: boolean } };

export type ITextentry_Manual_Grading_SubmitMutationVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ITextentry_Manual_Grading_SubmitMutation = { TextEntryManualGrading: { submit?: boolean | null } };

export type ITextentry_Manual_Grading_UpdateMutationVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ITextentry_Manual_Grading_UpdateMutation = { TextEntryManualGrading: { update: { id: string } } };

export type IFillinpool_Edit_AddgapMutationVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IFillinpool_Edit_AddgapMutation = { FillInPoolEdit?: { addGap: { id: string, gapId: string } } | null };

export type IFillinpool_Edit_AddvalueMutationVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IFillinpool_Edit_AddvalueMutation = { FillInPoolEdit?: { addValue: { id: string, valueId: string } } | null };

export type IFillinpool_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IFillinpool_Edit_DataQuery = { FillInPoolEdit?: { get: { id: string, scoring: FillInPoolEdit_Scoring, perGapScore?: number | null, header: { value: string }, text: { value: string }, question: { value: string }, values: Array<{ id: string, valueId: string, gap?: { id: string } | null, value: { value: string } }>, gaps: Array<{ id: string, gapId: string, correct: { id: string, valueId: string } }> } } | null };

export type IFillinpool_Edit_RemovegapMutationVariables = Exact<{
  itemId: Scalars['ID'];
  gapId: Scalars['ID'];
}>;


export type IFillinpool_Edit_RemovegapMutation = { FillInPoolEdit?: { removeGap: boolean } | null };

export type IFillinpool_Edit_RemovevalueMutationVariables = Exact<{
  itemId: Scalars['ID'];
  valueId: Scalars['ID'];
}>;


export type IFillinpool_Edit_RemovevalueMutation = { FillInPoolEdit?: { removeValue: boolean } | null };

export type IFillinpool_Edit_UpsertMutationVariables = Exact<{
  params: IFillInPoolEditUpsertInput;
}>;


export type IFillinpool_Edit_UpsertMutation = { FillInPoolEdit?: { upsert?: { id: string } | null } | null };

export type ILinetextentry_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ILinetextentry_Edit_DataQuery = { LineTextEntryEdit: { get: { id: string, scoring: LineTextEntryEdit_Scoring, lines: number, question: { value: string }, header: { value: string }, answers: Array<{ id: string, index: string, correct: boolean, score: number, value: { value: string } }> } } };

export type ILinetextentry_Edit_UpsertMutationVariables = Exact<{
  params: ILineTextEntryEditUpsertInput;
}>;


export type ILinetextentry_Edit_UpsertMutation = { LineTextEntryEdit: { upsert: { id: string } } };

export type ILinetextentry_Grading_SetvalueMutationVariables = Exact<{
  itemDocRefId: Scalars['ID'];
  topicId: Scalars['ID'];
  value: Scalars['String'];
}>;


export type ILinetextentry_Grading_SetvalueMutation = { LavakLineTextEntry?: { evaluator_setTopicValue: { id: string, topicId?: string | null } } | null };

export type ILinetextentry_Grading_SubmitMutationVariables = Exact<{
  itemDocRefId: Scalars['ID'];
}>;


export type ILinetextentry_Grading_SubmitMutation = { LavakLineTextEntry?: { evaluator_submit: boolean } | null };

export type ILinetextentry_Grading_UpdateMutationVariables = Exact<{
  itemDocRefId: Scalars['ID'];
}>;


export type ILinetextentry_Grading_UpdateMutation = { LavakLineTextEntry?: { evaluator_updateSharedGradingData: { id: string, header: { value: string }, question: { value: string }, topics: Array<{ id: string, topicId: string, isKeyAnswer: boolean, score: number, text: { value: string } }>, answers: Array<{ id: string, value: string, count: number, topicId?: string | null, submitted: boolean }> } } | null };

export type IMultiplechoice_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IMultiplechoice_Edit_DataQuery = { MultipleChoiceEdit: { get: { id: string, scoring: MultipleChoiceEdit_Scoring, shuffle: MultipleChoiceEdit_Shuffle, minSelectionLimit: number, maxSelectionLimit: number, question: { value: string }, header: { value: string }, answers: Array<{ id: string, index: string, correct: boolean, score: number, value: { value: string } }> } } };

export type IMultiplechoice_Edit_UpdateMutationVariables = Exact<{
  params: IMultipleChoiceEditUpsertInput;
}>;


export type IMultiplechoice_Edit_UpdateMutation = { MultipleChoiceEdit: { upsert: { id: string } } };

export type ILocalizationsFragment = { localizations: Array<{ localizationId: string, value: string }> };

export type IItem_Model_InitQueryVariables = Exact<{
  sessionId: Scalars['ID'];
  localizationId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type IItem_Model_InitQuery = { examSession: { id: string, items: Array<{ id: string, minWidth: number, minHeight: number, itemId: string, hasFocusMode: boolean, isTopItem: boolean, isOnlySibling: boolean, attachments: Array<{ id: string, name: string, etag: string, hrefResolved: string, altText: { value: string }, imageMetadata?: { id: string, width: number, height: number } | null, videoMetadata?: { id: string, width: number, height: number } | null }>, HandsOn_Data?: { id: string, topItemId: string, itemNr: number, files: Array<{ id: string, path: string, userCreated: boolean, resource?: { hrefResolved: string, id: string, etag: string, size: number, sha256: string, uniqueId: string } | null }>, preparators: Array<{ id: string, preparatorUri: string, serviceProviderId: string, properties: Array<{ propertyId: string, value?: string | null }> }>, investigators: Array<{ id: string, investigatorUri: string, serviceProviderId: string, properties: Array<{ propertyId: string, value?: string | null }> }> } | null, data?: { __typename: 'HandsOn_QueryItemSessionData', id: string, isDone: boolean, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, investigatorResults: Array<{ id: string, investigatorId: string, serializedValue: string }> } | { __typename: 'InApplicationCombo_QueryItemSessionData', id: string, selectedSubItem?: string | null, header: { localizations: Array<{ localizationId: string, value: string }> }, instruction: { localizations: Array<{ localizationId: string, value: string }> }, subItems: Array<{ id: string, itemDocRefId: string, status: InApplicationCombo_SubItem_StatusEnum, itemType: string }> } | { __typename: 'Instruction_QueryItemSessionData', header: { value: string }, instruction: { value: string } } | { __typename: 'InvisibleHotSpot_QueryItemSessionData', id: string, scoringMode: InvisibleHotSpotEdit_Scoring, imageWidth: number, imageHeight: number, minAnswers: number, maxAnswers: number, markerRadius: number, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, ihsImage: { id: string }, ihsAnswers: Array<{ id: string, index: string, x: number, y: number, correct?: InvisibleHotSpot_CorrectState | null }>, ihsZones?: Array<{ id: string, group: string, left: number, top: number, width: number, height: number }> | null } | { __typename: 'KosovoChoiceText_QueryItemSessionData', id: string, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, text: { localizations: Array<{ localizationId: string, value: string }> }, gaps: Array<{ id: string, gapId: string, selectedValue?: string | null, correctValue?: string | null, values: Array<{ id: string, value: { localizations: Array<{ localizationId: string, value: string }> } }> }> } | { __typename: 'KosovoContainer_QueryItemSessionData', id: string, selectedSubItem?: string | null, hasResultFiles: boolean, header: { localizations: Array<{ localizationId: string, value: string }> }, instruction: { localizations: Array<{ localizationId: string, value: string }> }, cSubItems: Array<{ id: string, itemDocRefId: string, status: KosovoContainer_SubItem_StatusEnum, itemType: string }>, containerImage?: { id: string } | null, multiMedia?: { id: string, textFormat: KosovoContainer_TextBlockFormat, onlineVideoLink?: string | null, text?: { localizations: Array<{ localizationId: string, value: string }> } | null, mmImage?: { id: string } | null, mmAudio?: { id: string } | null, mmVideo?: { id: string } | null, attachments?: Array<{ id: string, name: string, etag: string, hrefResolved: string }> | null } | null } | { __typename: 'KosovoCrossout_QueryItemSessionData', id: string, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, lines: Array<{ id: string, selectedFragment?: string | null, incorrectFragment?: string | null, fragments: Array<{ id: string, value: string }> }> } | { __typename: 'KosovoEssay_QueryItemSessionData', id: string, essayText?: string | null, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> } } | { __typename: 'KosovoFillinGap_QueryItemSessionData', id: string, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, text: { localizations: Array<{ localizationId: string, value: string }> }, gaps: Array<{ id: string, gapId: string, selectedValue?: string | null, correctValue?: string | null, values: Array<{ id: string, value: { localizations: Array<{ localizationId: string, value: string }> } }> }> } | { __typename: 'KosovoMatchingHotSpot_QueryItemSessionData', id: string, mhsWidth?: number | null, mhsHeight?: number | null, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, mhsImage?: { id: string } | null, mhsAnswers: Array<{ id: string, selectedShape?: string | null, correctShape?: string | null, value: { localizations: Array<{ localizationId: string, value: string }> } }>, shapes: Array<{ id: string, shape: string }> } | { __typename: 'KosovoMatchingImage_QueryItemSessionData', id: string, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, miAnswers: Array<{ id: string, value: { localizations: Array<{ localizationId: string, value: string }> }, selectedImage?: { id: string } | null, correctImage?: { id: string } | null }>, images: Array<{ id: string, miImage: { id: string } }> } | { __typename: 'KosovoMatchingText_QueryItemSessionData', id: string, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, answerTitle: { localizations: Array<{ localizationId: string, value: string }> }, mtAnswers: Array<{ id: string, selectedText?: string | null, correctText?: string | null, value: { localizations: Array<{ localizationId: string, value: string }> } }>, textTitle: { localizations: Array<{ localizationId: string, value: string }> }, texts: Array<{ id: string, value: { localizations: Array<{ localizationId: string, value: string }> } }> } | { __typename: 'KosovoOrderingSelection_QueryItemSessionData', id: string, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, distractorAnswers?: Array<{ id: string, answerId: string, value: { localizations: Array<{ localizationId: string, value: string }> } }> | null, osCorrectAnswer?: Array<{ id: string, answerId: string, value: { localizations: Array<{ localizationId: string, value: string }> } }> | null, availableAnswers: Array<{ id: string, answerId: string, value: { localizations: Array<{ localizationId: string, value: string }> } }>, selectedAnswers: Array<{ id: string, answerId: string, value: { localizations: Array<{ localizationId: string, value: string }> } }> } | { __typename: 'KosovoOrderingSentences_QueryItemSessionData', id: string, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, osCorrectAnswer?: Array<{ id: string, value: { localizations: Array<{ localizationId: string, value: string }> } }> | null, osAnswers: Array<{ id: string, value: { localizations: Array<{ localizationId: string, value: string }> } }>, osInitialOrder: Array<{ id: string }> } | { __typename: 'KosovoOrderingWords_QueryItemSessionData', id: string, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, owCorrectAnswer?: Array<{ id: string, value: { localizations: Array<{ localizationId: string, value: string }> } }> | null, owAnswers: Array<{ id: string, value: { localizations: Array<{ localizationId: string, value: string }> } }>, owInitialOrder: Array<{ id: string }> } | { __typename: 'KosovoSingleChoiceHotSpot_QueryItemSessionData', id: string, selectedAnswer?: string | null, correctAnswer?: string | null, schsWidth: number, schsHeight: number, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, schsImage: { id: string }, schsAnswers: Array<{ id: string, shape: string }> } | { __typename: 'KosovoSingleChoiceImage_QueryItemSessionData', id: string, imgWidth: number, imgHeight: number, selectedAnswer?: string | null, correctAnswer?: string | null, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, sciAnswers: Array<{ id: string, sciImage: { id: string } }> } | { __typename: 'KosovoSingleChoiceMatrix_QueryItemSessionData', id: string, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, rows: Array<{ id: string, correctAnswer?: string | null, selectedAnswer?: string | null, value: { localizations: Array<{ localizationId: string, value: string }> }, cells: Array<{ id: string, selected?: boolean | null, correct?: boolean | null }> }>, columns: Array<{ id: string, value: { localizations: Array<{ localizationId: string, value: string }> } }> } | { __typename: 'KosovoSingleChoiceText_QueryItemSessionData', id: string, selectedAnswer?: string | null, correctAnswer?: string | null, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, sctImage?: { id: string } | null, sctAnswers: Array<{ id: string, text: { localizations: Array<{ localizationId: string, value: string }> } }> } | { __typename: 'KosovoTextEntry_Auto_QueryItemSessionData', id: string, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, text: { localizations: Array<{ localizationId: string, value: string }> }, taImage?: { id: string } | null, gaps: Array<{ id: string, isCorrect?: boolean | null, givenAnswer?: string | null, gapId: string, pattern: string, width: string, correctAnswers?: Array<{ id: string, value: { localizations: Array<{ localizationId: string, value: string }> } }> | null, validationMessage: { localizations: Array<{ localizationId: string, value: string }> } }> } | { __typename: 'KosovoTextEntry_Manual_QueryItemSessionData', id: string, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, temText: { localizations: Array<{ localizationId: string, value: string }> }, temImage?: { id: string } | null, temGaps: Array<{ id: string, isCorrect?: boolean | null, gapId: string, givenAnswer?: string | null, pattern: string, correctAnswers?: Array<{ id: string, value: { localizations: Array<{ localizationId: string, value: string }> } }> | null, validationMessage: { localizations: Array<{ localizationId: string, value: string }> } }>, temAnswers: Array<{ id: string, value: { localizations: Array<{ localizationId: string, value: string }> } }> } | { __typename: 'LavakFillinPool_QueryItemSessionData', id: string, evaluationRemark?: string | null, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, fipText: { localizations: Array<{ localizationId: string, value: string }> }, fipGaps: Array<{ id: string, gapId: string, selectedValue?: string | null, correctValue?: string | null, evaluationRemark?: string | null }>, values: Array<{ id: string, value?: { localizations: Array<{ localizationId: string, value: string }> } | null }> } | { __typename: 'LavakLineTextEntry_QueryItemSessionData', id: string, evaluationRemark?: string | null, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, lteLines: Array<{ id: string, lineIndex: number, value?: string | null, isCorrect?: boolean | null, evaluationRemark?: string | null }> } | { __typename: 'LavakMultiplechoice_QueryItemSessionData', id: string, minSelectionLimit: number, maxSelectionLimit: number, evaluationRemark?: string | null, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, mcAnswers: Array<{ id: string, isSelected: boolean, isCorrectAnswer?: boolean | null, evaluationRemark?: string | null, text: { localizations: Array<{ localizationId: string, value: string }> } }> } | { __typename: 'MultistepHotSpot_QueryItemSessionData', id: string, markerRadius: number, initialStepId: string, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, mshsGiven?: { id: string, steps: Array<string>, x?: number | null, y?: number | null, correct?: MultistepHotSpot_CorrectState | null } | null, mshsSteps: Array<{ id: string, stepId: string, imageWidth: number, imageHeight: number, mshsImage: { id: string }, mshsZones: Array<{ id: string, zoneId: string, stepLinkId?: string | null, mshsAreas: Array<{ id: string, areaId: string, left: number, top: number, width: number, height: number }> }> }> } | { __typename: 'Organisation_QueryItemSessionData', id: string, header: { localizations: Array<{ localizationId: string, value: string }> }, orgText: { localizations: Array<{ localizationId: string, value: string }> }, orgNotes: Array<{ id: string, orgNoteType: Organisation_NoteType, orgCaption: { localizations: Array<{ localizationId: string, value: string }> }, orgNoteHeader: { localizations: Array<{ localizationId: string, value: string }> }, orgNoteBody: { localizations: Array<{ localizationId: string, value: string }> }, orgGiven?: { id: string } | null, orgCorrect?: { id: string } | null, orgActions: Array<{ id: string, orgAction: { localizations: Array<{ localizationId: string, value: string }> } }> }> } | { __typename: 'Placeholder_QueryItemSessionData', id: string } | { __typename: 'SpellingMatrix_QueryItemSessionData', id: string, header: { localizations: Array<{ localizationId: string, value: string }> }, smText: { localizations: Array<{ localizationId: string, value: string }> }, smTables: Array<{ id: string, smAnswers: Array<string>, smCaption: { localizations: Array<{ localizationId: string, value: string }> }, smValues: Array<{ id: string, label: string, correctValue?: string | null, given?: string | null, gapFormat: SpellingMatrix_GapFormat }> }> } | { __typename: 'SurveyCombo_QueryItemSessionData', id: string, showHideButtonOrder: SurveyCombo_ShowHideButtonOrder, showSubItems: SurveyCombo_ShowSubItems, header: { localizations: Array<{ localizationId: string, value: string }> }, text: { localizations: Array<{ localizationId: string, value: string }> }, showCaption: { localizations: Array<{ localizationId: string, value: string }> }, hideCaption: { localizations: Array<{ localizationId: string, value: string }> }, scSubItems: Array<{ id: string, itemDocRefId: string, status: SurveyCombo_SubItem_StatusEnum, itemType: string }> } | { __typename: 'SurveyComparision_QueryItemSessionData', id: string, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, smRows: Array<{ id: string, caption: { localizations: Array<{ localizationId: string, value: string }> } }>, smColumns: Array<{ id: string, caption: { localizations: Array<{ localizationId: string, value: string }> } }>, smScale: Array<{ id: string, invalid: boolean, hint: { localizations: Array<{ localizationId: string, value: string }> } }>, smCells: Array<{ id: string, row: { id: string }, col: { id: string }, selected?: { id: string } | null, initial: { id: string } }> } | { __typename: 'SurveySingleChoiceMatrix_QueryItemSessionData', id: string, option?: SurveySingleChoiceMatrix_QueryItemSessionData_Option | null, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, sscmRows?: Array<{ id: string, selectedAnswer?: string | null, value?: { localizations: Array<{ localizationId: string, value: string }> } | null, cells?: Array<{ id: string, selected?: boolean | null } | null> | null } | null> | null, sscmColumns?: Array<{ id: string, value?: { localizations: Array<{ localizationId: string, value: string }> } | null } | null> | null } | { __typename: 'SurveySingleChoiceText_QueryItemSessionData', id: string, userText: string, ssctOption: SurveySingleChoiceText_QueryItemSessionData_Option, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, ssctSelectedAnswer?: { id: string } | null, userTextAnswer?: { id: string } | null, ssctImage?: { id: string } | null, ssctAnswers: Array<{ id: string, text: { localizations: Array<{ localizationId: string, value: string }> } }> } | { __typename: 'SurveyTextEntry_QueryItemSessionData', id: string, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> }, text: { localizations: Array<{ localizationId: string, value: string }> }, steImage?: { id: string } | null, steGaps: Array<{ id: string, givenAnswer?: string | null, gapId: string, pattern: string, validationMessage: { localizations: Array<{ localizationId: string, value: string }> } }> } | { __typename: 'SurveyTextInput_QueryItemSessionData', id: string, essayText?: string | null, stiDone: boolean, stiOption: SurveyTextInput_QueryItemSessionData_Option, header: { localizations: Array<{ localizationId: string, value: string }> }, question: { localizations: Array<{ localizationId: string, value: string }> } } | { __typename: 'TypingTest2023_QueryItemSessionData', id: string, tt2023Text: string, tt2023TypedText: string, tt2023Errors?: number | null, tt2023TextLength?: number | null, tt2023StrokesPerMinute?: number | null, tt2023ReportDisplayTemplateText: TypingTest2023_DisplayTemplateText, tt2023Lines?: Array<{ id: string, lineNr: number, errors: number, textLength: number, typedText: string, text: string, fragments: Array<{ id: string, text: string, mode: TypingTest2023_Fragment_Mode, errorPoints: number }> }> | null } | { __typename: 'TypingTest_QueryItemSessionData', id: string, typedText: string, errors?: number | null, textLength?: number | null, ttText: string, fragments?: Array<{ text: string, mode: TypingTest_Fragment_Mode, errorPoints: number }> | null } | null, accumulatedScore?: { pointsGained: number, pointsLost: number, pointsMax: number, pointsPending: number } | null }> } };

export type IMultistephotspot_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IMultistephotspot_Edit_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null }> } | null } | null, MultistepHotSpotEdit: { get: { id: string, markerWidth: number, markerHeight: number, markerRadius: number, header: { value: string }, question: { value: string }, steps: Array<{ id: string, authorHint: string, stepId: string, isStartingStep: boolean, imageWidth: number, imageHeight: number, image?: { id: string, name: string, hrefResolved: string } | null, zones: Array<{ id: string, zoneId: string, stepLinkId?: string | null, rects: Array<{ id: string, areaId: string, centerX: number, centerY: number, width: number, height: number }>, circles: Array<{ id: string, areaId: string, x: number, y: number, radius: number }> }> }> } } };

export type IMultistephotspot_Edit_UpdateMutationVariables = Exact<{
  params: IMultistepHotSpotEditUpsertInput;
}>;


export type IMultistephotspot_Edit_UpdateMutation = { MultistepHotSpotEdit: { upsert: { id: string } } };

export type IOrganisation_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IOrganisation_Edit_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | null } | null, OrganisationEdit: { get: { id: string, header: { defaultValue: string }, text: { defaultValue: string }, notes: Array<{ id: string, key: string, noteType: Organisation_NoteType, caption: { defaultValue: string }, noteBody: { defaultValue: string }, noteHeader: { defaultValue: string }, correct?: { id: string } | null, actions: Array<{ id: string, key: string, action: { defaultValue: string } }> }> } } };

export type IOrganisation_Edit_UpdateMutationVariables = Exact<{
  params: IOrganisationEdit_UpsertInput;
}>;


export type IOrganisation_Edit_UpdateMutation = { OrganisationEdit?: { upsert?: { id: string } | null } | null };

export type IPlaceholder_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IPlaceholder_Edit_DataQuery = { PlaceholderEdit?: { get: { id: string } } | null };

export type ISpellingmatrix_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ISpellingmatrix_Edit_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string }> } | null } | null, SpellingMatrixEdit: { get: { id: string, header: { defaultValue: string }, text: { defaultValue: string }, values: Array<{ id: string, key: string, value: string, label: string, tableId: string, gapFormat: SpellingMatrix_GapFormat }>, tables: Array<{ id: string, key: string, answers: Array<string>, caption: { defaultValue: string } }> } } };

export type ISpellingmatrix_Edit_UpdateMutationVariables = Exact<{
  params: ISpellingMatrixEdit_UpsertInput;
}>;


export type ISpellingmatrix_Edit_UpdateMutation = { SpellingMatrixEdit?: { upsert?: { id: string } | null } | null };

export type ISurveycombo_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ISurveycombo_Edit_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | null } | null, SurveyComboEdit: { get: { id: string, showHideButtonOrder: SurveyCombo_ShowHideButtonOrder, header: { value: string }, text: { value: string }, showCaption: { value: string }, hideCaption: { value: string } } } };

export type ISurveycombo_Edit_UpdateMutationVariables = Exact<{
  params: ISurveyComboEditUpsertInput;
}>;


export type ISurveycombo_Edit_UpdateMutation = { SurveyComboEdit?: { upsert?: { id: string } | null } | null };

export type ISurveycomparision_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
  itemIdStr: Scalars['String'];
}>;


export type ISurveycomparision_Edit_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | null } | null, item: { get: { _id: string, metaData: { objectives: Array<{ objectiveId: string, scoreMax: number, taxonomy: { id: string, taxon: string, name: { value: string }, anchestors: Array<{ id: string, name: { value: string } }> } }> } } }, SurveyComparisionEdit: { get: { id: string, header: { value: string }, question: { value: string }, columns: Array<{ id: string, index: string, objectiveId?: string | null, caption: { value: string } }>, rows: Array<{ id: string, index: string, caption: { value: string } }>, scale: Array<{ id: string, index: string, value: number, invalid: boolean, hint: { value: string } }> } } };

export type ISurveycomparision_Edit_UpdateMutationVariables = Exact<{
  params: ISurveyComparisionEditUpsertInput;
}>;


export type ISurveycomparision_Edit_UpdateMutation = { SurveyComparisionEdit: { upsert: { id: string } } };

export type ISurveysinglechoicematrix_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ISurveysinglechoicematrix_Edit_DataQuery = { SurveySingleChoiceMatrixEdit: { get: { id: string, option: SurveySingleChoiceMatrixEdit_Option, shuffleRow: SurveySingleChoiceMatrixEdit_ShuffleRow, shuffleColumn: SurveySingleChoiceMatrixEdit_ShuffleColumn, neutralScore: number, header: { value: string }, question: { value: string }, rows: Array<{ id: string, index: string, value: { value: string } }>, columns: Array<{ id: string, index: string, score: number, value: { value: string } }> } } };

export type ISurveysinglecohicematrix_Edit_UpdateMutationVariables = Exact<{
  params: ISurveySingleChoiceMatrixEditUpsertInput;
}>;


export type ISurveysinglecohicematrix_Edit_UpdateMutation = { SurveySingleChoiceMatrixEdit: { upsert: { id: string } } };

export type ISurveysinglechoicetext_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ISurveysinglechoicetext_Edit_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | null } | null, SurveySingleChoiceTextEdit: { get: { id: string, shuffleMode: SurveySingleChoiceTextEdit_Shuffle, option: SurveySingleChoiceTextEdit_Option, userTextEntry: SurveySingleChoiceTextEdit_UserTextEntry, neutralScore: number, header: { value: string }, question: { value: string }, image?: { id: string, hrefResolved: string, name: string } | null, answers: Array<{ id: string, index: string, score: number, text: { value: string } }> } } };

export type ISurveysinglechoicetext_Edit_UpdateMutationVariables = Exact<{
  params: ISurveySingleChoiceTextEditUpsertInput;
}>;


export type ISurveysinglechoicetext_Edit_UpdateMutation = { SurveySingleChoiceTextEdit: { upsert: { id: string } } };

export type ISurveytextentry_Edit_AddgapMutationVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ISurveytextentry_Edit_AddgapMutation = { SurveyTextEntryEdit?: { addGap: { id: string, gapId: string } } | null };

export type ISurveytextentry_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ISurveytextentry_Edit_DataQuery = { SurveyTextEntryEdit?: { get: { id: string, header: { value: string }, text: { value: string }, question: { value: string }, gaps: Array<{ id: string, gapId: string, pattern: string, validationMessage: { value: string } }> } } | null };

export type ISurveytextentry_Edit_RemovegapMutationVariables = Exact<{
  itemId: Scalars['ID'];
  gapId: Scalars['ID'];
}>;


export type ISurveytextentry_Edit_RemovegapMutation = { SurveyTextEntryEdit?: { removeGap: boolean } | null };

export type ISurveytextentry_Edit_UpsertMutationVariables = Exact<{
  params: ISurveyTextEntryEditUpsertInput;
}>;


export type ISurveytextentry_Edit_UpsertMutation = { SurveyTextEntryEdit?: { upsert?: { id: string } | null } | null };

export type ISurveytextinput_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ISurveytextinput_Edit_DataQuery = { SurveyTextInputEdit: { get: { id: string, option: SurveyTextInputEdit_Option, header: { value: string }, question: { value: string } } } };

export type ISurveytextinput_Edit_UpsertMutationVariables = Exact<{
  params: ISurveyTextInputEditUpsertInput;
}>;


export type ISurveytextinput_Edit_UpsertMutation = { SurveyTextInputEdit: { upsert: { id: string } } };

export type ITypingtext_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ITypingtext_Edit_DataQuery = { TypingTestEdit: { get: { id: string, text: string, maxErrorQuota: number, exportErrors: string, exportTextLength: string, exportErrorQuota: string } } };

export type ITypingtest_Edit_UpdateMutationVariables = Exact<{
  params: ITypingTestEditUpsertInput;
}>;


export type ITypingtest_Edit_UpdateMutation = { TypingTestEdit: { upsert: { id: string } } };

export type ITypingtext2023_Edit_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type ITypingtext2023_Edit_DataQuery = { TypingTest2023Edit: { get: { id: string, text: string, maxErrorQuota: number, exportErrors: string, exportTextLength: string, exportErrorQuota: string, exportStrokesPerMinute: string, reportDisplayTemplateText: TypingTest2023_DisplayTemplateText } } };

export type ITypingtest2023_Edit_UpdateMutationVariables = Exact<{
  params: ITypingTest2023EditUpsertInput;
}>;


export type ITypingtest2023_Edit_UpdateMutation = { TypingTest2023Edit: { upsert: { id: string } } };

export type ITaxonomy_DataQueryVariables = Exact<{
  taxonomy: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ITaxonomy_DataQuery = { taxonomy: { get: Array<{ _id: string, items: Array<{ id: string, taxon: string, name: { value: string } }> }> } };

export type IUi_Author_Itemedit_CreateadhocexamMutationVariables = Exact<{
  itemDocRef: Scalars['ID'];
  testDefinitionProfileDocRef: Scalars['ID'];
  language: Scalars['ID'];
  userAgentString: Scalars['String'];
}>;


export type IUi_Author_Itemedit_CreateadhocexamMutation = { author?: { createAdHocExam?: { sessions?: Array<{ launchUrl: string } | null> | null } | null } | null };

export type IUi_Author_Itemedit_DeleteitemMutationVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IUi_Author_Itemedit_DeleteitemMutation = { item: { deleteItem: { ok: boolean, message: { value: string } } } };

export type IUi_Author_Itmeedit_GetconfigQueryVariables = Exact<{
  itemId: Scalars['String'];
}>;


export type IUi_Author_Itmeedit_GetconfigQuery = { config: { itemTranslationEnabled: boolean, contentLanguages: Array<{ id: string, name: { value: string } }> }, item: { get: { _id: string, itemId: string, parentItemId: Array<string>, topItem: { _id: string, docReferenceId: string }, workflow: { editAllowed: boolean, editableByYou: boolean, setToDoneAllowed: boolean, deleteAllowed: boolean }, itemType: { id: string, supportsTranslations: boolean, supportsSubItems: boolean, gradingMode: GradingMode } | { id: string, supportsTranslations: boolean, supportsSubItems: boolean, gradingMode: GradingMode }, basicValidationMessage?: { value: string } | null, metaData: { isSubItem: boolean, title: string, subject: { _id: string, docReferenceId: string, subjectId: string } } } }, TestDefinitionProfile: { all: Array<{ docReferenceId: string, id: string, title: string, examinationType: ExaminationTypeEnum }> } };

export type IUi_Author_Itemedit_Itemmetadatablock_GetQueryVariables = Exact<{
  itemId: Scalars['String'];
}>;


export type IUi_Author_Itemedit_Itemmetadatablock_GetQuery = { item: { get: { _id: string, itemId: string, parentItemId: Array<string>, itemType: { id: string, supportsSubItems: boolean, supportsObjectives: boolean, uuid: string, title: { value: string } } | { id: string, supportsSubItems: boolean, supportsObjectives: boolean, uuid: string, title: { value: string } }, workflow: { noteForAuthor: string, authoringStatus: AuthoringStatusEnum, editAllowed: boolean, editableByYou: boolean, currentAuthor?: { _id: string, shortcut: string, userId: string, displayName: string } | null }, metaData: { minWidth: number, minHeight: number, itemDifficultyIndex: string, title: string, defaultLocalization?: { id: string } | null, publicTitle: { defaultValue: string }, alternations: Array<{ id: string, taxon: string }>, audience: Array<{ _id: string, docReferenceId: string, audienceId: string, title: string }>, category: { id: string, taxon: string }, objectives: Array<{ id: string, objectiveId: string, scoreMax: number, taxonomy: { id: string, taxon: string, name: { value: string }, anchestors: Array<{ id: string, name: { value: string } }> } }>, copyFrom?: { _id: string, itemId: string } | null, revisionFrom?: { _id: string, itemId: string } | null, subject: { _id: string, subjectId: string, docReferenceId: string, audiences: Array<{ docReferenceId: string, audienceId: string, title: string }> } }, childItems: Array<{ id: string, index: number, item: { _id: string, docReferenceId: string, itemId: string, metaData: { title: string }, itemType: { id: string, title: { value: string } } | { id: string, title: { value: string } }, workflow: { authoringStatus: AuthoringStatusEnum } } }> } }, config: { localizations: Array<{ id: string, name: { value: string } }> } };

export type IUi_Author_Itemedit_Itemmetadatablock_AlternationsQueryVariables = Exact<{
  itemId: Scalars['String'];
}>;


export type IUi_Author_Itemedit_Itemmetadatablock_AlternationsQuery = { item: { get: { _id: string, metaData: { alternations: Array<{ id: string, taxon: string }> } } }, taxonomy: { getById: { _id: string, items: Array<{ id: string, taxon: string, name: { value: string } }> } } };

export type IUi_Author_Itemedit_Itemmetadatablock_CategoriesQueryVariables = Exact<{
  itemId: Scalars['String'];
}>;


export type IUi_Author_Itemedit_Itemmetadatablock_CategoriesQuery = { item: { get: { _id: string, metaData: { category: { id: string, taxon: string }, subject: { _id: string, categories: Array<{ id: string, taxon: string, name: { value: string } }> } } } } };

export type IUi_Author_Itemedit_Itemmetadatablock_AllobjectivesQueryVariables = Exact<{
  itemId: Scalars['String'];
}>;


export type IUi_Author_Itemedit_Itemmetadatablock_AllobjectivesQuery = { item: { get: { _id: string, metaData: { subject: { _id: string, syllabus: Array<{ id: string, taxon: string, name: { value: string } }> } } } } };

export type IUi_Author_Itemedit_Itemmetadatablock_ObjectivesQueryVariables = Exact<{
  itemId: Scalars['String'];
}>;


export type IUi_Author_Itemedit_Itemmetadatablock_ObjectivesQuery = { item: { get: { _id: string, itemType: { id: string, supportsObjectives: boolean } | { id: string, supportsObjectives: boolean }, metaData: { objectives: Array<{ id: string, objectiveId: string, scoreMax: number }> } } } };

export type IUi_Author_Itemedit_Itemmetadatablock_UpdateMutationVariables = Exact<{
  params: IUpdateItemMetaDataInput;
}>;


export type IUi_Author_Itemedit_Itemmetadatablock_UpdateMutation = { item: { updateMetaData: { ok: boolean } } };

export type IUi_Author_Itemedit_RouteQueryVariables = Exact<{
  itemId: Scalars['String'];
}>;


export type IUi_Author_Itemedit_RouteQuery = { item: { get: { _id: string, itemId: string, docReferenceId: string, parentItemId: Array<string>, workflow: { deleteAllowed: boolean, setToDoneAllowed: boolean, editAllowed: boolean }, metaData: { isSubItem: boolean, subject: { _id: string, docReferenceId: string } } } } };

export type IUi_Author_Itemedit_SettodoneMutationVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IUi_Author_Itemedit_SettodoneMutation = { item: { setToDone: { ok: boolean, message: { value: string } } } };

export type IUi_Author_Itemedit_Translation_DataQueryVariables = Exact<{
  params: IGetItemTranslationsInput;
}>;


export type IUi_Author_Itemedit_Translation_DataQuery = { getItemTranslations: Array<{ isoCode: string, entries: Array<{ itemDocRefId: string, defaultLanguage: string, translations: Array<{ id: string, key: string, value: string }> }> }> };

export type IUi_Author_Itemedit_Translation_InitQueryVariables = Exact<{
  itemId: Scalars['String'];
}>;


export type IUi_Author_Itemedit_Translation_InitQuery = { config: { contentLanguages: Array<{ id: string, name: { value: string } }> }, item: { get: { _id: string, docReferenceId: string, metaData: { defaultLocalization?: { id: string, localizationId: string } | null }, workflow: { editableByYou: boolean, translationStatus: Array<{ id: string, translateableByYou: boolean, status: TranslationStatusEnum, localization: { id: string, localizationId: string, name: { value: string }, isoLanguages: Array<{ id: string, isoCode: string, name: { value: string } }> } }> }, subject: { _id: string, docReferenceId: string } } } };

export type IUi_Author_Itemedit_Translation_UpdateMutationVariables = Exact<{
  params: IUpdateItemTranslationInput;
}>;


export type IUi_Author_Itemedit_Translation_UpdateMutation = { updateItemTranslation: { id: string, key: string, value: string } };

export type IUpdateStatusMutationVariables = Exact<{
  params: IUpdateWorkflowDataInput;
}>;


export type IUpdateStatusMutation = { item: { updateWorklowData: boolean } };

export type IUi_Author_Itemedit_ValidateMutationVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IUi_Author_Itemedit_ValidateMutation = { item: { validate: { ok: boolean, message: { value: string } } } };

export type IUi_Author_Itemoverview_DataQueryVariables = Exact<{
  subjectId: Scalars['ID'];
}>;


export type IUi_Author_Itemoverview_DataQuery = { subjectById: { _id: string, itemsForAuthor: Array<{ _id: string, itemId: string, visibleText: string, keywords: Array<string>, accumulatedScoreMax: number, metaData: { title: string, itemDifficultyIndex: string, category: { id: string, taxon: string, name: { value: string } }, objectives: Array<{ objectiveId: string, scoreMax: number, taxonomy: { id: string, name: { value: string } } }>, audience: Array<{ _id: string, audienceId: string }> }, itemType: { id: string, title: { value: string } } | { id: string, title: { value: string } }, workflow: { authoringStatus: AuthoringStatusEnum, noteForAuthor: string, editAllowed: boolean, obsolete: boolean, currentAuthor?: { _id: string, displayName: string } | null } }> } };

export type IUi_Author_Itemoverview_RouteQueryVariables = Exact<{
  subjectDocRef: Scalars['ID'];
}>;


export type IUi_Author_Itemoverview_RouteQuery = { subjectById: { _id: string, subjectId: string, title: string } };

export type IUi_Author_Manageitem_CopyitemtocontainerMutationVariables = Exact<{
  item: ICopyItemInput;
  containerDocRefId: Scalars['String'];
}>;


export type IUi_Author_Manageitem_CopyitemtocontainerMutation = { item: { copyItem: { toContainer: { ok: boolean, newItemDocRefId?: string | null, message: { value: string } } } } };

export type IUi_Author_Manageitem_CopyitemtosubjectMutationVariables = Exact<{
  item: ICopyItemInput;
  subjectDocRefId: Scalars['String'];
}>;


export type IUi_Author_Manageitem_CopyitemtosubjectMutation = { item: { copyItem: { toSubject: { ok: boolean, newItemDocRefId?: string | null, message: { value: string } } } } };

export type IUi_Author_Manageitem_InitQueryVariables = Exact<{
  currentItemId: Scalars['String'];
  targetSubjectId: Scalars['ID'];
}>;


export type IUi_Author_Manageitem_InitQuery = { subjects: Array<{ docReferenceId: string, subjectId: string, title: string }>, subjectById: { _id: string, itemsForAuthor: Array<{ _id: string, docReferenceId: string, itemId: string, workflow: { authoringStatus: AuthoringStatusEnum, locked: boolean } }> }, item: { get: { _id: string, itemId: string, itemType: { id: string, supportsSubItems: boolean } | { id: string, supportsSubItems: boolean } } } };

export type IUi_Author_Newitem_DataQueryVariables = Exact<{
  filter: IGetItemTypesFilter;
}>;


export type IUi_Author_Newitem_DataQuery = { itemtypes: Array<{ id: string, ordernr: number, description: { value: string }, title: { value: string } } | { id: string, ordernr: number, description: { value: string }, title: { value: string } }> };

export type IUi_Author_Newitem_NewMutationVariables = Exact<{
  params: INewItemInput;
}>;


export type IUi_Author_Newitem_NewMutation = { item: { newItem: { _id: string, itemId: string, docReferenceId: string } } };

export type IUi_Base_GetconfigQueryVariables = Exact<{ [key: string]: never; }>;


export type IUi_Base_GetconfigQuery = { whoAmI: { id: string, loginId: string, type: BrowserSessionType, isoLanguages: Array<string>, localization: { id: string, englishName: string }, user?: { _id: string, docReferenceId: string, privileges: Array<{ privilege: Privilege } | { privilege: Privilege } | { privilege: Privilege }>, isSuperUser?: { privilege: Privilege } | { privilege: Privilege } | { privilege: Privilege } | null, isAuthor?: { privilege: Privilege } | { privilege: Privilege } | { privilege: Privilege } | null, isTranslator?: { privilege: Privilege } | { privilege: Privilege } | { privilege: Privilege } | null, isEvaluator?: { privilege: Privilege } | { privilege: Privilege } | { privilege: Privilege } | null, isExamAdmin?: { privilege: Privilege } | { privilege: Privilege } | { privilege: Privilege } | null } | null }, config: { golemEnabled: boolean, serverVersion: string, instanceName: string, connectionLostTime: number, stopOnConnectionLost: boolean, onlineHelp: Array<{ id: string, label: { value: string } }>, languageSwitcher: Array<{ id: string, name: { value: string } }> } };

export type IUi_Bulkgrading_Selectitem_DataQueryVariables = Exact<{
  subject: Scalars['ID'];
}>;


export type IUi_Bulkgrading_Selectitem_DataQuery = { itemsForBulkGrading: Array<{ id: string, sessionsForItemCount: number, item: { _id: string, itemId: string, metaData: { title: string }, itemType: { id: string, title: { value: string } } | { id: string, title: { value: string } } }, evaluatorHint: { value: string } }> };

export type IUi_Demo_InitQueryVariables = Exact<{ [key: string]: never; }>;


export type IUi_Demo_InitQuery = { examination: { getDemoExams: Array<{ _id: string, examAliases: Array<string>, docReferenceId: string, title?: string | null, dateCreated: string }> } };

export type IUi_Focusmanager_Client_CacheMutationVariables = Exact<{
  data: IClient_TopItemDataInput;
}>;


export type IUi_Focusmanager_Client_CacheMutation = { itsr3client?: { cache: boolean } | null };

export type IUi_Focusmanager_Client_CleanupMutationVariables = Exact<{
  data: IClient_TopItemDataInput;
}>;


export type IUi_Focusmanager_Client_CleanupMutation = { itsr3client?: { cleanup: boolean } | null };

export type IUi_Focusmanager_Client_InitMutationVariables = Exact<{
  data: IClient_InitInput;
}>;


export type IUi_Focusmanager_Client_InitMutation = { itsr3client?: { init: { driveH: string } } | null };

export type IUi_Focusmanager_Client_InvestigateMutationVariables = Exact<{
  data: IClient_TopItemDataInput;
}>;


export type IUi_Focusmanager_Client_InvestigateMutation = { itsr3client?: { investigate: Array<{ investigatorId: string, serializedValue: string }> } | null };

export type IUi_Focusmanager_Client_ResetMutationVariables = Exact<{
  data: IClient_TopItemDataInput;
}>;


export type IUi_Focusmanager_Client_ResetMutation = { itsr3client?: { reset: boolean } | null };

export type IUi_Focusmanager_Client_SetupMutationVariables = Exact<{
  data: IClient_TopItemDataInput;
}>;


export type IUi_Focusmanager_Client_SetupMutation = { itsr3client?: { setup: boolean } | null };

export type IUi_Focusmanager_SetuserfieldsMutationVariables = Exact<{
  examSessionParams: IExamSessionMutationInput;
  params: Array<ISetUserFieldInput> | ISetUserFieldInput;
}>;


export type IUi_Focusmanager_SetuserfieldsMutation = { examSession?: { setUserFields: { id: string } } | null };

export type IOnline_HelpQueryVariables = Exact<{
  helpId: Scalars['ID'];
  widgetName?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type IOnline_HelpQuery = { config: { onlineHelpById: { url: string } } };

export type IUi_InitQueryVariables = Exact<{ [key: string]: never; }>;


export type IUi_InitQuery = { whoAmI: { type: BrowserSessionType, myExamSession?: { examInfo: { itemHost: ItemHostEnum } } | null }, config: { stopOnConnectionLost: boolean } };

export type IUi_LoginMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
  lang?: InputMaybe<Scalars['String']>;
}>;


export type IUi_LoginMutation = { login: { browserSessionId: string, href: string } };

export type IUi_Login_AnonymousMutationVariables = Exact<{
  lang?: InputMaybe<Scalars['String']>;
}>;


export type IUi_Login_AnonymousMutation = { loginAnonymous: { browserSessionId: string } };

export type IUi_LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type IUi_LogoutMutation = { logout: boolean };

export type IUi_Manualgrading_Grading_DataQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type IUi_Manualgrading_Grading_DataQuery = { itemForManualGrading: { id: string, sessions: Array<string>, item: { _id: string, isTopItem: boolean, itemType: { id: string } | { id: string } } } };

export type IUi_Manualgrading_Grading_UpdateQueryVariables = Exact<{
  itemId: Scalars['ID'];
  sessions: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type IUi_Manualgrading_Grading_UpdateQuery = { itemGradingData: Array<{ id: string, sessionId: string, submitted: boolean }> };

export type IUi_Manualgrading_Selectitem_DataQueryVariables = Exact<{
  subject: Scalars['ID'];
}>;


export type IUi_Manualgrading_Selectitem_DataQuery = { itemsForManualGrading: Array<{ id: string, sessionsForItemCount: number, item: { _id: string, docReferenceId: string, itemId: string, metaData: { title: string }, itemType: { id: string, title: { value: string } } | { id: string, title: { value: string } } } }> };

export type IUi_Paricipatesingle_SetnotificationemailMutationVariables = Exact<{
  sessionId: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
}>;


export type IUi_Paricipatesingle_SetnotificationemailMutation = { setSessionNotificationEmail: boolean };

export type IUi_Participatesingle_ExamsessionQueryVariables = Exact<{
  params: IExamSessionQueryInput;
}>;


export type IUi_Participatesingle_ExamsessionQuery = { config: { submitEnableTime: number }, examSession: { id: string, docReferenceId: string, sessionId: string, totalTime: string, mode: SessionModesEnum, startMode: SessionStartModesEnum, flags: Array<string>, notification: { email?: string | null, emailConfirmed: EMailConfirmed }, currentItem?: { id: string, itemDocRefId: string, itemId: string, itemType: string, index: number, accumulatedScore?: { pointsMax: number, pointsPending: number } | null } | null, currentSection?: { id: string, sectionInfo: { title?: string | null, id?: string | null, color?: string | null }, items: Array<{ id: string, itemDocRefId: string }> } | null, examInfo: { navigationStyle: NavigationStyleEnum, resetOnNavigate: boolean, languageTag: string }, candidate?: { display: string } | null, itemInfo: { completed: number, pending: number, total: number } } };

export type IUi_Participatesingle_InitQueryVariables = Exact<{
  params: IExamSessionQueryInput;
}>;


export type IUi_Participatesingle_InitQuery = { config: { customlogo1?: string | null, customlogo2?: string | null }, examSession: { id: string, examInfo: { examId: string, examAlias: string, title: string, welcomePage: { text: { value: string }, startButton: { visibility: ButtonVisibility, label: { value: string } }, cancelButton: { visibility: ButtonVisibility, label: { value: string } } }, executionPage: { displayTime: DisplayTime, submitButton: { visibility: ButtonVisibility, label: { value: string } }, finishButton: { visibility: ButtonVisibility, label: { value: string } } }, resultPage: { email: ResultPageEMail, pdf: ResultPagePdf, closeButton: { visibility: ButtonVisibility, label: { value: string } }, emailLabel: { value: string }, emailText: { value: string }, pdfButton: { visibility: ButtonVisibility, label: { value: string } } } } } };

export type IUi_Print_DataQueryVariables = Exact<{
  sessionDocRef: Scalars['ID'];
}>;


export type IUi_Print_DataQuery = { examSession: { maxTime: string, candidate?: { candidateId: string, display: string } | null, examInfo: { examId: string, examAlias: string, title: string, languageTag: string, pdfReportSettings: { includeItems: PdfReportSettingsIncludeItems, itemDetailCaption: { value: string } } }, items: Array<{ id: string, itemId: string, itemType: string, index: number, title: { value: string }, accumulatedScore?: { pointsGained: number, pointsPending: number, pointsLost: number, pointsMax: number, pointsPercentage?: number | null } | null }>, score?: { pointsGained: number, pointsPending: number, pointsLost: number, pointsMax: number, pointsPercentage?: number | null } | null } };

export type IUi_Resultscreens_Default_DataQueryVariables = Exact<{
  sessionDocRefId: Scalars['ID'];
  withResultPage: Scalars['Boolean'];
  withPDF: Scalars['Boolean'];
}>;


export type IUi_Resultscreens_Default_DataQuery = { examSession: { id: string, candidate?: { candidateId: string, display: string } | null, notification: { email?: string | null, emailConfirmed: EMailConfirmed }, examInfo: { itemHost: ItemHostEnum, title: string, pdfReportSettings?: { objectiveMinDepth: number, objectiveMaxDepth: number, displayItemId: DisplayItemIdEnum, displayObjectiveId: DisplayObjectiveIdEnum, text: { value: string }, itemText: { value: string }, objectiveText: { value: string }, itemHeader: { value: string }, objectiveHeader: { value: string } }, resultPage?: { objectiveMinDepth: number, objectiveMaxDepth: number, email: ResultPageEMail, pdf: ResultPagePdf, displayItemId: DisplayItemIdEnum, displayObjectiveId: DisplayObjectiveIdEnum, text: { value: string }, itemText: { value: string }, objectiveText: { value: string }, itemHeader: { value: string }, objectiveHeader: { value: string }, closeButton: { visibility: ButtonVisibility, label: { value: string } }, emailLabel: { value: string }, emailText: { value: string }, pdfButton: { visibility: ButtonVisibility, label: { value: string } } } }, score?: { pointsGained: number, pointsLost: number, pointsPending: number, pointsMax: number, pointsPercentage?: number | null } | null } };

export type IUi_Resultscreens_SetnotificationemailMutationVariables = Exact<{
  sessionId: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
}>;


export type IUi_Resultscreens_SetnotificationemailMutation = { setSessionNotificationEmail: boolean };

export type IUi_Resultscreens_Default_ObjectivesQueryVariables = Exact<{
  sessionDocRefId: Scalars['ID'];
  maxDepth: Scalars['Int'];
  includeObjectives: Scalars['Boolean'];
  includeItems: Scalars['Boolean'];
}>;


export type IUi_Resultscreens_Default_ObjectivesQuery = { examSession: { id: string, objectives?: Array<{ id: string, objectiveId: string, objectiveDepth: number, scoreGained?: number | null, scorePending?: number | null, scoreMax?: number | null, scoreLost?: number | null, description: { value: string } }>, items?: Array<{ id: string, itemId: string, itemType: string, index: number, title: { value: string }, accumulatedScore?: { pointsGained: number, pointsPending: number, pointsLost: number, pointsMax: number, pointsPercentage?: number | null } | null }> } };

export type IUi_Service_Participation_DataQueryVariables = Exact<{
  session: Scalars['ID'];
}>;


export type IUi_Service_Participation_DataQuery = { config: { passedTimeUpdateInterval: number }, examSession: { id: string, totalTime: string, mode: SessionModesEnum, startMode: SessionStartModesEnum, currentItem?: { id: string, itemDocRefId: string } | null, items: Array<{ id: string, itemDocRefId: string, navigationStatus: ItemNavigationStatus, interactionStatus?: { locked?: boolean | null, closed?: boolean | null, started?: boolean | null, complete?: boolean | null } | null, itemInfo: { started: number, locked: number, closed: number, completed: number, pending: number, total: number }, accumulatedScore?: { pointsGained: number, pointsPending: number, pointsMax: number } | null }>, itemInfo: { started: number, locked: number, closed: number, completed: number, pending: number, total: number }, sections: Array<{ id: string, sectionInfo: { id?: string | null, itemInfo?: { started: number, locked: number, closed: number, completed: number, pending: number, total: number } | null } }> } };

export type IUi_Service_Participation_FinishexamMutationVariables = Exact<{
  examSessionParams: IExamSessionMutationInput;
}>;


export type IUi_Service_Participation_FinishexamMutation = { examSession?: { finishExam?: { ok?: boolean | null, message?: { value: string } | null, session?: { id: string, mode: SessionModesEnum, startMode: SessionStartModesEnum } | null } | null } | null };

export type IUi_Service_Participation_InitQueryVariables = Exact<{
  params: IExamSessionQueryInput;
  userAgent: Scalars['String'];
}>;


export type IUi_Service_Participation_InitQuery = { config: { submitEnableTime: number, customlogo1?: string | null, customlogo2?: string | null }, examSession: { id: string, mode: SessionModesEnum, docReferenceId: string, sessionId: string, totalTime: string, golemScript?: { _id: string, scriptJson: string } | null, sections: Array<{ id: string, sectionInfo: { id?: string | null, name?: string | null, title?: string | null, description?: string | null, color?: string | null, alternateColor?: string | null }, items: Array<{ id: string, itemDocRefId: string, itemId: string, isTopItem: boolean, itemType: string, index: number, hasFocusMode: boolean, minWidth: number, minHeight: number, navigationStatus: ItemNavigationStatus, accumulatedScore?: { pointsMax: number } | null }> }>, examInfo: { hasInApplication: boolean, navigationStyle: NavigationStyleEnum, continueWith: ContinueWithEnum, resetOnNavigate: boolean, languageTag: string, passesRestrictions: boolean, restrictions: string, itemHost: ItemHostEnum, welcomePage: { text: { value: string }, startButton: { visibility: ButtonVisibility, label: { value: string } }, cancelButton: { visibility: ButtonVisibility, label: { value: string } } }, executionPage: { showImmediateResult: ShowImmediateResult, showItemMaxScore: ShowItemMaxScore, immediateResultSeconds: number, displayTime: DisplayTime, displayProgress: DisplayProgress, immediateResultText: { value: string }, timeLabel: { value: string }, progressLabel: { value: string }, submitButton: { visibility: ButtonVisibility, label: { value: string } }, postponeButton: { visibility: ButtonVisibility, label: { value: string } }, finishButton: { visibility: ButtonVisibility, label: { value: string } }, previousButton: { visibility: ButtonVisibility, label: { value: string } }, nextButton: { visibility: ButtonVisibility, label: { value: string } }, overviewButton: { visibility: ButtonVisibility, label: { value: string } }, resetButton: { visibility: ButtonVisibility, label: { value: string } } } }, candidate?: { candidateId: string, display: string } | null } };

export type IUi_Service_Participation_StartexamMutationVariables = Exact<{
  examSessionParams: IExamSessionMutationInput;
  startExamParams: IMutationStartExamParams;
}>;


export type IUi_Service_Participation_StartexamMutation = { examSession?: { startExam?: { id: string, startMode: SessionStartModesEnum, currentItem?: { id: string, itemDocRefId: string } | null } | null } | null };

export type IUi_Service_Participation_TicktockMutationVariables = Exact<{
  session: Scalars['ID'];
  timePassedMS: Scalars['Int'];
  updateExamState?: InputMaybe<IUpdateExamStateInput>;
  objectives: Scalars['Boolean'];
}>;


export type IUi_Service_Participation_TicktockMutation = { examSession?: { tickTock: { id: string, scormData: string, mode: SessionModesEnum, startMode: SessionStartModesEnum, timeLeft: { serverTime: string, timeLeft: string, timePassed: string }, currentItem?: { id: string, itemDocRefId: string } | null, objectives?: Array<{ id: string, objectiveId: string, scoreGained?: number | null, scoreLost?: number | null, scoreMax?: number | null, scorePending?: number | null }>, examInfo?: { masteryScore: number }, score?: { pointsGained: number, pointsLost: number, pointsPending: number, pointsMax: number } | null, items: Array<{ id: string, itemDocRefId: string, navigationStatus: ItemNavigationStatus, interactionStatus?: { locked?: boolean | null, closed?: boolean | null, started?: boolean | null, complete?: boolean | null } | null, itemInfo: { started: number, locked: number, closed: number, completed: number, pending: number, total: number }, accumulatedScore?: { pointsGained: number, pointsPending: number, pointsMax: number } | null }>, itemInfo: { started: number, locked: number, closed: number, completed: number, pending: number, total: number }, sections: Array<{ id: string, sectionInfo: { id?: string | null, itemInfo?: { started: number, locked: number, closed: number, completed: number, pending: number, total: number } | null } }> } } | null };

export type IUi_Sessionreport_DataQueryVariables = Exact<{
  sessionDocRef: Scalars['ID'];
}>;


export type IUi_Sessionreport_DataQuery = { examSession: { maxTime: string, externalId?: string | null, sessionStartTime: string, sessionCloseTime: string, candidate?: { candidateId: string, display: string } | null, objectives: Array<{ id: string, objectiveId: string, objectiveDepth: number, scoreGained?: number | null, scorePending?: number | null, scoreMax?: number | null, scoreLost?: number | null, description: { value: string } }>, examInfo: { examId: string, examAlias: string, title: string, languageTag: string }, items: Array<{ id: string, itemId: string, itemType: string, interactionStatus?: { started?: boolean | null, complete?: boolean | null } | null }>, score?: { pointsGained: number, pointsPending: number, pointsLost: number, pointsMax: number, pointsPercentage?: number | null } | null } };

export type IUi_Subjectcoordinator_Examorder_DataQueryVariables = Exact<{
  subjectDocRef: Scalars['ID'];
}>;


export type IUi_Subjectcoordinator_Examorder_DataQuery = { subjectById: { _id: string, subjectId: string, openExamOrders: Array<{ _id: string, docReferenceId: string, examinationOrderId: string, status: ExaminationOrderStatus, scoreMax: number, examDate?: string | null, examTime?: string | null, subject: { id: string, status: ExamOrderSubjectStatus, score: number }, localizations: Array<{ id: string, name: { value: string } }> }> } };

export type IUi_Subjectcoordinator_Examorderedit_CreatecttMutationVariables = Exact<{
  examOrderDocRef: Scalars['ID'];
  subjectDocRef: Scalars['ID'];
}>;


export type IUi_Subjectcoordinator_Examorderedit_CreatecttMutation = { examOrder?: { createCTTfromItems: boolean } | null };

export type IUi_Subjectcoordinator_Examorderedit_DataQueryVariables = Exact<{
  examOrderDocRef: Scalars['String'];
  subjectDocRef: Scalars['ID'];
}>;


export type IUi_Subjectcoordinator_Examorderedit_DataQuery = { whoAmI: { id: string, user?: { _id: string, superuser?: { __typename: 'BasicPrivilege', privilege: Privilege } | { __typename: 'LocalizationPrivilege', privilege: Privilege } | { __typename: 'SubjectPrivilege', privilege: Privilege } | null, translator?: { __typename: 'BasicPrivilege' } | { __typename: 'LocalizationPrivilege', privilege: Privilege, localizations: Array<{ id: string, localizationId: string }> } | { __typename: 'SubjectPrivilege' } | null } | null }, config: { levelOfSecrecyEnabled: boolean, examLanguages: Array<{ id: string, name: { value: string } }> }, examOrder: { byId: { _id: string, docReferenceId: string, examinationOrderId: string, title: string, levelOfSecrecy: LevelOfSecrecy, categoryDepth: number, syllabusDepth: number, status: ExaminationOrderStatus, examDate?: string | null, examTime?: string | null, maxTimeAllowed: string, defineScore: ExaminationOrderDefineScore, profile?: { _id: string, title: string } | null, audience?: { _id: string, audienceId: string } | null, items: Array<{ id: string, index: number, chance: number, item: { _id: string, docReferenceId: string, itemId: string, accumulatedScoreMax: number, visibleText: string, accumulatedCategories: Array<{ id: string, taxon: string }>, accumulatedObjectives: Array<{ id: string, taxon: string }>, itemType: { id: string, title: { value: string } } | { id: string, title: { value: string } }, metaData: { title: string }, workflow: { translateableByYou: boolean, editableByYou: boolean } } }>, subject: { id: string, score: number, status: ExamOrderSubjectStatus, subject: { _id: string, isTranslator?: { __typename: 'SubjectPrivilege', privilege: Privilege } | null }, validToFinish: { ok: boolean, validationMessages: Array<{ value: string }> }, dimensionCategories: Array<{ id: string, parentId?: string | null, taxon: string, name: { value: string } }>, dimensionSyllabus: Array<{ id: string, parentId?: string | null, taxon: string, isLeaf: boolean, name: { value: string } }>, localizations: Array<{ id: string, localizationId: string, name: { value: string } }>, entries: Array<{ categoryId: string, objectiveId: string, assignedScore: number, targetScore: number, items: Array<{ _id: string, itemId: string }> }> } } } };

export type IUi_Subjectcoordinator_Examorderedit_FinishsubjectMutationVariables = Exact<{
  examOrderDocRef: Scalars['ID'];
  subjectDocRef: Scalars['ID'];
}>;


export type IUi_Subjectcoordinator_Examorderedit_FinishsubjectMutation = { examOrder?: { finishSubject: boolean } | null };

export type IUi_Subjectcoordinator_Examorderedit_RouteQueryVariables = Exact<{
  examOrderDocRef: Scalars['String'];
  subjectDocRef: Scalars['ID'];
}>;


export type IUi_Subjectcoordinator_Examorderedit_RouteQuery = { examOrder: { byId: { _id: string, docReferenceId: string, examinationOrderId: string, title: string, status: ExaminationOrderStatus, subject: { id: string, status: ExamOrderSubjectStatus } } } };

export type IUi_Subjectcoordinator_Examorderedit_UpdateMutationVariables = Exact<{
  params: IUpsertExamOrderInput;
}>;


export type IUi_Subjectcoordinator_Examorderedit_UpdateMutation = { examOrder?: { upsert: { _id: string } } | null };

export type IUi_Subjectcoordinator_Examorderedit_UpdateitemsMutationVariables = Exact<{
  examOrderDocRef: Scalars['ID'];
  subjectDocRef: Scalars['ID'];
}>;


export type IUi_Subjectcoordinator_Examorderedit_UpdateitemsMutation = { examOrder?: { updateItems: boolean } | null };

export type IUi_Subjectcoordinator_Home_DataQueryVariables = Exact<{ [key: string]: never; }>;


export type IUi_Subjectcoordinator_Home_DataQuery = { config: { itemTranslationEnabled: boolean } };

export type IUi_Subjectcoordinator_Home_RouteQueryVariables = Exact<{
  subjectId: Scalars['ID'];
}>;


export type IUi_Subjectcoordinator_Home_RouteQuery = { subjectById: { _id: string, title: string } };

export type IUi_Subjectcoordinator_Itemreview_InitQueryVariables = Exact<{
  subjectDocRef: Scalars['ID'];
  topItems: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type IUi_Subjectcoordinator_Itemreview_InitQuery = { subjectById: { _id: string, subjectId: string, authors: Array<{ docReferenceId: string }>, itemsForSubjectCoordinator: Array<{ _id: string, itemId: string, docReferenceId: string, topItem: { _id: string, docReferenceId: string }, childItems: Array<{ id: string }> }> } };

export type IUi_Subjectcoordinator_Itemreview_Metadata_AssignauthorMutationVariables = Exact<{
  itemId: Scalars['ID'];
  authorId: Scalars['ID'];
  noteForAuthor?: InputMaybe<Scalars['String']>;
}>;


export type IUi_Subjectcoordinator_Itemreview_Metadata_AssignauthorMutation = { item: { assignAuthor: boolean } };

export type IUi_Subjectcoordinator_Itemreview_Metadata_AssigntoexamorderMutationVariables = Exact<{
  itemId: Scalars['ID'];
  examOrderId: Scalars['ID'];
  examOrderDocRef: Scalars['ID'];
}>;


export type IUi_Subjectcoordinator_Itemreview_Metadata_AssigntoexamorderMutation = { examOrder?: { upsert: { _id: string } } | null };

export type IUi_Subjectcoordinator_Itemreview_MetadataQueryVariables = Exact<{
  itemId: Scalars['String'];
}>;


export type IUi_Subjectcoordinator_Itemreview_MetadataQuery = { item: { get: { _id: string, itemId: string, docReferenceId: string, parentItemId: Array<string>, accumulatedScoreMax: number, scoreMax: number, childItems: Array<{ id: string, index: number, item: { _id: string, docReferenceId: string, itemId: string, workflow: { authoringStatus: AuthoringStatusEnum }, itemType: { id: string, title: { value: string } } | { id: string, title: { value: string } }, metaData: { title: string, category: { id: string, taxon: string }, objectives: Array<{ id: string, objectiveId: string }> } } }>, metaData: { minWidth: number, minHeight: number, title: string, itemDifficultyIndex: string, defaultLocalization?: { id: string, name: { value: string } } | null, category: { id: string, taxon: string, name: { value: string } }, objectives: Array<{ objectiveId: string, scoreMax: number, taxonomy: { id: string, taxon: string, name: { value: string }, anchestors: Array<{ id: string, taxon: string, name: { value: string } }> } }>, audience: Array<{ _id: string, docReferenceId: string, audienceId: string, title: string }>, alternations: Array<{ id: string, taxon: string }>, copyFrom?: { _id: string, itemId: string } | null, revisionFrom?: { _id: string, itemId: string } | null, successorItem?: { _id: string, docReferenceId: string, itemId: string } | null }, itemType: { id: string, supportsSubItems: boolean, supportsObjectives: boolean, uuid: string, title: { value: string } } | { id: string, supportsSubItems: boolean, supportsObjectives: boolean, uuid: string, title: { value: string } }, topItem: { _id: string, docReferenceId: string }, workflow: { authoringStatus: AuthoringStatusEnum, noteForAuthor: string, locked: boolean, isHiddenForAuthor?: boolean | null, editAllowed: boolean, obsolete: boolean, currentAuthor?: { _id: string, displayName: string, docReferenceId: string } | null, published: Array<{ _id: string, docReferenceId: string, examinationOrderId: string, title: string }>, provisioned: Array<{ _id: string, docReferenceId: string, examinationOrderId: string, title: string }> }, subject: { _id: string, subjectId: string, docReferenceId: string, audiences: Array<{ docReferenceId: string, audienceId: string, title: string }>, authors: Array<{ _id: string, docReferenceId: string, displayName: string }>, openExamOrders: Array<{ _id: string, docReferenceId: string, examinationOrderId: string, title: string }> } } } };

export type IUi_Subjectcoordinator_Itemreview_Metadata_AlternationsQueryVariables = Exact<{
  itemId: Scalars['String'];
}>;


export type IUi_Subjectcoordinator_Itemreview_Metadata_AlternationsQuery = { item: { get: { _id: string, metaData: { alternations: Array<{ id: string, taxon: string }> } } }, taxonomy: { getById: { _id: string, items: Array<{ id: string, taxon: string, name: { value: string } }> } } };

export type IUi_Subjectcoordinator_Itemreview_Metadata_CategoriesQueryVariables = Exact<{
  itemId: Scalars['String'];
}>;


export type IUi_Subjectcoordinator_Itemreview_Metadata_CategoriesQuery = { item: { get: { _id: string, metaData: { category: { id: string, taxon: string }, subject: { _id: string, categories: Array<{ id: string, taxon: string, name: { value: string } }> } } } } };

export type IUi_Subjectcoordinator_Itemreview_Metadata_ObjectivesQueryVariables = Exact<{
  itemId: Scalars['String'];
}>;


export type IUi_Subjectcoordinator_Itemreview_Metadata_ObjectivesQuery = { item: { get: { _id: string, metaData: { subject: { _id: string, syllabus: Array<{ id: string, taxon: string, name: { value: string } }> } } } } };

export type IUi_Subjectcoordinator_Itemreview_Metadata_RemovefromexamorderMutationVariables = Exact<{
  itemId: Scalars['ID'];
  examOrderId: Scalars['ID'];
  examOrderDocRef: Scalars['ID'];
}>;


export type IUi_Subjectcoordinator_Itemreview_Metadata_RemovefromexamorderMutation = { examOrder?: { upsert: { _id: string } } | null };

export type IUi_Subjectcoordinator_Itemreview_Metadata_ReopenitemMutationVariables = Exact<{
  item: Scalars['ID'];
}>;


export type IUi_Subjectcoordinator_Itemreview_Metadata_ReopenitemMutation = { item: { reopenItem: boolean } };

export type IUi_Subjectcoordinator_Itemreview_Metadata_ReviseitemMutationVariables = Exact<{
  item: IReviseItemInput;
}>;


export type IUi_Subjectcoordinator_Itemreview_Metadata_ReviseitemMutation = { item: { reviseItem: { ok: boolean, newItemDocRefId?: string | null, message: { value: string } } } };

export type IUi_Subjectcoordinator_Itemreview_Metadata_UpdateMutationVariables = Exact<{
  metadata: IUpdateItemMetaDataInput;
  workflow: IUpdateWorkflowDataInput;
}>;


export type IUi_Subjectcoordinator_Itemreview_Metadata_UpdateMutation = { item: { updateWorklowData: boolean, updateMetaData: { ok: boolean } } };

export type IUi_Subjectcoordinator_Itemreviewselection_ItemsQueryVariables = Exact<{
  subjectId: Scalars['ID'];
  filter: IItemFilterOptions;
}>;


export type IUi_Subjectcoordinator_Itemreviewselection_ItemsQuery = { subjectById: { _id: string, itemsForSubjectCoordinator: Array<{ _id: string, docReferenceId: string, docType: Doctype, itemId: string, parentItemId: Array<string>, visibleText: string, keywords: Array<string>, accumulatedScoreMax: number, itemType: { id: string, title: { value: string } } | { id: string, title: { value: string } }, accumulatedCategories: Array<{ id: string, taxon: string }>, accumulatedObjectives: Array<{ id: string, taxon: string }>, metaData: { title: string, audience: Array<{ _id: string, audienceId: string, title: string }> }, workflow: { obsolete: boolean, noteForAuthor: string, authoringStatus: AuthoringStatusEnum, currentAuthor?: { _id: string, displayName: string } | null } }> } };

export type IUi_Subjectcoordinator_Translation_DataQueryVariables = Exact<{
  subjectId: Scalars['ID'];
}>;


export type IUi_Subjectcoordinator_Translation_DataQuery = { config: { contentLanguages: Array<{ id: string, name: { value: string } }> }, subjectById: { _id: string, openExamOrders: Array<{ _id: string, docReferenceId: string, examinationOrderId: string, title: string }> } };

export type IUi_Subjectcoordinator_Translationedit_UpdateMutationVariables = Exact<{
  params: IUpdateItemTranslationInput;
}>;


export type IUi_Subjectcoordinator_Translationedit_UpdateMutation = { updateItemTranslation: { id: string, key: string, value: string } };

export type IUi_Subjectcoordinator_Translationedit_DataQueryVariables = Exact<{
  params: IGetItemTranslationsInput;
}>;


export type IUi_Subjectcoordinator_Translationedit_DataQuery = { config: { contentLanguages: Array<{ id: string, isoCode: string, name: { value: string } }> }, getItemTranslations: Array<{ isoCode: string, entries: Array<{ itemDocRefId: string, defaultLanguage: string, translations: Array<{ id: string, key: string, value: string }> }> }> };

export type IUi_Superuser_Examinationoverview_DataQueryVariables = Exact<{
  userAgentString: Scalars['String'];
}>;


export type IUi_Superuser_Examinationoverview_DataQuery = { whoAmI: { id: string, user?: { _id: string, userId: string } | null }, examination: { all: Array<{ examinationId: string, examAliases: Array<string>, dateCreated: string, docReferenceId: string, _id: string, obsolete: boolean, title?: string | null, passesRestrictions: boolean, type: ExaminationTypeEnum, maxScore: number, demoUrl?: string | null, alternationRestrictions: Array<{ id: string, alternation: { id: string, taxon: string } }>, examOrder?: { _id: string, title: string } | null }> } };

export type IUi_Superuser_Examinationoverview_JsonQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IUi_Superuser_Examinationoverview_JsonQuery = { examination: { byId: { _id: string, json: string } } };

export type IUi_Superuser_Examinationoverview_GolemQueryVariables = Exact<{
  id: Array<Scalars['String']> | Scalars['String'];
}>;


export type IUi_Superuser_Examinationoverview_GolemQuery = { examination: { get: Array<{ _id: string, golemScript: string }> } };

export type IUi_Superuser_Examinationoverview_PreviewMutationVariables = Exact<{
  examId: Scalars['String'];
  externalId: Scalars['String'];
  userAgentString: Scalars['String'];
}>;


export type IUi_Superuser_Examinationoverview_PreviewMutation = { newExamSession: { href: string } };

export type IUi_Superuser_Examinationoverview_SetobsoleteMutationVariables = Exact<{
  examIds: Array<Scalars['String']> | Scalars['String'];
  obsolete: Scalars['Boolean'];
}>;


export type IUi_Superuser_Examinationoverview_SetobsoleteMutation = { examination?: { setObsolete: Array<{ _id: string }> } | null };

export type IUi_Superuser_Examinationoverview_StatisticyamlQueryVariables = Exact<{
  options: IStatisticExportConfigQueryGetYamlConfigOptions;
}>;


export type IUi_Superuser_Examinationoverview_StatisticyamlQuery = { statisticexportconfig: { getYamlConfig: string } };

export type IUi_Superuser_Examorderedit_Addsubject_DataQueryVariables = Exact<{
  docRef: Scalars['String'];
}>;


export type IUi_Superuser_Examorderedit_Addsubject_DataQuery = { examOrder: { byId: { _id: string, examinationOrderId: string, audience?: { _id: string, docReferenceId: string, audienceId: string, subjects: Array<{ _id: string, docReferenceId: string, subjectId: string, title: string }> } | null, subjects: Array<{ id: string, subject: { _id: string, docReferenceId: string } }> } } };

export type IUi_Superuser_Examorderedit_AddsubjectMutationVariables = Exact<{
  params: IUpsertExamOrderInput;
}>;


export type IUi_Superuser_Examorderedit_AddsubjectMutation = { examOrder?: { upsert: { _id: string } } | null };

export type IUi_Superuser_Examorderedit_DataQueryVariables = Exact<{
  docRef: Scalars['String'];
}>;


export type IUi_Superuser_Examorderedit_DataQuery = { audiences: { all: Array<{ _id: string, isDeleted: boolean, docReferenceId: string, audienceId: string, title: string }> }, examOrder: { byId: { _id: string, examinationOrderId: string, title: string, dateCreated: string, docReferenceId: string, isDeleted: boolean, scoreMax: number, scoreRoundingMode: ScoreRoundingModeEnum, itemCount: number, examDate?: string | null, status: ExaminationOrderStatus, examTime?: string | null, maxTimeAllowed: string, defineScore: ExaminationOrderDefineScore, aliases: Array<string>, itemOrderStrategy: ItemOrderStrategy, levelOfSecrecy: LevelOfSecrecy, syllabusDepth: number, categoryDepth: number, profile?: { _id: string, docReferenceId: string } | null, audience?: { _id: string, docReferenceId: string, audienceId: string } | null, subjects: Array<{ id: string, score: number, status: ExamOrderSubjectStatus, subject: { _id: string, docReferenceId: string, title: string, iAmSubjectCoordinator?: { privilege: Privilege } | null, iAmTranslator?: { privilege: Privilege } | null }, localizations: Array<{ id: string }>, sectionTitle: { defaultValue: string } }>, alternations: Array<{ id: string, taxon: string }> } }, TestDefinitionProfile: { all: Array<{ _id: string, docReferenceId: string, title: string }> }, config: { levelOfSecrecyEnabled: boolean, examLanguages: Array<{ id: string, name: { value: string } }> } };

export type IUi_Superuser_Examorderedit_EditMutationVariables = Exact<{
  examOrderDocRef: Scalars['ID'];
}>;


export type IUi_Superuser_Examorderedit_EditMutation = { examOrder?: { edit: boolean } | null };

export type IUi_Superuser_Examorderedit_AlternationsQueryVariables = Exact<{
  docRef: Scalars['String'];
}>;


export type IUi_Superuser_Examorderedit_AlternationsQuery = { examOrder: { byId: { _id: string, alternations: Array<{ id: string, taxon: string }> } }, taxonomy: { getById: { _id: string, items: Array<{ id: string, taxon: string, name: { value: string } }> } } };

export type IUi_Superuser_Examorderedit_ExaminationsQueryVariables = Exact<{
  filter: IGetExaminationFilterInput;
}>;


export type IUi_Superuser_Examorderedit_ExaminationsQuery = { examination: { get: Array<{ _id: string, docReferenceId: string }> } };

export type IUi_Superuser_Examorderedit_ItemsQueryVariables = Exact<{
  examOrderDocRef: Scalars['String'];
  subjectDocRef: Scalars['ID'];
}>;


export type IUi_Superuser_Examorderedit_ItemsQuery = { examOrder: { byId: { _id: string, items: Array<{ id: string, index: number, chance: number, item: { _id: string, docReferenceId: string, itemId: string, accumulatedScoreMax: number, visibleText: string, accumulatedCategories: Array<{ id: string, taxon: string }>, accumulatedObjectives: Array<{ id: string, taxon: string }>, itemType: { id: string, title: { value: string } } | { id: string, title: { value: string } }, metaData: { title: string } } }> } } };

export type IUi_Superuser_Examorderedit_PublishMutationVariables = Exact<{
  docRef: Scalars['ID'];
}>;


export type IUi_Superuser_Examorderedit_PublishMutation = { examOrder?: { publish: boolean } | null };

export type IUi_Superuser_Examorderedit_RouteQueryVariables = Exact<{
  docRef: Scalars['String'];
}>;


export type IUi_Superuser_Examorderedit_RouteQuery = { examOrder: { byId: { _id: string, examinationOrderId: string, status: ExaminationOrderStatus } } };

export type IUi_Superuser_Examorderedit_SendtosubjectcoordinatorMutationVariables = Exact<{
  docRef: Scalars['ID'];
}>;


export type IUi_Superuser_Examorderedit_SendtosubjectcoordinatorMutation = { examOrder?: { sendToSubjectCoordinator: boolean } | null };

export type IUi_Superuser_Examorderedit_SetobsoleteMutationVariables = Exact<{
  docRefs: Array<Scalars['String']> | Scalars['String'];
}>;


export type IUi_Superuser_Examorderedit_SetobsoleteMutation = { examination?: { setObsolete: Array<{ _id: string }> } | null };

export type IUi_Superuser_Examorderedit_UpdateMutationVariables = Exact<{
  params: IUpsertExamOrderInput;
}>;


export type IUi_Superuser_Examorderedit_UpdateMutation = { examOrder?: { upsert: { _id: string } } | null };

export type IUi_Superuser_Examorderedit_Validate_Before_To_PublishQueryVariables = Exact<{
  examOrder: Scalars['String'];
}>;


export type IUi_Superuser_Examorderedit_Validate_Before_To_PublishQuery = { examOrder: { byId: { _id: string, validToPublish: { ok: boolean, validationMessages: Array<{ value: string }> } } } };

export type IUi_Superuser_Examorderedit_Validate_To_SendtosubjectcoordinatorQueryVariables = Exact<{
  examOrder: Scalars['String'];
}>;


export type IUi_Superuser_Examorderedit_Validate_To_SendtosubjectcoordinatorQuery = { examOrder: { byId: { _id: string, validToSendToSubjectCoordinator: { ok: boolean, validationMessages: Array<{ value: string }> } } } };

export type IUi_Superuser_Examorderoverview_CopyMutationVariables = Exact<{
  examOrderDocRef: Scalars['ID'];
}>;


export type IUi_Superuser_Examorderoverview_CopyMutation = { examOrder?: { copy: { _id: string, docReferenceId: string } } | null };

export type IUi_Superuser_Examorderoverview_DataQueryVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Examorderoverview_DataQuery = { examOrder: { list: Array<{ _id: string, docReferenceId: string, isDeleted: boolean, title: string, examinationOrderId: string, dateCreated: string, status: ExaminationOrderStatus, levelOfSecrecy: LevelOfSecrecy, scoreMax: number, examDate?: string | null, examTime?: string | null, profile?: { _id: string, title: string } | null, localizations: Array<{ id: string, name: { value: string } }>, audience?: { _id: string, audienceId: string } | null }> } };

export type IUi_Superuser_Examorderoverview_NewMutationVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Examorderoverview_NewMutation = { examOrder?: { new: { docReferenceId: string } } | null };

export type IUi_Superuser_Golemscriptedit_InitQueryVariables = Exact<{
  docRef: Scalars['ID'];
}>;


export type IUi_Superuser_Golemscriptedit_InitQuery = { golemScripts: { byId: { _id: string, golemScriptId: string, docReferenceId: string, isDeleted: boolean, title: string, scriptYaml: string } } };

export type IUi_Superuser_Golemscriptedit_RouteQueryVariables = Exact<{
  docRef: Scalars['ID'];
}>;


export type IUi_Superuser_Golemscriptedit_RouteQuery = { golemScripts: { byId: { _id: string, golemScriptId: string } } };

export type IUi_Superusre_Golemscriptedit_UpdateMutationVariables = Exact<{
  params: IUpsertGolemScriptInput;
}>;


export type IUi_Superusre_Golemscriptedit_UpdateMutation = { golemScripts: { upsert: { _id: string } } };

export type IUi_Superuser_Golemscriptoverview_DataQueryVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Golemscriptoverview_DataQuery = { golemScripts: { all: Array<{ _id: string, isDeleted: boolean, docReferenceId: string, golemScriptId: string, title: string }> } };

export type IUi_Superuser_Golemscriptoverview_NewMutationVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Golemscriptoverview_NewMutation = { golemScripts: { new: { _id: string, docReferenceId: string } } };

export type IUi_Superuser_Home_DataQueryVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Home_DataQuery = { whoAmI: { id: string, loginId: string } };

export type IUi_Superuser_Itemtypeoverview_DataQueryVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Itemtypeoverview_DataQuery = { itemtypes: Array<{ id: string, enabled: boolean, uuid: string, supportsTranslations: boolean, description: { value: string }, title: { value: string } } | { id: string, enabled: boolean, uuid: string, supportsTranslations: boolean, description: { value: string }, title: { value: string } }> };

export type IUi_Superuser_Itemtypeoverview_DisableMutationVariables = Exact<{
  itemtype: Scalars['ID'];
}>;


export type IUi_Superuser_Itemtypeoverview_DisableMutation = { itemtype?: { disable: Array<{ id: string } | { id: string }> } | null };

export type IUi_Superuser_Itemtypeoverview_EnableMutationVariables = Exact<{
  itemtype: Scalars['ID'];
}>;


export type IUi_Superuser_Itemtypeoverview_EnableMutation = { itemtype?: { enable: Array<{ id: string } | { id: string }> } | null };

export type IUi_Superuser_Launchtest_DataQueryVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Launchtest_DataQuery = { whoAmI: { id: string, user?: { _id: string, userId: string } | null }, golemScripts: { all: Array<{ _id: string, docReferenceId: string, golemScriptId: string, title: string }> } };

export type IUi_Superuser_Launchtest_GetexamsQueryVariables = Exact<{
  userAgentString: Scalars['String'];
  filter: IGetExaminationFilterInput;
}>;


export type IUi_Superuser_Launchtest_GetexamsQuery = { examination: { get: Array<{ _id: string, docReferenceId: string, examinationId: string, obsolete: boolean, passesRestrictions: boolean, alternationRestrictions: Array<{ id: string, alternation: { id: string, taxon: string }, description: { value: string } }> }> } };

export type IUi_Superuser_LaunchtestMutationVariables = Exact<{
  examId: Scalars['String'];
  externalId: Scalars['String'];
  userAgentString: Scalars['String'];
  candidateId?: InputMaybe<Scalars['String']>;
  candidateName?: InputMaybe<Scalars['String']>;
  golemScript?: InputMaybe<Scalars['String']>;
  scoreRoundingMode: ScoreRoundingModeEnum;
}>;


export type IUi_Superuser_LaunchtestMutation = { newExamSession: { href: string, sessionId: string } };

export type ILaunchtest_PrintMutationVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type ILaunchtest_PrintMutation = { printSession: { href: string } };

export type ILaunchtest_PrintPdfQueryVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type ILaunchtest_PrintPdfQuery = { examSession: { resultPdf?: { hrefResolved: string } | null } };

export type IUi_Superuser_Profileedit_DataQueryVariables = Exact<{
  profile: Scalars['ID'];
}>;


export type IUi_Superuser_Profileedit_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | null } | null, TestDefinitionProfile: { byId: { _id: string, docReferenceId: string, id: string, title: string, isDeleted: boolean, continueWith: ContinueWithEnum, continuationMode: ContinuationModeEnum, examinationType: ExaminationTypeEnum, itemHost: ItemHostEnum, maxTimeAllowed: string, navigationStyle: NavigationStyleEnum, resetOnNavigate: ResetOnNavigateEnum, scoreRoundingMode: ScoreRoundingModeEnum, revisableItemCount: number, grades: Array<{ id: string, letter: string, condition: string, passed: boolean, text: { value: string } }>, pdfReportSettings: { objectiveMaxDepth: number, objectiveMinDepth: number, displayItemId: DisplayItemIdEnum, displayObjectiveId: DisplayObjectiveIdEnum, includeItems: PdfReportSettingsIncludeItems, itemHeader: { value: string }, itemText: { value: string }, objectiveHeader: { value: string }, itemDetailCaption: { value: string }, objectiveText: { value: string }, text: { value: string }, emailSubject: { value: string }, emailBody: { value: string }, pageHeader: { value: string }, pageFooter: { value: string } }, welcomePage: { text: { value: string }, startButton: { visibility: ButtonVisibility, label: { value: string } }, cancelButton: { visibility: ButtonVisibility, label: { value: string } } }, executionPage: { displayTime: DisplayTime, displayProgress: DisplayProgress, minWidth: number, minHeight: number, showImmediateResult: ShowImmediateResult, showItemMaxScore: ShowItemMaxScore, immediateResultSeconds: number, submitButton: { visibility: ButtonVisibility, label: { value: string } }, postponeButton: { visibility: ButtonVisibility, label: { value: string } }, finishButton: { visibility: ButtonVisibility, label: { value: string } }, previousButton: { visibility: ButtonVisibility, label: { value: string } }, nextButton: { visibility: ButtonVisibility, label: { value: string } }, overviewButton: { visibility: ButtonVisibility, label: { value: string } }, resetButton: { visibility: ButtonVisibility, label: { value: string } }, immediateResultText: { value: string }, timeLabel: { value: string }, progressLabel: { value: string } }, resultPage: { displayItemId: DisplayItemIdEnum, displayObjectiveId: DisplayObjectiveIdEnum, objectiveMaxDepth: number, objectiveMinDepth: number, pdf: ResultPagePdf, email: ResultPageEMail, closeButton: { visibility: ButtonVisibility, label: { value: string } }, itemHeader: { value: string }, itemText: { value: string }, objectiveHeader: { value: string }, objectiveText: { value: string }, text: { value: string }, pdfButton: { visibility: ButtonVisibility, label: { value: string } }, emailLabel: { value: string }, emailText: { value: string } } } } };

export type IUi_Superuser_Profileedit_RouteQueryVariables = Exact<{
  profile: Scalars['ID'];
}>;


export type IUi_Superuser_Profileedit_RouteQuery = { TestDefinitionProfile: { byId: { _id: string, title: string } } };

export type IUi_Superuser_Profileedit_UpdateMutationVariables = Exact<{
  params: IUpsertTestDefinitionProfile;
}>;


export type IUi_Superuser_Profileedit_UpdateMutation = { TestDefinitionProfile: { upsert: { _id: string } } };

export type IUi_Superuser_Profileoverview_CopyMutationVariables = Exact<{
  docRef: Scalars['ID'];
}>;


export type IUi_Superuser_Profileoverview_CopyMutation = { TestDefinitionProfile: { copy: { _id: string, docReferenceId: string } } };

export type IUi_Superuser_Profileoverview_InitQueryVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Profileoverview_InitQuery = { TestDefinitionProfile: { all: Array<{ _id: string, id: string, isDeleted: boolean, docReferenceId: string, examinationType: ExaminationTypeEnum, itemHost: ItemHostEnum, title: string }> } };

export type IUi_Superuser_Profileoverview_NewprofileMutationVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Profileoverview_NewprofileMutation = { TestDefinitionProfile: { new: { _id: string, docReferenceId: string } } };

export type IUi_Superuser_Audience_InitQueryVariables = Exact<{
  docRef: Scalars['ID'];
}>;


export type IUi_Superuser_Audience_InitQuery = { subjects: Array<{ _id: string, docReferenceId: string, subjectId: string }>, audiences: { byId: { _id: string, audienceId: string, docReferenceId: string, isDeleted: boolean, title: string, subjects: Array<{ _id: string, docReferenceId: string, subjectId: string }> } } };

export type IUi_Superuser_Audienceedit_RouteQueryVariables = Exact<{
  docRef: Scalars['ID'];
}>;


export type IUi_Superuser_Audienceedit_RouteQuery = { audiences: { byId: { _id: string, audienceId: string } } };

export type IUi_Superuser_Audienceedit_UpdateMutationVariables = Exact<{
  params: IUpsertAudienceInput;
}>;


export type IUi_Superuser_Audienceedit_UpdateMutation = { audiences: { upsertAudience: { _id: string } } };

export type IUi_Superuser_Audienceedit_DataQueryVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Audienceedit_DataQuery = { audiences: { all: Array<{ _id: string, isDeleted: boolean, docReferenceId: string, audienceId: string, title: string, subjects: Array<{ _id: string, subjectId: string }> }> } };

export type IUi_Superuser_Audienceoverview_NewMutationVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Audienceoverview_NewMutation = { audiences: { newAudience: { _id: string, docReferenceId: string } } };

export type IUi_Superuser_Scormtokenoverview_DataQueryVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Scormtokenoverview_DataQuery = { scormTokens: { all: Array<{ scormTokenId: string, auditCreated: string, docReferenceId: string, examAlias: string, isDeleted: boolean, lmsOrgins: Array<string>, status: ScormTokenStatus, downloadCode: string, publicDownloadUrl?: string | null, privateDownloadUrl: string, trackability: ScormTokenTrackability, name: { value: string } }> } };

export type IUi_Superuser_Scormtokenoverview_NewMutationVariables = Exact<{
  args: INewScormTokenArgs;
}>;


export type IUi_Superuser_Scormtokenoverview_NewMutation = { scormTokens: { newScormToken: { docReferenceId: string } } };

export type IUi_Superuser_Sessions_JsonQueryVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type IUi_Superuser_Sessions_JsonQuery = { examSession: { id: string, json: string } };

export type IUi_Superuser_Sessions_InitQueryVariables = Exact<{
  filter: IExamSessionsQueryInput;
}>;


export type IUi_Superuser_Sessions_InitQuery = { examSessions: Array<{ id: string, docReferenceId: string, externalId?: string | null, mode: SessionModesEnum, sessionStartTime: string, sessionCloseTime: string, totalTime: string, auditUpdated: string, auditCreated: string, examInfo: { examAlias: string, examId: string, examType: TestTypeEnum, grade?: { id: string, passed: boolean } | null }, timeLeft: { timePassed: string, timeLeft: string }, score?: { pointsGained: number, pointsMax: number, pointsPercentage?: number | null } | null, itemInfo: { percentCompleted: number, progress: string }, candidate?: { candidateId: string, display: string } | null }> };

export type IUi_Superuser_Sessions_PrintMutationVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type IUi_Superuser_Sessions_PrintMutation = { printSession: { id: string, href: string } };

export type IUi_Superuser_Sessions_DeleteMutationVariables = Exact<{
  sessionDocRefId: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type IUi_Superuser_Sessions_DeleteMutation = { deleteSession: { processed: number } };

export type IUi_Superuser_Sessions_GetreportMutationVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type IUi_Superuser_Sessions_GetreportMutation = { sessionReport: { id: string, href: string } };

export type IUi_Superuser_Settings_DataQueryVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Settings_DataQuery = { config: { sharePointConnections: Array<{ id: string, password: string, username: string, triggerKey: string, downloadFolder: string, siteUrl: string, forcedImport: number }> } };

export type IUi_Superuser_Settings_DeletesharepointconnectionMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type IUi_Superuser_Settings_DeletesharepointconnectionMutation = { config?: { deleteSharePointConnections: boolean } | null };

export type IUi_Superuser_Settings_GeneratepasswordMutationVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Settings_GeneratepasswordMutation = { generatePassword: string };

export type IUi_Superuser_Settings_UpdatesharepointconnectionMutationVariables = Exact<{
  params: IUpsertSharePointConnection;
}>;


export type IUi_Superuser_Settings_UpdatesharepointconnectionMutation = { config?: { upsertSharePointConnection: boolean } | null };

export type IUi_Superuser_Statisticexport_DataQueryVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Statisticexport_DataQuery = { statisticexportconfig: { all: Array<{ configurationId: string, title: string }> } };

export type IUi_Superuser_Subjectedit_RouteQueryVariables = Exact<{
  subjectDocRef: Scalars['ID'];
}>;


export type IUi_Superuser_Subjectedit_RouteQuery = { subjectById: { _id: string, subjectId: string } };

export type IUi_Superuser_Subjectedit_DataQueryVariables = Exact<{
  subjectDocRef: Scalars['ID'];
}>;


export type IUi_Superuser_Subjectedit_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | { _id: string, attachments: Array<{ id: string, name: string }> } | null } | null, subjectById: { _id: string, title: string, color?: string | null, alternateColor?: string | null, isDeleted: boolean, subjectId: string, allowNonTranslateable: boolean, itemEditVisibility: ItemEditVisibility, image?: { id: string, name: string, hrefResolved: string } | null, defaultLocalization?: { id: string } | null }, config: { localizations: Array<{ id: string, name: { value: string } }> } };

export type IUi_Superuser_Subjectedit_UpdateMutationVariables = Exact<{
  params: IUpsertSubjectInput;
}>;


export type IUi_Superuser_Subjectedit_UpdateMutation = { subjects: { upsertSubject: { _id: string } } };

export type IUi_Superuser_Subjectoverview_InitQueryVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Subjectoverview_InitQuery = { subjects: Array<{ docReferenceId: string, title: string, isDeleted: boolean, subjectId: string, subjectCoordinators: Array<{ docReferenceId: string, isDeleted: boolean, displayName: string }>, authors: Array<{ docReferenceId: string, isDeleted: boolean, displayName: string }> }> };

export type IUi_Superuser_Subjectoverview_NewMutationVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Subjectoverview_NewMutation = { subjects: { newSubject: { _id: string, docReferenceId: string } } };

export type IUi_Superuser_Testaliasedit_DataQueryVariables = Exact<{
  profile: Scalars['ID'];
}>;


export type IUi_Superuser_Testaliasedit_DataQuery = { TestAlias: { byId: { _id: string, docReferenceId: string, id: string, alias: string, resolvesTo: Array<string> } } };

export type IUi_Superuser_Testaliasedit_RouteQueryVariables = Exact<{
  profile: Scalars['ID'];
}>;


export type IUi_Superuser_Testaliasedit_RouteQuery = { TestAlias: { byId: { _id: string, alias: string } } };

export type IUi_Superuser_Testaliasedit_UpdateMutationVariables = Exact<{
  params: IUpsertTestAlias;
}>;


export type IUi_Superuser_Testaliasedit_UpdateMutation = { TestAlias: { upsert?: { _id: string } | null } };

export type IUi_Superuser_Testaliasoverview_InitQueryVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Testaliasoverview_InitQuery = { TestAlias: { all: Array<{ _id: string, id: string, isDeleted: boolean, docReferenceId: string, alias: string, resolvesTo: Array<string> }> } };

export type IUi_Superuser_Testaliasoverview_NewMutationVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Testaliasoverview_NewMutation = { TestAlias: { new: { _id: string, docReferenceId: string } } };

export type IUi_Superuser_Useredit_GeneratepasswordMutationVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Useredit_GeneratepasswordMutation = { generatePassword: string };

export type IUi_Superuser_Useredit_InitQueryVariables = Exact<{
  userDocRef: Scalars['ID'];
}>;


export type IUi_Superuser_Useredit_InitQuery = { getUserById: { _id: string, docReferenceId: string, displayName: string, shortcut: string, userId: string, mobilephone?: string | null, password: string, isDeleted: boolean, initials: string, privileges: Array<{ __typename: 'BasicPrivilege', privilege: Privilege } | { __typename: 'LocalizationPrivilege', privilege: Privilege, localizations: Array<{ id: string, localizationId: string }> } | { __typename: 'SubjectPrivilege', privilege: Privilege, subjects: Array<{ _id: string, docReferenceId: string }> }> }, config: { localizations: Array<{ id: string, localizationId: string, name: { value: string } }> }, subjects: Array<{ docReferenceId: string, title: string, subjectId: string }> };

export type IUi_Superuser_Useredit_RouteQueryVariables = Exact<{
  userDocRef: Scalars['ID'];
}>;


export type IUi_Superuser_Useredit_RouteQuery = { getUserById: { _id: string, userId: string } };

export type IUi_Superuser_Useredit_UpdateMutationVariables = Exact<{
  params: IUpsertUserInput;
}>;


export type IUi_Superuser_Useredit_UpdateMutation = { users: { upsertUser: { _id: string } } };

export type IUi_Superuser_Useroverview_NewMutationVariables = Exact<{ [key: string]: never; }>;


export type IUi_Superuser_Useroverview_NewMutation = { users: { newUser: { _id: string, docReferenceId: string } } };

export type IUi_Superuser_Useroverview_UsersQueryVariables = Exact<{
  pager?: InputMaybe<IPagerInput>;
}>;


export type IUi_Superuser_Useroverview_UsersQuery = { users: Array<{ _id: string, docReferenceId: string, userId: string, docType: Doctype, isDeleted: boolean, initials: string, displayName: string, privileges: Array<{ privilege: Privilege } | { privilege: Privilege } | { privilege: Privilege }> }> };

export type IUi_SwitchlanguageMutationVariables = Exact<{
  lang: Scalars['String'];
}>;


export type IUi_SwitchlanguageMutation = { switchLanguage: boolean };

export type IUi_Translator_Selectexamorder_DataQueryVariables = Exact<{ [key: string]: never; }>;


export type IUi_Translator_Selectexamorder_DataQuery = { examOrder: { list: Array<{ _id: string, docReferenceId: string, isDeleted: boolean, title: string, examinationOrderId: string, dateCreated: string, status: ExaminationOrderStatus, levelOfSecrecy: LevelOfSecrecy, scoreMax: number, examDate?: string | null, examTime?: string | null, profile?: { _id: string, title: string } | null, localizations: Array<{ id: string, name: { value: string } }>, audience?: { _id: string, audienceId: string } | null }> } };

export type IItemDataFragment = { _id: string, itemId: string, isTopItem: boolean, itemType: { id: string, supportsTranslations: boolean } | { id: string, supportsTranslations: boolean }, metaData: { title: string, subject: { _id: string } }, workflow: { translationStatus: Array<{ id: string, translateableByYou: boolean, status: TranslationStatusEnum, localization: { id: string, localizationId: string } }> } };

export type IUi_Translator_Translateexamorder_DataQueryVariables = Exact<{
  examOrder: Scalars['String'];
}>;


export type IUi_Translator_Translateexamorder_DataQuery = { whoAmI: { id: string, user?: { _id: string, translatorRole?: { __typename: 'BasicPrivilege' } | { __typename: 'LocalizationPrivilege', localizations: Array<{ id: string, localizationId: string, name: { value: string } }> } | { __typename: 'SubjectPrivilege' } | null } | null }, examOrder: { byId: { _id: string, examinationOrderId: string, title: string, subjects: Array<{ id: string, subject: { _id: string, subjectId: string, title: string }, localizations: Array<{ id: string, localizationId: string, isoCodes: Array<string>, name: { value: string } }> }>, items: Array<{ id: string, index: number, item: { _id: string, itemId: string, isTopItem: boolean, descendantItems: Array<{ _id: string, itemId: string, isTopItem: boolean, itemType: { id: string, supportsTranslations: boolean } | { id: string, supportsTranslations: boolean }, metaData: { title: string, subject: { _id: string } }, workflow: { translationStatus: Array<{ id: string, translateableByYou: boolean, status: TranslationStatusEnum, localization: { id: string, localizationId: string } }> } }>, itemType: { id: string, supportsTranslations: boolean } | { id: string, supportsTranslations: boolean }, metaData: { title: string, subject: { _id: string } }, workflow: { translationStatus: Array<{ id: string, translateableByYou: boolean, status: TranslationStatusEnum, localization: { id: string, localizationId: string } }> } } }> } } };

export type IUi_Translateexamorder_ExamorderstringsQueryVariables = Exact<{
  examOrder: Scalars['String'];
}>;


export type IUi_Translateexamorder_ExamorderstringsQuery = { examOrder: { byId: { _id: string, localizations: Array<{ id: string, isoLanguages: Array<{ id: string, isoCode: string, name: { value: string } }> }>, strings: Array<{ id: string, key: string, label: { value: string }, value: { defaultValue: string, languages: Array<{ isoCode: string, value: string } | null> } }> } } };

export type IUi_Translator_Translateexamorder_UpdateMutationVariables = Exact<{
  examOrder: Scalars['ID'];
  strings: Array<IExamOrderUpdateStringsInput> | IExamOrderUpdateStringsInput;
}>;


export type IUi_Translator_Translateexamorder_UpdateMutation = { examOrder?: { updateStrings: boolean } | null };

export type IUi_Advanceditempresenter_AdditemMutationVariables = Exact<{
  sessionDocRef: Scalars['ID'];
  itemDocRef: Scalars['ID'];
}>;


export type IUi_Advanceditempresenter_AdditemMutation = { examSession?: { setSessionItems: Array<{ id: string, itemType: string, isTopItem: boolean }> } | null };

export type IUi_Advanceditempresenter_ItemQueryVariables = Exact<{
  itemDocRef: Scalars['String'];
}>;


export type IUi_Advanceditempresenter_ItemQuery = { item: { get: { _id: string, isTopItem: boolean, itemType: { id: string } | { id: string } } } };

export type IUi_Advanceditempresenter_TicktockMutationVariables = Exact<{
  session: Scalars['ID'];
  timePassedMS: Scalars['Int'];
  updateExamState: IUpdateExamStateInput;
}>;


export type IUi_Advanceditempresenter_TicktockMutation = { examSession?: { tickTock: { id: string } } | null };

export type IUi_Widgets_Connectionlost_RetryQueryVariables = Exact<{ [key: string]: never; }>;


export type IUi_Widgets_Connectionlost_RetryQuery = { config: { serverVersion: string } };

export type IUi_Selectsubject_InitQueryVariables = Exact<{
  role: Privilege;
  itemsForManualGrading: Scalars['Boolean'];
  itemsForBulkGrading: Scalars['Boolean'];
}>;


export type IUi_Selectsubject_InitQuery = { subjects: Array<{ subjectId: string, docReferenceId: string, color?: string | null, title: string, image?: { hrefResolved: string } | null, itemsForBulkGrading?: Array<{ id: string }>, itemsForManualGrading?: Array<{ id: string }>, authors: Array<{ initials: string, docReferenceId: string, displayName: string }>, subjectCoordinators: Array<{ initials: string, docReferenceId: string, displayName: string }> }> };

export type IUi_Assetmanager_DataQueryVariables = Exact<{
  docType: Doctype;
  docRef: Scalars['ID'];
}>;


export type IUi_Assetmanager_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, size: number, name: string, hrefResolved: string, altText: { defaultValue: string }, videoMetadata?: { id: string, width: number, height: number, duration: number } | null, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, size: number, name: string, hrefResolved: string, altText: { defaultValue: string }, videoMetadata?: { id: string, width: number, height: number, duration: number } | null, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, size: number, name: string, hrefResolved: string, altText: { defaultValue: string }, videoMetadata?: { id: string, width: number, height: number, duration: number } | null, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, size: number, name: string, hrefResolved: string, altText: { defaultValue: string }, videoMetadata?: { id: string, width: number, height: number, duration: number } | null, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, size: number, name: string, hrefResolved: string, altText: { defaultValue: string }, videoMetadata?: { id: string, width: number, height: number, duration: number } | null, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, size: number, name: string, hrefResolved: string, altText: { defaultValue: string }, videoMetadata?: { id: string, width: number, height: number, duration: number } | null, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, size: number, name: string, hrefResolved: string, altText: { defaultValue: string }, videoMetadata?: { id: string, width: number, height: number, duration: number } | null, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, size: number, name: string, hrefResolved: string, altText: { defaultValue: string }, videoMetadata?: { id: string, width: number, height: number, duration: number } | null, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, size: number, name: string, hrefResolved: string, altText: { defaultValue: string }, videoMetadata?: { id: string, width: number, height: number, duration: number } | null, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, size: number, name: string, hrefResolved: string, altText: { defaultValue: string }, videoMetadata?: { id: string, width: number, height: number, duration: number } | null, imageMetadata?: { id: string, width: number, height: number } | null }> } | { _id: string, attachments: Array<{ id: string, size: number, name: string, hrefResolved: string, altText: { defaultValue: string }, videoMetadata?: { id: string, width: number, height: number, duration: number } | null, imageMetadata?: { id: string, width: number, height: number } | null }> } | null } | null };

export type IUi_Assetmanager_RemoveMutationVariables = Exact<{
  docType: Doctype;
  docRef: Scalars['ID'];
  attachmentId: Scalars['ID'];
}>;


export type IUi_Assetmanager_RemoveMutation = { document: { removeAttachments: boolean } };

export type IUi_Assetmanager_UpdateMutationVariables = Exact<{
  docType: Doctype;
  docRef: Scalars['ID'];
  data: IUpdateAttachmentInput;
}>;


export type IUi_Assetmanager_UpdateMutation = { document: { updateAttachment: { id: string } } };

export type IUi_Htmleditor_Imgtageditor_DataQueryVariables = Exact<{
  docReferenceId: Scalars['ID'];
  docType: Doctype;
}>;


export type IUi_Htmleditor_Imgtageditor_DataQuery = { documents?: { get?: { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null, videoMetadata?: { id: string, width: number, height: number, duration: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null, videoMetadata?: { id: string, width: number, height: number, duration: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null, videoMetadata?: { id: string, width: number, height: number, duration: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null, videoMetadata?: { id: string, width: number, height: number, duration: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null, videoMetadata?: { id: string, width: number, height: number, duration: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null, videoMetadata?: { id: string, width: number, height: number, duration: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null, videoMetadata?: { id: string, width: number, height: number, duration: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null, videoMetadata?: { id: string, width: number, height: number, duration: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null, videoMetadata?: { id: string, width: number, height: number, duration: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null, videoMetadata?: { id: string, width: number, height: number, duration: number } | null }> } | { _id: string, attachments: Array<{ id: string, name: string, hrefResolved: string, imageMetadata?: { id: string, width: number, height: number } | null, videoMetadata?: { id: string, width: number, height: number, duration: number } | null }> } | null } | null };

export type IUi_Htmleditor_NewimagestubMutationVariables = Exact<{
  docType: Doctype;
  docReferenceId: Scalars['ID'];
}>;


export type IUi_Htmleditor_NewimagestubMutation = { document: { newImageStub: { id: string, hrefResolved: string, name: string } } };

export const PropertiesFragmentDoc = gql`
    fragment properties on HandsOnEdit_Property {
  id
  propertyId
  value
  info {
    id
    type
    validationRule
    enumType {
      values {
        id
      }
    }
    name {
      value
    }
    description {
      value
    }
  }
}
    `;
export const ResultFragmentDoc = gql`
    fragment Result on Result {
  ... on BinaryFunctionResult {
    __typename
    id
    error
    result
    binOp: operator
    fieldId
    argsStr
    argsStrArr
    argsNumber
    argsNumberArray
    argsBoolean
  }
  ... on ConditionResult {
    __typename
    id
    error
    result
    conOp: operator
    args {
      id
    }
  }
  ... on UnaryFunctionResult {
    id
    error
    result
    __typename
    unOp: operator
    arg {
      id
    }
  }
}
    `;
export const LocalizationsFragmentDoc = gql`
    fragment localizations on LangString {
  localizations(localizationId: $localizationId) {
    localizationId
    value
  }
}
    `;
export const ItemDataFragmentDoc = gql`
    fragment ItemData on ItemDocument {
  _id
  itemId
  itemType {
    id
    supportsTranslations
  }
  isTopItem
  metaData {
    title
    subject {
      _id
    }
  }
  workflow {
    translationStatus {
      id
      localization {
        id
        localizationId
      }
      translateableByYou
      status
    }
  }
}
    `;
export const Inaplicationcombo_Edit_DataDocument = gql`
    query inaplicationcombo_edit_data($itemId: ID!) {
  documents {
    get(docType: item, docReferenceId: $itemId) {
      _id
      attachments {
        id
        name
      }
    }
  }
  item {
    getFileStructure(topItemId: $itemId) {
      id
      path
      itemId
      userCreated
    }
  }
  inApplicationComboEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      instruction {
        value(uiLanguagePreference: "x-none")
      }
      filestructure {
        id
        fileId
        resourceItem
        resourceName
        userCreated
        path
      }
      preparators {
        id
        valid
        validationMessage {
          value
        }
        preparatorId
        preparatorUri
        serviceProviderId
        properties {
          ...properties
        }
      }
    }
  }
}
    ${PropertiesFragmentDoc}`;
export const Inapplication_Combo_Edit_InvestigatorsDocument = gql`
    query inapplication_combo_edit_investigators {
  enrichment {
    status {
      serviceProviders {
        id
        version
        preparatorDescriptions {
          id
          name {
            value
          }
          description {
            value
          }
        }
        investigatorDescriptions {
          id
          name {
            value
          }
          description {
            value
          }
          obsolete
        }
      }
    }
  }
}
    `;
export const Inapplicatiocombo_Edit_UpdateDocument = gql`
    mutation inapplicatiocombo_edit_update($params: InApplicationComboEditUpsertInput!) {
  inApplicationComboEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Instruction_Edit_DataDocument = gql`
    query instruction_edit_data($itemId: ID!) {
  InstructionEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      instruction {
        value(uiLanguagePreference: "x-none")
      }
    }
  }
}
    `;
export const Instruction_Edit_UpdateDocument = gql`
    mutation instruction_edit_update($params: InstructionEditUpsertInput!) {
  InstructionEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Invisiblehotspot_Edit_DataDocument = gql`
    query invisiblehotspot_edit_data($itemId: ID!) {
  documents {
    get(docType: item, docReferenceId: $itemId) {
      _id
      attachments {
        id
        name
        hrefResolved
        imageMetadata {
          id
          width
          height
        }
      }
    }
  }
  InvisibleHotSpotEdit {
    get(itemId: $itemId) {
      id
      minAnswers
      maxAnswers
      header {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      image {
        id
        name
        hrefResolved
      }
      imageWidth
      imageHeight
      scoringMode
      perAnswerScore
      markerWidth
      markerHeight
      markerRadius
      answers {
        id
        index
        rects {
          id
          index
          left
          top
          width
          height
        }
        circles {
          id
          index
          x
          y
          radius
        }
      }
    }
  }
}
    `;
export const Invisiblehotspot_Edit_UpdateDocument = gql`
    mutation invisiblehotspot_edit_update($params: InvisibleHotSpotEditUpsertInput!) {
  InvisibleHotSpotEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Choicetext_Edit_AddgapDocument = gql`
    mutation choicetext_edit_addgap($itemId: ID!) {
  ChoiceTextEdit {
    addGap(itemId: $itemId) {
      id
      gapId
    }
  }
}
    `;
export const Choicetext_Edit_AddvalueDocument = gql`
    mutation choicetext_edit_addvalue($itemId: ID!, $gapId: ID!) {
  ChoiceTextEdit {
    addValue(itemId: $itemId, gapId: $gapId) {
      id
      valueId
    }
  }
}
    `;
export const Choicetext_Edit_DataDocument = gql`
    query choicetext_edit_data($itemId: ID!) {
  ChoiceTextEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      text {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      scoring
      perGapScore
      shuffleMode
      gaps {
        id
        gapId
        correct {
          id
          valueId
        }
        possibilities {
          id
          valueId
          value {
            value(uiLanguagePreference: "x-none")
          }
        }
      }
    }
  }
}
    `;
export const Choicetext_Edit_RemovegapDocument = gql`
    mutation choicetext_edit_removegap($itemId: ID!, $gapId: ID!) {
  ChoiceTextEdit {
    removeGap(itemId: $itemId, gapId: $gapId)
  }
}
    `;
export const Choicetext_Edit_RemovevalueDocument = gql`
    mutation choicetext_edit_removevalue($itemId: ID!, $valueId: ID!) {
  ChoiceTextEdit {
    removeValue(itemId: $itemId, valueId: $valueId)
  }
}
    `;
export const Choicetext_Edit_UpdateDocument = gql`
    mutation choicetext_edit_update($params: ChoiceTextEditUpsertInput!) {
  ChoiceTextEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Container_Edit_DataDocument = gql`
    query container_edit_data($itemId: ID!) {
  documents {
    get(docType: item, docReferenceId: $itemId) {
      _id
      attachments {
        id
        name
      }
    }
  }
  containerEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      instruction {
        value(uiLanguagePreference: "x-none")
      }
      filestructure {
        id
        fileId
        resourceItem
        resourceName
        userCreated
        path
      }
      textBlock {
        value(uiLanguagePreference: "x-none")
      }
      textBlockFormat
      image
      audioFile
      videoFile
      onlineVideoLink
      attachmentFile1
      attachmentFile2
      attachmentFile3
      attachmentFile4
      attachmentFile5
    }
  }
}
    `;
export const Container_Edit_UpdateDocument = gql`
    mutation container_edit_update($params: ContainerEditUpsertInput!) {
  containerEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Container_SettingsDocument = gql`
    query container_settings {
  itemtype {
    kosovo {
      container {
        supportsAudio
        supportsVideo
        supportsAttachments
        supportsImage
        supportsText
        supportsFileStructure
      }
    }
  }
}
    `;
export const Crossout_Edit_DataDocument = gql`
    query crossout_edit_data($itemId: ID!) {
  CrossoutEdit {
    get(itemId: $itemId) {
      id
      scoringMode
      shuffleMode
      question {
        value(uiLanguagePreference: "x-none")
      }
      header {
        value(uiLanguagePreference: "x-none")
      }
      lines {
        id
        index
        annotatedText
        incorrect {
          id
          index
        }
        fragments {
          id
          index
          value
        }
      }
    }
  }
}
    `;
export const Crossout_Edit_UpdateDocument = gql`
    mutation crossout_edit_update($params: CrossoutEditUpsertInput!) {
  CrossoutEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Essay_Edit_DataDocument = gql`
    query essay_edit_data($itemId: ID!) {
  EssayEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      evaluationInfo {
        value(uiLanguagePreference: "x-none")
      }
    }
  }
}
    `;
export const Essay_Edit_UpdateDocument = gql`
    mutation essay_edit_update($params: EssayEditUpsertInput!) {
  EssayEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Essay_Grading_DataDocument = gql`
    query essay_grading_data($itemId: ID!, $sessionId: ID!) {
  essayGrading {
    get(itemId: $itemId, sessionId: $sessionId) {
      id
      itemId
      sessionId
      attachments {
        id
        name
        hrefResolved
        altText {
          value
        }
        imageMetadata {
          id
          width
          height
        }
        videoMetadata {
          id
          width
          height
        }
      }
      header {
        value
      }
      question {
        value
      }
      evalInfo {
        value
      }
      essayText
      reason
      objectives {
        id
        objectiveId
        score
        maxScore
      }
    }
  }
}
    `;
export const Essay_Grading_SetreasonDocument = gql`
    mutation essay_grading_setreason($sessionId: ID!, $itemId: ID!, $reason: String!) {
  essayGrading {
    setReason(sessionId: $sessionId, itemId: $itemId, reason: $reason)
  }
}
    `;
export const Essay_Grading_SetscoreDocument = gql`
    mutation essay_grading_setscore($sessionId: ID!, $itemId: ID!, $objectiveId: ID!, $score: Float!) {
  essayGrading {
    setScore(
      sessionId: $sessionId
      itemId: $itemId
      objectiveId: $objectiveId
      score: $score
    )
  }
}
    `;
export const Essaygrading_SubmitDocument = gql`
    mutation essaygrading_submit($sessionId: ID!, $itemId: ID!) {
  essayGrading {
    submit(sessionId: $sessionId, itemId: $itemId)
  }
}
    `;
export const Fillingap_Edit_AddgapDocument = gql`
    mutation fillingap_edit_addgap($itemId: ID!) {
  FillInGapEdit {
    addGap(itemId: $itemId) {
      id
      gapId
    }
  }
}
    `;
export const Fillingap_Edit_AddvalueDocument = gql`
    mutation fillingap_edit_addvalue($itemId: ID!, $gapId: ID!) {
  FillInGapEdit {
    addValue(itemId: $itemId, gapId: $gapId) {
      id
      valueId
    }
  }
}
    `;
export const Fillingap_Edit_DataDocument = gql`
    query fillingap_edit_data($itemId: ID!) {
  FillInGapEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      text {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      scoring
      perGapScore
      shuffleMode
      gaps {
        id
        gapId
        correct {
          id
          valueId
        }
        possibilities {
          id
          valueId
          value {
            value(uiLanguagePreference: "x-none")
          }
        }
      }
    }
  }
}
    `;
export const Fillingap_Edit_RemovegapDocument = gql`
    mutation fillingap_edit_removegap($itemId: ID!, $gapId: ID!) {
  FillInGapEdit {
    removeGap(itemId: $itemId, gapId: $gapId)
  }
}
    `;
export const Fillingap_Edit_RemovevalueDocument = gql`
    mutation fillingap_edit_removevalue($itemId: ID!, $valueId: ID!) {
  FillInGapEdit {
    removeValue(itemId: $itemId, valueId: $valueId)
  }
}
    `;
export const Fillingap_Edit_UpsertDocument = gql`
    mutation fillingap_edit_upsert($params: FillInGapEditUpsertInput!) {
  FillInGapEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Inapplication_Edit_DataDocument = gql`
    query inapplication_edit_data($itemId: ID!) {
  documents {
    get(docType: item, docReferenceId: $itemId) {
      _id
      attachments {
        id
        name
      }
    }
  }
  item {
    getFileStructure(topItemId: $itemId) {
      id
      path
      itemId
      userCreated
    }
  }
  handsOnEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      evaluationInfo {
        value(uiLanguagePreference: "x-none")
      }
      filestructure {
        id
        fileId
        resourceItem
        resourceName
        userCreated
        path
        valid
        validationMessage {
          value
        }
      }
      preparators {
        id
        valid
        validationMessage {
          value
        }
        preparatorId
        preparatorUri
        serviceProviderId
        properties {
          ...properties
        }
      }
      investigators {
        id
        info {
          resultIsArray
          resultType
          resultEnumType {
            values {
              id
            }
          }
        }
        valid
        validationMessage {
          value
        }
        investigatorId
        investigatorUri
        serviceProviderId
        properties {
          ...properties
        }
        temporaryResult {
          id
          serializedValue
          status
        }
      }
      evaluations {
        id
        valid
        validationMessage {
          value
        }
        formula
        evaluationId
        score
      }
    }
  }
}
    ${PropertiesFragmentDoc}`;
export const Inapplication_Edit_EvalDocument = gql`
    mutation inapplication_edit_eval($formulas: [String!]!, $fields: [FormulaFieldValueInput!]!) {
  handsOnEdit {
    validateFormulas(formulas: $formulas, fields: $fields) {
      formula
      ok
      error
      rootResult {
        id
      }
      allResults {
        ...Result
      }
    }
  }
}
    ${ResultFragmentDoc}`;
export const Inapplication_Edit_InvestigatorsDocument = gql`
    query inapplication_edit_investigators {
  enrichment {
    status {
      serviceProviders {
        id
        version
        preparatorDescriptions {
          id
          name {
            value
          }
          description {
            value
          }
        }
        investigatorDescriptions {
          id
          name {
            value
          }
          description {
            value
          }
          obsolete
        }
      }
    }
  }
}
    `;
export const Inapplicatoin_Edit_UpdateDocument = gql`
    mutation inapplicatoin_edit_update($params: HandsOnEditUpsertInput!) {
  handsOnEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Matchinghotspot_Edit_AddcircleDocument = gql`
    mutation matchinghotspot_edit_addcircle($itemId: ID!, $x: Float!, $y: Float!, $radius: Float!) {
  MatchingHotspotEdit {
    addCircle(itemId: $itemId, x: $x, y: $y, radius: $radius) {
      id
      index
    }
  }
}
    `;
export const Matchinghotspot_Edit_ConnectDocument = gql`
    mutation matchinghotspot_edit_connect($itemId: ID!, $shape: ID, $answer: ID) {
  MatchingHotspotEdit {
    connect(itemId: $itemId, shapeIndex: $shape, answerIndex: $answer) {
      id
    }
  }
}
    `;
export const Matchinghotspot_Edit_DataDocument = gql`
    query matchinghotspot_edit_data($itemId: ID!) {
  documents {
    get(docType: item, docReferenceId: $itemId) {
      _id
      attachments {
        id
        name
        hrefResolved
        imageMetadata {
          id
          width
          height
        }
      }
    }
  }
  MatchingHotspotEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      image {
        id
        name
        hrefResolved
      }
      imageWidth
      imageHeight
      shuffleMode
      scoring
      perAnswerScore
      shapes {
        id
        index
        shape
        correct {
          id
          index
        }
      }
      answers {
        id
        index
        correct {
          id
          index
        }
        value {
          value(uiLanguagePreference: "x-none")
        }
      }
    }
  }
}
    `;
export const Matchinghotspot_Edit_UpdateDocument = gql`
    mutation matchinghotspot_edit_update($params: MatchingHotspotEditUpsertInput!) {
  MatchingHotspotEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Matchingimage_Edit_DataDocument = gql`
    query matchingimage_edit_data($itemId: ID!) {
  documents {
    get(docReferenceId: $itemId, docType: item) {
      _id
      attachments {
        id
        name
      }
    }
  }
  MatchingImageEdit {
    get(itemId: $itemId) {
      id
      pairs {
        id
        index
        image {
          id
          name
          hrefResolved
        }
        value {
          value(uiLanguagePreference: "x-none")
        }
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      header {
        value(uiLanguagePreference: "x-none")
      }
    }
  }
}
    `;
export const Matchingimage_Edit_UpdateDocument = gql`
    mutation matchingimage_edit_update($params: MatchingImageEditUpsertInput!) {
  MatchingImageEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Matchingtext_Edit_DataDocument = gql`
    query matchingtext_edit_data($itemId: ID!) {
  documents {
    get(docReferenceId: $itemId, docType: item) {
      _id
      attachments {
        id
        name
      }
    }
  }
  MatchingTextEdit {
    get(itemId: $itemId) {
      id
      pairs {
        id
        index
        leftText {
          value(uiLanguagePreference: "x-none")
        }
        rightText {
          value(uiLanguagePreference: "x-none")
        }
      }
      rightTitle {
        value(uiLanguagePreference: "x-none")
      }
      leftTitle {
        value(uiLanguagePreference: "x-none")
      }
      shuffleLeft
      shuffleRight
      question {
        value(uiLanguagePreference: "x-none")
      }
      header {
        value(uiLanguagePreference: "x-none")
      }
    }
  }
}
    `;
export const Matchingtext_Edit_UpdateDocument = gql`
    mutation matchingtext_edit_update($params: MatchingTextEditUpsertInput!) {
  MatchingTextEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Orderingselection_Edit_DataDocument = gql`
    query orderingselection_edit_data($itemId: ID!) {
  OrderingSelectionEdit {
    get(itemId: $itemId) {
      id
      question {
        value(uiLanguagePreference: "x-none")
      }
      header {
        value(uiLanguagePreference: "x-none")
      }
      answers {
        id
        index
        value {
          value(uiLanguagePreference: "x-none")
        }
      }
      distractors {
        id
        index
        value {
          value(uiLanguagePreference: "x-none")
        }
      }
      correctOrder
    }
  }
}
    `;
export const Orderingselection_Edit_UpdateDocument = gql`
    mutation orderingselection_edit_update($params: OrderingSelectionEditUpsertInput!) {
  OrderingSelectionEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Orderingsentences_Edit_DataDocument = gql`
    query orderingsentences_edit_data($itemId: ID!) {
  OrderingSentencesEdit {
    get(itemId: $itemId) {
      id
      question {
        value(uiLanguagePreference: "x-none")
      }
      header {
        value(uiLanguagePreference: "x-none")
      }
      answers {
        id
        index
        value {
          value(uiLanguagePreference: "x-none")
        }
      }
      correctOrder
    }
  }
}
    `;
export const Orderingsentences_Edit_UpdateDocument = gql`
    mutation orderingsentences_edit_update($params: OrderingSentencesEditUpsertInput!) {
  OrderingSentencesEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Orderingwords_Edit_DataDocument = gql`
    query orderingwords_edit_data($itemId: ID!) {
  OrderingWordsEdit {
    get(itemId: $itemId) {
      id
      question {
        value(uiLanguagePreference: "x-none")
      }
      header {
        value(uiLanguagePreference: "x-none")
      }
      answers {
        id
        index
        value {
          value(uiLanguagePreference: "x-none")
        }
      }
      correctOrder
    }
  }
}
    `;
export const Orderingwords_Edit_UpdateDocument = gql`
    mutation orderingwords_edit_update($params: OrderingWordsEditUpsertInput!) {
  OrderingWordsEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Singlechoicehotspot_Edit_AddcircleDocument = gql`
    mutation singlechoicehotspot_edit_addcircle($itemId: ID!, $x: Float!, $y: Float!, $radius: Float!) {
  SingleChoiceHotspotEdit {
    addCircle(itemId: $itemId, x: $x, y: $y, radius: $radius) {
      id
      index
    }
  }
}
    `;
export const Singlechoicehotspot_Edit_DataDocument = gql`
    query singlechoicehotspot_edit_data($itemId: ID!) {
  documents {
    get(docType: item, docReferenceId: $itemId) {
      _id
      attachments {
        id
        name
        hrefResolved
        imageMetadata {
          id
          width
          height
        }
      }
    }
  }
  SingleChoiceHotspotEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      image {
        id
        name
        hrefResolved
      }
      imageWidth
      imageHeight
      shapes {
        id
        index
        shape
        correct
      }
    }
  }
}
    `;
export const Singlechoicehotspot_Edit_UpdateDocument = gql`
    mutation singlechoicehotspot_edit_update($params: SingleChoiceHotspotEditUpsertInput!) {
  SingleChoiceHotspotEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Singlechoiceimage_Edit_DataDocument = gql`
    query singlechoiceimage_edit_data($itemId: ID!) {
  documents {
    get(docType: item, docReferenceId: $itemId) {
      _id
      attachments {
        id
        name
      }
    }
  }
  SingleChoiceImageEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      answers {
        id
        index
        correct
        image {
          id
          hrefResolved
          name
        }
      }
      imgWidth
      imgHeight
    }
  }
}
    `;
export const Singlechoiceimage_Edit_UpdateDocument = gql`
    mutation singlechoiceimage_edit_update($params: SingleChoiceImageEditUpsertInput!) {
  SingleChoiceImageEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Singlechoicematrix_Edit_DataDocument = gql`
    query singlechoicematrix_edit_data($itemId: ID!) {
  SingleChoiceMatrixEdit {
    get(itemId: $itemId) {
      id
      scoring
      shuffleRow
      shuffleColumn
      header {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      rows {
        id
        index
        score
        value {
          value(uiLanguagePreference: "x-none")
        }
        correct
      }
      columns {
        id
        index
        value {
          value(uiLanguagePreference: "x-none")
        }
      }
    }
  }
}
    `;
export const Singlechoicematrix_Edit_UpdateDocument = gql`
    mutation singlechoicematrix_edit_update($params: SingleChoiceMatrixEditUpsertInput!) {
  SingleChoiceMatrixEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Singlechoicetext_Edit_DataDocument = gql`
    query singlechoicetext_edit_data($itemId: ID!) {
  documents {
    get(docType: item, docReferenceId: $itemId) {
      _id
      attachments {
        id
        name
      }
    }
  }
  SingleChoiceTextEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      image {
        id
        hrefResolved
        name
      }
      shuffleMode
      answers {
        id
        index
        correct
        text {
          value(uiLanguagePreference: "x-none")
        }
      }
    }
  }
}
    `;
export const Singlechoicetext_Edit_UpdateDocument = gql`
    mutation singlechoicetext_edit_update($params: SingleChoiceTextEditUpsertInput!) {
  SingleChoiceTextEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Textentry_Auto_Edit_AddgapDocument = gql`
    mutation textentry_auto_edit_addgap($itemId: ID!) {
  TextEntryAutoEdit {
    addGap(itemId: $itemId) {
      id
      gapId
    }
  }
}
    `;
export const Textentry_Auto_Edit_AddvalueDocument = gql`
    mutation textentry_auto_edit_addvalue($itemId: ID!, $gapId: ID!) {
  TextEntryAutoEdit {
    addValue(itemId: $itemId, gapId: $gapId) {
      id
      valueId
    }
  }
}
    `;
export const Textentry_Auto_Edit_DataDocument = gql`
    query textentry_auto_edit_data($itemId: ID!) {
  TextEntryAutoEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      text {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      scoring
      perGapScore
      defaultGapMode
      gaps {
        id
        gapId
        possibilities {
          id
          valueId
          value {
            value(uiLanguagePreference: "x-none")
          }
        }
        pattern
        validationMessage {
          value(uiLanguagePreference: "x-none")
        }
        width
      }
    }
  }
}
    `;
export const Textentry_Auto_Edit_RemovegapDocument = gql`
    mutation textentry_auto_edit_removegap($itemId: ID!, $gapId: ID!) {
  TextEntryAutoEdit {
    removeGap(itemId: $itemId, gapId: $gapId)
  }
}
    `;
export const Textentry_Auto_Edit_RemovevalueDocument = gql`
    mutation textentry_auto_edit_removevalue($itemId: ID!, $valueId: ID!) {
  TextEntryAutoEdit {
    removeValue(itemId: $itemId, valueId: $valueId)
  }
}
    `;
export const Textentry_Auto_Edit_UpdateDocument = gql`
    mutation textentry_auto_edit_update($params: TextEntryAutoEditUpsertInput!) {
  TextEntryAutoEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Textentry_Manual_Edit_AddgapDocument = gql`
    mutation textentry_manual_edit_addgap($itemId: ID!) {
  TextEntryManualEdit {
    addGap(itemId: $itemId) {
      id
      gapId
    }
  }
}
    `;
export const Textentry_Manual_Edit_AddvalueDocument = gql`
    mutation textentry_manual_edit_addvalue($itemId: ID!, $gapId: ID!) {
  TextEntryManualEdit {
    addValue(itemId: $itemId, gapId: $gapId) {
      id
      valueId
    }
  }
}
    `;
export const Textentry_Manual_Edit_DataDocument = gql`
    query textentry_manual_edit_data($itemId: ID!) {
  TextEntryManualEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      text {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      scoring
      perGapScore
      gaps {
        id
        gapId
        possibilities {
          id
          valueId
          value {
            value(uiLanguagePreference: "x-none")
          }
        }
        pattern
        validationMessage {
          value(uiLanguagePreference: "x-none")
        }
      }
    }
  }
}
    `;
export const Textentrymanual_Edit_RemovegapDocument = gql`
    mutation textentrymanual_edit_removegap($itemId: ID!, $gapId: ID!) {
  TextEntryManualEdit {
    removeGap(itemId: $itemId, gapId: $gapId)
  }
}
    `;
export const Textentrymanual_Edit_RemovevalueDocument = gql`
    mutation textentrymanual_edit_removevalue($itemId: ID!, $valueId: ID!) {
  TextEntryManualEdit {
    removeValue(itemId: $itemId, valueId: $valueId)
  }
}
    `;
export const Textentry_Manual_Edit_UpdateDocument = gql`
    mutation textentry_manual_edit_update($params: TextEntryManualEditUpsertInput!) {
  TextEntryManualEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Textentry_Manual_Grading_DataDocument = gql`
    query textentry_manual_grading_data($itemId: ID!) {
  TextEntryManualGrading {
    get(itemId: $itemId) {
      id
      attachments {
        id
        name
        hrefResolved
        altText {
          value
        }
        imageMetadata {
          id
          width
          height
        }
        videoMetadata {
          id
          width
          height
        }
      }
      question {
        value
      }
      header {
        value
      }
      text {
        value
      }
      gaps {
        id
        gapId
        given {
          correct
          count
          id
          submitted
          value
        }
        possibilities {
          id
          valueId
          value {
            value
          }
        }
      }
    }
  }
}
    `;
export const Textentry_Manual_Grading_SetanswerDocument = gql`
    mutation textentry_manual_grading_setanswer($itemId: ID!, $gapId: ID!, $value: String!, $correct: Boolean!) {
  TextEntryManualGrading {
    setAnswer(itemId: $itemId, gapId: $gapId, value: $value, correct: $correct)
  }
}
    `;
export const Textentry_Manual_Grading_SubmitDocument = gql`
    mutation textentry_manual_grading_submit($itemId: ID!) {
  TextEntryManualGrading {
    submit(itemId: $itemId)
  }
}
    `;
export const Textentry_Manual_Grading_UpdateDocument = gql`
    mutation textentry_manual_grading_update($itemId: ID!) {
  TextEntryManualGrading {
    update(itemId: $itemId) {
      id
    }
  }
}
    `;
export const Fillinpool_Edit_AddgapDocument = gql`
    mutation fillinpool_edit_addgap($itemId: ID!) {
  FillInPoolEdit {
    addGap(itemId: $itemId) {
      id
      gapId
    }
  }
}
    `;
export const Fillinpool_Edit_AddvalueDocument = gql`
    mutation fillinpool_edit_addvalue($itemId: ID!) {
  FillInPoolEdit {
    addValue(itemId: $itemId) {
      id
      valueId
    }
  }
}
    `;
export const Fillinpool_Edit_DataDocument = gql`
    query fillinpool_edit_data($itemId: ID!) {
  FillInPoolEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      text {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      scoring
      perGapScore
      values {
        id
        valueId
        gap {
          id
        }
        value {
          value(uiLanguagePreference: "x-none")
        }
      }
      gaps {
        id
        gapId
        correct {
          id
          valueId
        }
      }
    }
  }
}
    `;
export const Fillinpool_Edit_RemovegapDocument = gql`
    mutation fillinpool_edit_removegap($itemId: ID!, $gapId: ID!) {
  FillInPoolEdit {
    removeGap(itemId: $itemId, gapId: $gapId)
  }
}
    `;
export const Fillinpool_Edit_RemovevalueDocument = gql`
    mutation fillinpool_edit_removevalue($itemId: ID!, $valueId: ID!) {
  FillInPoolEdit {
    removeValue(itemId: $itemId, valueId: $valueId)
  }
}
    `;
export const Fillinpool_Edit_UpsertDocument = gql`
    mutation fillinpool_edit_upsert($params: FillInPoolEditUpsertInput!) {
  FillInPoolEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Linetextentry_Edit_DataDocument = gql`
    query linetextentry_edit_data($itemId: ID!) {
  LineTextEntryEdit {
    get(itemId: $itemId) {
      id
      question {
        value(uiLanguagePreference: "x-none")
      }
      header {
        value(uiLanguagePreference: "x-none")
      }
      scoring
      lines
      answers {
        id
        index
        correct
        score
        value {
          value(uiLanguagePreference: "x-none")
        }
      }
    }
  }
}
    `;
export const Linetextentry_Edit_UpsertDocument = gql`
    mutation linetextentry_edit_upsert($params: LineTextEntryEditUpsertInput!) {
  LineTextEntryEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Linetextentry_Grading_SetvalueDocument = gql`
    mutation linetextentry_grading_setvalue($itemDocRefId: ID!, $topicId: ID!, $value: String!) {
  LavakLineTextEntry {
    evaluator_setTopicValue(
      itemDocRefId: $itemDocRefId
      value: $value
      topicId: $topicId
    ) {
      id
      topicId
    }
  }
}
    `;
export const Linetextentry_Grading_SubmitDocument = gql`
    mutation linetextentry_grading_submit($itemDocRefId: ID!) {
  LavakLineTextEntry {
    evaluator_submit(itemDocRefId: $itemDocRefId)
  }
}
    `;
export const Linetextentry_Grading_UpdateDocument = gql`
    mutation linetextentry_grading_update($itemDocRefId: ID!) {
  LavakLineTextEntry {
    evaluator_updateSharedGradingData(itemDocRefId: $itemDocRefId) {
      id
      header {
        value
      }
      question {
        value
      }
      topics {
        id
        topicId
        isKeyAnswer
        score
        text {
          value
        }
      }
      answers {
        id
        value
        count
        topicId
        submitted
      }
    }
  }
}
    `;
export const Multiplechoice_Edit_DataDocument = gql`
    query multiplechoice_edit_data($itemId: ID!) {
  MultipleChoiceEdit {
    get(itemId: $itemId) {
      id
      question {
        value(uiLanguagePreference: "x-none")
      }
      header {
        value(uiLanguagePreference: "x-none")
      }
      scoring
      shuffle
      minSelectionLimit
      maxSelectionLimit
      answers {
        id
        index
        correct
        score
        value {
          value(uiLanguagePreference: "x-none")
        }
      }
    }
  }
}
    `;
export const Multiplechoice_Edit_UpdateDocument = gql`
    mutation multiplechoice_edit_update($params: MultipleChoiceEditUpsertInput!) {
  MultipleChoiceEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Item_Model_InitDocument = gql`
    query item_model_init($sessionId: ID!, $localizationId: [ID!]) {
  examSession(params: {sessionDocRefId: $sessionId}) {
    id
    items {
      id
      minWidth
      minHeight
      itemId
      hasFocusMode
      isTopItem
      isOnlySibling
      attachments {
        id
        name
        etag
        hrefResolved
        altText {
          value
        }
        imageMetadata {
          id
          width
          height
        }
        videoMetadata {
          id
          width
          height
        }
      }
      HandsOn_Data {
        id
        topItemId
        itemNr
        files {
          id
          path
          userCreated
          resource {
            hrefResolved
            id
            etag
            size
            sha256
            uniqueId
          }
        }
        preparators {
          id
          preparatorUri
          serviceProviderId
          properties {
            propertyId
            value
          }
        }
        investigators {
          id
          investigatorUri
          serviceProviderId
          properties {
            propertyId
            value
          }
        }
      }
      data {
        __typename
        ... on Instruction_QueryItemSessionData {
          header {
            value
          }
          instruction {
            value
          }
        }
        ... on Organisation_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          orgText: text {
            ...localizations
          }
          orgNotes: notes {
            id
            orgCaption: caption {
              ...localizations
            }
            orgNoteHeader: noteHeader {
              ...localizations
            }
            orgNoteBody: noteBody {
              ...localizations
            }
            orgNoteType: noteType
            orgGiven: given {
              id
            }
            orgCorrect: correct {
              id
            }
            orgActions: actions {
              id
              orgAction: action {
                ...localizations
              }
            }
          }
        }
        ... on SpellingMatrix_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          smText: text {
            ...localizations
          }
          smTables: tables {
            id
            smCaption: caption {
              ...localizations
            }
            smAnswers: answers
            smValues: values {
              id
              label
              correctValue
              given
              gapFormat
            }
          }
        }
        ... on InvisibleHotSpot_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          scoringMode
          imageWidth
          imageHeight
          minAnswers
          maxAnswers
          markerRadius
          ihsImage: image {
            id
          }
          ihsAnswers: givenAnswers {
            id
            index
            x
            y
            correct
          }
          ihsZones: zones {
            id
            group
            left
            top
            width
            height
          }
        }
        ... on MultistepHotSpot_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          markerRadius
          initialStepId
          mshsGiven: givenAnswer {
            id
            steps
            x
            y
            correct
          }
          mshsSteps: steps {
            id
            stepId
            imageWidth
            imageHeight
            mshsImage: image {
              id
            }
            mshsZones: zones {
              id
              zoneId
              stepLinkId
              mshsAreas: areas {
                id
                areaId
                left
                top
                width
                height
              }
            }
          }
        }
        ... on InApplicationCombo_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          instruction {
            ...localizations
          }
          selectedSubItem
          subItems {
            id
            itemDocRefId
            status
            itemType
          }
        }
        ... on SurveyCombo_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          text {
            ...localizations
          }
          showCaption {
            ...localizations
          }
          hideCaption {
            ...localizations
          }
          showHideButtonOrder
          showSubItems
          scSubItems: subItems {
            id
            itemDocRefId
            status
            itemType
          }
        }
        ... on KosovoSingleChoiceText_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          selectedAnswer
          correctAnswer
          sctImage: image {
            id
          }
          sctAnswers: answers {
            id
            text {
              ...localizations
            }
          }
        }
        ... on KosovoChoiceText_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          text {
            ...localizations
          }
          gaps {
            id
            gapId
            selectedValue
            correctValue
            values {
              id
              value {
                ...localizations
              }
            }
          }
        }
        ... on HandsOn_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          isDone
          investigatorResults {
            id
            investigatorId
            serializedValue
          }
        }
        ... on KosovoMatchingHotSpot_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          mhsImage: image {
            id
          }
          mhsWidth: imageWidth
          mhsHeight: imageHeight
          mhsAnswers: answers {
            id
            value {
              ...localizations
            }
            selectedShape
            correctShape
          }
          shapes {
            id
            shape
          }
        }
        ... on KosovoFillinGap_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          text {
            ...localizations
          }
          gaps {
            id
            gapId
            selectedValue
            correctValue
            values {
              id
              value {
                ...localizations
              }
            }
          }
        }
        ... on KosovoTextEntry_Auto_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          text {
            ...localizations
          }
          taImage: image {
            id
          }
          gaps {
            id
            isCorrect
            givenAnswer
            gapId
            correctAnswers {
              id
              value {
                ...localizations
              }
            }
            pattern
            width
            validationMessage {
              ...localizations
            }
          }
        }
        ... on SurveyTextEntry_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          text {
            ...localizations
          }
          steImage: image {
            id
          }
          steGaps: gaps {
            id
            givenAnswer
            gapId
            pattern
            validationMessage {
              ...localizations
            }
          }
        }
        ... on KosovoMatchingImage_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          miAnswers: answers {
            id
            value {
              ...localizations
            }
            selectedImage {
              id
            }
            correctImage {
              id
            }
          }
          images {
            id
            miImage: image {
              id
            }
          }
        }
        ... on KosovoSingleChoiceImage_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          imgWidth
          imgHeight
          selectedAnswer
          correctAnswer
          sciAnswers: answers {
            id
            sciImage: img {
              id
            }
          }
        }
        ... on KosovoSingleChoiceMatrix_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          rows {
            id
            value {
              ...localizations
            }
            correctAnswer
            selectedAnswer
            cells {
              id
              selected
              correct
            }
          }
          columns {
            id
            value {
              ...localizations
            }
          }
        }
        ... on KosovoOrderingWords_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          owCorrectAnswer: correctAnswer {
            id
            value {
              ...localizations
            }
          }
          owAnswers: answers {
            id
            value {
              ...localizations
            }
          }
          owInitialOrder: initialOrder {
            id
          }
        }
        ... on KosovoOrderingSentences_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          osCorrectAnswer: correctAnswer {
            id
            value {
              ...localizations
            }
          }
          osAnswers: answers {
            id
            value {
              ...localizations
            }
          }
          osInitialOrder: initialOrder {
            id
          }
        }
        ... on KosovoOrderingSelection_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          distractorAnswers {
            id
            answerId
            value {
              ...localizations
            }
          }
          osCorrectAnswer: correctAnswer {
            id
            answerId
            value {
              ...localizations
            }
          }
          availableAnswers {
            id
            answerId
            value {
              ...localizations
            }
          }
          selectedAnswers {
            id
            answerId
            value {
              ...localizations
            }
          }
        }
        ... on Placeholder_QueryItemSessionData {
          id
        }
        ... on KosovoContainer_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          instruction {
            ...localizations
          }
          selectedSubItem
          cSubItems: subItems {
            id
            itemDocRefId
            status
            itemType
          }
          containerImage: image {
            id
          }
          hasResultFiles
          multiMedia {
            id
            textFormat
            text {
              ...localizations
            }
            mmImage: image {
              id
            }
            mmAudio: audio {
              id
            }
            mmVideo: video {
              id
            }
            onlineVideoLink
            attachments {
              id
              name
              etag
              hrefResolved
            }
          }
        }
        ... on KosovoCrossout_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          lines {
            id
            selectedFragment
            incorrectFragment
            fragments {
              id
              value
            }
          }
        }
        ... on KosovoEssay_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          essayText
        }
        ... on KosovoMatchingText_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          answerTitle {
            ...localizations
          }
          mtAnswers: answers {
            id
            value {
              ...localizations
            }
            selectedText
            correctText
          }
          textTitle {
            ...localizations
          }
          texts {
            id
            value {
              ...localizations
            }
          }
        }
        ... on KosovoSingleChoiceHotSpot_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          selectedAnswer
          correctAnswer
          schsImage: image {
            id
          }
          schsAnswers: answers {
            id
            shape
          }
          schsWidth: imageWidth
          schsHeight: imageHeight
        }
        ... on KosovoTextEntry_Manual_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          temText: text {
            ...localizations
          }
          temImage: image {
            id
          }
          temGaps: gaps {
            id
            isCorrect
            gapId
            correctAnswers {
              id
              value {
                ...localizations
              }
            }
            givenAnswer
            pattern
            validationMessage {
              ...localizations
            }
          }
          temAnswers: answers {
            id
            value {
              ...localizations
            }
          }
        }
        ... on LavakFillinPool_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          fipText: text {
            ...localizations
          }
          fipGaps: gaps {
            id
            gapId
            selectedValue
            correctValue
            evaluationRemark
          }
          values {
            id
            value {
              ...localizations
            }
          }
          evaluationRemark
        }
        ... on LavakLineTextEntry_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          lteLines: lines {
            id
            lineIndex
            value
            isCorrect
            evaluationRemark
          }
          evaluationRemark
        }
        ... on LavakMultiplechoice_QueryItemSessionData {
          id
          minSelectionLimit
          maxSelectionLimit
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          mcAnswers: answers {
            id
            text {
              ...localizations
            }
            isSelected
            isCorrectAnswer
            evaluationRemark
          }
          evaluationRemark
        }
        ... on SurveySingleChoiceMatrix_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          sscmRows: rows {
            id
            value {
              ...localizations
            }
            selectedAnswer
            cells {
              id
              selected
            }
          }
          sscmColumns: columns {
            id
            value {
              ...localizations
            }
          }
          option
        }
        ... on SurveyComparision_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          smRows: rows {
            id
            caption {
              ...localizations
            }
          }
          smColumns: columns {
            id
            caption {
              ...localizations
            }
          }
          smScale: scale {
            id
            hint {
              ...localizations
            }
            invalid
          }
          smCells: cells {
            id
            row {
              id
            }
            col {
              id
            }
            selected {
              id
            }
            initial {
              id
            }
          }
        }
        ... on SurveySingleChoiceText_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          ssctSelectedAnswer: selectedAnswer {
            id
          }
          userText
          userTextAnswer {
            id
          }
          ssctOption: option
          ssctImage: image {
            id
          }
          ssctAnswers: answers {
            id
            text {
              ...localizations
            }
          }
        }
        ... on TypingTest_QueryItemSessionData {
          id
          ttText: text
          typedText
          errors
          textLength
          fragments {
            text
            mode
            errorPoints
          }
        }
        ... on TypingTest2023_QueryItemSessionData {
          id
          tt2023Text: text
          tt2023TypedText: typedText
          tt2023Errors: errors
          tt2023TextLength: textLength
          tt2023StrokesPerMinute: strokesPerMinute
          tt2023ReportDisplayTemplateText: reportDisplayTemplateText
          tt2023Lines: lines {
            id
            lineNr
            errors
            textLength
            typedText
            text
            fragments {
              id
              text
              mode
              errorPoints
            }
          }
        }
        ... on SurveyTextInput_QueryItemSessionData {
          id
          header {
            ...localizations
          }
          question {
            ...localizations
          }
          essayText
          stiDone: done
          stiOption: option
        }
      }
      accumulatedScore {
        pointsGained
        pointsLost
        pointsMax
        pointsPending
      }
    }
  }
}
    ${LocalizationsFragmentDoc}`;
export const Multistephotspot_Edit_DataDocument = gql`
    query multistephotspot_edit_data($itemId: ID!) {
  documents {
    get(docType: item, docReferenceId: $itemId) {
      _id
      attachments {
        id
        name
        hrefResolved
        imageMetadata {
          id
          width
          height
        }
      }
    }
  }
  MultistepHotSpotEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      steps {
        id
        authorHint
        stepId
        isStartingStep
        image {
          id
          name
          hrefResolved
        }
        imageWidth
        imageHeight
        zones {
          id
          zoneId
          stepLinkId
          rects {
            id
            areaId
            centerX
            centerY
            width
            height
          }
          circles {
            id
            areaId
            x
            y
            radius
          }
        }
      }
      markerWidth
      markerHeight
      markerRadius
    }
  }
}
    `;
export const Multistephotspot_Edit_UpdateDocument = gql`
    mutation multistephotspot_edit_update($params: MultistepHotSpotEditUpsertInput!) {
  MultistepHotSpotEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Organisation_Edit_DataDocument = gql`
    query organisation_edit_data($itemId: ID!) {
  documents {
    get(docType: item, docReferenceId: $itemId) {
      _id
      attachments {
        id
        name
        hrefResolved
      }
    }
  }
  OrganisationEdit {
    get(itemId: $itemId) {
      id
      header {
        defaultValue
      }
      text {
        defaultValue
      }
      notes {
        id
        key
        caption {
          defaultValue
        }
        noteBody {
          defaultValue
        }
        noteHeader {
          defaultValue
        }
        noteType
        correct {
          id
        }
        actions {
          id
          key
          action {
            defaultValue
          }
        }
      }
    }
  }
}
    `;
export const Organisation_Edit_UpdateDocument = gql`
    mutation organisation_edit_update($params: OrganisationEdit_UpsertInput!) {
  OrganisationEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Placeholder_Edit_DataDocument = gql`
    query placeholder_edit_data($itemId: ID!) {
  PlaceholderEdit {
    get(itemId: $itemId) {
      id
    }
  }
}
    `;
export const Spellingmatrix_Edit_DataDocument = gql`
    query spellingmatrix_edit_data($itemId: ID!) {
  documents {
    get(docType: item, docReferenceId: $itemId) {
      _id
      attachments {
        id
        name
        hrefResolved
      }
    }
  }
  SpellingMatrixEdit {
    get(itemId: $itemId) {
      id
      header {
        defaultValue
      }
      text {
        defaultValue
      }
      values {
        id
        key
        value
        label
        tableId
        gapFormat
      }
      tables {
        id
        key
        caption {
          defaultValue
        }
        answers
      }
    }
  }
}
    `;
export const Spellingmatrix_Edit_UpdateDocument = gql`
    mutation spellingmatrix_edit_update($params: SpellingMatrixEdit_UpsertInput!) {
  SpellingMatrixEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Surveycombo_Edit_DataDocument = gql`
    query surveycombo_edit_data($itemId: ID!) {
  documents {
    get(docType: item, docReferenceId: $itemId) {
      _id
      attachments {
        id
        name
      }
    }
  }
  SurveyComboEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      text {
        value(uiLanguagePreference: "x-none")
      }
      showCaption {
        value(uiLanguagePreference: "x-none")
      }
      hideCaption {
        value(uiLanguagePreference: "x-none")
      }
      showHideButtonOrder
    }
  }
}
    `;
export const Surveycombo_Edit_UpdateDocument = gql`
    mutation surveycombo_edit_update($params: SurveyComboEditUpsertInput!) {
  SurveyComboEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Surveycomparision_Edit_DataDocument = gql`
    query surveycomparision_edit_data($itemId: ID!, $itemIdStr: String!) {
  documents {
    get(docType: item, docReferenceId: $itemId) {
      _id
      attachments {
        id
        name
      }
    }
  }
  item {
    get(itemId: $itemIdStr) {
      _id
      metaData {
        objectives {
          objectiveId
          scoreMax
          taxonomy {
            id
            taxon
            name {
              value
            }
            anchestors {
              id
              name {
                value
              }
            }
          }
        }
      }
    }
  }
  SurveyComparisionEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      columns {
        id
        index
        caption {
          value(uiLanguagePreference: "x-none")
        }
        objectiveId
      }
      rows {
        id
        index
        caption {
          value(uiLanguagePreference: "x-none")
        }
      }
      scale {
        id
        index
        value
        hint {
          value(uiLanguagePreference: "x-none")
        }
        invalid
      }
    }
  }
}
    `;
export const Surveycomparision_Edit_UpdateDocument = gql`
    mutation surveycomparision_edit_update($params: SurveyComparisionEditUpsertInput!) {
  SurveyComparisionEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Surveysinglechoicematrix_Edit_DataDocument = gql`
    query surveysinglechoicematrix_edit_data($itemId: ID!) {
  SurveySingleChoiceMatrixEdit {
    get(itemId: $itemId) {
      id
      option
      shuffleRow
      shuffleColumn
      neutralScore
      header {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      rows {
        id
        index
        value {
          value(uiLanguagePreference: "x-none")
        }
      }
      columns {
        id
        index
        score
        value {
          value(uiLanguagePreference: "x-none")
        }
      }
    }
  }
}
    `;
export const Surveysinglecohicematrix_Edit_UpdateDocument = gql`
    mutation surveysinglecohicematrix_edit_update($params: SurveySingleChoiceMatrixEditUpsertInput!) {
  SurveySingleChoiceMatrixEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Surveysinglechoicetext_Edit_DataDocument = gql`
    query surveysinglechoicetext_edit_data($itemId: ID!) {
  documents {
    get(docType: item, docReferenceId: $itemId) {
      _id
      attachments {
        id
        name
      }
    }
  }
  SurveySingleChoiceTextEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      image {
        id
        hrefResolved
        name
      }
      shuffleMode
      option
      userTextEntry
      neutralScore
      answers {
        id
        index
        score
        text {
          value(uiLanguagePreference: "x-none")
        }
      }
    }
  }
}
    `;
export const Surveysinglechoicetext_Edit_UpdateDocument = gql`
    mutation surveysinglechoicetext_edit_update($params: SurveySingleChoiceTextEditUpsertInput!) {
  SurveySingleChoiceTextEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Surveytextentry_Edit_AddgapDocument = gql`
    mutation surveytextentry_edit_addgap($itemId: ID!) {
  SurveyTextEntryEdit {
    addGap(itemId: $itemId) {
      id
      gapId
    }
  }
}
    `;
export const Surveytextentry_Edit_DataDocument = gql`
    query surveytextentry_edit_data($itemId: ID!) {
  SurveyTextEntryEdit {
    get(itemId: $itemId) {
      id
      header {
        value(uiLanguagePreference: "x-none")
      }
      text {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
      gaps {
        id
        gapId
        pattern
        validationMessage {
          value(uiLanguagePreference: "x-none")
        }
      }
    }
  }
}
    `;
export const Surveytextentry_Edit_RemovegapDocument = gql`
    mutation surveytextentry_edit_removegap($itemId: ID!, $gapId: ID!) {
  SurveyTextEntryEdit {
    removeGap(itemId: $itemId, gapId: $gapId)
  }
}
    `;
export const Surveytextentry_Edit_UpsertDocument = gql`
    mutation surveytextentry_edit_upsert($params: SurveyTextEntryEditUpsertInput!) {
  SurveyTextEntryEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Surveytextinput_Edit_DataDocument = gql`
    query surveytextinput_edit_data($itemId: ID!) {
  SurveyTextInputEdit {
    get(itemId: $itemId) {
      id
      option
      header {
        value(uiLanguagePreference: "x-none")
      }
      question {
        value(uiLanguagePreference: "x-none")
      }
    }
  }
}
    `;
export const Surveytextinput_Edit_UpsertDocument = gql`
    mutation surveytextinput_edit_upsert($params: SurveyTextInputEditUpsertInput!) {
  SurveyTextInputEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Typingtext_Edit_DataDocument = gql`
    query typingtext_edit_data($itemId: ID!) {
  TypingTestEdit {
    get(itemId: $itemId) {
      id
      text
      maxErrorQuota
      exportErrors
      exportTextLength
      exportErrorQuota
    }
  }
}
    `;
export const Typingtest_Edit_UpdateDocument = gql`
    mutation typingtest_edit_update($params: TypingTestEditUpsertInput!) {
  TypingTestEdit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Typingtext2023_Edit_DataDocument = gql`
    query typingtext2023_edit_data($itemId: ID!) {
  TypingTest2023Edit {
    get(itemId: $itemId) {
      id
      text
      maxErrorQuota
      exportErrors
      exportTextLength
      exportErrorQuota
      exportStrokesPerMinute
      reportDisplayTemplateText
    }
  }
}
    `;
export const Typingtest2023_Edit_UpdateDocument = gql`
    mutation typingtest2023_edit_update($params: TypingTest2023EditUpsertInput!) {
  TypingTest2023Edit {
    upsert(params: $params) {
      id
    }
  }
}
    `;
export const Taxonomy_DataDocument = gql`
    query taxonomy_data($taxonomy: [ID!]!) {
  taxonomy {
    get(params: {taxonomyDocRefIds: $taxonomy}) {
      _id
      items {
        id
        taxon
        name {
          value
        }
      }
    }
  }
}
    `;
export const Ui_Author_Itemedit_CreateadhocexamDocument = gql`
    mutation ui_author_itemedit_createadhocexam($itemDocRef: ID!, $testDefinitionProfileDocRef: ID!, $language: ID!, $userAgentString: String!) {
  author {
    createAdHocExam(
      itemDocRefs: [$itemDocRef]
      testDefinitionProfileDocRef: $testDefinitionProfileDocRef
      language: $language
      sessions: 1
      userAgentString: $userAgentString
    ) {
      sessions {
        launchUrl
      }
    }
  }
}
    `;
export const Ui_Author_Itemedit_DeleteitemDocument = gql`
    mutation ui_author_itemedit_deleteitem($itemId: ID!) {
  item {
    deleteItem(itemId: $itemId) {
      ok
      message {
        value
      }
    }
  }
}
    `;
export const Ui_Author_Itmeedit_GetconfigDocument = gql`
    query ui_author_itmeedit_getconfig($itemId: String!) {
  config {
    contentLanguages {
      id
      name {
        value
      }
    }
    itemTranslationEnabled
  }
  item {
    get(itemId: $itemId) {
      _id
      itemId
      topItem {
        _id
        docReferenceId
      }
      workflow {
        editAllowed
        editableByYou
        setToDoneAllowed
        deleteAllowed
      }
      itemType {
        id
        supportsTranslations
        supportsSubItems
        gradingMode
      }
      basicValidationMessage {
        value
      }
      metaData {
        isSubItem
        title
        subject {
          _id
          docReferenceId
          subjectId
        }
      }
      parentItemId
    }
  }
  TestDefinitionProfile {
    all {
      docReferenceId
      id
      title
      examinationType
    }
  }
}
    `;
export const Ui_Author_Itemedit_Itemmetadatablock_GetDocument = gql`
    query ui_author_itemedit_itemmetadatablock_get($itemId: String!) {
  item {
    get(itemId: $itemId) {
      _id
      itemId
      parentItemId
      itemType {
        id
        supportsSubItems
        supportsObjectives
        title {
          value
        }
        uuid
      }
      workflow {
        currentAuthor {
          _id
          shortcut
          userId
          displayName
        }
        noteForAuthor
        authoringStatus
        editAllowed
        editableByYou
      }
      metaData {
        defaultLocalization {
          id
        }
        publicTitle {
          defaultValue
        }
        minWidth
        minHeight
        alternations {
          id
          taxon
        }
        audience {
          _id
          docReferenceId
          audienceId
          title
        }
        category {
          id
          taxon
        }
        objectives {
          id
          objectiveId
          scoreMax
          taxonomy {
            id
            taxon
            name {
              value
            }
            anchestors {
              id
              name {
                value
              }
            }
          }
        }
        copyFrom {
          _id
          itemId
        }
        revisionFrom {
          _id
          itemId
        }
        subject {
          _id
          subjectId
          docReferenceId
          audiences {
            docReferenceId
            audienceId
            title
          }
        }
        itemDifficultyIndex
        title
      }
      childItems {
        id
        index
        item {
          _id
          docReferenceId
          itemId
          metaData {
            title
          }
          itemType {
            id
            title {
              value
            }
          }
          workflow {
            authoringStatus
          }
        }
      }
    }
  }
  config {
    localizations(enabledForExams: yes) {
      id
      name {
        value
      }
    }
  }
}
    `;
export const Ui_Author_Itemedit_Itemmetadatablock_AlternationsDocument = gql`
    query ui_author_itemedit_itemmetadatablock_alternations($itemId: String!) {
  item {
    get(itemId: $itemId) {
      _id
      metaData {
        alternations {
          id
          taxon
        }
      }
    }
  }
  taxonomy {
    getById(docRefOrId: "ALTERNATIONS") {
      _id
      items {
        id
        taxon
        name {
          value
        }
      }
    }
  }
}
    `;
export const Ui_Author_Itemedit_Itemmetadatablock_CategoriesDocument = gql`
    query ui_author_itemedit_itemmetadatablock_categories($itemId: String!) {
  item {
    get(itemId: $itemId) {
      _id
      metaData {
        category {
          id
          taxon
        }
        subject {
          _id
          categories {
            id
            taxon
            name {
              value
            }
          }
        }
      }
    }
  }
}
    `;
export const Ui_Author_Itemedit_Itemmetadatablock_AllobjectivesDocument = gql`
    query ui_author_itemedit_itemmetadatablock_allobjectives($itemId: String!) {
  item {
    get(itemId: $itemId) {
      _id
      metaData {
        subject {
          _id
          syllabus {
            id
            taxon
            name {
              value
            }
          }
        }
      }
    }
  }
}
    `;
export const Ui_Author_Itemedit_Itemmetadatablock_ObjectivesDocument = gql`
    query ui_author_itemedit_itemmetadatablock_objectives($itemId: String!) {
  item {
    get(itemId: $itemId) {
      _id
      itemType {
        id
        supportsObjectives
      }
      metaData {
        objectives {
          id
          objectiveId
          scoreMax
        }
      }
    }
  }
}
    `;
export const Ui_Author_Itemedit_Itemmetadatablock_UpdateDocument = gql`
    mutation ui_author_itemedit_itemmetadatablock_update($params: UpdateItemMetaDataInput!) {
  item {
    updateMetaData(params: $params) {
      ok
    }
  }
}
    `;
export const Ui_Author_Itemedit_RouteDocument = gql`
    query ui_author_itemedit_route($itemId: String!) {
  item {
    get(itemId: $itemId) {
      _id
      itemId
      docReferenceId
      workflow {
        deleteAllowed
        setToDoneAllowed
        editAllowed
      }
      metaData {
        isSubItem
        subject {
          _id
          docReferenceId
        }
      }
      parentItemId
    }
  }
}
    `;
export const Ui_Author_Itemedit_SettodoneDocument = gql`
    mutation ui_author_itemedit_settodone($itemId: ID!) {
  item {
    setToDone(itemId: $itemId) {
      ok
      message {
        value
      }
    }
  }
}
    `;
export const Ui_Author_Itemedit_Translation_DataDocument = gql`
    query ui_author_itemedit_translation_data($params: GetItemTranslationsInput!) {
  getItemTranslations(params: $params) {
    isoCode
    entries {
      itemDocRefId
      defaultLanguage
      translations {
        id
        key
        value
      }
    }
  }
}
    `;
export const Ui_Author_Itemedit_Translation_InitDocument = gql`
    query ui_author_itemedit_translation_init($itemId: String!) {
  config {
    contentLanguages {
      id
      name {
        value
      }
    }
  }
  item {
    get(itemId: $itemId) {
      _id
      docReferenceId
      metaData {
        defaultLocalization {
          id
          localizationId
        }
      }
      workflow {
        editableByYou
        translationStatus {
          id
          localization {
            id
            localizationId
            name {
              value
            }
            isoLanguages {
              id
              isoCode
              name {
                value
              }
            }
          }
          translateableByYou
          status
        }
      }
      subject {
        _id
        docReferenceId
      }
    }
  }
}
    `;
export const Ui_Author_Itemedit_Translation_UpdateDocument = gql`
    mutation ui_author_itemedit_translation_update($params: UpdateItemTranslationInput!) {
  updateItemTranslation(params: $params) {
    id
    key
    value
  }
}
    `;
export const UpdateStatusDocument = gql`
    mutation UpdateStatus($params: UpdateWorkflowDataInput!) {
  item {
    updateWorklowData(params: $params)
  }
}
    `;
export const Ui_Author_Itemedit_ValidateDocument = gql`
    mutation ui_author_itemedit_validate($itemId: ID!) {
  item {
    validate(itemId: $itemId) {
      ok
      message {
        value
      }
    }
  }
}
    `;
export const Ui_Author_Itemoverview_DataDocument = gql`
    query ui_author_itemoverview_data($subjectId: ID!) {
  subjectById(docReferenceId: $subjectId) {
    _id
    itemsForAuthor(filter: {obsolete: no, showDeleted: no}) {
      _id
      itemId
      visibleText(includeChildItems: true)
      keywords(includeChildItems: true)
      accumulatedScoreMax
      metaData {
        title
        category {
          id
          taxon
          name {
            value
          }
        }
        objectives {
          objectiveId
          taxonomy {
            id
            name {
              value
            }
          }
          scoreMax
        }
        audience {
          _id
          audienceId
        }
        itemDifficultyIndex
      }
      itemType {
        id
        title {
          value
        }
      }
      workflow {
        authoringStatus
        currentAuthor {
          _id
          displayName
        }
        noteForAuthor
        editAllowed
        obsolete
      }
    }
  }
}
    `;
export const Ui_Author_Itemoverview_RouteDocument = gql`
    query ui_author_itemoverview_route($subjectDocRef: ID!) {
  subjectById(docReferenceId: $subjectDocRef) {
    _id
    subjectId
    title
  }
}
    `;
export const Ui_Author_Manageitem_CopyitemtocontainerDocument = gql`
    mutation ui_author_manageitem_copyitemtocontainer($item: CopyItemInput!, $containerDocRefId: String!) {
  item {
    copyItem(item: $item) {
      toContainer(containerDocRefId: $containerDocRefId) {
        ok
        newItemDocRefId
        message {
          value
        }
      }
    }
  }
}
    `;
export const Ui_Author_Manageitem_CopyitemtosubjectDocument = gql`
    mutation ui_author_manageitem_copyitemtosubject($item: CopyItemInput!, $subjectDocRefId: String!) {
  item {
    copyItem(item: $item) {
      toSubject(subjectDocRefId: $subjectDocRefId) {
        ok
        newItemDocRefId
        message {
          value
        }
      }
    }
  }
}
    `;
export const Ui_Author_Manageitem_InitDocument = gql`
    query ui_author_manageitem_init($currentItemId: String!, $targetSubjectId: ID!) {
  subjects {
    docReferenceId
    subjectId
    title
  }
  subjectById(docReferenceId: $targetSubjectId) {
    _id
    itemsForAuthor(filter: {supportsSubItems: yes, topItems: yes}) {
      _id
      docReferenceId
      itemId
      workflow {
        authoringStatus
        locked
      }
    }
  }
  item {
    get(itemId: $currentItemId) {
      _id
      itemId
      itemType {
        id
        supportsSubItems
      }
    }
  }
}
    `;
export const Ui_Author_Newitem_DataDocument = gql`
    query ui_author_newitem_data($filter: getItemTypesFilter!) {
  itemtypes(filter: $filter) {
    id
    ordernr
    description {
      value
    }
    title {
      value
    }
  }
}
    `;
export const Ui_Author_Newitem_NewDocument = gql`
    mutation ui_author_newitem_new($params: NewItemInput!) {
  item {
    newItem(params: $params) {
      _id
      itemId
      docReferenceId
    }
  }
}
    `;
export const Ui_Base_GetconfigDocument = gql`
    query ui_base_getconfig {
  whoAmI {
    id
    loginId
    type
    isoLanguages
    localization {
      id
      englishName
    }
    user {
      _id
      docReferenceId
      privileges {
        privilege
      }
      isSuperUser: privilege(privilege: superuser) {
        privilege
      }
      isAuthor: privilege(privilege: author_subjects) {
        privilege
      }
      isTranslator: privilege(privilege: translator_subjects) {
        privilege
      }
      isEvaluator: privilege(privilege: evaluator_subjects) {
        privilege
      }
      isExamAdmin: privilege(privilege: admin) {
        privilege
      }
    }
  }
  config {
    onlineHelp {
      id
      label {
        value
      }
    }
    golemEnabled
    serverVersion
    instanceName
    connectionLostTime
    stopOnConnectionLost
    languageSwitcher: localizations(enabledForAdministration: yes) {
      id
      name {
        value
      }
    }
  }
}
    `;
export const Ui_Bulkgrading_Selectitem_DataDocument = gql`
    query ui_bulkgrading_selectitem_data($subject: ID!) {
  itemsForBulkGrading(subject: $subject) {
    id
    item {
      _id
      itemId
      metaData {
        title
      }
      itemType {
        id
        title {
          value
        }
      }
    }
    sessionsForItemCount
    evaluatorHint {
      value
    }
  }
}
    `;
export const Ui_Demo_InitDocument = gql`
    query ui_demo_init {
  examination {
    getDemoExams {
      _id
      examAliases
      docReferenceId
      title
      dateCreated
    }
  }
}
    `;
export const Ui_Focusmanager_Client_CacheDocument = gql`
    mutation ui_focusmanager_client_cache($data: Client_TopItemDataInput!) {
  itsr3client {
    cache(data: $data)
  }
}
    `;
export const Ui_Focusmanager_Client_CleanupDocument = gql`
    mutation ui_focusmanager_client_cleanup($data: Client_TopItemDataInput!) {
  itsr3client {
    cleanup(data: $data)
  }
}
    `;
export const Ui_Focusmanager_Client_InitDocument = gql`
    mutation ui_focusmanager_client_init($data: Client_InitInput!) {
  itsr3client {
    init(data: $data) {
      driveH
    }
  }
}
    `;
export const Ui_Focusmanager_Client_InvestigateDocument = gql`
    mutation ui_focusmanager_client_investigate($data: Client_TopItemDataInput!) {
  itsr3client {
    investigate(data: $data) {
      investigatorId
      serializedValue
    }
  }
}
    `;
export const Ui_Focusmanager_Client_ResetDocument = gql`
    mutation ui_focusmanager_client_reset($data: Client_TopItemDataInput!) {
  itsr3client {
    reset(data: $data)
  }
}
    `;
export const Ui_Focusmanager_Client_SetupDocument = gql`
    mutation ui_focusmanager_client_setup($data: Client_TopItemDataInput!) {
  itsr3client {
    setup(data: $data)
  }
}
    `;
export const Ui_Focusmanager_SetuserfieldsDocument = gql`
    mutation ui_focusmanager_setuserfields($examSessionParams: ExamSessionMutationInput!, $params: [SetUserFieldInput!]!) {
  examSession(params: $examSessionParams) {
    setUserFields(params: $params) {
      id
    }
  }
}
    `;
export const Online_HelpDocument = gql`
    query online_help($helpId: ID!, $widgetName: [String!]) {
  config {
    onlineHelpById(id: $helpId) {
      url(widgetName: $widgetName)
    }
  }
}
    `;
export const Ui_InitDocument = gql`
    query ui_init {
  whoAmI {
    type
    myExamSession {
      examInfo {
        itemHost
      }
    }
  }
  config {
    stopOnConnectionLost
  }
}
    `;
export const Ui_LoginDocument = gql`
    mutation ui_login($username: String!, $password: String!, $lang: String) {
  login(username: $username, password: $password, lang: $lang) {
    browserSessionId
    href
  }
}
    `;
export const Ui_Login_AnonymousDocument = gql`
    mutation ui_login_anonymous($lang: String) {
  loginAnonymous(lang: $lang) {
    browserSessionId
  }
}
    `;
export const Ui_LogoutDocument = gql`
    mutation ui_logout {
  logout
}
    `;
export const Ui_Manualgrading_Grading_DataDocument = gql`
    query ui_manualgrading_grading_data($itemId: ID!) {
  itemForManualGrading(itemId: $itemId) {
    id
    item {
      _id
      itemType {
        id
      }
      isTopItem
    }
    sessions(pick: 5)
  }
}
    `;
export const Ui_Manualgrading_Grading_UpdateDocument = gql`
    query ui_manualgrading_grading_update($itemId: ID!, $sessions: [ID!]!) {
  itemGradingData(itemId: $itemId, sessions: $sessions) {
    id
    sessionId
    submitted
  }
}
    `;
export const Ui_Manualgrading_Selectitem_DataDocument = gql`
    query ui_manualgrading_selectitem_data($subject: ID!) {
  itemsForManualGrading(subject: $subject) {
    id
    item {
      _id
      docReferenceId
      itemId
      metaData {
        title
      }
      itemType {
        id
        title {
          value
        }
      }
    }
    sessionsForItemCount
  }
}
    `;
export const Ui_Paricipatesingle_SetnotificationemailDocument = gql`
    mutation ui_paricipatesingle_setnotificationemail($sessionId: ID!, $email: String, $confirmed: Boolean) {
  setSessionNotificationEmail(
    sessionId: $sessionId
    email: $email
    confirmed: $confirmed
  )
}
    `;
export const Ui_Participatesingle_ExamsessionDocument = gql`
    query ui_participatesingle_examsession($params: ExamSessionQueryInput!) {
  config {
    submitEnableTime
  }
  examSession(params: $params) {
    id
    docReferenceId
    sessionId
    totalTime
    mode
    startMode
    notification {
      email
      emailConfirmed
    }
    currentItem {
      id
      itemDocRefId
      itemId
      itemType
      index
      accumulatedScore {
        pointsMax
        pointsPending
      }
    }
    currentSection {
      id
      sectionInfo {
        title
        id
        color
      }
      items {
        id
        itemDocRefId
      }
    }
    flags
    examInfo {
      navigationStyle
      resetOnNavigate
      languageTag
    }
    candidate {
      display
    }
    itemInfo {
      completed
      pending
      total
    }
  }
}
    `;
export const Ui_Participatesingle_InitDocument = gql`
    query ui_participatesingle_init($params: ExamSessionQueryInput!) {
  config {
    customlogo1
    customlogo2
  }
  examSession(params: $params) {
    id
    examInfo {
      examId
      examAlias
      title
      welcomePage {
        text {
          value
        }
        startButton {
          visibility
          label {
            value
          }
        }
        cancelButton {
          visibility
          label {
            value
          }
        }
      }
      executionPage {
        displayTime
        submitButton {
          visibility
          label {
            value
          }
        }
        finishButton {
          visibility
          label {
            value
          }
        }
      }
      resultPage {
        closeButton {
          visibility
          label {
            value
          }
        }
        email
        emailLabel {
          value
        }
        emailText {
          value
        }
        pdf
        pdfButton {
          visibility
          label {
            value
          }
        }
      }
    }
  }
}
    `;
export const Ui_Print_DataDocument = gql`
    query ui_print_data($sessionDocRef: ID!) {
  examSession(params: {sessionDocRefId: $sessionDocRef}) {
    maxTime
    candidate {
      candidateId
      display
    }
    examInfo {
      examId
      examAlias
      title
      languageTag
      pdfReportSettings {
        includeItems
        itemDetailCaption {
          value
        }
      }
    }
    items {
      id
      itemId
      itemType
      title {
        value
      }
      index
      accumulatedScore {
        pointsGained
        pointsPending
        pointsLost
        pointsMax
        pointsPercentage
      }
    }
    score {
      pointsGained
      pointsPending
      pointsLost
      pointsMax
      pointsPercentage
    }
  }
}
    `;
export const Ui_Resultscreens_Default_DataDocument = gql`
    query ui_resultscreens_default_data($sessionDocRefId: ID!, $withResultPage: Boolean!, $withPDF: Boolean!) {
  examSession(params: {sessionDocRefId: $sessionDocRefId}) {
    id
    candidate {
      candidateId
      display
    }
    notification {
      email
      emailConfirmed
    }
    examInfo {
      itemHost
      title
      pdfReportSettings @include(if: $withPDF) {
        text {
          value
        }
        itemText {
          value
        }
        objectiveText {
          value
        }
        itemHeader {
          value
        }
        objectiveHeader {
          value
        }
        objectiveMinDepth
        objectiveMaxDepth
        displayItemId
        displayObjectiveId
      }
      resultPage @include(if: $withResultPage) {
        text {
          value
        }
        itemText {
          value
        }
        objectiveText {
          value
        }
        itemHeader {
          value
        }
        objectiveHeader {
          value
        }
        closeButton {
          visibility
          label {
            value
          }
        }
        objectiveMinDepth
        objectiveMaxDepth
        email
        emailLabel {
          value
        }
        emailText {
          value
        }
        pdf
        pdfButton {
          visibility
          label {
            value
          }
        }
        displayItemId
        displayObjectiveId
      }
    }
    score {
      pointsGained
      pointsLost
      pointsPending
      pointsMax
      pointsPercentage
    }
  }
}
    `;
export const Ui_Resultscreens_SetnotificationemailDocument = gql`
    mutation ui_resultscreens_setnotificationemail($sessionId: ID!, $email: String, $confirmed: Boolean) {
  setSessionNotificationEmail(
    sessionId: $sessionId
    email: $email
    confirmed: $confirmed
  )
}
    `;
export const Ui_Resultscreens_Default_ObjectivesDocument = gql`
    query ui_resultscreens_default_objectives($sessionDocRefId: ID!, $maxDepth: Int!, $includeObjectives: Boolean!, $includeItems: Boolean!) {
  examSession(params: {sessionDocRefId: $sessionDocRefId}) {
    id
    objectives(params: {maxDepth: $maxDepth}) @include(if: $includeObjectives) {
      id
      objectiveId
      objectiveDepth
      description {
        value
      }
      scoreGained
      scorePending
      scoreMax
      scoreLost
    }
    items @include(if: $includeItems) {
      id
      itemId
      itemType
      index
      title {
        value
      }
      accumulatedScore {
        pointsGained
        pointsPending
        pointsLost
        pointsMax
        pointsPercentage
      }
    }
  }
}
    `;
export const Ui_Service_Participation_DataDocument = gql`
    query ui_service_participation_data($session: ID!) {
  config {
    passedTimeUpdateInterval
  }
  examSession(params: {sessionDocRefId: $session}) {
    id
    totalTime
    mode
    startMode
    currentItem {
      id
      itemDocRefId
    }
    items(topItemsOnly: true) {
      id
      itemDocRefId
      navigationStatus
      interactionStatus {
        locked
        closed
        started
        complete
      }
      itemInfo {
        started
        locked
        closed
        completed
        pending
        total
      }
      accumulatedScore {
        pointsGained
        pointsPending
        pointsMax
      }
    }
    itemInfo {
      started
      locked
      closed
      completed
      pending
      total
    }
    sections {
      id
      sectionInfo {
        id
        itemInfo {
          started
          locked
          closed
          completed
          pending
          total
        }
      }
    }
  }
}
    `;
export const Ui_Service_Participation_FinishexamDocument = gql`
    mutation ui_service_participation_finishexam($examSessionParams: ExamSessionMutationInput!) {
  examSession(params: $examSessionParams) {
    finishExam {
      ok
      message {
        value
      }
      session {
        id
        mode
        startMode
      }
    }
  }
}
    `;
export const Ui_Service_Participation_InitDocument = gql`
    query ui_service_participation_init($params: ExamSessionQueryInput!, $userAgent: String!) {
  config {
    submitEnableTime
    customlogo1
    customlogo2
  }
  examSession(params: $params) {
    id
    mode
    golemScript {
      _id
      scriptJson
    }
    docReferenceId
    sessionId
    totalTime
    sections {
      id
      sectionInfo {
        id
        name
        title
        description
        color
        alternateColor
      }
      items {
        id
        itemDocRefId
        itemId
        isTopItem
        itemType
        index
        hasFocusMode
        minWidth
        minHeight
        navigationStatus
        accumulatedScore {
          pointsMax
        }
      }
    }
    examInfo {
      hasInApplication
      navigationStyle
      continueWith
      resetOnNavigate
      languageTag
      passesRestrictions(userAgentString: $userAgent)
      restrictions(userAgentString: $userAgent)
      itemHost
      welcomePage {
        text {
          value
        }
        startButton {
          visibility
          label {
            value
          }
        }
        cancelButton {
          visibility
          label {
            value
          }
        }
      }
      executionPage {
        showImmediateResult
        showItemMaxScore
        immediateResultText {
          value
        }
        immediateResultSeconds
        displayTime
        displayProgress
        timeLabel {
          value
        }
        progressLabel {
          value
        }
        submitButton {
          visibility
          label {
            value
          }
        }
        postponeButton {
          visibility
          label {
            value
          }
        }
        finishButton {
          visibility
          label {
            value
          }
        }
        previousButton {
          visibility
          label {
            value
          }
        }
        nextButton {
          visibility
          label {
            value
          }
        }
        overviewButton {
          visibility
          label {
            value
          }
        }
        resetButton {
          visibility
          label {
            value
          }
        }
      }
    }
    candidate {
      candidateId
      display
    }
  }
}
    `;
export const Ui_Service_Participation_StartexamDocument = gql`
    mutation ui_service_participation_startexam($examSessionParams: ExamSessionMutationInput!, $startExamParams: MutationStartExamParams!) {
  examSession(params: $examSessionParams) {
    startExam(params: $startExamParams) {
      id
      startMode
      currentItem {
        id
        itemDocRefId
      }
    }
  }
}
    `;
export const Ui_Service_Participation_TicktockDocument = gql`
    mutation ui_service_participation_ticktock($session: ID!, $timePassedMS: Int!, $updateExamState: UpdateExamStateInput, $objectives: Boolean!) {
  examSession(params: {sessionDocRefId: $session}) {
    tickTock(timePassedMS: $timePassedMS, updateExamState: $updateExamState) {
      id
      scormData
      timeLeft {
        serverTime
        timeLeft
        timePassed
      }
      mode
      startMode
      currentItem {
        id
        itemDocRefId
      }
      objectives @include(if: $objectives) {
        id
        objectiveId
        scoreGained
        scoreLost
        scoreMax
        scorePending
      }
      examInfo @include(if: $objectives) {
        masteryScore
      }
      score @include(if: $objectives) {
        pointsGained
        pointsLost
        pointsPending
        pointsMax
      }
      items(topItemsOnly: true) {
        id
        itemDocRefId
        navigationStatus
        interactionStatus {
          locked
          closed
          started
          complete
        }
        itemInfo {
          started
          locked
          closed
          completed
          pending
          total
        }
        accumulatedScore {
          pointsGained
          pointsPending
          pointsMax
        }
      }
      itemInfo {
        started
        locked
        closed
        completed
        pending
        total
      }
      sections {
        id
        sectionInfo {
          id
          itemInfo {
            started
            locked
            closed
            completed
            pending
            total
          }
        }
      }
    }
  }
}
    `;
export const Ui_Sessionreport_DataDocument = gql`
    query ui_sessionreport_data($sessionDocRef: ID!) {
  examSession(params: {sessionDocRefId: $sessionDocRef}) {
    maxTime
    externalId
    sessionStartTime
    sessionCloseTime
    candidate {
      candidateId
      display
    }
    objectives {
      id
      objectiveId
      objectiveDepth
      description {
        value
      }
      scoreGained
      scorePending
      scoreMax
      scoreLost
    }
    examInfo {
      examId
      examAlias
      title
      languageTag
    }
    items {
      id
      itemId
      itemType
      interactionStatus {
        started
        complete
      }
    }
    score {
      pointsGained
      pointsPending
      pointsLost
      pointsMax
      pointsPercentage
    }
  }
}
    `;
export const Ui_Subjectcoordinator_Examorder_DataDocument = gql`
    query ui_subjectcoordinator_examorder_data($subjectDocRef: ID!) {
  subjectById(docReferenceId: $subjectDocRef) {
    _id
    subjectId
    openExamOrders {
      _id
      docReferenceId
      examinationOrderId
      status
      scoreMax
      examDate
      examTime
      subject(subjectDocRef: $subjectDocRef) {
        id
        status
        score
      }
      localizations {
        id
        name {
          value
        }
      }
    }
  }
}
    `;
export const Ui_Subjectcoordinator_Examorderedit_CreatecttDocument = gql`
    mutation ui_subjectcoordinator_examorderedit_createctt($examOrderDocRef: ID!, $subjectDocRef: ID!) {
  examOrder {
    createCTTfromItems(
      examOrderDocRef: $examOrderDocRef
      subjectDocRef: $subjectDocRef
    )
  }
}
    `;
export const Ui_Subjectcoordinator_Examorderedit_DataDocument = gql`
    query ui_subjectcoordinator_examorderedit_data($examOrderDocRef: String!, $subjectDocRef: ID!) {
  whoAmI {
    id
    user {
      _id
      superuser: privilege(privilege: superuser) {
        __typename
        privilege
      }
      translator: privilege(privilege: translator_localizations) {
        __typename
        ... on LocalizationPrivilege {
          privilege
          localizations {
            id
            localizationId
          }
        }
      }
    }
  }
  config {
    levelOfSecrecyEnabled
    examLanguages: localizations(enabledForExams: yes) {
      id
      name {
        value
      }
    }
  }
  examOrder {
    byId(docRef: $examOrderDocRef) {
      _id
      docReferenceId
      examinationOrderId
      title
      profile {
        _id
        title
      }
      levelOfSecrecy
      categoryDepth
      syllabusDepth
      status
      audience {
        _id
        audienceId
      }
      examDate
      examTime
      maxTimeAllowed
      defineScore
      items(subjectDocRef: $subjectDocRef) {
        id
        index
        chance
        item {
          _id
          docReferenceId
          itemId
          accumulatedScoreMax
          accumulatedCategories {
            id
            taxon
          }
          accumulatedObjectives {
            id
            taxon
          }
          itemType {
            id
            title {
              value
            }
          }
          visibleText(includeChildItems: true, includeSolutionHints: true)
          metaData {
            title
          }
          workflow {
            translateableByYou
            editableByYou
          }
        }
      }
      subject(subjectDocRef: $subjectDocRef) {
        id
        score
        status
        subject {
          _id
          isTranslator: myPrivilege(privilege: translator_subjects) {
            __typename
            privilege
          }
        }
        validToFinish {
          ok
          validationMessages {
            value
          }
        }
        dimensionCategories {
          id
          parentId
          taxon
          name {
            value
          }
        }
        dimensionSyllabus {
          id
          parentId
          taxon
          isLeaf
          name {
            value
          }
        }
        localizations {
          id
          localizationId
          name {
            value
          }
        }
        entries {
          categoryId
          objectiveId
          assignedScore
          targetScore
          items {
            _id
            itemId
          }
        }
      }
    }
  }
}
    `;
export const Ui_Subjectcoordinator_Examorderedit_FinishsubjectDocument = gql`
    mutation ui_subjectcoordinator_examorderedit_finishsubject($examOrderDocRef: ID!, $subjectDocRef: ID!) {
  examOrder {
    finishSubject(examOrderDocRef: $examOrderDocRef, subjectDocRef: $subjectDocRef)
  }
}
    `;
export const Ui_Subjectcoordinator_Examorderedit_RouteDocument = gql`
    query ui_subjectcoordinator_examorderedit_route($examOrderDocRef: String!, $subjectDocRef: ID!) {
  examOrder {
    byId(docRef: $examOrderDocRef) {
      _id
      docReferenceId
      examinationOrderId
      title
      status
      subject(subjectDocRef: $subjectDocRef) {
        id
        status
      }
    }
  }
}
    `;
export const Ui_Subjectcoordinator_Examorderedit_UpdateDocument = gql`
    mutation ui_subjectcoordinator_examorderedit_update($params: UpsertExamOrderInput!) {
  examOrder {
    upsert(params: $params) {
      _id
    }
  }
}
    `;
export const Ui_Subjectcoordinator_Examorderedit_UpdateitemsDocument = gql`
    mutation ui_subjectcoordinator_examorderedit_updateitems($examOrderDocRef: ID!, $subjectDocRef: ID!) {
  examOrder {
    updateItems(examOrderDocRef: $examOrderDocRef, subjectDocRef: $subjectDocRef)
  }
}
    `;
export const Ui_Subjectcoordinator_Home_DataDocument = gql`
    query ui_subjectcoordinator_home_data {
  config {
    itemTranslationEnabled
  }
}
    `;
export const Ui_Subjectcoordinator_Home_RouteDocument = gql`
    query ui_subjectcoordinator_home_route($subjectId: ID!) {
  subjectById(docReferenceId: $subjectId) {
    _id
    title
  }
}
    `;
export const Ui_Subjectcoordinator_Itemreview_InitDocument = gql`
    query ui_subjectcoordinator_itemreview_init($subjectDocRef: ID!, $topItems: [ID!]!) {
  subjectById(docReferenceId: $subjectDocRef) {
    _id
    subjectId
    authors {
      docReferenceId
    }
    itemsForSubjectCoordinator(
      filter: {showDeleted: no, topItems: all, topItemDocRefs: $topItems}
    ) {
      _id
      itemId
      topItem {
        _id
        docReferenceId
      }
      docReferenceId
      childItems {
        id
      }
    }
  }
}
    `;
export const Ui_Subjectcoordinator_Itemreview_Metadata_AssignauthorDocument = gql`
    mutation ui_subjectcoordinator_itemreview_metadata_assignauthor($itemId: ID!, $authorId: ID!, $noteForAuthor: String) {
  item {
    assignAuthor(itemId: $itemId, author: $authorId, noteForAuthor: $noteForAuthor)
  }
}
    `;
export const Ui_Subjectcoordinator_Itemreview_Metadata_AssigntoexamorderDocument = gql`
    mutation ui_subjectcoordinator_itemreview_metadata_assigntoexamorder($itemId: ID!, $examOrderId: ID!, $examOrderDocRef: ID!) {
  examOrder {
    upsert(
      params: {examOrderDocRef: $examOrderDocRef, examOrderId: $examOrderId, addItems: [$itemId]}
    ) {
      _id
    }
  }
}
    `;
export const Ui_Subjectcoordinator_Itemreview_MetadataDocument = gql`
    query ui_subjectcoordinator_itemreview_metadata($itemId: String!) {
  item {
    get(itemId: $itemId) {
      _id
      itemId
      docReferenceId
      parentItemId
      accumulatedScoreMax
      scoreMax
      childItems {
        id
        index
        item {
          _id
          docReferenceId
          itemId
          workflow {
            authoringStatus
          }
          itemType {
            id
            title {
              value
            }
          }
          metaData {
            title
            category {
              id
              taxon
            }
            objectives {
              id
              objectiveId
            }
          }
        }
      }
      metaData {
        defaultLocalization {
          id
          name {
            value
          }
        }
        minWidth
        minHeight
        title
        category {
          id
          taxon
          name {
            value
          }
        }
        itemDifficultyIndex
        objectives {
          objectiveId
          taxonomy {
            id
            taxon
            name {
              value
            }
            anchestors {
              id
              taxon
              name {
                value
              }
            }
          }
          scoreMax
        }
        audience {
          _id
          docReferenceId
          audienceId
          title
        }
        alternations {
          id
          taxon
        }
        copyFrom {
          _id
          itemId
        }
        revisionFrom {
          _id
          itemId
        }
        successorItem {
          _id
          docReferenceId
          itemId
        }
      }
      itemType {
        id
        title {
          value
        }
        supportsSubItems
        supportsObjectives
        uuid
      }
      topItem {
        _id
        docReferenceId
      }
      workflow {
        authoringStatus
        currentAuthor {
          _id
          displayName
          docReferenceId
        }
        noteForAuthor
        locked
        isHiddenForAuthor
        editAllowed
        obsolete
        published {
          _id
          docReferenceId
          examinationOrderId
          title
        }
        provisioned {
          _id
          docReferenceId
          examinationOrderId
          title
        }
      }
      subject {
        _id
        subjectId
        docReferenceId
        audiences {
          docReferenceId
          audienceId
          title
        }
        authors {
          _id
          docReferenceId
          displayName
        }
        openExamOrders {
          _id
          docReferenceId
          examinationOrderId
          title
        }
      }
    }
  }
}
    `;
export const Ui_Subjectcoordinator_Itemreview_Metadata_AlternationsDocument = gql`
    query ui_subjectcoordinator_itemreview_metadata_alternations($itemId: String!) {
  item {
    get(itemId: $itemId) {
      _id
      metaData {
        alternations {
          id
          taxon
        }
      }
    }
  }
  taxonomy {
    getById(docRefOrId: "ALTERNATIONS") {
      _id
      items {
        id
        taxon
        name {
          value
        }
      }
    }
  }
}
    `;
export const Ui_Subjectcoordinator_Itemreview_Metadata_CategoriesDocument = gql`
    query ui_subjectcoordinator_itemreview_metadata_categories($itemId: String!) {
  item {
    get(itemId: $itemId) {
      _id
      metaData {
        category {
          id
          taxon
        }
        subject {
          _id
          categories {
            id
            taxon
            name {
              value
            }
          }
        }
      }
    }
  }
}
    `;
export const Ui_Subjectcoordinator_Itemreview_Metadata_ObjectivesDocument = gql`
    query ui_subjectcoordinator_itemreview_metadata_objectives($itemId: String!) {
  item {
    get(itemId: $itemId) {
      _id
      metaData {
        subject {
          _id
          syllabus {
            id
            taxon
            name {
              value
            }
          }
        }
      }
    }
  }
}
    `;
export const Ui_Subjectcoordinator_Itemreview_Metadata_RemovefromexamorderDocument = gql`
    mutation ui_subjectcoordinator_itemreview_metadata_removefromexamorder($itemId: ID!, $examOrderId: ID!, $examOrderDocRef: ID!) {
  examOrder {
    upsert(
      params: {examOrderDocRef: $examOrderDocRef, examOrderId: $examOrderId, removeItems: [$itemId]}
    ) {
      _id
    }
  }
}
    `;
export const Ui_Subjectcoordinator_Itemreview_Metadata_ReopenitemDocument = gql`
    mutation ui_subjectcoordinator_itemreview_metadata_reopenitem($item: ID!) {
  item {
    reopenItem(itemId: $item)
  }
}
    `;
export const Ui_Subjectcoordinator_Itemreview_Metadata_ReviseitemDocument = gql`
    mutation ui_subjectcoordinator_itemreview_metadata_reviseitem($item: ReviseItemInput!) {
  item {
    reviseItem(item: $item) {
      ok
      newItemDocRefId
      message {
        value
      }
    }
  }
}
    `;
export const Ui_Subjectcoordinator_Itemreview_Metadata_UpdateDocument = gql`
    mutation ui_subjectcoordinator_itemreview_metadata_update($metadata: UpdateItemMetaDataInput!, $workflow: UpdateWorkflowDataInput!) {
  item {
    updateMetaData(params: $metadata, keepWorkflowStatus: true) {
      ok
    }
    updateWorklowData(params: $workflow)
  }
}
    `;
export const Ui_Subjectcoordinator_Itemreviewselection_ItemsDocument = gql`
    query ui_subjectcoordinator_itemreviewselection_items($subjectId: ID!, $filter: ItemFilterOptions!) {
  subjectById(docReferenceId: $subjectId) {
    _id
    itemsForSubjectCoordinator(filter: $filter) {
      _id
      docReferenceId
      docType
      itemId
      parentItemId
      visibleText(includeChildItems: true)
      keywords(includeChildItems: true)
      itemType {
        id
        title {
          value
        }
      }
      accumulatedScoreMax
      accumulatedCategories {
        id
        taxon
      }
      accumulatedObjectives {
        id
        taxon
      }
      metaData {
        title
        audience {
          _id
          audienceId
          title
        }
      }
      workflow {
        obsolete
        currentAuthor {
          _id
          displayName
        }
        noteForAuthor
        authoringStatus
      }
    }
  }
}
    `;
export const Ui_Subjectcoordinator_Translation_DataDocument = gql`
    query ui_subjectcoordinator_translation_data($subjectId: ID!) {
  config {
    contentLanguages {
      id
      name {
        value
      }
    }
  }
  subjectById(docReferenceId: $subjectId) {
    _id
    openExamOrders {
      _id
      docReferenceId
      examinationOrderId
      title
    }
  }
}
    `;
export const Ui_Subjectcoordinator_Translationedit_UpdateDocument = gql`
    mutation ui_subjectcoordinator_translationedit_update($params: UpdateItemTranslationInput!) {
  updateItemTranslation(params: $params) {
    id
    key
    value
  }
}
    `;
export const Ui_Subjectcoordinator_Translationedit_DataDocument = gql`
    query ui_subjectcoordinator_translationedit_data($params: GetItemTranslationsInput!) {
  config {
    contentLanguages {
      id
      isoCode
      name {
        value
      }
    }
  }
  getItemTranslations(params: $params) {
    isoCode
    entries {
      itemDocRefId
      defaultLanguage
      translations {
        id
        key
        value
      }
    }
  }
}
    `;
export const Ui_Superuser_Examinationoverview_DataDocument = gql`
    query ui_superuser_examinationoverview_data($userAgentString: String!) {
  whoAmI {
    id
    user {
      _id
      userId
    }
  }
  examination {
    all {
      examinationId
      examAliases
      dateCreated
      docReferenceId
      _id
      obsolete
      title
      passesRestrictions(userAgentString: $userAgentString)
      alternationRestrictions {
        id
        alternation {
          id
          taxon
        }
      }
      type
      examOrder {
        _id
        title
      }
      maxScore
      demoUrl
    }
  }
}
    `;
export const Ui_Superuser_Examinationoverview_JsonDocument = gql`
    query ui_superuser_examinationoverview_json($id: ID!) {
  examination {
    byId(id: $id) {
      _id
      json
    }
  }
}
    `;
export const Ui_Superuser_Examinationoverview_GolemDocument = gql`
    query ui_superuser_examinationoverview_golem($id: [String!]!) {
  examination {
    get(filter: {docRef: $id}) {
      _id
      golemScript
    }
  }
}
    `;
export const Ui_Superuser_Examinationoverview_PreviewDocument = gql`
    mutation ui_superuser_examinationoverview_preview($examId: String!, $externalId: String!, $userAgentString: String!) {
  newExamSession(
    params: {examAlias: $examId, externalId: $externalId, userAgentString: $userAgentString}
  ) {
    href
  }
}
    `;
export const Ui_Superuser_Examinationoverview_SetobsoleteDocument = gql`
    mutation ui_superuser_examinationoverview_setobsolete($examIds: [String!]!, $obsolete: Boolean!) {
  examination {
    setObsolete(docRef: $examIds, obsolete: $obsolete) {
      _id
    }
  }
}
    `;
export const Ui_Superuser_Examinationoverview_StatisticyamlDocument = gql`
    query ui_superuser_examinationoverview_statisticyaml($options: StatisticExportConfigQueryGetYamlConfigOptions!) {
  statisticexportconfig {
    getYamlConfig(params: $options)
  }
}
    `;
export const Ui_Superuser_Examorderedit_Addsubject_DataDocument = gql`
    query ui_superuser_examorderedit_addsubject_data($docRef: String!) {
  examOrder {
    byId(docRef: $docRef) {
      _id
      examinationOrderId
      audience {
        _id
        docReferenceId
        audienceId
        subjects {
          _id
          docReferenceId
          subjectId
          title
        }
      }
      subjects {
        id
        subject {
          _id
          docReferenceId
        }
      }
    }
  }
}
    `;
export const Ui_Superuser_Examorderedit_AddsubjectDocument = gql`
    mutation ui_superuser_examorderedit_addsubject($params: UpsertExamOrderInput!) {
  examOrder {
    upsert(params: $params) {
      _id
    }
  }
}
    `;
export const Ui_Superuser_Examorderedit_DataDocument = gql`
    query ui_superuser_examorderedit_data($docRef: String!) {
  audiences {
    all {
      _id
      isDeleted
      docReferenceId
      audienceId
      title
    }
  }
  examOrder {
    byId(docRef: $docRef) {
      _id
      examinationOrderId
      title
      dateCreated
      docReferenceId
      isDeleted
      scoreMax
      scoreRoundingMode
      itemCount
      examDate
      status
      examTime
      maxTimeAllowed
      defineScore
      aliases
      itemOrderStrategy
      levelOfSecrecy
      profile {
        _id
        docReferenceId
      }
      audience {
        _id
        docReferenceId
        audienceId
      }
      syllabusDepth
      categoryDepth
      subjects {
        id
        subject {
          _id
          docReferenceId
          title
          iAmSubjectCoordinator: myPrivilege(privilege: subjectcoordinator_subjects) {
            privilege
          }
          iAmTranslator: myPrivilege(privilege: translator_subjects) {
            privilege
          }
        }
        score
        localizations {
          id
        }
        status
        sectionTitle {
          defaultValue
        }
      }
      alternations {
        id
        taxon
      }
    }
  }
  TestDefinitionProfile {
    all {
      _id
      docReferenceId
      title
    }
  }
  config {
    levelOfSecrecyEnabled
    examLanguages: localizations(enabledForExams: yes) {
      id
      name {
        value
      }
    }
  }
}
    `;
export const Ui_Superuser_Examorderedit_EditDocument = gql`
    mutation ui_superuser_examorderedit_edit($examOrderDocRef: ID!) {
  examOrder {
    edit(examOrderDocRef: $examOrderDocRef)
  }
}
    `;
export const Ui_Superuser_Examorderedit_AlternationsDocument = gql`
    query ui_superuser_examorderedit_alternations($docRef: String!) {
  examOrder {
    byId(docRef: $docRef) {
      _id
      alternations {
        id
        taxon
      }
    }
  }
  taxonomy {
    getById(docRefOrId: "ALTERNATIONS") {
      _id
      items {
        id
        taxon
        name {
          value
        }
      }
    }
  }
}
    `;
export const Ui_Superuser_Examorderedit_ExaminationsDocument = gql`
    query ui_superuser_examorderedit_examinations($filter: GetExaminationFilterInput!) {
  examination {
    get(filter: $filter) {
      _id
      docReferenceId
    }
  }
}
    `;
export const Ui_Superuser_Examorderedit_ItemsDocument = gql`
    query ui_superuser_examorderedit_items($examOrderDocRef: String!, $subjectDocRef: ID!) {
  examOrder {
    byId(docRef: $examOrderDocRef) {
      _id
      items(subjectDocRef: $subjectDocRef) {
        id
        index
        chance
        item {
          _id
          docReferenceId
          itemId
          accumulatedScoreMax
          accumulatedCategories {
            id
            taxon
          }
          accumulatedObjectives {
            id
            taxon
          }
          itemType {
            id
            title {
              value
            }
          }
          visibleText(includeChildItems: true, includeSolutionHints: true)
          metaData {
            title
          }
        }
      }
    }
  }
}
    `;
export const Ui_Superuser_Examorderedit_PublishDocument = gql`
    mutation ui_superuser_examorderedit_publish($docRef: ID!) {
  examOrder {
    publish(examOrderDocRef: $docRef)
  }
}
    `;
export const Ui_Superuser_Examorderedit_RouteDocument = gql`
    query ui_superuser_examorderedit_route($docRef: String!) {
  examOrder {
    byId(docRef: $docRef) {
      _id
      examinationOrderId
      status
    }
  }
}
    `;
export const Ui_Superuser_Examorderedit_SendtosubjectcoordinatorDocument = gql`
    mutation ui_superuser_examorderedit_sendtosubjectcoordinator($docRef: ID!) {
  examOrder {
    sendToSubjectCoordinator(examOrderDocRef: $docRef)
  }
}
    `;
export const Ui_Superuser_Examorderedit_SetobsoleteDocument = gql`
    mutation ui_superuser_examorderedit_setobsolete($docRefs: [String!]!) {
  examination {
    setObsolete(docRef: $docRefs, obsolete: true) {
      _id
    }
  }
}
    `;
export const Ui_Superuser_Examorderedit_UpdateDocument = gql`
    mutation ui_superuser_examorderedit_update($params: UpsertExamOrderInput!) {
  examOrder {
    upsert(params: $params) {
      _id
    }
  }
}
    `;
export const Ui_Superuser_Examorderedit_Validate_Before_To_PublishDocument = gql`
    query ui_superuser_examorderedit_validate_before_to_publish($examOrder: String!) {
  examOrder {
    byId(docRef: $examOrder) {
      _id
      validToPublish {
        ok
        validationMessages {
          value
        }
      }
    }
  }
}
    `;
export const Ui_Superuser_Examorderedit_Validate_To_SendtosubjectcoordinatorDocument = gql`
    query ui_superuser_examorderedit_validate_to_sendtosubjectcoordinator($examOrder: String!) {
  examOrder {
    byId(docRef: $examOrder) {
      _id
      validToSendToSubjectCoordinator {
        ok
        validationMessages {
          value
        }
      }
    }
  }
}
    `;
export const Ui_Superuser_Examorderoverview_CopyDocument = gql`
    mutation ui_superuser_examorderoverview_copy($examOrderDocRef: ID!) {
  examOrder {
    copy(examOrderDocRef: $examOrderDocRef) {
      _id
      docReferenceId
    }
  }
}
    `;
export const Ui_Superuser_Examorderoverview_DataDocument = gql`
    query ui_superuser_examorderoverview_data {
  examOrder {
    list(showDeleted: true) {
      _id
      docReferenceId
      isDeleted
      title
      examinationOrderId
      dateCreated
      status
      levelOfSecrecy
      profile {
        _id
        title
      }
      scoreMax
      examDate
      examTime
      localizations {
        id
        name {
          value
        }
      }
      audience {
        _id
        audienceId
      }
    }
  }
}
    `;
export const Ui_Superuser_Examorderoverview_NewDocument = gql`
    mutation ui_superuser_examorderoverview_new {
  examOrder {
    new {
      docReferenceId
    }
  }
}
    `;
export const Ui_Superuser_Golemscriptedit_InitDocument = gql`
    query ui_superuser_golemscriptedit_init($docRef: ID!) {
  golemScripts {
    byId(docRef: $docRef) {
      _id
      golemScriptId
      docReferenceId
      isDeleted
      title
      scriptYaml
    }
  }
}
    `;
export const Ui_Superuser_Golemscriptedit_RouteDocument = gql`
    query ui_superuser_golemscriptedit_route($docRef: ID!) {
  golemScripts {
    byId(docRef: $docRef) {
      _id
      golemScriptId
    }
  }
}
    `;
export const Ui_Superusre_Golemscriptedit_UpdateDocument = gql`
    mutation ui_superusre_golemscriptedit_update($params: UpsertGolemScriptInput!) {
  golemScripts {
    upsert(params: $params) {
      _id
    }
  }
}
    `;
export const Ui_Superuser_Golemscriptoverview_DataDocument = gql`
    query ui_superuser_golemscriptoverview_data {
  golemScripts {
    all {
      _id
      isDeleted
      docReferenceId
      golemScriptId
      title
    }
  }
}
    `;
export const Ui_Superuser_Golemscriptoverview_NewDocument = gql`
    mutation ui_superuser_golemscriptoverview_new {
  golemScripts {
    new {
      _id
      docReferenceId
    }
  }
}
    `;
export const Ui_Superuser_Home_DataDocument = gql`
    query ui_superuser_home_data {
  whoAmI {
    id
    loginId
  }
}
    `;
export const Ui_Superuser_Itemtypeoverview_DataDocument = gql`
    query ui_superuser_itemtypeoverview_data {
  itemtypes(filter: {enabled: all}) {
    id
    description {
      value
    }
    title {
      value
    }
    enabled
    uuid
    supportsTranslations
  }
}
    `;
export const Ui_Superuser_Itemtypeoverview_DisableDocument = gql`
    mutation ui_superuser_itemtypeoverview_disable($itemtype: ID!) {
  itemtype {
    disable(itemTypes: [$itemtype]) {
      id
    }
  }
}
    `;
export const Ui_Superuser_Itemtypeoverview_EnableDocument = gql`
    mutation ui_superuser_itemtypeoverview_enable($itemtype: ID!) {
  itemtype {
    enable(itemTypes: [$itemtype]) {
      id
    }
  }
}
    `;
export const Ui_Superuser_Launchtest_DataDocument = gql`
    query ui_superuser_launchtest_data {
  whoAmI {
    id
    user {
      _id
      userId
    }
  }
  golemScripts {
    all {
      _id
      docReferenceId
      golemScriptId
      title
    }
  }
}
    `;
export const Ui_Superuser_Launchtest_GetexamsDocument = gql`
    query ui_superuser_launchtest_getexams($userAgentString: String!, $filter: GetExaminationFilterInput!) {
  examination {
    get(filter: $filter) {
      _id
      docReferenceId
      examinationId
      obsolete
      passesRestrictions(userAgentString: $userAgentString)
      alternationRestrictions {
        id
        alternation {
          id
          taxon
        }
        description {
          value
        }
      }
    }
  }
}
    `;
export const Ui_Superuser_LaunchtestDocument = gql`
    mutation ui_superuser_launchtest($examId: String!, $externalId: String!, $userAgentString: String!, $candidateId: String, $candidateName: String, $golemScript: String, $scoreRoundingMode: ScoreRoundingModeEnum!) {
  newExamSession(
    params: {examAlias: $examId, externalId: $externalId, userAgentString: $userAgentString, candidateId: $candidateId, candidateDisplay: $candidateName, golemScript: $golemScript, scoreRoundingMode: $scoreRoundingMode}
  ) {
    href
    sessionId
  }
}
    `;
export const Launchtest_PrintDocument = gql`
    mutation launchtest_print($sessionId: ID!) {
  printSession(sessionId: $sessionId) {
    href
  }
}
    `;
export const Launchtest_PrintPdfDocument = gql`
    query launchtest_printPdf($sessionId: ID!) {
  examSession(params: {sessionDocRefId: $sessionId}) {
    resultPdf {
      hrefResolved
    }
  }
}
    `;
export const Ui_Superuser_Profileedit_DataDocument = gql`
    query ui_superuser_profileedit_data($profile: ID!) {
  documents {
    get(docType: testdefinitionprofile, docReferenceId: $profile) {
      _id
      attachments {
        id
        name
      }
    }
  }
  TestDefinitionProfile {
    byId(id: $profile) {
      _id
      docReferenceId
      id
      title
      isDeleted
      continueWith
      continuationMode
      examinationType
      itemHost
      maxTimeAllowed
      navigationStyle
      resetOnNavigate
      scoreRoundingMode
      grades {
        id
        letter
        condition
        passed
        text {
          value(uiLanguagePreference: "x-none")
        }
      }
      pdfReportSettings {
        itemHeader {
          value(uiLanguagePreference: "x-none")
        }
        itemText {
          value(uiLanguagePreference: "x-none")
        }
        objectiveHeader {
          value(uiLanguagePreference: "x-none")
        }
        itemDetailCaption {
          value(uiLanguagePreference: "x-none")
        }
        objectiveMaxDepth
        objectiveMinDepth
        displayItemId
        displayObjectiveId
        objectiveText {
          value(uiLanguagePreference: "x-none")
        }
        text {
          value(uiLanguagePreference: "x-none")
        }
        emailSubject {
          value(uiLanguagePreference: "x-none")
        }
        emailBody {
          value(uiLanguagePreference: "x-none")
        }
        pageHeader {
          value(uiLanguagePreference: "x-none")
        }
        pageFooter {
          value(uiLanguagePreference: "x-none")
        }
        includeItems
      }
      welcomePage {
        text {
          value(uiLanguagePreference: "x-none")
        }
        startButton {
          visibility
          label {
            value(uiLanguagePreference: "x-none")
          }
        }
        cancelButton {
          visibility
          label {
            value(uiLanguagePreference: "x-none")
          }
        }
      }
      executionPage {
        displayTime
        displayProgress
        minWidth
        minHeight
        submitButton {
          visibility
          label {
            value(uiLanguagePreference: "x-none")
          }
        }
        postponeButton {
          visibility
          label {
            value(uiLanguagePreference: "x-none")
          }
        }
        finishButton {
          visibility
          label {
            value(uiLanguagePreference: "x-none")
          }
        }
        previousButton {
          visibility
          label {
            value(uiLanguagePreference: "x-none")
          }
        }
        nextButton {
          visibility
          label {
            value(uiLanguagePreference: "x-none")
          }
        }
        overviewButton {
          visibility
          label {
            value(uiLanguagePreference: "x-none")
          }
        }
        resetButton {
          visibility
          label {
            value(uiLanguagePreference: "x-none")
          }
        }
        showImmediateResult
        showItemMaxScore
        immediateResultText {
          value(uiLanguagePreference: "x-none")
        }
        immediateResultSeconds
        timeLabel {
          value(uiLanguagePreference: "x-none")
        }
        progressLabel {
          value(uiLanguagePreference: "x-none")
        }
      }
      resultPage {
        closeButton {
          visibility
          label {
            value(uiLanguagePreference: "x-none")
          }
        }
        itemHeader {
          value(uiLanguagePreference: "x-none")
        }
        itemText {
          value(uiLanguagePreference: "x-none")
        }
        displayItemId
        displayObjectiveId
        objectiveHeader {
          value(uiLanguagePreference: "x-none")
        }
        objectiveMaxDepth
        objectiveMinDepth
        objectiveText {
          value(uiLanguagePreference: "x-none")
        }
        text {
          value(uiLanguagePreference: "x-none")
        }
        pdfButton {
          visibility
          label {
            value(uiLanguagePreference: "x-none")
          }
        }
        emailLabel {
          value(uiLanguagePreference: "x-none")
        }
        emailText {
          value(uiLanguagePreference: "x-none")
        }
        pdf
        email
      }
      revisableItemCount
    }
  }
}
    `;
export const Ui_Superuser_Profileedit_RouteDocument = gql`
    query ui_superuser_profileedit_route($profile: ID!) {
  TestDefinitionProfile {
    byId(id: $profile) {
      _id
      title
    }
  }
}
    `;
export const Ui_Superuser_Profileedit_UpdateDocument = gql`
    mutation ui_superuser_profileedit_update($params: UpsertTestDefinitionProfile!) {
  TestDefinitionProfile {
    upsert(params: $params) {
      _id
    }
  }
}
    `;
export const Ui_Superuser_Profileoverview_CopyDocument = gql`
    mutation ui_superuser_profileoverview_copy($docRef: ID!) {
  TestDefinitionProfile {
    copy(docRef: $docRef) {
      _id
      docReferenceId
    }
  }
}
    `;
export const Ui_Superuser_Profileoverview_InitDocument = gql`
    query ui_superuser_profileoverview_init {
  TestDefinitionProfile {
    all {
      _id
      id
      isDeleted
      docReferenceId
      examinationType
      itemHost
      title
    }
  }
}
    `;
export const Ui_Superuser_Profileoverview_NewprofileDocument = gql`
    mutation ui_superuser_profileoverview_newprofile {
  TestDefinitionProfile {
    new {
      _id
      docReferenceId
    }
  }
}
    `;
export const Ui_Superuser_Audience_InitDocument = gql`
    query ui_superuser_audience_init($docRef: ID!) {
  subjects(showDeleted: false) {
    _id
    docReferenceId
    subjectId
  }
  audiences {
    byId(docRef: $docRef) {
      _id
      audienceId
      subjects {
        _id
        docReferenceId
        subjectId
      }
      docReferenceId
      isDeleted
      title
    }
  }
}
    `;
export const Ui_Superuser_Audienceedit_RouteDocument = gql`
    query ui_superuser_audienceedit_route($docRef: ID!) {
  audiences {
    byId(docRef: $docRef) {
      _id
      audienceId
    }
  }
}
    `;
export const Ui_Superuser_Audienceedit_UpdateDocument = gql`
    mutation ui_superuser_audienceedit_update($params: UpsertAudienceInput!) {
  audiences {
    upsertAudience(params: $params) {
      _id
    }
  }
}
    `;
export const Ui_Superuser_Audienceedit_DataDocument = gql`
    query ui_superuser_audienceedit_data {
  audiences {
    all {
      _id
      isDeleted
      docReferenceId
      audienceId
      title
      subjects {
        _id
        subjectId
      }
    }
  }
}
    `;
export const Ui_Superuser_Audienceoverview_NewDocument = gql`
    mutation ui_superuser_audienceoverview_new {
  audiences {
    newAudience {
      _id
      docReferenceId
    }
  }
}
    `;
export const Ui_Superuser_Scormtokenoverview_DataDocument = gql`
    query ui_superuser_scormtokenoverview_data {
  scormTokens {
    all {
      name {
        value
      }
      scormTokenId
      auditCreated
      docReferenceId
      examAlias
      isDeleted
      lmsOrgins
      status
      downloadCode
      publicDownloadUrl
      privateDownloadUrl
      trackability
    }
  }
}
    `;
export const Ui_Superuser_Scormtokenoverview_NewDocument = gql`
    mutation ui_superuser_scormtokenoverview_new($args: NewScormTokenArgs!) {
  scormTokens {
    newScormToken(args: $args) {
      docReferenceId
    }
  }
}
    `;
export const Ui_Superuser_Sessions_JsonDocument = gql`
    query ui_superuser_sessions_json($sessionId: ID!) {
  examSession(params: {sessionDocRefId: $sessionId}) {
    id
    json
  }
}
    `;
export const Ui_Superuser_Sessions_InitDocument = gql`
    query ui_superuser_sessions_init($filter: ExamSessionsQueryInput!) {
  examSessions(params: $filter) {
    id
    docReferenceId
    externalId
    examInfo {
      examAlias
      examId
      examType
      grade {
        id
        passed
      }
    }
    mode
    sessionStartTime
    sessionCloseTime
    timeLeft {
      timePassed
      timeLeft
    }
    score {
      pointsGained
      pointsMax
      pointsPercentage
    }
    totalTime
    auditUpdated
    auditCreated
    itemInfo(symbols: v2) {
      percentCompleted
      progress
    }
    candidate {
      candidateId
      display
    }
  }
}
    `;
export const Ui_Superuser_Sessions_PrintDocument = gql`
    mutation ui_superuser_sessions_print($sessionId: ID!) {
  printSession(sessionId: $sessionId) {
    id
    href
  }
}
    `;
export const Ui_Superuser_Sessions_DeleteDocument = gql`
    mutation ui_superuser_sessions_delete($sessionDocRefId: [ID!]!) {
  deleteSession(selector: {sessionDocRefId: $sessionDocRefId}) {
    processed
  }
}
    `;
export const Ui_Superuser_Sessions_GetreportDocument = gql`
    mutation ui_superuser_sessions_getreport($sessionId: ID!) {
  sessionReport(sessionId: $sessionId) {
    id
    href
  }
}
    `;
export const Ui_Superuser_Settings_DataDocument = gql`
    query ui_superuser_settings_data {
  config {
    sharePointConnections {
      id
      password
      username
      triggerKey
      downloadFolder
      siteUrl
      forcedImport
    }
  }
}
    `;
export const Ui_Superuser_Settings_DeletesharepointconnectionDocument = gql`
    mutation ui_superuser_settings_deletesharepointconnection($ids: [ID!]!) {
  config {
    deleteSharePointConnections(ids: $ids)
  }
}
    `;
export const Ui_Superuser_Settings_GeneratepasswordDocument = gql`
    mutation ui_superuser_settings_generatepassword {
  generatePassword
}
    `;
export const Ui_Superuser_Settings_UpdatesharepointconnectionDocument = gql`
    mutation ui_superuser_settings_updatesharepointconnection($params: UpsertSharePointConnection!) {
  config {
    upsertSharePointConnection(params: $params)
  }
}
    `;
export const Ui_Superuser_Statisticexport_DataDocument = gql`
    query ui_superuser_statisticexport_data {
  statisticexportconfig {
    all {
      configurationId
      title
    }
  }
}
    `;
export const Ui_Superuser_Subjectedit_RouteDocument = gql`
    query ui_superuser_subjectedit_route($subjectDocRef: ID!) {
  subjectById(docReferenceId: $subjectDocRef) {
    _id
    subjectId
  }
}
    `;
export const Ui_Superuser_Subjectedit_DataDocument = gql`
    query ui_superuser_subjectedit_data($subjectDocRef: ID!) {
  documents {
    get(docType: subject, docReferenceId: $subjectDocRef) {
      _id
      attachments {
        id
        name
      }
    }
  }
  subjectById(docReferenceId: $subjectDocRef) {
    _id
    title
    color
    alternateColor
    isDeleted
    subjectId
    image {
      id
      name
      hrefResolved
    }
    defaultLocalization {
      id
    }
    allowNonTranslateable
    itemEditVisibility
  }
  config {
    localizations(enabledForExams: yes) {
      id
      name {
        value
      }
    }
  }
}
    `;
export const Ui_Superuser_Subjectedit_UpdateDocument = gql`
    mutation ui_superuser_subjectedit_update($params: UpsertSubjectInput!) {
  subjects {
    upsertSubject(params: $params) {
      _id
    }
  }
}
    `;
export const Ui_Superuser_Subjectoverview_InitDocument = gql`
    query ui_superuser_subjectoverview_init {
  subjects(showDeleted: true) {
    docReferenceId
    title
    isDeleted
    subjectId
    subjectCoordinators {
      docReferenceId
      isDeleted
      displayName
    }
    authors {
      docReferenceId
      isDeleted
      displayName
    }
  }
}
    `;
export const Ui_Superuser_Subjectoverview_NewDocument = gql`
    mutation ui_superuser_subjectoverview_new {
  subjects {
    newSubject {
      _id
      docReferenceId
    }
  }
}
    `;
export const Ui_Superuser_Testaliasedit_DataDocument = gql`
    query ui_superuser_testaliasedit_data($profile: ID!) {
  TestAlias {
    byId(id: $profile) {
      _id
      docReferenceId
      id
      alias
      resolvesTo
    }
  }
}
    `;
export const Ui_Superuser_Testaliasedit_RouteDocument = gql`
    query ui_superuser_testaliasedit_route($profile: ID!) {
  TestAlias {
    byId(id: $profile) {
      _id
      alias
    }
  }
}
    `;
export const Ui_Superuser_Testaliasedit_UpdateDocument = gql`
    mutation ui_superuser_testaliasedit_update($params: UpsertTestAlias!) {
  TestAlias {
    upsert(params: $params) {
      _id
    }
  }
}
    `;
export const Ui_Superuser_Testaliasoverview_InitDocument = gql`
    query ui_superuser_testaliasoverview_init {
  TestAlias {
    all {
      _id
      id
      isDeleted
      docReferenceId
      alias
      resolvesTo
    }
  }
}
    `;
export const Ui_Superuser_Testaliasoverview_NewDocument = gql`
    mutation ui_superuser_testaliasoverview_new {
  TestAlias {
    new {
      _id
      docReferenceId
    }
  }
}
    `;
export const Ui_Superuser_Useredit_GeneratepasswordDocument = gql`
    mutation ui_superuser_useredit_generatepassword {
  generatePassword
}
    `;
export const Ui_Superuser_Useredit_InitDocument = gql`
    query ui_superuser_useredit_init($userDocRef: ID!) {
  getUserById(userDocRef: $userDocRef) {
    _id
    docReferenceId
    displayName
    shortcut
    userId
    mobilephone
    password
    isDeleted
    initials
    privileges {
      __typename
      ... on BasicPrivilege {
        privilege
      }
      ... on SubjectPrivilege {
        privilege
        subjects {
          _id
          docReferenceId
        }
      }
      ... on LocalizationPrivilege {
        privilege
        localizations {
          id
          localizationId
        }
      }
    }
  }
  config {
    localizations(enabledForExams: yes) {
      id
      localizationId
      name {
        value
      }
    }
  }
  subjects {
    docReferenceId
    title
    subjectId
  }
}
    `;
export const Ui_Superuser_Useredit_RouteDocument = gql`
    query ui_superuser_useredit_route($userDocRef: ID!) {
  getUserById(userDocRef: $userDocRef) {
    _id
    userId
  }
}
    `;
export const Ui_Superuser_Useredit_UpdateDocument = gql`
    mutation ui_superuser_useredit_update($params: UpsertUserInput!) {
  users {
    upsertUser(params: $params) {
      _id
    }
  }
}
    `;
export const Ui_Superuser_Useroverview_NewDocument = gql`
    mutation ui_superuser_useroverview_new {
  users {
    newUser {
      _id
      docReferenceId
    }
  }
}
    `;
export const Ui_Superuser_Useroverview_UsersDocument = gql`
    query ui_superuser_useroverview_users($pager: PagerInput) {
  users(pager: $pager) {
    _id
    docReferenceId
    userId
    docType
    isDeleted
    initials
    displayName
    privileges {
      privilege
    }
  }
}
    `;
export const Ui_SwitchlanguageDocument = gql`
    mutation ui_switchlanguage($lang: String!) {
  switchLanguage(lang: $lang)
}
    `;
export const Ui_Translator_Selectexamorder_DataDocument = gql`
    query ui_translator_selectexamorder_data {
  examOrder {
    list(forTranslation: true) {
      _id
      docReferenceId
      isDeleted
      title
      examinationOrderId
      dateCreated
      status
      levelOfSecrecy
      profile {
        _id
        title
      }
      scoreMax
      examDate
      examTime
      localizations {
        id
        name {
          value
        }
      }
      audience {
        _id
        audienceId
      }
    }
  }
}
    `;
export const Ui_Translator_Translateexamorder_DataDocument = gql`
    query ui_translator_translateexamorder_data($examOrder: String!) {
  whoAmI {
    id
    user {
      _id
      translatorRole: privilege(privilege: translator_localizations) {
        __typename
        ... on LocalizationPrivilege {
          localizations {
            id
            localizationId
            name {
              value
            }
          }
        }
      }
    }
  }
  examOrder {
    byId(docRef: $examOrder) {
      _id
      examinationOrderId
      title
      subjects {
        id
        subject {
          _id
          subjectId
          title
        }
        localizations {
          id
          localizationId
          name {
            value
          }
          isoCodes
        }
      }
      items {
        id
        index
        item {
          ...ItemData
          descendantItems {
            ...ItemData
          }
        }
      }
    }
  }
}
    ${ItemDataFragmentDoc}`;
export const Ui_Translateexamorder_ExamorderstringsDocument = gql`
    query ui_translateexamorder_examorderstrings($examOrder: String!) {
  examOrder {
    byId(docRef: $examOrder) {
      _id
      localizations {
        id
        isoLanguages {
          id
          isoCode
          name {
            value
          }
        }
      }
      strings {
        id
        key
        label {
          value
        }
        value {
          defaultValue
          languages {
            isoCode
            value
          }
        }
      }
    }
  }
}
    `;
export const Ui_Translator_Translateexamorder_UpdateDocument = gql`
    mutation ui_translator_translateexamorder_update($examOrder: ID!, $strings: [ExamOrderUpdateStringsInput!]!) {
  examOrder {
    updateStrings(examOrder: $examOrder, strings: $strings)
  }
}
    `;
export const Ui_Advanceditempresenter_AdditemDocument = gql`
    mutation ui_advanceditempresenter_additem($sessionDocRef: ID!, $itemDocRef: ID!) {
  examSession(params: {sessionDocRefId: $sessionDocRef}) {
    setSessionItems(topItems: [$itemDocRef]) {
      id
      itemType
      isTopItem
    }
  }
}
    `;
export const Ui_Advanceditempresenter_ItemDocument = gql`
    query ui_advanceditempresenter_item($itemDocRef: String!) {
  item {
    get(itemId: $itemDocRef) {
      _id
      itemType {
        id
      }
      isTopItem
    }
  }
}
    `;
export const Ui_Advanceditempresenter_TicktockDocument = gql`
    mutation ui_advanceditempresenter_ticktock($session: ID!, $timePassedMS: Int!, $updateExamState: UpdateExamStateInput!) {
  examSession(params: {sessionDocRefId: $session}) {
    tickTock(timePassedMS: $timePassedMS, updateExamState: $updateExamState) {
      id
    }
  }
}
    `;
export const Ui_Widgets_Connectionlost_RetryDocument = gql`
    query ui_widgets_connectionlost_retry {
  config {
    serverVersion
  }
}
    `;
export const Ui_Selectsubject_InitDocument = gql`
    query ui_selectsubject_init($role: PRIVILEGE!, $itemsForManualGrading: Boolean!, $itemsForBulkGrading: Boolean!) {
  subjects(myRole: $role) {
    subjectId
    docReferenceId
    color
    title
    image {
      hrefResolved
    }
    itemsForBulkGrading @include(if: $itemsForBulkGrading) {
      id
    }
    itemsForManualGrading @include(if: $itemsForManualGrading) {
      id
    }
    authors {
      initials
      docReferenceId
      displayName
    }
    subjectCoordinators {
      initials
      docReferenceId
      displayName
    }
  }
}
    `;
export const Ui_Assetmanager_DataDocument = gql`
    query ui_assetmanager_data($docType: DOCTYPE!, $docRef: ID!) {
  documents {
    get(docReferenceId: $docRef, docType: $docType) {
      _id
      attachments {
        id
        size
        name
        hrefResolved
        altText {
          defaultValue
        }
        videoMetadata {
          id
          width
          height
          duration
        }
        imageMetadata {
          id
          width
          height
        }
      }
    }
  }
}
    `;
export const Ui_Assetmanager_RemoveDocument = gql`
    mutation ui_assetmanager_remove($docType: DOCTYPE!, $docRef: ID!, $attachmentId: ID!) {
  document(docType: $docType, docReferenceId: $docRef) {
    removeAttachments(names: [$attachmentId])
  }
}
    `;
export const Ui_Assetmanager_UpdateDocument = gql`
    mutation ui_assetmanager_update($docType: DOCTYPE!, $docRef: ID!, $data: UpdateAttachmentInput!) {
  document(docType: $docType, docReferenceId: $docRef) {
    updateAttachment(data: $data) {
      id
    }
  }
}
    `;
export const Ui_Htmleditor_Imgtageditor_DataDocument = gql`
    query ui_htmleditor_imgtageditor_data($docReferenceId: ID!, $docType: DOCTYPE!) {
  documents {
    get(docReferenceId: $docReferenceId, docType: $docType) {
      _id
      attachments {
        id
        name
        hrefResolved
        imageMetadata {
          id
          width
          height
        }
        videoMetadata {
          id
          width
          height
          duration
        }
      }
    }
  }
}
    `;
export const Ui_Htmleditor_NewimagestubDocument = gql`
    mutation ui_htmleditor_newimagestub($docType: DOCTYPE!, $docReferenceId: ID!) {
  document(docType: $docType, docReferenceId: $docReferenceId) {
    newImageStub {
      id
      hrefResolved
      name
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    inaplicationcombo_edit_data(variables: IInaplicationcombo_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IInaplicationcombo_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IInaplicationcombo_Edit_DataQuery>(Inaplicationcombo_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'inaplicationcombo_edit_data', 'query');
    },
    inapplication_combo_edit_investigators(variables?: IInapplication_Combo_Edit_InvestigatorsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IInapplication_Combo_Edit_InvestigatorsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IInapplication_Combo_Edit_InvestigatorsQuery>(Inapplication_Combo_Edit_InvestigatorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'inapplication_combo_edit_investigators', 'query');
    },
    inapplicatiocombo_edit_update(variables: IInapplicatiocombo_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IInapplicatiocombo_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IInapplicatiocombo_Edit_UpdateMutation>(Inapplicatiocombo_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'inapplicatiocombo_edit_update', 'mutation');
    },
    instruction_edit_data(variables: IInstruction_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IInstruction_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IInstruction_Edit_DataQuery>(Instruction_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'instruction_edit_data', 'query');
    },
    instruction_edit_update(variables: IInstruction_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IInstruction_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IInstruction_Edit_UpdateMutation>(Instruction_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'instruction_edit_update', 'mutation');
    },
    invisiblehotspot_edit_data(variables: IInvisiblehotspot_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IInvisiblehotspot_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IInvisiblehotspot_Edit_DataQuery>(Invisiblehotspot_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invisiblehotspot_edit_data', 'query');
    },
    invisiblehotspot_edit_update(variables: IInvisiblehotspot_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IInvisiblehotspot_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IInvisiblehotspot_Edit_UpdateMutation>(Invisiblehotspot_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invisiblehotspot_edit_update', 'mutation');
    },
    choicetext_edit_addgap(variables: IChoicetext_Edit_AddgapMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IChoicetext_Edit_AddgapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IChoicetext_Edit_AddgapMutation>(Choicetext_Edit_AddgapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'choicetext_edit_addgap', 'mutation');
    },
    choicetext_edit_addvalue(variables: IChoicetext_Edit_AddvalueMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IChoicetext_Edit_AddvalueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IChoicetext_Edit_AddvalueMutation>(Choicetext_Edit_AddvalueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'choicetext_edit_addvalue', 'mutation');
    },
    choicetext_edit_data(variables: IChoicetext_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IChoicetext_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IChoicetext_Edit_DataQuery>(Choicetext_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'choicetext_edit_data', 'query');
    },
    choicetext_edit_removegap(variables: IChoicetext_Edit_RemovegapMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IChoicetext_Edit_RemovegapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IChoicetext_Edit_RemovegapMutation>(Choicetext_Edit_RemovegapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'choicetext_edit_removegap', 'mutation');
    },
    choicetext_edit_removevalue(variables: IChoicetext_Edit_RemovevalueMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IChoicetext_Edit_RemovevalueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IChoicetext_Edit_RemovevalueMutation>(Choicetext_Edit_RemovevalueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'choicetext_edit_removevalue', 'mutation');
    },
    choicetext_edit_update(variables: IChoicetext_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IChoicetext_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IChoicetext_Edit_UpdateMutation>(Choicetext_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'choicetext_edit_update', 'mutation');
    },
    container_edit_data(variables: IContainer_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IContainer_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IContainer_Edit_DataQuery>(Container_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'container_edit_data', 'query');
    },
    container_edit_update(variables: IContainer_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IContainer_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IContainer_Edit_UpdateMutation>(Container_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'container_edit_update', 'mutation');
    },
    container_settings(variables?: IContainer_SettingsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IContainer_SettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IContainer_SettingsQuery>(Container_SettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'container_settings', 'query');
    },
    crossout_edit_data(variables: ICrossout_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ICrossout_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ICrossout_Edit_DataQuery>(Crossout_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'crossout_edit_data', 'query');
    },
    crossout_edit_update(variables: ICrossout_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ICrossout_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ICrossout_Edit_UpdateMutation>(Crossout_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'crossout_edit_update', 'mutation');
    },
    essay_edit_data(variables: IEssay_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IEssay_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IEssay_Edit_DataQuery>(Essay_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'essay_edit_data', 'query');
    },
    essay_edit_update(variables: IEssay_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IEssay_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IEssay_Edit_UpdateMutation>(Essay_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'essay_edit_update', 'mutation');
    },
    essay_grading_data(variables: IEssay_Grading_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IEssay_Grading_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IEssay_Grading_DataQuery>(Essay_Grading_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'essay_grading_data', 'query');
    },
    essay_grading_setreason(variables: IEssay_Grading_SetreasonMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IEssay_Grading_SetreasonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IEssay_Grading_SetreasonMutation>(Essay_Grading_SetreasonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'essay_grading_setreason', 'mutation');
    },
    essay_grading_setscore(variables: IEssay_Grading_SetscoreMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IEssay_Grading_SetscoreMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IEssay_Grading_SetscoreMutation>(Essay_Grading_SetscoreDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'essay_grading_setscore', 'mutation');
    },
    essaygrading_submit(variables: IEssaygrading_SubmitMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IEssaygrading_SubmitMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IEssaygrading_SubmitMutation>(Essaygrading_SubmitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'essaygrading_submit', 'mutation');
    },
    fillingap_edit_addgap(variables: IFillingap_Edit_AddgapMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IFillingap_Edit_AddgapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IFillingap_Edit_AddgapMutation>(Fillingap_Edit_AddgapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fillingap_edit_addgap', 'mutation');
    },
    fillingap_edit_addvalue(variables: IFillingap_Edit_AddvalueMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IFillingap_Edit_AddvalueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IFillingap_Edit_AddvalueMutation>(Fillingap_Edit_AddvalueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fillingap_edit_addvalue', 'mutation');
    },
    fillingap_edit_data(variables: IFillingap_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IFillingap_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IFillingap_Edit_DataQuery>(Fillingap_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fillingap_edit_data', 'query');
    },
    fillingap_edit_removegap(variables: IFillingap_Edit_RemovegapMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IFillingap_Edit_RemovegapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IFillingap_Edit_RemovegapMutation>(Fillingap_Edit_RemovegapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fillingap_edit_removegap', 'mutation');
    },
    fillingap_edit_removevalue(variables: IFillingap_Edit_RemovevalueMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IFillingap_Edit_RemovevalueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IFillingap_Edit_RemovevalueMutation>(Fillingap_Edit_RemovevalueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fillingap_edit_removevalue', 'mutation');
    },
    fillingap_edit_upsert(variables: IFillingap_Edit_UpsertMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IFillingap_Edit_UpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IFillingap_Edit_UpsertMutation>(Fillingap_Edit_UpsertDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fillingap_edit_upsert', 'mutation');
    },
    inapplication_edit_data(variables: IInapplication_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IInapplication_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IInapplication_Edit_DataQuery>(Inapplication_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'inapplication_edit_data', 'query');
    },
    inapplication_edit_eval(variables: IInapplication_Edit_EvalMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IInapplication_Edit_EvalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IInapplication_Edit_EvalMutation>(Inapplication_Edit_EvalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'inapplication_edit_eval', 'mutation');
    },
    inapplication_edit_investigators(variables?: IInapplication_Edit_InvestigatorsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IInapplication_Edit_InvestigatorsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IInapplication_Edit_InvestigatorsQuery>(Inapplication_Edit_InvestigatorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'inapplication_edit_investigators', 'query');
    },
    inapplicatoin_edit_update(variables: IInapplicatoin_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IInapplicatoin_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IInapplicatoin_Edit_UpdateMutation>(Inapplicatoin_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'inapplicatoin_edit_update', 'mutation');
    },
    matchinghotspot_edit_addcircle(variables: IMatchinghotspot_Edit_AddcircleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IMatchinghotspot_Edit_AddcircleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IMatchinghotspot_Edit_AddcircleMutation>(Matchinghotspot_Edit_AddcircleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matchinghotspot_edit_addcircle', 'mutation');
    },
    matchinghotspot_edit_connect(variables: IMatchinghotspot_Edit_ConnectMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IMatchinghotspot_Edit_ConnectMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IMatchinghotspot_Edit_ConnectMutation>(Matchinghotspot_Edit_ConnectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matchinghotspot_edit_connect', 'mutation');
    },
    matchinghotspot_edit_data(variables: IMatchinghotspot_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IMatchinghotspot_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IMatchinghotspot_Edit_DataQuery>(Matchinghotspot_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matchinghotspot_edit_data', 'query');
    },
    matchinghotspot_edit_update(variables: IMatchinghotspot_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IMatchinghotspot_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IMatchinghotspot_Edit_UpdateMutation>(Matchinghotspot_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matchinghotspot_edit_update', 'mutation');
    },
    matchingimage_edit_data(variables: IMatchingimage_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IMatchingimage_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IMatchingimage_Edit_DataQuery>(Matchingimage_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matchingimage_edit_data', 'query');
    },
    matchingimage_edit_update(variables: IMatchingimage_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IMatchingimage_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IMatchingimage_Edit_UpdateMutation>(Matchingimage_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matchingimage_edit_update', 'mutation');
    },
    matchingtext_edit_data(variables: IMatchingtext_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IMatchingtext_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IMatchingtext_Edit_DataQuery>(Matchingtext_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matchingtext_edit_data', 'query');
    },
    matchingtext_edit_update(variables: IMatchingtext_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IMatchingtext_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IMatchingtext_Edit_UpdateMutation>(Matchingtext_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matchingtext_edit_update', 'mutation');
    },
    orderingselection_edit_data(variables: IOrderingselection_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IOrderingselection_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IOrderingselection_Edit_DataQuery>(Orderingselection_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderingselection_edit_data', 'query');
    },
    orderingselection_edit_update(variables: IOrderingselection_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IOrderingselection_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IOrderingselection_Edit_UpdateMutation>(Orderingselection_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderingselection_edit_update', 'mutation');
    },
    orderingsentences_edit_data(variables: IOrderingsentences_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IOrderingsentences_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IOrderingsentences_Edit_DataQuery>(Orderingsentences_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderingsentences_edit_data', 'query');
    },
    orderingsentences_edit_update(variables: IOrderingsentences_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IOrderingsentences_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IOrderingsentences_Edit_UpdateMutation>(Orderingsentences_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderingsentences_edit_update', 'mutation');
    },
    orderingwords_edit_data(variables: IOrderingwords_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IOrderingwords_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IOrderingwords_Edit_DataQuery>(Orderingwords_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderingwords_edit_data', 'query');
    },
    orderingwords_edit_update(variables: IOrderingwords_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IOrderingwords_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IOrderingwords_Edit_UpdateMutation>(Orderingwords_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderingwords_edit_update', 'mutation');
    },
    singlechoicehotspot_edit_addcircle(variables: ISinglechoicehotspot_Edit_AddcircleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISinglechoicehotspot_Edit_AddcircleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISinglechoicehotspot_Edit_AddcircleMutation>(Singlechoicehotspot_Edit_AddcircleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'singlechoicehotspot_edit_addcircle', 'mutation');
    },
    singlechoicehotspot_edit_data(variables: ISinglechoicehotspot_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISinglechoicehotspot_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISinglechoicehotspot_Edit_DataQuery>(Singlechoicehotspot_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'singlechoicehotspot_edit_data', 'query');
    },
    singlechoicehotspot_edit_update(variables: ISinglechoicehotspot_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISinglechoicehotspot_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISinglechoicehotspot_Edit_UpdateMutation>(Singlechoicehotspot_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'singlechoicehotspot_edit_update', 'mutation');
    },
    singlechoiceimage_edit_data(variables: ISinglechoiceimage_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISinglechoiceimage_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISinglechoiceimage_Edit_DataQuery>(Singlechoiceimage_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'singlechoiceimage_edit_data', 'query');
    },
    singlechoiceimage_edit_update(variables: ISinglechoiceimage_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISinglechoiceimage_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISinglechoiceimage_Edit_UpdateMutation>(Singlechoiceimage_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'singlechoiceimage_edit_update', 'mutation');
    },
    singlechoicematrix_edit_data(variables: ISinglechoicematrix_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISinglechoicematrix_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISinglechoicematrix_Edit_DataQuery>(Singlechoicematrix_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'singlechoicematrix_edit_data', 'query');
    },
    singlechoicematrix_edit_update(variables: ISinglechoicematrix_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISinglechoicematrix_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISinglechoicematrix_Edit_UpdateMutation>(Singlechoicematrix_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'singlechoicematrix_edit_update', 'mutation');
    },
    singlechoicetext_edit_data(variables: ISinglechoicetext_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISinglechoicetext_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISinglechoicetext_Edit_DataQuery>(Singlechoicetext_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'singlechoicetext_edit_data', 'query');
    },
    singlechoicetext_edit_update(variables: ISinglechoicetext_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISinglechoicetext_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISinglechoicetext_Edit_UpdateMutation>(Singlechoicetext_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'singlechoicetext_edit_update', 'mutation');
    },
    textentry_auto_edit_addgap(variables: ITextentry_Auto_Edit_AddgapMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITextentry_Auto_Edit_AddgapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITextentry_Auto_Edit_AddgapMutation>(Textentry_Auto_Edit_AddgapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'textentry_auto_edit_addgap', 'mutation');
    },
    textentry_auto_edit_addvalue(variables: ITextentry_Auto_Edit_AddvalueMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITextentry_Auto_Edit_AddvalueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITextentry_Auto_Edit_AddvalueMutation>(Textentry_Auto_Edit_AddvalueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'textentry_auto_edit_addvalue', 'mutation');
    },
    textentry_auto_edit_data(variables: ITextentry_Auto_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITextentry_Auto_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITextentry_Auto_Edit_DataQuery>(Textentry_Auto_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'textentry_auto_edit_data', 'query');
    },
    textentry_auto_edit_removegap(variables: ITextentry_Auto_Edit_RemovegapMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITextentry_Auto_Edit_RemovegapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITextentry_Auto_Edit_RemovegapMutation>(Textentry_Auto_Edit_RemovegapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'textentry_auto_edit_removegap', 'mutation');
    },
    textentry_auto_edit_removevalue(variables: ITextentry_Auto_Edit_RemovevalueMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITextentry_Auto_Edit_RemovevalueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITextentry_Auto_Edit_RemovevalueMutation>(Textentry_Auto_Edit_RemovevalueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'textentry_auto_edit_removevalue', 'mutation');
    },
    textentry_auto_edit_update(variables: ITextentry_Auto_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITextentry_Auto_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITextentry_Auto_Edit_UpdateMutation>(Textentry_Auto_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'textentry_auto_edit_update', 'mutation');
    },
    textentry_manual_edit_addgap(variables: ITextentry_Manual_Edit_AddgapMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITextentry_Manual_Edit_AddgapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITextentry_Manual_Edit_AddgapMutation>(Textentry_Manual_Edit_AddgapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'textentry_manual_edit_addgap', 'mutation');
    },
    textentry_manual_edit_addvalue(variables: ITextentry_Manual_Edit_AddvalueMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITextentry_Manual_Edit_AddvalueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITextentry_Manual_Edit_AddvalueMutation>(Textentry_Manual_Edit_AddvalueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'textentry_manual_edit_addvalue', 'mutation');
    },
    textentry_manual_edit_data(variables: ITextentry_Manual_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITextentry_Manual_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITextentry_Manual_Edit_DataQuery>(Textentry_Manual_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'textentry_manual_edit_data', 'query');
    },
    textentrymanual_edit_removegap(variables: ITextentrymanual_Edit_RemovegapMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITextentrymanual_Edit_RemovegapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITextentrymanual_Edit_RemovegapMutation>(Textentrymanual_Edit_RemovegapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'textentrymanual_edit_removegap', 'mutation');
    },
    textentrymanual_edit_removevalue(variables: ITextentrymanual_Edit_RemovevalueMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITextentrymanual_Edit_RemovevalueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITextentrymanual_Edit_RemovevalueMutation>(Textentrymanual_Edit_RemovevalueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'textentrymanual_edit_removevalue', 'mutation');
    },
    textentry_manual_edit_update(variables: ITextentry_Manual_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITextentry_Manual_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITextentry_Manual_Edit_UpdateMutation>(Textentry_Manual_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'textentry_manual_edit_update', 'mutation');
    },
    textentry_manual_grading_data(variables: ITextentry_Manual_Grading_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITextentry_Manual_Grading_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITextentry_Manual_Grading_DataQuery>(Textentry_Manual_Grading_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'textentry_manual_grading_data', 'query');
    },
    textentry_manual_grading_setanswer(variables: ITextentry_Manual_Grading_SetanswerMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITextentry_Manual_Grading_SetanswerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITextentry_Manual_Grading_SetanswerMutation>(Textentry_Manual_Grading_SetanswerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'textentry_manual_grading_setanswer', 'mutation');
    },
    textentry_manual_grading_submit(variables: ITextentry_Manual_Grading_SubmitMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITextentry_Manual_Grading_SubmitMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITextentry_Manual_Grading_SubmitMutation>(Textentry_Manual_Grading_SubmitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'textentry_manual_grading_submit', 'mutation');
    },
    textentry_manual_grading_update(variables: ITextentry_Manual_Grading_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITextentry_Manual_Grading_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITextentry_Manual_Grading_UpdateMutation>(Textentry_Manual_Grading_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'textentry_manual_grading_update', 'mutation');
    },
    fillinpool_edit_addgap(variables: IFillinpool_Edit_AddgapMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IFillinpool_Edit_AddgapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IFillinpool_Edit_AddgapMutation>(Fillinpool_Edit_AddgapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fillinpool_edit_addgap', 'mutation');
    },
    fillinpool_edit_addvalue(variables: IFillinpool_Edit_AddvalueMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IFillinpool_Edit_AddvalueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IFillinpool_Edit_AddvalueMutation>(Fillinpool_Edit_AddvalueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fillinpool_edit_addvalue', 'mutation');
    },
    fillinpool_edit_data(variables: IFillinpool_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IFillinpool_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IFillinpool_Edit_DataQuery>(Fillinpool_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fillinpool_edit_data', 'query');
    },
    fillinpool_edit_removegap(variables: IFillinpool_Edit_RemovegapMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IFillinpool_Edit_RemovegapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IFillinpool_Edit_RemovegapMutation>(Fillinpool_Edit_RemovegapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fillinpool_edit_removegap', 'mutation');
    },
    fillinpool_edit_removevalue(variables: IFillinpool_Edit_RemovevalueMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IFillinpool_Edit_RemovevalueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IFillinpool_Edit_RemovevalueMutation>(Fillinpool_Edit_RemovevalueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fillinpool_edit_removevalue', 'mutation');
    },
    fillinpool_edit_upsert(variables: IFillinpool_Edit_UpsertMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IFillinpool_Edit_UpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IFillinpool_Edit_UpsertMutation>(Fillinpool_Edit_UpsertDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fillinpool_edit_upsert', 'mutation');
    },
    linetextentry_edit_data(variables: ILinetextentry_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ILinetextentry_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ILinetextentry_Edit_DataQuery>(Linetextentry_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'linetextentry_edit_data', 'query');
    },
    linetextentry_edit_upsert(variables: ILinetextentry_Edit_UpsertMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ILinetextentry_Edit_UpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ILinetextentry_Edit_UpsertMutation>(Linetextentry_Edit_UpsertDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'linetextentry_edit_upsert', 'mutation');
    },
    linetextentry_grading_setvalue(variables: ILinetextentry_Grading_SetvalueMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ILinetextentry_Grading_SetvalueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ILinetextentry_Grading_SetvalueMutation>(Linetextentry_Grading_SetvalueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'linetextentry_grading_setvalue', 'mutation');
    },
    linetextentry_grading_submit(variables: ILinetextentry_Grading_SubmitMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ILinetextentry_Grading_SubmitMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ILinetextentry_Grading_SubmitMutation>(Linetextentry_Grading_SubmitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'linetextentry_grading_submit', 'mutation');
    },
    linetextentry_grading_update(variables: ILinetextentry_Grading_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ILinetextentry_Grading_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ILinetextentry_Grading_UpdateMutation>(Linetextentry_Grading_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'linetextentry_grading_update', 'mutation');
    },
    multiplechoice_edit_data(variables: IMultiplechoice_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IMultiplechoice_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IMultiplechoice_Edit_DataQuery>(Multiplechoice_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'multiplechoice_edit_data', 'query');
    },
    multiplechoice_edit_update(variables: IMultiplechoice_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IMultiplechoice_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IMultiplechoice_Edit_UpdateMutation>(Multiplechoice_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'multiplechoice_edit_update', 'mutation');
    },
    item_model_init(variables: IItem_Model_InitQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IItem_Model_InitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IItem_Model_InitQuery>(Item_Model_InitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'item_model_init', 'query');
    },
    multistephotspot_edit_data(variables: IMultistephotspot_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IMultistephotspot_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IMultistephotspot_Edit_DataQuery>(Multistephotspot_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'multistephotspot_edit_data', 'query');
    },
    multistephotspot_edit_update(variables: IMultistephotspot_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IMultistephotspot_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IMultistephotspot_Edit_UpdateMutation>(Multistephotspot_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'multistephotspot_edit_update', 'mutation');
    },
    organisation_edit_data(variables: IOrganisation_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IOrganisation_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IOrganisation_Edit_DataQuery>(Organisation_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organisation_edit_data', 'query');
    },
    organisation_edit_update(variables: IOrganisation_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IOrganisation_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IOrganisation_Edit_UpdateMutation>(Organisation_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organisation_edit_update', 'mutation');
    },
    placeholder_edit_data(variables: IPlaceholder_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IPlaceholder_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IPlaceholder_Edit_DataQuery>(Placeholder_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'placeholder_edit_data', 'query');
    },
    spellingmatrix_edit_data(variables: ISpellingmatrix_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISpellingmatrix_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISpellingmatrix_Edit_DataQuery>(Spellingmatrix_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'spellingmatrix_edit_data', 'query');
    },
    spellingmatrix_edit_update(variables: ISpellingmatrix_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISpellingmatrix_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISpellingmatrix_Edit_UpdateMutation>(Spellingmatrix_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'spellingmatrix_edit_update', 'mutation');
    },
    surveycombo_edit_data(variables: ISurveycombo_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISurveycombo_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISurveycombo_Edit_DataQuery>(Surveycombo_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'surveycombo_edit_data', 'query');
    },
    surveycombo_edit_update(variables: ISurveycombo_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISurveycombo_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISurveycombo_Edit_UpdateMutation>(Surveycombo_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'surveycombo_edit_update', 'mutation');
    },
    surveycomparision_edit_data(variables: ISurveycomparision_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISurveycomparision_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISurveycomparision_Edit_DataQuery>(Surveycomparision_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'surveycomparision_edit_data', 'query');
    },
    surveycomparision_edit_update(variables: ISurveycomparision_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISurveycomparision_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISurveycomparision_Edit_UpdateMutation>(Surveycomparision_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'surveycomparision_edit_update', 'mutation');
    },
    surveysinglechoicematrix_edit_data(variables: ISurveysinglechoicematrix_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISurveysinglechoicematrix_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISurveysinglechoicematrix_Edit_DataQuery>(Surveysinglechoicematrix_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'surveysinglechoicematrix_edit_data', 'query');
    },
    surveysinglecohicematrix_edit_update(variables: ISurveysinglecohicematrix_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISurveysinglecohicematrix_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISurveysinglecohicematrix_Edit_UpdateMutation>(Surveysinglecohicematrix_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'surveysinglecohicematrix_edit_update', 'mutation');
    },
    surveysinglechoicetext_edit_data(variables: ISurveysinglechoicetext_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISurveysinglechoicetext_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISurveysinglechoicetext_Edit_DataQuery>(Surveysinglechoicetext_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'surveysinglechoicetext_edit_data', 'query');
    },
    surveysinglechoicetext_edit_update(variables: ISurveysinglechoicetext_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISurveysinglechoicetext_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISurveysinglechoicetext_Edit_UpdateMutation>(Surveysinglechoicetext_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'surveysinglechoicetext_edit_update', 'mutation');
    },
    surveytextentry_edit_addgap(variables: ISurveytextentry_Edit_AddgapMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISurveytextentry_Edit_AddgapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISurveytextentry_Edit_AddgapMutation>(Surveytextentry_Edit_AddgapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'surveytextentry_edit_addgap', 'mutation');
    },
    surveytextentry_edit_data(variables: ISurveytextentry_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISurveytextentry_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISurveytextentry_Edit_DataQuery>(Surveytextentry_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'surveytextentry_edit_data', 'query');
    },
    surveytextentry_edit_removegap(variables: ISurveytextentry_Edit_RemovegapMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISurveytextentry_Edit_RemovegapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISurveytextentry_Edit_RemovegapMutation>(Surveytextentry_Edit_RemovegapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'surveytextentry_edit_removegap', 'mutation');
    },
    surveytextentry_edit_upsert(variables: ISurveytextentry_Edit_UpsertMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISurveytextentry_Edit_UpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISurveytextentry_Edit_UpsertMutation>(Surveytextentry_Edit_UpsertDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'surveytextentry_edit_upsert', 'mutation');
    },
    surveytextinput_edit_data(variables: ISurveytextinput_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISurveytextinput_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISurveytextinput_Edit_DataQuery>(Surveytextinput_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'surveytextinput_edit_data', 'query');
    },
    surveytextinput_edit_upsert(variables: ISurveytextinput_Edit_UpsertMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ISurveytextinput_Edit_UpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ISurveytextinput_Edit_UpsertMutation>(Surveytextinput_Edit_UpsertDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'surveytextinput_edit_upsert', 'mutation');
    },
    typingtext_edit_data(variables: ITypingtext_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITypingtext_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITypingtext_Edit_DataQuery>(Typingtext_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'typingtext_edit_data', 'query');
    },
    typingtest_edit_update(variables: ITypingtest_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITypingtest_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITypingtest_Edit_UpdateMutation>(Typingtest_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'typingtest_edit_update', 'mutation');
    },
    typingtext2023_edit_data(variables: ITypingtext2023_Edit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITypingtext2023_Edit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITypingtext2023_Edit_DataQuery>(Typingtext2023_Edit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'typingtext2023_edit_data', 'query');
    },
    typingtest2023_edit_update(variables: ITypingtest2023_Edit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITypingtest2023_Edit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITypingtest2023_Edit_UpdateMutation>(Typingtest2023_Edit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'typingtest2023_edit_update', 'mutation');
    },
    taxonomy_data(variables: ITaxonomy_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ITaxonomy_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ITaxonomy_DataQuery>(Taxonomy_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'taxonomy_data', 'query');
    },
    ui_author_itemedit_createadhocexam(variables: IUi_Author_Itemedit_CreateadhocexamMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Itemedit_CreateadhocexamMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Itemedit_CreateadhocexamMutation>(Ui_Author_Itemedit_CreateadhocexamDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_itemedit_createadhocexam', 'mutation');
    },
    ui_author_itemedit_deleteitem(variables: IUi_Author_Itemedit_DeleteitemMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Itemedit_DeleteitemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Itemedit_DeleteitemMutation>(Ui_Author_Itemedit_DeleteitemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_itemedit_deleteitem', 'mutation');
    },
    ui_author_itmeedit_getconfig(variables: IUi_Author_Itmeedit_GetconfigQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Itmeedit_GetconfigQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Itmeedit_GetconfigQuery>(Ui_Author_Itmeedit_GetconfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_itmeedit_getconfig', 'query');
    },
    ui_author_itemedit_itemmetadatablock_get(variables: IUi_Author_Itemedit_Itemmetadatablock_GetQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Itemedit_Itemmetadatablock_GetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Itemedit_Itemmetadatablock_GetQuery>(Ui_Author_Itemedit_Itemmetadatablock_GetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_itemedit_itemmetadatablock_get', 'query');
    },
    ui_author_itemedit_itemmetadatablock_alternations(variables: IUi_Author_Itemedit_Itemmetadatablock_AlternationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Itemedit_Itemmetadatablock_AlternationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Itemedit_Itemmetadatablock_AlternationsQuery>(Ui_Author_Itemedit_Itemmetadatablock_AlternationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_itemedit_itemmetadatablock_alternations', 'query');
    },
    ui_author_itemedit_itemmetadatablock_categories(variables: IUi_Author_Itemedit_Itemmetadatablock_CategoriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Itemedit_Itemmetadatablock_CategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Itemedit_Itemmetadatablock_CategoriesQuery>(Ui_Author_Itemedit_Itemmetadatablock_CategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_itemedit_itemmetadatablock_categories', 'query');
    },
    ui_author_itemedit_itemmetadatablock_allobjectives(variables: IUi_Author_Itemedit_Itemmetadatablock_AllobjectivesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Itemedit_Itemmetadatablock_AllobjectivesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Itemedit_Itemmetadatablock_AllobjectivesQuery>(Ui_Author_Itemedit_Itemmetadatablock_AllobjectivesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_itemedit_itemmetadatablock_allobjectives', 'query');
    },
    ui_author_itemedit_itemmetadatablock_objectives(variables: IUi_Author_Itemedit_Itemmetadatablock_ObjectivesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Itemedit_Itemmetadatablock_ObjectivesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Itemedit_Itemmetadatablock_ObjectivesQuery>(Ui_Author_Itemedit_Itemmetadatablock_ObjectivesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_itemedit_itemmetadatablock_objectives', 'query');
    },
    ui_author_itemedit_itemmetadatablock_update(variables: IUi_Author_Itemedit_Itemmetadatablock_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Itemedit_Itemmetadatablock_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Itemedit_Itemmetadatablock_UpdateMutation>(Ui_Author_Itemedit_Itemmetadatablock_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_itemedit_itemmetadatablock_update', 'mutation');
    },
    ui_author_itemedit_route(variables: IUi_Author_Itemedit_RouteQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Itemedit_RouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Itemedit_RouteQuery>(Ui_Author_Itemedit_RouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_itemedit_route', 'query');
    },
    ui_author_itemedit_settodone(variables: IUi_Author_Itemedit_SettodoneMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Itemedit_SettodoneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Itemedit_SettodoneMutation>(Ui_Author_Itemedit_SettodoneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_itemedit_settodone', 'mutation');
    },
    ui_author_itemedit_translation_data(variables: IUi_Author_Itemedit_Translation_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Itemedit_Translation_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Itemedit_Translation_DataQuery>(Ui_Author_Itemedit_Translation_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_itemedit_translation_data', 'query');
    },
    ui_author_itemedit_translation_init(variables: IUi_Author_Itemedit_Translation_InitQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Itemedit_Translation_InitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Itemedit_Translation_InitQuery>(Ui_Author_Itemedit_Translation_InitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_itemedit_translation_init', 'query');
    },
    ui_author_itemedit_translation_update(variables: IUi_Author_Itemedit_Translation_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Itemedit_Translation_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Itemedit_Translation_UpdateMutation>(Ui_Author_Itemedit_Translation_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_itemedit_translation_update', 'mutation');
    },
    UpdateStatus(variables: IUpdateStatusMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUpdateStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUpdateStatusMutation>(UpdateStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateStatus', 'mutation');
    },
    ui_author_itemedit_validate(variables: IUi_Author_Itemedit_ValidateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Itemedit_ValidateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Itemedit_ValidateMutation>(Ui_Author_Itemedit_ValidateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_itemedit_validate', 'mutation');
    },
    ui_author_itemoverview_data(variables: IUi_Author_Itemoverview_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Itemoverview_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Itemoverview_DataQuery>(Ui_Author_Itemoverview_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_itemoverview_data', 'query');
    },
    ui_author_itemoverview_route(variables: IUi_Author_Itemoverview_RouteQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Itemoverview_RouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Itemoverview_RouteQuery>(Ui_Author_Itemoverview_RouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_itemoverview_route', 'query');
    },
    ui_author_manageitem_copyitemtocontainer(variables: IUi_Author_Manageitem_CopyitemtocontainerMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Manageitem_CopyitemtocontainerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Manageitem_CopyitemtocontainerMutation>(Ui_Author_Manageitem_CopyitemtocontainerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_manageitem_copyitemtocontainer', 'mutation');
    },
    ui_author_manageitem_copyitemtosubject(variables: IUi_Author_Manageitem_CopyitemtosubjectMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Manageitem_CopyitemtosubjectMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Manageitem_CopyitemtosubjectMutation>(Ui_Author_Manageitem_CopyitemtosubjectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_manageitem_copyitemtosubject', 'mutation');
    },
    ui_author_manageitem_init(variables: IUi_Author_Manageitem_InitQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Manageitem_InitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Manageitem_InitQuery>(Ui_Author_Manageitem_InitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_manageitem_init', 'query');
    },
    ui_author_newitem_data(variables: IUi_Author_Newitem_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Newitem_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Newitem_DataQuery>(Ui_Author_Newitem_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_newitem_data', 'query');
    },
    ui_author_newitem_new(variables: IUi_Author_Newitem_NewMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Author_Newitem_NewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Author_Newitem_NewMutation>(Ui_Author_Newitem_NewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_author_newitem_new', 'mutation');
    },
    ui_base_getconfig(variables?: IUi_Base_GetconfigQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Base_GetconfigQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Base_GetconfigQuery>(Ui_Base_GetconfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_base_getconfig', 'query');
    },
    ui_bulkgrading_selectitem_data(variables: IUi_Bulkgrading_Selectitem_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Bulkgrading_Selectitem_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Bulkgrading_Selectitem_DataQuery>(Ui_Bulkgrading_Selectitem_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_bulkgrading_selectitem_data', 'query');
    },
    ui_demo_init(variables?: IUi_Demo_InitQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Demo_InitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Demo_InitQuery>(Ui_Demo_InitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_demo_init', 'query');
    },
    ui_focusmanager_client_cache(variables: IUi_Focusmanager_Client_CacheMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Focusmanager_Client_CacheMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Focusmanager_Client_CacheMutation>(Ui_Focusmanager_Client_CacheDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_focusmanager_client_cache', 'mutation');
    },
    ui_focusmanager_client_cleanup(variables: IUi_Focusmanager_Client_CleanupMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Focusmanager_Client_CleanupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Focusmanager_Client_CleanupMutation>(Ui_Focusmanager_Client_CleanupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_focusmanager_client_cleanup', 'mutation');
    },
    ui_focusmanager_client_init(variables: IUi_Focusmanager_Client_InitMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Focusmanager_Client_InitMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Focusmanager_Client_InitMutation>(Ui_Focusmanager_Client_InitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_focusmanager_client_init', 'mutation');
    },
    ui_focusmanager_client_investigate(variables: IUi_Focusmanager_Client_InvestigateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Focusmanager_Client_InvestigateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Focusmanager_Client_InvestigateMutation>(Ui_Focusmanager_Client_InvestigateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_focusmanager_client_investigate', 'mutation');
    },
    ui_focusmanager_client_reset(variables: IUi_Focusmanager_Client_ResetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Focusmanager_Client_ResetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Focusmanager_Client_ResetMutation>(Ui_Focusmanager_Client_ResetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_focusmanager_client_reset', 'mutation');
    },
    ui_focusmanager_client_setup(variables: IUi_Focusmanager_Client_SetupMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Focusmanager_Client_SetupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Focusmanager_Client_SetupMutation>(Ui_Focusmanager_Client_SetupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_focusmanager_client_setup', 'mutation');
    },
    ui_focusmanager_setuserfields(variables: IUi_Focusmanager_SetuserfieldsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Focusmanager_SetuserfieldsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Focusmanager_SetuserfieldsMutation>(Ui_Focusmanager_SetuserfieldsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_focusmanager_setuserfields', 'mutation');
    },
    online_help(variables: IOnline_HelpQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IOnline_HelpQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IOnline_HelpQuery>(Online_HelpDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'online_help', 'query');
    },
    ui_init(variables?: IUi_InitQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_InitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_InitQuery>(Ui_InitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_init', 'query');
    },
    ui_login(variables: IUi_LoginMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_LoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_LoginMutation>(Ui_LoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_login', 'mutation');
    },
    ui_login_anonymous(variables?: IUi_Login_AnonymousMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Login_AnonymousMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Login_AnonymousMutation>(Ui_Login_AnonymousDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_login_anonymous', 'mutation');
    },
    ui_logout(variables?: IUi_LogoutMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_LogoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_LogoutMutation>(Ui_LogoutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_logout', 'mutation');
    },
    ui_manualgrading_grading_data(variables: IUi_Manualgrading_Grading_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Manualgrading_Grading_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Manualgrading_Grading_DataQuery>(Ui_Manualgrading_Grading_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_manualgrading_grading_data', 'query');
    },
    ui_manualgrading_grading_update(variables: IUi_Manualgrading_Grading_UpdateQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Manualgrading_Grading_UpdateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Manualgrading_Grading_UpdateQuery>(Ui_Manualgrading_Grading_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_manualgrading_grading_update', 'query');
    },
    ui_manualgrading_selectitem_data(variables: IUi_Manualgrading_Selectitem_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Manualgrading_Selectitem_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Manualgrading_Selectitem_DataQuery>(Ui_Manualgrading_Selectitem_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_manualgrading_selectitem_data', 'query');
    },
    ui_paricipatesingle_setnotificationemail(variables: IUi_Paricipatesingle_SetnotificationemailMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Paricipatesingle_SetnotificationemailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Paricipatesingle_SetnotificationemailMutation>(Ui_Paricipatesingle_SetnotificationemailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_paricipatesingle_setnotificationemail', 'mutation');
    },
    ui_participatesingle_examsession(variables: IUi_Participatesingle_ExamsessionQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Participatesingle_ExamsessionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Participatesingle_ExamsessionQuery>(Ui_Participatesingle_ExamsessionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_participatesingle_examsession', 'query');
    },
    ui_participatesingle_init(variables: IUi_Participatesingle_InitQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Participatesingle_InitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Participatesingle_InitQuery>(Ui_Participatesingle_InitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_participatesingle_init', 'query');
    },
    ui_print_data(variables: IUi_Print_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Print_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Print_DataQuery>(Ui_Print_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_print_data', 'query');
    },
    ui_resultscreens_default_data(variables: IUi_Resultscreens_Default_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Resultscreens_Default_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Resultscreens_Default_DataQuery>(Ui_Resultscreens_Default_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_resultscreens_default_data', 'query');
    },
    ui_resultscreens_setnotificationemail(variables: IUi_Resultscreens_SetnotificationemailMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Resultscreens_SetnotificationemailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Resultscreens_SetnotificationemailMutation>(Ui_Resultscreens_SetnotificationemailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_resultscreens_setnotificationemail', 'mutation');
    },
    ui_resultscreens_default_objectives(variables: IUi_Resultscreens_Default_ObjectivesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Resultscreens_Default_ObjectivesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Resultscreens_Default_ObjectivesQuery>(Ui_Resultscreens_Default_ObjectivesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_resultscreens_default_objectives', 'query');
    },
    ui_service_participation_data(variables: IUi_Service_Participation_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Service_Participation_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Service_Participation_DataQuery>(Ui_Service_Participation_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_service_participation_data', 'query');
    },
    ui_service_participation_finishexam(variables: IUi_Service_Participation_FinishexamMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Service_Participation_FinishexamMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Service_Participation_FinishexamMutation>(Ui_Service_Participation_FinishexamDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_service_participation_finishexam', 'mutation');
    },
    ui_service_participation_init(variables: IUi_Service_Participation_InitQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Service_Participation_InitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Service_Participation_InitQuery>(Ui_Service_Participation_InitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_service_participation_init', 'query');
    },
    ui_service_participation_startexam(variables: IUi_Service_Participation_StartexamMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Service_Participation_StartexamMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Service_Participation_StartexamMutation>(Ui_Service_Participation_StartexamDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_service_participation_startexam', 'mutation');
    },
    ui_service_participation_ticktock(variables: IUi_Service_Participation_TicktockMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Service_Participation_TicktockMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Service_Participation_TicktockMutation>(Ui_Service_Participation_TicktockDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_service_participation_ticktock', 'mutation');
    },
    ui_sessionreport_data(variables: IUi_Sessionreport_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Sessionreport_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Sessionreport_DataQuery>(Ui_Sessionreport_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_sessionreport_data', 'query');
    },
    ui_subjectcoordinator_examorder_data(variables: IUi_Subjectcoordinator_Examorder_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Examorder_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Examorder_DataQuery>(Ui_Subjectcoordinator_Examorder_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_examorder_data', 'query');
    },
    ui_subjectcoordinator_examorderedit_createctt(variables: IUi_Subjectcoordinator_Examorderedit_CreatecttMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Examorderedit_CreatecttMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Examorderedit_CreatecttMutation>(Ui_Subjectcoordinator_Examorderedit_CreatecttDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_examorderedit_createctt', 'mutation');
    },
    ui_subjectcoordinator_examorderedit_data(variables: IUi_Subjectcoordinator_Examorderedit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Examorderedit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Examorderedit_DataQuery>(Ui_Subjectcoordinator_Examorderedit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_examorderedit_data', 'query');
    },
    ui_subjectcoordinator_examorderedit_finishsubject(variables: IUi_Subjectcoordinator_Examorderedit_FinishsubjectMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Examorderedit_FinishsubjectMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Examorderedit_FinishsubjectMutation>(Ui_Subjectcoordinator_Examorderedit_FinishsubjectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_examorderedit_finishsubject', 'mutation');
    },
    ui_subjectcoordinator_examorderedit_route(variables: IUi_Subjectcoordinator_Examorderedit_RouteQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Examorderedit_RouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Examorderedit_RouteQuery>(Ui_Subjectcoordinator_Examorderedit_RouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_examorderedit_route', 'query');
    },
    ui_subjectcoordinator_examorderedit_update(variables: IUi_Subjectcoordinator_Examorderedit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Examorderedit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Examorderedit_UpdateMutation>(Ui_Subjectcoordinator_Examorderedit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_examorderedit_update', 'mutation');
    },
    ui_subjectcoordinator_examorderedit_updateitems(variables: IUi_Subjectcoordinator_Examorderedit_UpdateitemsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Examorderedit_UpdateitemsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Examorderedit_UpdateitemsMutation>(Ui_Subjectcoordinator_Examorderedit_UpdateitemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_examorderedit_updateitems', 'mutation');
    },
    ui_subjectcoordinator_home_data(variables?: IUi_Subjectcoordinator_Home_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Home_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Home_DataQuery>(Ui_Subjectcoordinator_Home_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_home_data', 'query');
    },
    ui_subjectcoordinator_home_route(variables: IUi_Subjectcoordinator_Home_RouteQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Home_RouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Home_RouteQuery>(Ui_Subjectcoordinator_Home_RouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_home_route', 'query');
    },
    ui_subjectcoordinator_itemreview_init(variables: IUi_Subjectcoordinator_Itemreview_InitQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Itemreview_InitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Itemreview_InitQuery>(Ui_Subjectcoordinator_Itemreview_InitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_itemreview_init', 'query');
    },
    ui_subjectcoordinator_itemreview_metadata_assignauthor(variables: IUi_Subjectcoordinator_Itemreview_Metadata_AssignauthorMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Itemreview_Metadata_AssignauthorMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Itemreview_Metadata_AssignauthorMutation>(Ui_Subjectcoordinator_Itemreview_Metadata_AssignauthorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_itemreview_metadata_assignauthor', 'mutation');
    },
    ui_subjectcoordinator_itemreview_metadata_assigntoexamorder(variables: IUi_Subjectcoordinator_Itemreview_Metadata_AssigntoexamorderMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Itemreview_Metadata_AssigntoexamorderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Itemreview_Metadata_AssigntoexamorderMutation>(Ui_Subjectcoordinator_Itemreview_Metadata_AssigntoexamorderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_itemreview_metadata_assigntoexamorder', 'mutation');
    },
    ui_subjectcoordinator_itemreview_metadata(variables: IUi_Subjectcoordinator_Itemreview_MetadataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Itemreview_MetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Itemreview_MetadataQuery>(Ui_Subjectcoordinator_Itemreview_MetadataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_itemreview_metadata', 'query');
    },
    ui_subjectcoordinator_itemreview_metadata_alternations(variables: IUi_Subjectcoordinator_Itemreview_Metadata_AlternationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Itemreview_Metadata_AlternationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Itemreview_Metadata_AlternationsQuery>(Ui_Subjectcoordinator_Itemreview_Metadata_AlternationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_itemreview_metadata_alternations', 'query');
    },
    ui_subjectcoordinator_itemreview_metadata_categories(variables: IUi_Subjectcoordinator_Itemreview_Metadata_CategoriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Itemreview_Metadata_CategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Itemreview_Metadata_CategoriesQuery>(Ui_Subjectcoordinator_Itemreview_Metadata_CategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_itemreview_metadata_categories', 'query');
    },
    ui_subjectcoordinator_itemreview_metadata_objectives(variables: IUi_Subjectcoordinator_Itemreview_Metadata_ObjectivesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Itemreview_Metadata_ObjectivesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Itemreview_Metadata_ObjectivesQuery>(Ui_Subjectcoordinator_Itemreview_Metadata_ObjectivesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_itemreview_metadata_objectives', 'query');
    },
    ui_subjectcoordinator_itemreview_metadata_removefromexamorder(variables: IUi_Subjectcoordinator_Itemreview_Metadata_RemovefromexamorderMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Itemreview_Metadata_RemovefromexamorderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Itemreview_Metadata_RemovefromexamorderMutation>(Ui_Subjectcoordinator_Itemreview_Metadata_RemovefromexamorderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_itemreview_metadata_removefromexamorder', 'mutation');
    },
    ui_subjectcoordinator_itemreview_metadata_reopenitem(variables: IUi_Subjectcoordinator_Itemreview_Metadata_ReopenitemMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Itemreview_Metadata_ReopenitemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Itemreview_Metadata_ReopenitemMutation>(Ui_Subjectcoordinator_Itemreview_Metadata_ReopenitemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_itemreview_metadata_reopenitem', 'mutation');
    },
    ui_subjectcoordinator_itemreview_metadata_reviseitem(variables: IUi_Subjectcoordinator_Itemreview_Metadata_ReviseitemMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Itemreview_Metadata_ReviseitemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Itemreview_Metadata_ReviseitemMutation>(Ui_Subjectcoordinator_Itemreview_Metadata_ReviseitemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_itemreview_metadata_reviseitem', 'mutation');
    },
    ui_subjectcoordinator_itemreview_metadata_update(variables: IUi_Subjectcoordinator_Itemreview_Metadata_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Itemreview_Metadata_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Itemreview_Metadata_UpdateMutation>(Ui_Subjectcoordinator_Itemreview_Metadata_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_itemreview_metadata_update', 'mutation');
    },
    ui_subjectcoordinator_itemreviewselection_items(variables: IUi_Subjectcoordinator_Itemreviewselection_ItemsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Itemreviewselection_ItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Itemreviewselection_ItemsQuery>(Ui_Subjectcoordinator_Itemreviewselection_ItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_itemreviewselection_items', 'query');
    },
    ui_subjectcoordinator_translation_data(variables: IUi_Subjectcoordinator_Translation_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Translation_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Translation_DataQuery>(Ui_Subjectcoordinator_Translation_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_translation_data', 'query');
    },
    ui_subjectcoordinator_translationedit_update(variables: IUi_Subjectcoordinator_Translationedit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Translationedit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Translationedit_UpdateMutation>(Ui_Subjectcoordinator_Translationedit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_translationedit_update', 'mutation');
    },
    ui_subjectcoordinator_translationedit_data(variables: IUi_Subjectcoordinator_Translationedit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Subjectcoordinator_Translationedit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Subjectcoordinator_Translationedit_DataQuery>(Ui_Subjectcoordinator_Translationedit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_subjectcoordinator_translationedit_data', 'query');
    },
    ui_superuser_examinationoverview_data(variables: IUi_Superuser_Examinationoverview_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examinationoverview_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examinationoverview_DataQuery>(Ui_Superuser_Examinationoverview_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examinationoverview_data', 'query');
    },
    ui_superuser_examinationoverview_json(variables: IUi_Superuser_Examinationoverview_JsonQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examinationoverview_JsonQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examinationoverview_JsonQuery>(Ui_Superuser_Examinationoverview_JsonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examinationoverview_json', 'query');
    },
    ui_superuser_examinationoverview_golem(variables: IUi_Superuser_Examinationoverview_GolemQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examinationoverview_GolemQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examinationoverview_GolemQuery>(Ui_Superuser_Examinationoverview_GolemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examinationoverview_golem', 'query');
    },
    ui_superuser_examinationoverview_preview(variables: IUi_Superuser_Examinationoverview_PreviewMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examinationoverview_PreviewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examinationoverview_PreviewMutation>(Ui_Superuser_Examinationoverview_PreviewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examinationoverview_preview', 'mutation');
    },
    ui_superuser_examinationoverview_setobsolete(variables: IUi_Superuser_Examinationoverview_SetobsoleteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examinationoverview_SetobsoleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examinationoverview_SetobsoleteMutation>(Ui_Superuser_Examinationoverview_SetobsoleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examinationoverview_setobsolete', 'mutation');
    },
    ui_superuser_examinationoverview_statisticyaml(variables: IUi_Superuser_Examinationoverview_StatisticyamlQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examinationoverview_StatisticyamlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examinationoverview_StatisticyamlQuery>(Ui_Superuser_Examinationoverview_StatisticyamlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examinationoverview_statisticyaml', 'query');
    },
    ui_superuser_examorderedit_addsubject_data(variables: IUi_Superuser_Examorderedit_Addsubject_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examorderedit_Addsubject_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examorderedit_Addsubject_DataQuery>(Ui_Superuser_Examorderedit_Addsubject_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examorderedit_addsubject_data', 'query');
    },
    ui_superuser_examorderedit_addsubject(variables: IUi_Superuser_Examorderedit_AddsubjectMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examorderedit_AddsubjectMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examorderedit_AddsubjectMutation>(Ui_Superuser_Examorderedit_AddsubjectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examorderedit_addsubject', 'mutation');
    },
    ui_superuser_examorderedit_data(variables: IUi_Superuser_Examorderedit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examorderedit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examorderedit_DataQuery>(Ui_Superuser_Examorderedit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examorderedit_data', 'query');
    },
    ui_superuser_examorderedit_edit(variables: IUi_Superuser_Examorderedit_EditMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examorderedit_EditMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examorderedit_EditMutation>(Ui_Superuser_Examorderedit_EditDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examorderedit_edit', 'mutation');
    },
    ui_superuser_examorderedit_alternations(variables: IUi_Superuser_Examorderedit_AlternationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examorderedit_AlternationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examorderedit_AlternationsQuery>(Ui_Superuser_Examorderedit_AlternationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examorderedit_alternations', 'query');
    },
    ui_superuser_examorderedit_examinations(variables: IUi_Superuser_Examorderedit_ExaminationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examorderedit_ExaminationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examorderedit_ExaminationsQuery>(Ui_Superuser_Examorderedit_ExaminationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examorderedit_examinations', 'query');
    },
    ui_superuser_examorderedit_items(variables: IUi_Superuser_Examorderedit_ItemsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examorderedit_ItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examorderedit_ItemsQuery>(Ui_Superuser_Examorderedit_ItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examorderedit_items', 'query');
    },
    ui_superuser_examorderedit_publish(variables: IUi_Superuser_Examorderedit_PublishMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examorderedit_PublishMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examorderedit_PublishMutation>(Ui_Superuser_Examorderedit_PublishDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examorderedit_publish', 'mutation');
    },
    ui_superuser_examorderedit_route(variables: IUi_Superuser_Examorderedit_RouteQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examorderedit_RouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examorderedit_RouteQuery>(Ui_Superuser_Examorderedit_RouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examorderedit_route', 'query');
    },
    ui_superuser_examorderedit_sendtosubjectcoordinator(variables: IUi_Superuser_Examorderedit_SendtosubjectcoordinatorMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examorderedit_SendtosubjectcoordinatorMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examorderedit_SendtosubjectcoordinatorMutation>(Ui_Superuser_Examorderedit_SendtosubjectcoordinatorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examorderedit_sendtosubjectcoordinator', 'mutation');
    },
    ui_superuser_examorderedit_setobsolete(variables: IUi_Superuser_Examorderedit_SetobsoleteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examorderedit_SetobsoleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examorderedit_SetobsoleteMutation>(Ui_Superuser_Examorderedit_SetobsoleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examorderedit_setobsolete', 'mutation');
    },
    ui_superuser_examorderedit_update(variables: IUi_Superuser_Examorderedit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examorderedit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examorderedit_UpdateMutation>(Ui_Superuser_Examorderedit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examorderedit_update', 'mutation');
    },
    ui_superuser_examorderedit_validate_before_to_publish(variables: IUi_Superuser_Examorderedit_Validate_Before_To_PublishQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examorderedit_Validate_Before_To_PublishQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examorderedit_Validate_Before_To_PublishQuery>(Ui_Superuser_Examorderedit_Validate_Before_To_PublishDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examorderedit_validate_before_to_publish', 'query');
    },
    ui_superuser_examorderedit_validate_to_sendtosubjectcoordinator(variables: IUi_Superuser_Examorderedit_Validate_To_SendtosubjectcoordinatorQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examorderedit_Validate_To_SendtosubjectcoordinatorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examorderedit_Validate_To_SendtosubjectcoordinatorQuery>(Ui_Superuser_Examorderedit_Validate_To_SendtosubjectcoordinatorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examorderedit_validate_to_sendtosubjectcoordinator', 'query');
    },
    ui_superuser_examorderoverview_copy(variables: IUi_Superuser_Examorderoverview_CopyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examorderoverview_CopyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examorderoverview_CopyMutation>(Ui_Superuser_Examorderoverview_CopyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examorderoverview_copy', 'mutation');
    },
    ui_superuser_examorderoverview_data(variables?: IUi_Superuser_Examorderoverview_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examorderoverview_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examorderoverview_DataQuery>(Ui_Superuser_Examorderoverview_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examorderoverview_data', 'query');
    },
    ui_superuser_examorderoverview_new(variables?: IUi_Superuser_Examorderoverview_NewMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Examorderoverview_NewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Examorderoverview_NewMutation>(Ui_Superuser_Examorderoverview_NewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_examorderoverview_new', 'mutation');
    },
    ui_superuser_golemscriptedit_init(variables: IUi_Superuser_Golemscriptedit_InitQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Golemscriptedit_InitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Golemscriptedit_InitQuery>(Ui_Superuser_Golemscriptedit_InitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_golemscriptedit_init', 'query');
    },
    ui_superuser_golemscriptedit_route(variables: IUi_Superuser_Golemscriptedit_RouteQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Golemscriptedit_RouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Golemscriptedit_RouteQuery>(Ui_Superuser_Golemscriptedit_RouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_golemscriptedit_route', 'query');
    },
    ui_superusre_golemscriptedit_update(variables: IUi_Superusre_Golemscriptedit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superusre_Golemscriptedit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superusre_Golemscriptedit_UpdateMutation>(Ui_Superusre_Golemscriptedit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superusre_golemscriptedit_update', 'mutation');
    },
    ui_superuser_golemscriptoverview_data(variables?: IUi_Superuser_Golemscriptoverview_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Golemscriptoverview_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Golemscriptoverview_DataQuery>(Ui_Superuser_Golemscriptoverview_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_golemscriptoverview_data', 'query');
    },
    ui_superuser_golemscriptoverview_new(variables?: IUi_Superuser_Golemscriptoverview_NewMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Golemscriptoverview_NewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Golemscriptoverview_NewMutation>(Ui_Superuser_Golemscriptoverview_NewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_golemscriptoverview_new', 'mutation');
    },
    ui_superuser_home_data(variables?: IUi_Superuser_Home_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Home_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Home_DataQuery>(Ui_Superuser_Home_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_home_data', 'query');
    },
    ui_superuser_itemtypeoverview_data(variables?: IUi_Superuser_Itemtypeoverview_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Itemtypeoverview_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Itemtypeoverview_DataQuery>(Ui_Superuser_Itemtypeoverview_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_itemtypeoverview_data', 'query');
    },
    ui_superuser_itemtypeoverview_disable(variables: IUi_Superuser_Itemtypeoverview_DisableMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Itemtypeoverview_DisableMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Itemtypeoverview_DisableMutation>(Ui_Superuser_Itemtypeoverview_DisableDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_itemtypeoverview_disable', 'mutation');
    },
    ui_superuser_itemtypeoverview_enable(variables: IUi_Superuser_Itemtypeoverview_EnableMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Itemtypeoverview_EnableMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Itemtypeoverview_EnableMutation>(Ui_Superuser_Itemtypeoverview_EnableDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_itemtypeoverview_enable', 'mutation');
    },
    ui_superuser_launchtest_data(variables?: IUi_Superuser_Launchtest_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Launchtest_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Launchtest_DataQuery>(Ui_Superuser_Launchtest_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_launchtest_data', 'query');
    },
    ui_superuser_launchtest_getexams(variables: IUi_Superuser_Launchtest_GetexamsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Launchtest_GetexamsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Launchtest_GetexamsQuery>(Ui_Superuser_Launchtest_GetexamsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_launchtest_getexams', 'query');
    },
    ui_superuser_launchtest(variables: IUi_Superuser_LaunchtestMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_LaunchtestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_LaunchtestMutation>(Ui_Superuser_LaunchtestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_launchtest', 'mutation');
    },
    launchtest_print(variables: ILaunchtest_PrintMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ILaunchtest_PrintMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ILaunchtest_PrintMutation>(Launchtest_PrintDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'launchtest_print', 'mutation');
    },
    launchtest_printPdf(variables: ILaunchtest_PrintPdfQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ILaunchtest_PrintPdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ILaunchtest_PrintPdfQuery>(Launchtest_PrintPdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'launchtest_printPdf', 'query');
    },
    ui_superuser_profileedit_data(variables: IUi_Superuser_Profileedit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Profileedit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Profileedit_DataQuery>(Ui_Superuser_Profileedit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_profileedit_data', 'query');
    },
    ui_superuser_profileedit_route(variables: IUi_Superuser_Profileedit_RouteQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Profileedit_RouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Profileedit_RouteQuery>(Ui_Superuser_Profileedit_RouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_profileedit_route', 'query');
    },
    ui_superuser_profileedit_update(variables: IUi_Superuser_Profileedit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Profileedit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Profileedit_UpdateMutation>(Ui_Superuser_Profileedit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_profileedit_update', 'mutation');
    },
    ui_superuser_profileoverview_copy(variables: IUi_Superuser_Profileoverview_CopyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Profileoverview_CopyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Profileoverview_CopyMutation>(Ui_Superuser_Profileoverview_CopyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_profileoverview_copy', 'mutation');
    },
    ui_superuser_profileoverview_init(variables?: IUi_Superuser_Profileoverview_InitQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Profileoverview_InitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Profileoverview_InitQuery>(Ui_Superuser_Profileoverview_InitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_profileoverview_init', 'query');
    },
    ui_superuser_profileoverview_newprofile(variables?: IUi_Superuser_Profileoverview_NewprofileMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Profileoverview_NewprofileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Profileoverview_NewprofileMutation>(Ui_Superuser_Profileoverview_NewprofileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_profileoverview_newprofile', 'mutation');
    },
    ui_superuser_audience_init(variables: IUi_Superuser_Audience_InitQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Audience_InitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Audience_InitQuery>(Ui_Superuser_Audience_InitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_audience_init', 'query');
    },
    ui_superuser_audienceedit_route(variables: IUi_Superuser_Audienceedit_RouteQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Audienceedit_RouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Audienceedit_RouteQuery>(Ui_Superuser_Audienceedit_RouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_audienceedit_route', 'query');
    },
    ui_superuser_audienceedit_update(variables: IUi_Superuser_Audienceedit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Audienceedit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Audienceedit_UpdateMutation>(Ui_Superuser_Audienceedit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_audienceedit_update', 'mutation');
    },
    ui_superuser_audienceedit_data(variables?: IUi_Superuser_Audienceedit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Audienceedit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Audienceedit_DataQuery>(Ui_Superuser_Audienceedit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_audienceedit_data', 'query');
    },
    ui_superuser_audienceoverview_new(variables?: IUi_Superuser_Audienceoverview_NewMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Audienceoverview_NewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Audienceoverview_NewMutation>(Ui_Superuser_Audienceoverview_NewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_audienceoverview_new', 'mutation');
    },
    ui_superuser_scormtokenoverview_data(variables?: IUi_Superuser_Scormtokenoverview_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Scormtokenoverview_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Scormtokenoverview_DataQuery>(Ui_Superuser_Scormtokenoverview_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_scormtokenoverview_data', 'query');
    },
    ui_superuser_scormtokenoverview_new(variables: IUi_Superuser_Scormtokenoverview_NewMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Scormtokenoverview_NewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Scormtokenoverview_NewMutation>(Ui_Superuser_Scormtokenoverview_NewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_scormtokenoverview_new', 'mutation');
    },
    ui_superuser_sessions_json(variables: IUi_Superuser_Sessions_JsonQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Sessions_JsonQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Sessions_JsonQuery>(Ui_Superuser_Sessions_JsonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_sessions_json', 'query');
    },
    ui_superuser_sessions_init(variables: IUi_Superuser_Sessions_InitQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Sessions_InitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Sessions_InitQuery>(Ui_Superuser_Sessions_InitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_sessions_init', 'query');
    },
    ui_superuser_sessions_print(variables: IUi_Superuser_Sessions_PrintMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Sessions_PrintMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Sessions_PrintMutation>(Ui_Superuser_Sessions_PrintDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_sessions_print', 'mutation');
    },
    ui_superuser_sessions_delete(variables: IUi_Superuser_Sessions_DeleteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Sessions_DeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Sessions_DeleteMutation>(Ui_Superuser_Sessions_DeleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_sessions_delete', 'mutation');
    },
    ui_superuser_sessions_getreport(variables: IUi_Superuser_Sessions_GetreportMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Sessions_GetreportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Sessions_GetreportMutation>(Ui_Superuser_Sessions_GetreportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_sessions_getreport', 'mutation');
    },
    ui_superuser_settings_data(variables?: IUi_Superuser_Settings_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Settings_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Settings_DataQuery>(Ui_Superuser_Settings_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_settings_data', 'query');
    },
    ui_superuser_settings_deletesharepointconnection(variables: IUi_Superuser_Settings_DeletesharepointconnectionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Settings_DeletesharepointconnectionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Settings_DeletesharepointconnectionMutation>(Ui_Superuser_Settings_DeletesharepointconnectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_settings_deletesharepointconnection', 'mutation');
    },
    ui_superuser_settings_generatepassword(variables?: IUi_Superuser_Settings_GeneratepasswordMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Settings_GeneratepasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Settings_GeneratepasswordMutation>(Ui_Superuser_Settings_GeneratepasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_settings_generatepassword', 'mutation');
    },
    ui_superuser_settings_updatesharepointconnection(variables: IUi_Superuser_Settings_UpdatesharepointconnectionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Settings_UpdatesharepointconnectionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Settings_UpdatesharepointconnectionMutation>(Ui_Superuser_Settings_UpdatesharepointconnectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_settings_updatesharepointconnection', 'mutation');
    },
    ui_superuser_statisticexport_data(variables?: IUi_Superuser_Statisticexport_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Statisticexport_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Statisticexport_DataQuery>(Ui_Superuser_Statisticexport_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_statisticexport_data', 'query');
    },
    ui_superuser_subjectedit_route(variables: IUi_Superuser_Subjectedit_RouteQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Subjectedit_RouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Subjectedit_RouteQuery>(Ui_Superuser_Subjectedit_RouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_subjectedit_route', 'query');
    },
    ui_superuser_subjectedit_data(variables: IUi_Superuser_Subjectedit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Subjectedit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Subjectedit_DataQuery>(Ui_Superuser_Subjectedit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_subjectedit_data', 'query');
    },
    ui_superuser_subjectedit_update(variables: IUi_Superuser_Subjectedit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Subjectedit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Subjectedit_UpdateMutation>(Ui_Superuser_Subjectedit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_subjectedit_update', 'mutation');
    },
    ui_superuser_subjectoverview_init(variables?: IUi_Superuser_Subjectoverview_InitQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Subjectoverview_InitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Subjectoverview_InitQuery>(Ui_Superuser_Subjectoverview_InitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_subjectoverview_init', 'query');
    },
    ui_superuser_subjectoverview_new(variables?: IUi_Superuser_Subjectoverview_NewMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Subjectoverview_NewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Subjectoverview_NewMutation>(Ui_Superuser_Subjectoverview_NewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_subjectoverview_new', 'mutation');
    },
    ui_superuser_testaliasedit_data(variables: IUi_Superuser_Testaliasedit_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Testaliasedit_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Testaliasedit_DataQuery>(Ui_Superuser_Testaliasedit_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_testaliasedit_data', 'query');
    },
    ui_superuser_testaliasedit_route(variables: IUi_Superuser_Testaliasedit_RouteQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Testaliasedit_RouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Testaliasedit_RouteQuery>(Ui_Superuser_Testaliasedit_RouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_testaliasedit_route', 'query');
    },
    ui_superuser_testaliasedit_update(variables: IUi_Superuser_Testaliasedit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Testaliasedit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Testaliasedit_UpdateMutation>(Ui_Superuser_Testaliasedit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_testaliasedit_update', 'mutation');
    },
    ui_superuser_testaliasoverview_init(variables?: IUi_Superuser_Testaliasoverview_InitQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Testaliasoverview_InitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Testaliasoverview_InitQuery>(Ui_Superuser_Testaliasoverview_InitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_testaliasoverview_init', 'query');
    },
    ui_superuser_testaliasoverview_new(variables?: IUi_Superuser_Testaliasoverview_NewMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Testaliasoverview_NewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Testaliasoverview_NewMutation>(Ui_Superuser_Testaliasoverview_NewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_testaliasoverview_new', 'mutation');
    },
    ui_superuser_useredit_generatepassword(variables?: IUi_Superuser_Useredit_GeneratepasswordMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Useredit_GeneratepasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Useredit_GeneratepasswordMutation>(Ui_Superuser_Useredit_GeneratepasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_useredit_generatepassword', 'mutation');
    },
    ui_superuser_useredit_init(variables: IUi_Superuser_Useredit_InitQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Useredit_InitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Useredit_InitQuery>(Ui_Superuser_Useredit_InitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_useredit_init', 'query');
    },
    ui_superuser_useredit_route(variables: IUi_Superuser_Useredit_RouteQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Useredit_RouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Useredit_RouteQuery>(Ui_Superuser_Useredit_RouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_useredit_route', 'query');
    },
    ui_superuser_useredit_update(variables: IUi_Superuser_Useredit_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Useredit_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Useredit_UpdateMutation>(Ui_Superuser_Useredit_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_useredit_update', 'mutation');
    },
    ui_superuser_useroverview_new(variables?: IUi_Superuser_Useroverview_NewMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Useroverview_NewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Useroverview_NewMutation>(Ui_Superuser_Useroverview_NewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_useroverview_new', 'mutation');
    },
    ui_superuser_useroverview_users(variables?: IUi_Superuser_Useroverview_UsersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Superuser_Useroverview_UsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Superuser_Useroverview_UsersQuery>(Ui_Superuser_Useroverview_UsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_superuser_useroverview_users', 'query');
    },
    ui_switchlanguage(variables: IUi_SwitchlanguageMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_SwitchlanguageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_SwitchlanguageMutation>(Ui_SwitchlanguageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_switchlanguage', 'mutation');
    },
    ui_translator_selectexamorder_data(variables?: IUi_Translator_Selectexamorder_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Translator_Selectexamorder_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Translator_Selectexamorder_DataQuery>(Ui_Translator_Selectexamorder_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_translator_selectexamorder_data', 'query');
    },
    ui_translator_translateexamorder_data(variables: IUi_Translator_Translateexamorder_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Translator_Translateexamorder_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Translator_Translateexamorder_DataQuery>(Ui_Translator_Translateexamorder_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_translator_translateexamorder_data', 'query');
    },
    ui_translateexamorder_examorderstrings(variables: IUi_Translateexamorder_ExamorderstringsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Translateexamorder_ExamorderstringsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Translateexamorder_ExamorderstringsQuery>(Ui_Translateexamorder_ExamorderstringsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_translateexamorder_examorderstrings', 'query');
    },
    ui_translator_translateexamorder_update(variables: IUi_Translator_Translateexamorder_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Translator_Translateexamorder_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Translator_Translateexamorder_UpdateMutation>(Ui_Translator_Translateexamorder_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_translator_translateexamorder_update', 'mutation');
    },
    ui_advanceditempresenter_additem(variables: IUi_Advanceditempresenter_AdditemMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Advanceditempresenter_AdditemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Advanceditempresenter_AdditemMutation>(Ui_Advanceditempresenter_AdditemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_advanceditempresenter_additem', 'mutation');
    },
    ui_advanceditempresenter_item(variables: IUi_Advanceditempresenter_ItemQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Advanceditempresenter_ItemQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Advanceditempresenter_ItemQuery>(Ui_Advanceditempresenter_ItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_advanceditempresenter_item', 'query');
    },
    ui_advanceditempresenter_ticktock(variables: IUi_Advanceditempresenter_TicktockMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Advanceditempresenter_TicktockMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Advanceditempresenter_TicktockMutation>(Ui_Advanceditempresenter_TicktockDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_advanceditempresenter_ticktock', 'mutation');
    },
    ui_widgets_connectionlost_retry(variables?: IUi_Widgets_Connectionlost_RetryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Widgets_Connectionlost_RetryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Widgets_Connectionlost_RetryQuery>(Ui_Widgets_Connectionlost_RetryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_widgets_connectionlost_retry', 'query');
    },
    ui_selectsubject_init(variables: IUi_Selectsubject_InitQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Selectsubject_InitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Selectsubject_InitQuery>(Ui_Selectsubject_InitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_selectsubject_init', 'query');
    },
    ui_assetmanager_data(variables: IUi_Assetmanager_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Assetmanager_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Assetmanager_DataQuery>(Ui_Assetmanager_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_assetmanager_data', 'query');
    },
    ui_assetmanager_remove(variables: IUi_Assetmanager_RemoveMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Assetmanager_RemoveMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Assetmanager_RemoveMutation>(Ui_Assetmanager_RemoveDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_assetmanager_remove', 'mutation');
    },
    ui_assetmanager_update(variables: IUi_Assetmanager_UpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Assetmanager_UpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Assetmanager_UpdateMutation>(Ui_Assetmanager_UpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_assetmanager_update', 'mutation');
    },
    ui_htmleditor_imgtageditor_data(variables: IUi_Htmleditor_Imgtageditor_DataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Htmleditor_Imgtageditor_DataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Htmleditor_Imgtageditor_DataQuery>(Ui_Htmleditor_Imgtageditor_DataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_htmleditor_imgtageditor_data', 'query');
    },
    ui_htmleditor_newimagestub(variables: IUi_Htmleditor_NewimagestubMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IUi_Htmleditor_NewimagestubMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IUi_Htmleditor_NewimagestubMutation>(Ui_Htmleditor_NewimagestubDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ui_htmleditor_newimagestub', 'mutation');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;